<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card class="d-print-none">
        <template v-if="TypeProject == '1'">
          <div>
            <v-stepper v-model="e1" vertical :alt-labels="altLabels">
              <template>
                <v-stepper-step v-show="CheckStep1" step="1" editable class="font-weight-bold">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">{{
                      TypeProject == "1"
                      ? "ข้อมูลจัดโครงการ"
                      : "ข้อมูลจัดเดินทางปฏิบัติงานราชการ"
                      }}
                      (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>{{
                      TypeProject == "1"
                      ? "ข้อมูลจัดโครงการ"
                      : "ข้อมูลจัดเดินทางปฏิบัติงานราชการ"
                      }}</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 1 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 1 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">{{
                      TypeProject == "1"
                      ? "ข้อมูลจัดโครงการ"
                      : "ข้อมูลจัดเดินทางปฏิบัติงานราชการ"
                      }}</span>
                  </template>
                </v-stepper-step>
                <v-stepper-step v-show="!CheckStep1" :rules="[() => false]" step="1" editable class="font-weight-bold">
                  {{
                  TypeProject == "1"
                  ? "ข้อมูลจัดโครงการ"
                  : "ข้อมูลจัดเดินทางปฏิบัติงานราชการ"
                  }}
                  <small>กรอกข้อมูลไม่ครบถ้วน</small>
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-list>
                    <v-list-item>
                      <div align="center">
                        <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
                      </div>
                    </v-list-item>
                    <v-list-item>
                      <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel"
                        :key="fiscalYear.year" @change="selProjFiscalYear">
                        <v-radio :value="fiscalYear.year" class="font-weight-bold"
                          :label="('' + fiscalYear.yearth)"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item>
                          <v-radio-group row v-model="TypeInsertProject" @change="ClearPlanProject">
                            <v-radio value="1" class="font-weight-bold"
                              label="ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"></v-radio>
                            <v-radio value="0" class="font-weight-bold" label="ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"
                              disabled v-if="false"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item>
                          <v-autocomplete :items="
                              TypeInsertProject == '1'
                                ? Project_plan.filter(
                                    (item) =>
                                      (item.IsPlanStatus == '2' ||
                                        item.IsPlanStatus == '5' ||
                                        item.IsPlanStatus == '6' ||
                                        item.IsPlanStatus == '7') &&
                                      item.Project_type == TypeProject &&
                                      item.Approve == TypeInsertProject
                                  )
                                : Project_plan.filter(
                                    (item) =>
                                      (item.IsPlanStatus == '0' ||
                                        item.IsPlanStatus == '2' ||
                                        item.IsPlanStatus == '4') &&
                                      item.Project_type == TypeProject &&
                                      item.Approve == TypeInsertProject
                                  )
                            " item-text="full_Text" item-value="Project_code" item-disabled="disabled"
                            v-model="ProjectPlan" outlined :label="
                              TypeInsertProject == '1'
                                ? 'ข้อมูลจากการเสนอแผนขออนุมัติงบประมาณประจำปี'
                                : 'ข้อมูลโครงการ'
                            " clearable @click:clear="ClearPlanProject" @change="GetPlanToForm" :loading="isLoading"
                            :disabled="isLoading">
                            <template v-slot:selection="{ item }">
                              <span>
                                {{
                                item.full_Text.replaceAll("[^a-zA-Z]+", "")
                                }}
                                <v-chip v-if="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == item.IsPlanStatus
                                    ).length > 0
                                  " :color="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == item.IsPlanStatus
                                    ).length > 0
                                      ? StatusProject.filter(
                                          (staItem) =>
                                            staItem.id == item.IsPlanStatus
                                        )[0].color
                                      : ''
                                  " style="transform: scale(0.8);color: white">
                                  <span style="color: white">{{
                                    StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == item.IsPlanStatus
                                    ).length > 0
                                    ? StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == item.IsPlanStatus
                                    )[0].status
                                    : ""
                                    }}</span>
                                </v-chip>
                                <v-chip v-if="item.IsLog == '1'" color="red" style="transform: scale(0.8);color: white">
                                  <span style="color: white">ล็อคการแก้ไข</span>
                                </v-chip>
                                <v-chip v-if="item.IsDataComplete == '0'" color="#E53935"
                                  style="transform: scale(0.8);color: white">
                                  <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                                </v-chip>
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <span>
                                {{
                                item.full_Text.replaceAll("[^a-zA-Z]+", "")
                                }}
                                <v-chip v-if="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == item.IsPlanStatus
                                    ).length > 0
                                  " :color="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == item.IsPlanStatus
                                    ).length > 0
                                      ? StatusProject.filter(
                                          (staItem) =>
                                            staItem.id == item.IsPlanStatus
                                        )[0].color
                                      : ''
                                  " style="transform: scale(0.8);color: white">
                                  <span style="color: white">{{
                                    StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == item.IsPlanStatus
                                    ).length > 0
                                    ? StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == item.IsPlanStatus
                                    )[0].status
                                    : ""
                                    }}</span>
                                </v-chip>
                                <v-chip v-if="item.IsLog == '1'" color="red" style="transform: scale(0.8);color: white">
                                  <span style="color: white">ล็อคการแก้ไข</span>
                                </v-chip>
                                <v-chip v-if="item.IsDataComplete == '0'" color="#E53935"
                                  style="transform: scale(0.8);color: white">
                                  <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                                </v-chip>
                              </span>
                            </template>
                          </v-autocomplete>
                        </v-list-item>
                        <template v-if="
                            ProjectPlan == null ||
                              (ProjectPlan != null && TypeInsertProject == '0')
                          ">
                          <template v-if="false">
                            <v-list-item>
                              <v-row justify="space-around">
                                <span>วันที่เริ่มต้น</span>
                                <span>วันที่สิ้นสุด</span>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <v-date-picker v-model="DateStart" :landscape="landscape" :reactive="reactive"
                                    :full-width="fullWidth" :show-current="showCurrent" :type="month ? 'month' : 'date'"
                                    :multiple="multiple" :readonly="readonly" :disabled="disabled" locale="th"
                                    :events="enableEvents ? functionEvents : null"
                                    :color="DateStart == '' ? 'red' : 'primary'"></v-date-picker>
                                </v-col>
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <v-date-picker v-model="DateEnd" :landscape="landscape" :reactive="reactive"
                                    :full-width="fullWidth" :show-current="showCurrent" :type="month ? 'month' : 'date'"
                                    :multiple="multiple" :readonly="readonly" :disabled="disabled" locale="th"
                                    :events="enableEvents ? functionEvents : null"
                                    :color="DateEnd == '' ? 'red' : 'primary'"></v-date-picker>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item style="margin-top: 20px">
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="6">
                                  <v-autocomplete v-model="DepSelect" label="หน่วยงาน" :items="depart"
                                    item-text="dep_name" item-value="dep_id" hint="หน่วยงาน (ห้ามว่าง)" :error-messages="
                                      DepSelect == null
                                        ? 'หน่วยงาน (ห้ามว่าง)'
                                        : ''
                                    " persistent-hint :error="DepSelect == null" clearable>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-autocomplete v-model="FiscalYear" label="แผนประจำปี" :items="FiscalYearData"
                                    item-text="yearth" item-value="year" :error-messages="
                                      FiscalYear == ''
                                        ? 'โครงการของปี (ห้ามว่าง)'
                                        : ''
                                    " persistent-hint :error="FiscalYear == ''" :disabled="ProjectPlan != null"
                                    @change="getCourseType"></v-autocomplete>
                                </v-col>
                                <!--                          <v-col-->
                                <!--                              cols="12"-->
                                <!--                              md="2"-->
                                <!--                          >-->
                                <!--                            <v-text-field label="ITEM CODE" readonly v-model="itemCode"></v-text-field>-->
                                <!--                          </v-col>-->
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <div class="d-inline">
                                    <v-text-field v-model="Project_code" label="รหัสโครงการ" hide-details="auto"
                                      disabled></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="5">
                                  <div class="d-inline">
                                    <v-text-field v-model="Project_name" label="ชื่องาน / กิจกรรม"
                                      :rules="[rules.required]" required hide-details="auto" :error-messages="
                                        Project_name == ''
                                          ? 'ชื่องาน / กิจกรรม (ห้ามว่าง)'
                                          : ''
                                      " :error="Project_name == ''" persistent-hint></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-select :error="Project_group == ''" v-model="Project_group" :items="
                                        TypeProject == '1'
                                          ? projectGroup.filter(
                                              (item) => item.Type == '1'
                                            )
                                          : projectGroup.filter(
                                              (item) => item.Type == '2'
                                            )
                                      " item-value="Project_group" item-text="Project_group_des" label="ประเภทโครงการ"
                                      :error-messages="
                                        Project_group == ''
                                          ? 'ประเภทโครงการ (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint :rules="[rules.required]" required
                                      @change="SelProjectGroup"></v-select>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <div class="d-inline">
                                    <v-autocomplete :items="
                                        courseData.filter(
                                          (item) =>
                                            item.Course_type2 == '2' ||
                                            item.Course_type2 == '3'
                                        )
                                      " item-text="Course_name" item-value="Course_code" v-model="Course_code"
                                      label="หลักสูตร" @change="getCourseType" @click:clear="CheckCourseClear"
                                      persistent-hint clearable></v-autocomplete>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <div class="d-inline">
                                    <v-text-field v-model="course_group" label="สาขาประเภทหลักสูตร" required
                                      disabled></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <div class="d-inline">
                                    <v-autocomplete readonly :items="period" item-text="name" item-value="id"
                                      v-model="Period_code" label="ระยะเวลา" required></v-autocomplete>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <div class="d-flex flex-column justify-center align-center">
                                    <v-checkbox @change="clearRoundData" v-model="roundNeed" required>
                                      <template v-slot:label>
                                        <span style="font-weight: bold;color: black">มีการกำหนดรุ่น</span>
                                      </template>
                                    </v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-text-field type="number" :error="CalHourse == ''" v-model="CalHourse"
                                      label="จำนวน ช.ม" hide-details="auto" :rules="[rules.required]" required
                                      :error-messages="
                                        CalHourse == ''
                                          ? 'จำนวน ช.ม (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-text-field type="number" :error="CalCredit == ''" v-model="CalCredit"
                                      label="จำนวน เครดิต" hide-details="auto" :error-messages="
                                        CalCredit == ''
                                          ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0'
                                          : ''
                                      " persistent-hint></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-select :items="PLACESelete" item-value="id" item-text="detail"
                                      :error="PLACE == ''" v-model="PLACE" label="งาน / กิจกรรม ถูกจัดขึ้น"
                                      :error-messages="
                                        PLACE == ''
                                          ? 'งาน / กิจกรรม ถูกจัดขึ้น (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint required :rules="[rules.required]" @change="CheckPlace">
                                    </v-select>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline" v-if="PLACE == '2'">
                                    <v-autocomplete :error="Province_id == null" v-model="Province_id"
                                      :items="provinces_Data" item-text="name_th" item-value="code" label="จังหวัด"
                                      :error-messages="
                                        Province_id == null
                                          ? 'จังหวัด (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint required :rules="[rules.required]"></v-autocomplete>
                                  </div>
                                  <div class="d-inline" v-if="PLACE == '3'">
                                    <v-autocomplete :error="Country_id == null" v-model="Country_id"
                                      :items="countryData" item-text="ct_nameTHA" item-value="ct_code" label="ประเทศ"
                                      :error-messages="
                                        Country_id == null
                                          ? 'ประเทศ (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint required :rules="[rules.required]"></v-autocomplete>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-text-field type="number" :error="BudgetRequest == ''" v-model="BudgetRequest"
                                      label="งบประมาณที่ขอ" hide-details="auto" :rules="[rules.required]" required
                                      :error-messages="
                                        BudgetRequest == ''
                                          ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0'
                                          : ''
                                      " persistent-hint></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-select :error="WorkBy == ''" v-model="WorkBy" label="จัดโดย" :items="WorkByData"
                                      item-value="id" item-text="detail" :error-messages="
                                        WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''
                                      " persistent-hint required :rules="[rules.required]"></v-select>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-text-field :error="WorkByName == ''" v-model="WorkByName" label="ชื่อผู้จัด"
                                      hide-details="auto" :error-messages="
                                        WorkByName == ''
                                          ? 'ชื่อผู้จัด (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint required :rules="[rules.required]"></v-text-field>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                  <div class="d-inline">
                                    <v-text-field :error="Location == ''" v-model="Location" label="สถานที่จัด"
                                      hide-details="auto" :error-messages="
                                        Location == ''
                                          ? 'สถานที่จัด (ห้ามว่าง)'
                                          : ''
                                      " persistent-hint required :rules="[rules.required]"></v-text-field>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12">
                                  <div class="d-inline">
                                    <v-textarea v-model="TargetGroup" outlined name="" label="กลุ่มเป้าหมาย" value=""
                                      persistent-hint :error="
                                        TargetGroup == '' || TargetGroup == null
                                      " :error-messages="
                                        TargetGroup == '' || TargetGroup == null
                                          ? 'กลุ่มเป้าหมาย (ห้ามว่าง)'
                                          : ''
                                      " required></v-textarea>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12">
                                  <div class="d-inline">
                                    <v-textarea v-model="Objective" outlined name="" label="วัตถุประสงค์" value=""
                                      persistent-hint :error="Objective == ''" :error-messages="
                                        Objective == ''
                                          ? 'วัตถุประสงค์ (ห้ามว่าง)'
                                          : ''
                                      " required></v-textarea>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12">
                                  <div class="d-inline">
                                    <v-textarea v-model="Remarks" outlined name=""
                                      label="รายละเอียดประกอบ (เพิ่มเติม ถ้ามี)" value="" persistent-hint></v-textarea>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-file-input v-model="files" color="deep-purple accent-4" counter
                                label="แนบไฟล์เอกสารประกอบโครงการ" multiple placeholder="เลือกไฟล์"
                                prepend-icon="mdi-paperclip" outlined :show-size="1000" @change="FileSelect">
                                <template v-slot:selection="{ index, text }">
                                  <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                                    {{ text }}
                                  </v-chip>

                                  <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                                    +{{ files.length - 2 }} File(s)
                                  </span>
                                </template>
                              </v-file-input>
                            </v-list-item>
                            <!--                      <v-list-item class="mt-7">
                                                  <v-text-field label="รหัสอ้างอิงการประชุม" outlined v-model="LinkGen"
                                                                readonly></v-text-field>
                                                </v-list-item>
                                                <v-list-item>
                                                  <v-row class="d-flex justify-center">
                                                    <v-col
                                                        cols="12"
                                                        md="10">
                                                      <v-text-field label="ลิงค์เว็บไซต์รับสมัคร" outlined v-model="url"
                                                                    readonly></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        md="2">
                                                      <CopyToClipboard :text="url">
                                                        <v-btn
                                                            outlined
                                                            color="puple"
                                                            @click="Copy"
                                                        >
                                                          คัดลอกลิงค์
                                                        </v-btn>
                                                      </CopyToClipboard>
                                                    </v-col>
                                                  </v-row>
                                                </v-list-item>-->
                            <v-list-item>
                              <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">
                                **สนับสนุนไฟล์ PDF เท่านั้น
                              </p>
                            </v-list-item>
                            <v-list-item>
                              <v-alert v-if="alert" prominent type="error">
                                <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                  <v-col class="d-flex grow">- {{ item.Detail }}
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-list-item>
                            <v-list-item v-if="FileProject.length > 0">
                              <template>
                                <v-row>
                                  <v-col cols="12">
                                    <v-card>
                                      <v-card-title>
                                        ไฟล์ประกอบ
                                      </v-card-title>
                                      <v-container fluid>
                                        <v-row>
                                          <v-col v-for="(file_i, index) in FileProject" :key="index"
                                            class="d-flex child-flex" cols="12" md="4">
                                            <v-card flat tile class="d-flex">
                                              <v-img v-if="file_i.type == 'image'" :src="file_i.src" :lazy-src="
                                                  `https://picsum.photos/10/6?image=${(index +
                                                    1) *
                                                    5 +
                                                    10}`
                                                " aspect-ratio="1" class="grey lighten-2">
                                                <template v-slot:placeholder>
                                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                                    <v-progress-circular indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-img v-if="file_i.type == 'pdf'" src="../../assets/Image/pdf.png"
                                                :lazy-src="
                                                  `https://picsum.photos/10/6?image=${(index +
                                                    1) *
                                                    5 +
                                                    10}`
                                                " aspect-ratio="1" class="grey lighten-2">
                                                <template v-slot:placeholder>
                                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                                    <v-progress-circular indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-card-actions>
                                                <v-btn text @click="ShowData(file_i.src)">
                                                  <span style="color: indigo">
                                                    เรียกดู
                                                  </span>
                                                </v-btn>
                                                <v-btn @click="DeleteFile(file_i)" text color="red">
                                                  ลบ
                                                </v-btn>
                                              </v-card-actions>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-else>
                            <div align="center;padding: 100px">
                              <span style="font-weight: bold;font-size: 24px;color: #ff6d81">
                                กรุณาเลือกข้อมูลแผนงบประมาณประจำปีก่อนทำรายการ
                              </span>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="4">
                                <span>วันที่เริ่มต้น</span>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span>วันที่สิ้นสุด</span>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="4">
                                <v-date-picker v-model="DateStart" :landscape="landscape" :reactive="reactive"
                                  :full-width="fullWidth" :show-current="showCurrent" :type="month ? 'month' : 'date'"
                                  :multiple="multiple" :readonly="readonly" :disabled="disabled" locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  :color="DateStart == '' ? 'red' : 'primary'"></v-date-picker>
                              </v-col>
                              <v-col cols="12" md="4">
                                <v-date-picker v-model="DateEnd" :landscape="landscape" :reactive="reactive"
                                  :full-width="fullWidth" :show-current="showCurrent" :type="month ? 'month' : 'date'"
                                  :multiple="multiple" :readonly="readonly" :disabled="disabled" locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  :color="DateEnd == '' ? 'red' : 'primary'"></v-date-picker>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="4">
                                <v-text-field :error="Location == ''" v-model="Location" label="สถานที่จัด"
                                  hide-details="auto" :error-messages="
                                    Location == ''
                                      ? 'สถานที่จัด (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint required :disabled="IsLog == '1'"
                                  :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4">
                                <v-checkbox @change="clearRoundData" v-model="roundNeed" :disabled="IsLog == '1'"
                                  required>
                                  <template v-slot:label>
                                    <span style="font-weight: bold;color: black">มีการกำหนดรุ่น</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item style="margin-top: 20px" v-if="Project != null">
                            <div class="py-4">
                              <v-row>
                                <v-col cols="12" md="6">
                                  <p class="font-weight-bold">
                                    หน่วยงาน:
                                    {{
                                    depart.length > 0
                                    ? depart.filter(
                                    (item) =>
                                    item.dep_id == Project.Dep_Code
                                    ).length > 0
                                    ? depart.filter(
                                    (item) =>
                                    item.dep_id == Project.Dep_Code
                                    )[0].dep_name
                                    : "-"
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    แผนประจำปี:
                                    {{ parseInt(Project.FiscalYear) + 543 }}
                                  </p>
                                  <p class="font-weight-bold" v-if="Project.Project_type == '2'">
                                    ประเภททำรายการ:
                                    {{
                                    Project.IsProcess == "2"
                                    ? "เดินทางไปราชการ (ในวิชาชีพ)"
                                    : Project.IsProcess == "1"
                                    ? "เดินทางไปราชการ (นอกวิชาชีพ)"
                                    : "เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    หมวดโครงการ:
                                    {{
                                    Project.Project_category == "1"
                                    ? "พัฒนาบุคลากร"
                                    : Project.Project_category == "2"
                                    ? "โครงการอื่นๆ"
                                    : Project.Project_category == "3"
                                    ? "บริการวิชาการ"
                                    : "วิจัย"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    ประเภทแผน:
                                    {{
                                    Project.IsPlan == "1" ? "ในแผน" : "นอกแผน"
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-if="episode == '1'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                    "ต.ค. " +
                                    (parseInt(FiscalYear) + 543 - 1) +
                                    "- ธ.ค. " +
                                    (parseInt(FiscalYear) + 543 - 1)
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-else-if="episode == '2'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                    "ม.ค. " +
                                    (parseInt(FiscalYear) + 543) +
                                    "- มี.ค. " +
                                    (parseInt(FiscalYear) + 543)
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-else-if="episode == '3'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                    "เม.ย. " +
                                    (parseInt(FiscalYear) + 543) +
                                    "- มิ.ย. " +
                                    (parseInt(FiscalYear) + 543)
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-else-if="episode == '4'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                    "ก.ค. " +
                                    (parseInt(FiscalYear) + 543) +
                                    "- ก.ย. " +
                                    (parseInt(FiscalYear) + 543)
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-else-if="episode == '9'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                    "ตลอดปีงบประมาณ " +
                                    (parseInt(FiscalYear) + 543)
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    รหัสโครงการ: {{ Project.Project_code }}
                                  </p>
                                  <p class="font-weight-bold">
                                    ชื่อโครงการ: {{ Project.Project_name }}
                                  </p>
                                  <p class="font-weight-bold">
                                    ประเภทโครงการ:
                                    {{
                                    projectGroup.filter(
                                    (item) =>
                                    item.Project_group ==
                                    Project.Project_group
                                    ).length > 0
                                    ? projectGroup.filter(
                                    (item) =>
                                    item.Project_group ==
                                    Project.Project_group
                                    )[0].Project_group_des
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    หลักสูตร:
                                    {{
                                    courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    ).length > 0
                                    ? courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    )[0].Course_name
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    สาขาประเภทหลักสูตร:
                                    {{
                                    courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    ).length > 0
                                    ? courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    )[0].Course_type_des
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    ระยะเวลา:
                                    {{
                                    courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    ).length > 0
                                    ? period.filter(
                                    (perios_item) =>
                                    perios_item.id ==
                                    courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    )[0].Period_code
                                    ).length > 0
                                    ? period.filter(
                                    (perios_item) =>
                                    perios_item.id ==
                                    courseData.filter(
                                    (item) =>
                                    item.Course_code ==
                                    Project.Course_code
                                    )[0].Period_code
                                    )[0].name
                                    : "-"
                                    : "-"
                                    }}
                                  </p>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <p class="font-weight-bold">
                                    จำนวน ช.ม.: {{ Project.CalHourse }}
                                  </p>
                                  <p class="font-weight-bold">
                                    จำนวน เครดิต: {{ Project.CalCredit }}
                                  </p>
                                  <p class="font-weight-bold">
                                    งบประมาณที่ขอ: {{ Project.BudgetRequest }}
                                  </p>
                                  <p class="font-weight-bold">
                                    โครงการถูกจัดขึ้น:
                                    {{
                                    PLACESelete.filter(
                                    (item) => item.id == Project.PLACE
                                    ).length > 0
                                    ? PLACESelete.filter(
                                    (item) => item.id == Project.PLACE
                                    )[0].detail
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-if="Project.PLACE == '2'">
                                    จังหวัด:
                                    {{
                                    provinces_Data.filter(
                                    (item) =>
                                    item.code == Project.Province_id
                                    ).length > 0
                                    ? provinces_Data.filter(
                                    (item) =>
                                    item.code == Project.Province_id
                                    )[0].name_th
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold" v-else-if="Project.PLACE == '3'">
                                    ประเทศ:
                                    {{
                                    countryData.filter(
                                    (item) =>
                                    item.ct_code == Project.Country_id
                                    ).length > 0
                                    ? countryData.filter(
                                    (item) =>
                                    item.ct_code == Project.Country_id
                                    )[0].ct_nameTHA
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    จัดโดย:
                                    {{
                                    WorkByData.filter(
                                    (item) => item.id == Project.WorkBy
                                    ).length > 0
                                    ? WorkByData.filter(
                                    (item) => item.id == Project.WorkBy
                                    )[0].detail
                                    : "-"
                                    }}
                                  </p>
                                  <p class="font-weight-bold">
                                    ชื่อผู้จัด: {{ Project.WorkByName }}
                                  </p>
                                  <p class="font-weight-bold">
                                    เบอร์โทรติดต่อผู้กรอกข้อมูล:
                                    {{ Project.WorkByPhone }}
                                  </p>
                                  <p class="font-weight-bold">
                                    สถานที่จัด: {{ Project.Location }}
                                  </p>
                                  <p class="font-weight-bold">
                                    กลุ่มเป้าหมาย: {{ Project.TargetGroup }}
                                  </p>
                                  <p class="font-weight-bold" :style="
                                      Project.Objective == '' ||
                                      Project.Objective == null
                                        ? { color: 'red' }
                                        : {}
                                    ">
                                    วัตถุประสงค์: {{ Project.Objective }}
                                    <v-btn v-if="
                                        Project.Objective == '' ||
                                          Project.Objective == null
                                      " text color="green" class="darken-4 ml-4 font-weight-bold"
                                      @click="openDialogEditObj">เพิ่มวัตุประสงค์
                                    </v-btn>
                                  </p>
                                  <p class="font-weight-bold">
                                    รายละเอียดประกอบ (เพิ่มเติม):
                                    {{ Project.Remarks }}
                                  </p>
                                  <p class="font-weight-bold">
                                    Competency,Core Value,Strategic Objective:
                                    <v-btn text color="primary" @click="showCompetency(Project)">คลิก!!
                                    </v-btn>
                                  </p>
                                  <p class="font-weight-bold">
                                    ไฟล์เอกสารประกอบ:
                                    <v-btn text color="primary" @click="showFile()">คลิก!!
                                    </v-btn>
                                  </p>
                                </v-col>
                              </v-row>
                              <v-divider></v-divider>
                              <p class="mt-8" style="font-weight: bold">
                                วันที่บันทึกข้อมูลแผนโครงการ:
                                {{ Project.Create_Time | dateToThai2 }}
                              </p>
                              <p style="font-weight: bold">
                                สถานะแผน:
                                <v-chip v-if="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == Project.IsPlanStatus
                                    ).length > 0
                                  " :color="
                                    StatusProject.filter(
                                      (staItem) =>
                                        staItem.id == Project.IsPlanStatus
                                    ).length > 0
                                      ? StatusProject.filter(
                                          (staItem) =>
                                            staItem.id == Project.IsPlanStatus
                                        )[0].color
                                      : ''
                                  " style="transform: scale(0.8);color: white">
                                  <span style="color: white;font-weight: bold;padding: 20px">{{
                                    StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == Project.IsPlanStatus
                                    ).length > 0
                                    ? StatusProject.filter(
                                    (staItem) =>
                                    staItem.id == Project.IsPlanStatus
                                    )[0].status
                                    : ""
                                    }}</span>
                                </v-chip>
                              </p>
                              <template v-if="
                                  parseInt(Project.IsPlanStatus) >= 6 &&
                                    parseInt(Project.IsPlanStatus) <= 9
                                ">
                                <hr class="mb-2 mt-2" />
                                <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                  อนุมัติวงเงิน :
                                  {{ Project.BudgetArrove | currency }} บาท
                                </span>
                              </template>
                              <template v-if="
                                  parseInt(Project.IsPlanStatus) >= 6 &&
                                    parseInt(Project.IsPlanStatus) <= 9
                                ">
                                <hr class="mb-2 mt-2" />
                                <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                  จำนวนเงินเบิกจ่าย :
                                  {{ Project.MoneyDisburse | currency }} บาท
                                </span>
                              </template>
                              <v-divider></v-divider>
                            </div>
                          </v-list-item>
                        </template>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="d-flex justify-end">
                      <v-btn color="primary" @click="nextStep(1)" v-if="ProjectPlan != null">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="2" :editable="
                    ProjectPlan == null ||
                      (ProjectPlan != null && TypeInsertProject == '0')
                  " v-if="ProjectPlan != null" class="font-weight-bold">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red"
                      v-if="IsLog == '1'">สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์ (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 2 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 2 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="2" v-if="ProjectPlan != null">
                  <v-list>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1"><span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col cols="12" md="12">
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="12">
                                  <v-responsive>
                                    <v-spacer></v-spacer>
                                    <v-text-field label="ค้นหา สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์"
                                      v-model="searchCompe"></v-text-field>
                                  </v-responsive>
                                  <v-responsive>
                                    <v-treeview v-model="selection" selectable :activatable="true"
                                      :items="CompetencyData" :search="searchCompe">
                                      <template v-slot:prepend="{ item, open }">
                                        <v-icon v-if="!item.file" color="blue lighten-2">
                                          {{
                                          open
                                          ? "mdi-folder-open"
                                          : "mdi-folder"
                                          }}
                                        </v-icon>
                                        <v-icon v-else>
                                          {{ files[item.file] }}
                                        </v-icon>
                                      </template>
                                      <template v-slot:label="{ item, active }">
                                        <div v-if="isMobile" style="cursor: pointer" @click="ShowDetail(item)">
                                          <span style="font-size: 12px;color: black" v-if="!active">
                                            {{ item.name }}
                                          </span>
                                          <span style="font-size: 12px;color: #364eff;font-weight: bold" v-else>
                                            {{ item.name }}
                                          </span>
                                        </div>
                                        <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                          <span style="color:black;" v-if="!active">
                                            {{ item.name }}
                                          </span>
                                          <span style="color: #364eff;font-weight: bold" v-else>
                                            {{ item.name }}
                                          </span>
                                        </div>
                                      </template>
                                    </v-treeview>
                                  </v-responsive>
                                  <!--<v-list-item>
                                                                    <v-row class="d-flex justify-center">
                                                                        <v-col class="d-flex justify-center" cols="8"
                                                                               sm="2">
                                                                            <v-btn
                                                                                    outlined
                                                                                    color="primary"
                                                                                    @click="InsertCompetency"
                                                                            >
                                                                                เพิ่ม Competency
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-list-item>
                                                                <v-list-item class="d-flex justify-center"
                                                                             style="margin-top: 20px">
                                                                    <v-data-table
                                                                            :headers="competencyHeader"
                                                                            :items="competency_DataForSubmit"
                                                                            item-key="Competency_code"
                                                                            class="elevation-1">
                                                                        <template v-slot:header.Competency_des>
                                                                            <v-label
                                                                                    fontSize="16px"
                                                                                    fontWeight="bold">
                                                                                Competency
                                                                            </v-label>
                                                                        </template>
                                                                        <template v-slot:header.UPercent>
                                                                            <v-label
                                                                                    fontSize="16px"
                                                                                    fontWeight="bold">
                                                                                เปอเซ็นต์
                                                                            </v-label>
                                                                        </template>
                                                                        <template v-slot:item.Competency_des="{item}">
                                                                            <span style="font-weight: bold">
                                                                                {{item.Competency_des}}
                                                                            </span>
                                                                        </template>
                                                                        <template v-slot:item.UPercent="{item}">
                                                                            <span style="font-weight: bold">
                                                                                {{item.UPercent}} %
                                                                            </span>
                                                                        </template>
                                                                        <template v-slot:item.action="{item}">
                                                                            <v-row class="d-flex">
                                                                                <v-col
                                                                                        cols="6"
                                                                                        md="6">
                                                                                    <v-btn
                                                                                            outlined
                                                                                            color="#BF360C"
                                                                                            @click="DeleteCompetency(item)">
                                                                                        ลบ
                                                                                    </v-btn>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                    </v-data-table>
                                                                </v-list-item>-->
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(1)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(2)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="3" editable class="font-weight-bold" v-if="ProjectPlan != null">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">คณะทำงาน (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>คณะทำงาน</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 3 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 3 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">คณะทำงาน</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="3" v-if="ProjectPlan != null">
                  <v-list>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1"><span>คณะทำงาน</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col cols="12" md="12">
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="10">
                                  <v-list-item>
                                    <v-label class="d-flex justify-center">
                                      <!--                                      กรรมการผู้ร่วมโครงการ-->
                                    </v-label>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-row class="d-flex justify-center">
                                      <v-col class="d-flex justify-center" cols="12" sm="12">
                                        <v-radio-group v-model="radioGroup" row @change="chooseCommitteeType">
                                          <v-radio label="บุคลากรคณะแพทย์" value="0"></v-radio>
                                          <v-radio label="นักศึกษาคณะแพทย์" value="1"></v-radio>
                                          <v-radio label="บุคลากรคณะอื่น" value="2"></v-radio>
                                          <v-radio label="นักศึกษาคณะอื่น" value="3"></v-radio>
                                          <v-radio label="บุคคลภายนอก" value="4"></v-radio>
                                          <v-radio label="นักศึกษาภายนอก" value="5"></v-radio>
                                          <v-radio label="จากการแต่งตั้งคณะกรรมการ" value="6"></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-row class="d-flex justify-center">
                                      <v-col class="d-flex justify-center" cols="12" md="8">
                                        <template v-if="radioGroup == '0'">
                                          <v-autocomplete v-model="perid" :items="staffData" item-text="customDetail"
                                            item-value="perid" label="รายชื่อบุคลากรในคณะ" outlined
                                            @change="UpdateName"></v-autocomplete>
                                        </template>
                                        <template v-else-if="radioGroup == '1'">
                                          <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID"
                                            item-text="fullName" v-model="Idstudent"
                                            label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา" @change="UpdateName">
                                          </v-autocomplete>
                                        </template>
                                        <template v-else-if="radioGroup == '2'">
                                          <v-list-item class="d-flex justify-center">
                                            <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                              item-text="FAC_NAME_THAI" v-model="IdDepart" label="ค้นหาคณะ/สังกัด"
                                              @change="GetPersonalPSU">
                                            </v-autocomplete>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-autocomplete outlined :items="personalMedData" item-value="STAFF_ID"
                                              item-text="FULL_NAME" v-model="IdPersonal"
                                              label="ค้นหา ชื่อ - สกุล รหัสบุคลากร" @change="UpdateName">
                                            </v-autocomplete>
                                          </v-list-item>
                                        </template>
                                        <template v-else-if="radioGroup == '3'">
                                          <v-list-item class="d-flex justify-center">
                                            <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                              item-text="FAC_NAME_THAI" v-model="IdDepartStd" label="ค้นหาคณะ"
                                              @change="GetStdPSU">
                                            </v-autocomplete>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-autocomplete outlined :items="studentUniData" item-value="STUDENT_ID"
                                              item-text="fullName" v-model="IdstudentUni"
                                              label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"
                                              @change="UpdateName"></v-autocomplete>
                                          </v-list-item>
                                        </template>
                                        <template v-else-if="radioGroup == '4'">
                                          <v-list-item class="d-flex justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col cols="12" md="12">
                                                <v-row>
                                                  <v-col cols="12" md="6">
                                                    <v-text-field v-model="NameP" label="ชื่อ (name)" outlined
                                                      :error-messages="NameP == '' ? '*' : ''" :error="NameP == ''"
                                                      @keyup="UpdateName">
                                                    </v-text-field>
                                                  </v-col>
                                                  <v-col cols="12" md="6">
                                                    <v-text-field v-model="SurNameP" label="สกุล (surname)" outlined
                                                      :error-messages="SurNameP == '' ? '*' : ''"
                                                      :error="SurNameP == ''" @keyup="UpdateName">
                                                    </v-text-field>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </template>
                                        <template v-else-if="radioGroup == '5'">
                                          <v-list-item class="d-flex justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col cols="12" md="12">
                                                <v-row>
                                                  <v-col cols="12" md="6">
                                                    <v-text-field v-model="NameStd" label="ชื่อ (name)" outlined
                                                      :error-messages="NameStd == '' ? '*' : ''" :error="NameStd == ''"
                                                      @keyup="UpdateName">
                                                    </v-text-field>
                                                  </v-col>
                                                  <v-col cols="12" md="6">
                                                    <v-text-field v-model="SurNameStd" label="สกุล (surname)" outlined
                                                      :error-messages="SurNameStd == '' ? '*' : ''"
                                                      :error="SurNameStd == ''" @keyup="UpdateName">
                                                    </v-text-field>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </template>
                                      </v-col>
                                      <v-col v-if="radioGroup != '6'" cols="12" md="4">
                                        <v-autocomplete v-model="Committee_code" :items="
                                            committee_Posi.filter(
                                              (item) =>
                                                item.committee_type != '1' &&
                                                item.committee_type != '4' &&
                                                item.committee_type != '5'
                                            )
                                          " item-text="committee_des" item-value="Committee_code" label="ตำแหน่ง"
                                          outlined required
                                          :style="radioGroup == '4' || radioGroup == '5' ? { marginTop: '24px' } : {}"></v-autocomplete>
                                      </v-col>
                                      <v-col v-else cols="12" md="8">
                                        <v-autocomplete v-model="AppointmentSel" :items="Appointment" item-text="Topic"
                                          item-value="id" label="คณะกรรมการ" outlined required
                                          @change="GetAppointmentGroupFn">
                                          <template v-slot:item="{ item }">
                                            <span style="font-weight: bold;color: #364eff">{{ item.Topic }}</span><span
                                              style="color: rebeccapurple;margin-left: 15px">{{ item.dep_name }}</span>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item v-if="radioGroup != '6'">
                                    <v-row class="d-flex justify-center">
                                      <v-col class="d-flex justify-center" cols="12" sm="5">
                                        <v-text-field v-if="radioGroup == '0'" v-model="full_name" label="ชื่อ - สกุล"
                                          hide-details="auto"></v-text-field>
                                        <v-text-field v-else v-model="full_name" label="ชื่อ - สกุล" hide-details="auto"
                                          :readonly="true"></v-text-field>
                                      </v-col>
                                      <v-col class="d-flex justify-center" cols="12" sm="5">
                                        <v-text-field v-model="phone" label="เบอร์โทร"
                                          hide-details="auto"></v-text-field>
                                      </v-col>
                                      <v-col class="d-flex justify-center" cols="8" sm="2">
                                        <v-btn outlined color="primary" @click="InsertCoordinator(false)">
                                          เพิ่ม
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item class="d-flex justify-center mb-2"
                                    style="margin-top: 20px;margin-bottom: 25px">
                                    <v-data-table v-if="Coordinator.length > 0" style="width: 100%;margin-bottom: 25px"
                                      :headers="CoordinatorHeader" :items="Coordinator" :search="search"
                                      item-key="PosWork" class="elevation-1">
                                      <template v-slot:header.Name>
                                        <v-label fontSize="16px" fontWeight="bold">
                                          ชื่อ - สกุล
                                        </v-label>
                                      </template>
                                      <template v-slot:header.Committee_des>
                                        <v-label fontSize="16px" fontWeight="bold">
                                          ตำแหน่ง
                                        </v-label>
                                      </template>
                                      <template v-slot:header.Committee_type>
                                        <v-label fontSize="16px" fontWeight="bold">
                                          สถานะ
                                        </v-label>
                                      </template>
                                      <template v-slot:header.TEL>
                                        <v-label fontSize="16px" fontWeight="bold">
                                          เบอร์โทร
                                        </v-label>
                                      </template>
                                      <template v-slot:header.Lecturer>
                                        <v-label fontSize="16px" fontWeight="bold">
                                          ข้อมูลวิทยากร
                                        </v-label>
                                      </template>
                                      <template v-slot:item.Committee_type="{ item }">
                                        <span v-if="item.Committee_type == '0'"
                                          style="color: darkblue; font-weight: bold;">
                                          บุคลากรคณะแพทย์
                                        </span>
                                        <span v-else-if="item.Committee_type == '1'"
                                          style="color: green; font-weight: bold;">
                                          นักศึกษาคณะแพทย์
                                        </span>
                                        <span v-else-if="item.Committee_type == '2'"
                                          style="color: purple; font-weight: bold;">
                                          บุคลากรคณะอื่น
                                        </span>
                                        <span v-else-if="item.Committee_type == '3'"
                                          style="color: orange; font-weight: bold;">
                                          นักศึกษาคณะอื่น
                                        </span>
                                        <span v-else-if="item.Committee_type == '4'"
                                          style="color: red; font-weight: bold;">
                                          บุคคลภายนอก
                                        </span>
                                        <span v-else-if="item.Committee_type == '5'"
                                          style="color: brown; font-weight: bold;">
                                          นักศึกษาภายนอก
                                        </span>
                                        <span v-else-if="item.Committee_type == '6'"
                                          style="color: teal; font-weight: bold;">
                                          จากการแต่งตั้งคณะกรรมการ
                                        </span>
                                        <span v-else style="color: gray; font-weight: bold;">
                                          ไม่ระบุประเภท
                                        </span>
                                      </template>
                                      <template v-slot:item.Lecturer="{ item }">
                                        <v-btn text v-if="
                                            (item.Committee_code == '6' ||
                                              item.Committee_code == '23' ||
                                              item.Committee_code == '24') &&
                                              item.Committee_type == '0'
                                          " color="primary" @click="ShowDetailLecturer(item)">
                                          รายละเอียด
                                        </v-btn>
                                      </template>
                                      <template v-slot:item.action="{ item }">
                                        <v-row class="d-flex">
                                          <v-col cols="6" md="6">
                                            <v-btn outlined color="#BF360C" @click="
                                                DeleteCoordinator(
                                                  item,
                                                  item.idx
                                                )
                                              ">
                                              ลบ
                                            </v-btn>
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </v-data-table>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-alert v-if="alert2" prominent type="error" style="width: 100%">
                                      <v-row align="center" v-for="item in txtAlert2" :key="item.id">
                                        <v-col class="d-flex grow">- {{ item.Detail }}
                                        </v-col>
                                      </v-row>
                                    </v-alert>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-btn outlined color="green" class="darken-3" @click="OpenIDCheckIn"
                        v-if="Coordinator.length > 0">ลงบันทึกข้อมูลการลา
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(2)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(3)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="4" editable class="font-weight-bold" v-if="ProjectPlan != null">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">รายละเอียดค่าใช้จ่าย / การเบิกจ่าย
                      (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>รายละเอียดค่าใช้จ่าย / การเบิกจ่าย</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 4 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 4 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">รายละเอียดค่าใช้จ่าย / การเบิกจ่าย</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="4" v-if="ProjectPlan != null">
                  <v-list>
                    <v-list-item-title class="headline mb-1"><span>รายละเอียดค่าใช้จ่าย / การเบิกจ่าย</span>
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-radio-group v-model="TypeBuggetProject" row @change="ChangeTypeBuggetProject">
                        <v-radio label="กรอกรายละเอียดค่าใช้จ่าย" value="1"></v-radio>
                        <v-radio label="ประวัติรายละเอียดค่าใช้จ่าย" value="2"></v-radio>
                        <v-radio label="ประวัติการเบิกจ่าย (คณะ)" value="3"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <template v-if="TypeBuggetProject == '1'">
                      <v-list-item class="text-center">
                        <v-card color="#EFEBE9" style="width: 100%; border-radius: 12px;" elevation="3">
                          <v-card-title class="pb-2">
                            <v-icon left color="primary">mdi-plus-circle</v-icon>
                            <span class="font-weight-bold">เพิ่มรายการค่าใช้จ่าย</span>
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-card-text class="pa-6">
                            <v-list-item class="px-0">
                              <v-row class="justify-center">
                                <v-col cols="12" md="7">
                                  <v-autocomplete v-model="expenseCost" :items="expense_Data" item-text="cost_desc"
                                    item-value="cost_id" label="รายการค่าใช้จ่าย" clearable outlined
                                    prepend-inner-icon="mdi-format-list-bulleted" class="mb-2"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="5">
                                  <v-text-field v-model="Rm" outlined label="รายละเอียด" prepend-inner-icon="mdi-text"
                                    :error="expenseCost != null && Rm == ''" :error-messages="
                                      expenseCost != null && Rm == ''
                                        ? 'รายละเอียด (ห้ามว่าง)'
                                        : ''
                                    " class="mb-2"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>

                            <v-list-item class="px-0">
                              <v-row class="justify-center">
                                <v-col cols="12" md="4">
                                  <v-text-field @keyup="SumMoneyFuc" v-model="ReqMoney" outlined label="อัตรา (บาท)"
                                    type="number" prepend-inner-icon="mdi-currency-usd" :error="
                                      TypeProject == '1' &&
                                        expenseCost != null &&
                                        ReqMoney == ''
                                    " :error-messages="
                                      TypeProject == '1' &&
                                      expenseCost != null &&
                                      ReqMoney == ''
                                        ? 'อัตรา (บาท) (ห้ามว่าง)'
                                        : ''
                                    " class="mb-2"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-text-field @keyup="SumMoneyFuc" v-model="ReqPerson" outlined label="อัตรา (คน)"
                                    type="number" prepend-inner-icon="mdi-account-multiple" :error="
                                      TypeProject == '1' &&
                                        expenseCost != null &&
                                        (ReqPerson == '' ||
                                          parseInt(ReqPerson) <= 0)
                                    " :error-messages="
                                      TypeProject == '1' &&
                                      expenseCost != null &&
                                      (ReqPerson == '' ||
                                        parseInt(ReqPerson) <= 0)
                                        ? 'อัตรา (คน) (ห้ามว่าง)'
                                        : ''
                                    " class="mb-2"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-text-field v-model="MoneySummary" type="number" outlined
                                    label="จำนวนเงินรวม (ทั้งสิ้น)" prepend-inner-icon="mdi-calculator" :error="
                                      expenseCost != null && MoneySummary == ''
                                    " :error-messages="
                                      expenseCost != null && MoneySummary == ''
                                        ? 'จำนวนเงินรวม (ทั้งสิ้น) (ห้ามว่าง)'
                                        : ''
                                    " class="mb-2"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>

                            <div class="d-flex justify-center mt-4">
                              <v-btn color="primary" elevation="2" large class="font-weight-bold px-8 py-3"
                                style="border-radius: 8px;" @click="AddExpenseData">
                                <v-icon left>mdi-plus</v-icon>
                                เพิ่มรายการ
                              </v-btn>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-list-item>
                      <v-list-item class="mt-4">
                        <template v-if="budgetData.length > 0">
                          <div class="d-flex flex-column justify-stretch" style="width: 100%">
                            <v-data-table :headers="budgetHeader" :items="budgetData" style="border: 1px solid black">
                              <template v-slot:header.Custom_Expense_des>
                                <span style="font-weight: bold;font-size: 16px">รายการ</span>
                              </template>
                              <template v-slot:header.SumMoney>
                                <span style="font-weight: bold;font-size: 16px">จำนวนเงินรวม (ทั้งสิ้น)</span>
                              </template>
                              <template v-slot:item.Custom_Expense_des="props">
                                <div v-html="props.item.Custom_Expense_des"></div>
                              </template>
                              <template v-slot:item.SumMoney="props">
                                <p style="font-weight: bold">
                                  {{ props.item.SumMoney | currency }}
                                </p>
                              </template>
                              <template v-slot:item.ReqMoney="props">
                                <v-edit-dialog :return-value.sync="props.item.ReqMoney" @save="save" @cancel="cancel"
                                  @open="open" @close="close">
                                  {{ props.item.ReqMoney }}
                                  <template v-slot:input>
                                    <v-text-field v-model="props.item.ReqMoney" label="จำนวนเงิน" single-line
                                      counter></v-text-field>
                                  </template>
                                </v-edit-dialog>
                              </template>
                              <template v-slot:item.Rm="props">
                                <v-edit-dialog :return-value.sync="props.item.Rm" @save="save" @cancel="cancel"
                                  @open="open" @close="close">
                                  <div>{{ props.item.Rm }}</div>
                                  <template v-slot:input>
                                    <v-text-field v-model="props.item.Rm" label="หมายเหตุ" single-line counter
                                      autofocus></v-text-field>
                                  </template>
                                </v-edit-dialog>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <div class="d-flex justify-center">
                                  <!-- ปุ่มแก้ไข -->
                                  <v-btn class="mr-2" color="primary" outlined @click="showDialogEditExpense(item)">
                                    แก้ไข
                                  </v-btn>
                                  <v-btn color="red" outlined @click="DelExpense(item)">
                                    ลบ
                                  </v-btn>
                                </div>
                              </template>
                              <!-- <template v-slot:footer>
                                <template v-if="BudgetRequest > 0">
                                  <div align="right" style="margin-top: 15px">
                                    <span
                                      style="font-weight: bold;color: #364eff"
                                      >งบประมาณที่ขอ :
                                      {{ BudgetRequest | currency }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                      style="font-weight: bold;color: #ff6d81"
                                      >ค่าใช้จ่าย :
                                      {{ Expense | currency }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                      style="font-weight: bold;color: #42b983"
                                      >คงเหลือ :
                                      {{
                                        (BudgetRequest - Expense) | currency
                                      }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                      v-if="Expense > BudgetRequest"
                                      style="font-weight: bold;color: darkred"
                                      >เกินงบประมาณที่ขอ :
                                      {{
                                        (Expense > BudgetRequest
                                          ? Expense - BudgetRequest
                                          : 0) | currency
                                      }}</span
                                    >
                                  </div>
                                </template>
                              </template> -->
                            </v-data-table>
                          </div>
                        </template>
                        <template v-else>
                          <p
                            style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                            ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย
                          </p>
                        </template>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center mt-4" v-if="budgetData.length > 0 && IsLog == '0'">
                        <v-btn x-large outlined color="primary" class="mt-2 font-weight-bold elevation-2"
                          style="padding: 30px 40px; border-width: 2px; border-radius: 12px;"
                          ref="btnSaveHistoryExpense" @click="confirmSaveHistoryExpensse">
                          <v-icon left>mdi-content-save</v-icon>
                          บันทึกข้อมูลประวัติค่าใช้จ่าย
                        </v-btn>
                      </v-list-item>
                    </template>
                    <template v-else-if="TypeBuggetProject == '2'">
                      <v-list-item class="mt-4">
                        <template v-if="budgetHistoryData.length > 0">
                          <div class="d-flex flex-column justify-stretch" style="width: 100%">
                            <v-data-table :headers="budgetHistotyHeader" :items="budgetHistoryData"
                              style="border: 1px solid black">
                              <template v-slot:item.SumMoney="{ item }">
                                <p style="font-weight: bold">
                                  {{ item.SumMoney | currency }}
                                </p>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <div class="d-flex justify-center">
                                  <v-btn class="mr-2" color="primary" outlined @click="showHistoryExpense(item)">
                                    แสดงรายละเอียด
                                  </v-btn>
                                  <v-btn color="red" outlined @click="DeleteHistoryExpense(item)" v-if=" IsLog == '0'">
                                    ลบ
                                  </v-btn>
                                </div>
                              </template>
                              <template v-slot:footer>
                                <v-divider class="mt-5"></v-divider>
                                <template v-if="BudgetRequest > 0">
                                  <div align="right" style="margin-top: 15px">
                                    <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ :
                                      {{ BudgetRequest | currency }}</span>
                                  </div>
                                  <div align="right">
                                    <span style="font-weight: bold;color: #ff6d81">สรุปรายการค่าใช้จ่าย :
                                      {{ ExpenseGroup | currency }}</span>
                                  </div>
                                  <div align="right">
                                    <span style="font-weight: bold;color: #42b983">คงเหลือ :
                                      {{
                                      (BudgetRequest - ExpenseGroup) | currency
                                      }}</span>
                                  </div>
                                  <div align="right">
                                    <span v-if="ExpenseGroup > BudgetRequest"
                                      style="font-weight: bold;color: darkred">เกินงบประมาณที่ขอ :
                                      {{
                                      (ExpenseGroup > BudgetRequest
                                      ? ExpenseGroup - BudgetRequest
                                      : 0) | currency
                                      }}</span>
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </template>
                        <template v-else>
                          <p
                            style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                            ไม่พบข้อมูลรายละเอียดประวัติค่าใช้จ่าย
                          </p>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-else-if="TypeBuggetProject == '3'">
                      <v-list-item class="mt-4">
                        <template v-if="expenseRealData.length > 0">
                          <div class="d-flex flex-column justify-stretch" style="width: 100%">
                            <v-data-table :headers="expenseRealHeader" :items="expenseRealData"
                              style="border: 1px solid black">
                              <template v-slot:item.Mon_total="{ item }">
                                <p style="font-weight: bold">
                                  {{ item.Mon_total | currency }}
                                </p>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <div class="d-flex justify-center">
                                  <v-btn class="mr-2" color="primary" outlined @click="showHistoryExpenseReal(item)">
                                    แสดงรายละเอียด
                                  </v-btn>
                                </div>
                              </template>
                              <template v-slot:footer>
                                <v-divider class="mt-5"></v-divider>
                                <template v-if="ExpenseRealSummay > 0">
                                  <div align="right">
                                    <span style="font-weight: bold;color: #ff6d81">สรุปรายการเบิกจ่าย :
                                      {{ ExpenseRealSummay | currency }}</span>
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </template>
                        <template v-else>
                          <p
                            style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                            ไม่พบข้อมูลรายละเอียดการเบิกจ่าย
                          </p>
                        </template>
                      </v-list-item>
                    </template>
                    <!--<v-list-item>
                                        <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12"
                                                   sm="12">
                                                <v-radio-group v-model="radioGroup2" row>
                                                    <v-radio
                                                            label="เบิก/จ่าย โครงการ"
                                                            value="0"
                                                    ></v-radio>
                                                    <v-radio
                                                            label="เบิก/จ่าย บุคลากร"
                                                            value="1"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-row class="justify-center">
                                            <v-col
                                                    cols="12"
                                                    md="8">
                                                <v-row>
                                                    <v-col
                                                            cols="12"
                                                            md="4">
                                                        <v-autocomplete
                                                                v-if="radioGroup2 == '1'"
                                                                clearable
                                                                v-model="peridCost"
                                                                :items="staffData"
                                                                item-text="full_Name"
                                                                item-value="perid"
                                                                label="รายชื่อบุคลากรในคณะ"
                                                                :rules="[rules.required]"
                                                                outlined
                                                                @change="UpdateName(perid)"
                                                        ></v-autocomplete>
                                                        <v-autocomplete
                                                                clearable
                                                                v-model="DepCost"
                                                                :items="depart"
                                                                item-text="dep_name"
                                                                item-value="dep_id"
                                                                label="หน่วยงานสนับสนุนค่าใช้จ่าย"
                                                                :rules="[rules.required]"
                                                                outlined
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col
                                                            cols="12"
                                                            md="8">
                                                        <v-card>
                                                            <v-card-title>
                                                                รายละเอียดการส่งเบิกจ่ายเงินบุคลากร
                                                            </v-card-title>
                                                            <v-list-item>
                                                                <v-row class="justify-center">
                                                                    <v-col
                                                                            cols="12"
                                                                            md="6">
                                                                        <v-autocomplete
                                                                                v-model="expenseCost"
                                                                                :items="expense_Data"
                                                                                item-text="Expense_des"
                                                                                item-value="Expense_id"
                                                                                label="รายการค่าใช้จ่าย"
                                                                                :rules="[rules.required]"
                                                                                outlined
                                                                        ></v-autocomplete>
                                                                    </v-col>
                                                                    <v-col
                                                                            cols="6"
                                                                            md="3">
                                                                        <v-text-field
                                                                                v-model="moneyCost"
                                                                                outlined
                                                                                label="จำนวนเงิน"
                                                                                :rules="[rules.required]"
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                    <v-col
                                                                            class="d-flex justify-center"
                                                                            cols="6"
                                                                            md="3">
                                                                        <v-btn
                                                                                style="height: 55px"
                                                                                outlined
                                                                                color="primary"
                                                                                @click="AddExpense"
                                                                        >
                                                                            บันทึก
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-list-item>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-row class="justify-center">
                                            <v-col
                                                    cols="12"
                                                    md="8">

                                                <template>
                                                    <v-card>
                                                        <v-tabs
                                                                v-model="tab"
                                                                background-color="transparent"
                                                                color="basil"
                                                                grow
                                                        >
                                                            <v-tab>
                                                                <span style="font-weight: bold;font-size: 16px;color: #ff6d81">เบิก/จ่ายเงินโครงการ</span>
                                                            </v-tab>
                                                            <v-tab>
                                                                <span style="font-weight: bold;font-size: 16px;color: #ff6d81">เบิก/จ่ายเงินบุคคล</span>
                                                            </v-tab>
                                                        </v-tabs>

                                                        <v-tabs-items v-model="tab">
                                                            <v-tab-item
                                                            >
                                                                <v-card>
                                                                    <v-card-title
                                                                            style="background-color: antiquewhite">
                                                                        ข้อมูลชี้แจงรายละเอียดการ เบิก/จ่าย โครงการ
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        <v-row justify="center">
                                                                            <v-expansion-panels
                                                                                    popout
                                                                                    inset
                                                                                    multiple
                                                                                    focusable
                                                                                    hover
                                                                            >
                                                                                <v-expansion-panel
                                                                                        v-for="(item,i) in expense_p_DataForSubmit"
                                                                                        :key="i"
                                                                                >
                                                                                    <v-expansion-panel-header>
                                                                                        <div>
                                                                                            <span style="color: darkblue;font-weight: bold">รายละเอียดการเบิกจ่ายเงินโครงการ</span>
                                                                                        </div>
                                                                                        รวมจำนวนเงิน
                                                                                        <div>
                                                                                            <span style="color: darkblue;font-weight: bold;padding-left: 10px;padding-right: 10px">( {{item.SumCost}} )</span>
                                                                                            บาท
                                                                                        </div>
                                                                                        <v-btn
                                                                                                text
                                                                                                color="red"
                                                                                                @click="DeleteExpense_p(item)"
                                                                                        >
                                                                                            ลบ
                                                                                        </v-btn>
                                                                                    </v-expansion-panel-header>
                                                                                    <v-expansion-panel-content>
                                                                                        <v-list-item
                                                                                                v-for="(expense_i,k) in item.Expense_data"
                                                                                                :key="k"
                                                                                        >
                                                                          <span style="font-weight: bold">
                                                                              {{k + 1}} .
                                                                          </span>
                                                                                            <span style="padding-left: 10px;font-weight: bold">
                                                                                {{expense_i.Expense_des}} : {{expense_i.ReqMoney}} บาท
                                                                            </span>
                                                                                            <span style="margin-left: 15px;font-weight: bold;color: brown"
                                                                                                  v-if="expense_i.Dep_Cost_Name != ''">
                                                                                สนับสนุนโดย {{expense_i.Dep_Cost_Name}}
                                                                            </span>
                                                                                        </v-list-item>
                                                                                    </v-expansion-panel-content>
                                                                                </v-expansion-panel>
                                                                            </v-expansion-panels>
                                                                        </v-row>
                                                                    </v-card-text>
                                                                    <v-card-actions
                                                                            v-if="expense_p_DataForSubmit.length > 0 && BudgetRequest != ''">
                                                                        <v-list-item class="justify-end">
                                                                            <span style="color: black;font-weight: bold">งบประมาณที่ขอ: {{BudgetRequest}} บาท </span>
                                                                            <span style="color: black;font-weight: bold;margin-left: 10px">งบเบิก/จ่าย: {{expenseCostSum}} บาท </span>
                                                                            <span style="color: black;font-weight: bold;margin-left: 10px">คงเหลือ {{parseInt(BudgetRequest) - parseInt(expenseCostSum)}} บาท </span>
                                                                        </v-list-item>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-tab-item>
                                                            <v-tab-item
                                                            >
                                                                <v-card>
                                                                    <v-card-title
                                                                            style="background-color: antiquewhite">
                                                                        ข้อมูลรายชื่อบุคลากรชี้แจงรายละเอียด เบิก/จ่าย
                                                                        โครงการ
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        <v-row justify="center">
                                                                            <v-expansion-panels
                                                                                    popout
                                                                                    inset
                                                                                    multiple
                                                                                    focusable
                                                                                    hover
                                                                            >
                                                                                <v-expansion-panel
                                                                                        v-for="(item,i) in expense_DataForSubmit"
                                                                                        :key="i"
                                                                                >
                                                                                    <v-expansion-panel-header>
                                                                                        <div>
                                                                                            <span style="color: darkblue;font-weight: bold">{{item.full_Name}}</span>
                                                                                            สังกัด
                                                                                            <span style="color: hotpink;font-weight: bold">{{item.Dep_name}}</span>
                                                                                        </div>
                                                                                        รวมจำนวนเงิน
                                                                                        <div>
                                                                                            <span style="color: darkblue;font-weight: bold;padding-left: 10px;padding-right: 10px">( {{item.SumCost}} )</span>
                                                                                            บาท
                                                                                        </div>
                                                                                        <v-btn
                                                                                                text
                                                                                                color="red"
                                                                                                @click="DeleteExpense(item)"
                                                                                        >
                                                                                            ลบ
                                                                                        </v-btn>
                                                                                    </v-expansion-panel-header>
                                                                                    <v-expansion-panel-content>
                                                                                        <v-list-item
                                                                                                v-for="(expense_i,k) in item.Expense_data"
                                                                                                :key="k"
                                                                                        >
                                                                          <span style="font-weight: bold">
                                                                              {{k + 1}} .
                                                                          </span>
                                                                                            <span style="padding-left: 10px;font-weight: bold">
                                                                                {{expense_i.Expense_des}} : {{expense_i.ReqMoney}} บาท
                                                                            </span>
                                                                                            <span style="margin-left: 15px;font-weight: bold;color: brown"
                                                                                                  v-if="expense_i.Dep_Cost_Name != ''">
                                                                                สนับสนุนโดย {{expense_i.Dep_Cost_Name}}
                                                                            </span>
                                                                                        </v-list-item>
                                                                                    </v-expansion-panel-content>
                                                                                </v-expansion-panel>
                                                                            </v-expansion-panels>
                                                                        </v-row>
                                                                    </v-card-text>
                                                                    <v-card-actions
                                                                            v-if="expense_DataForSubmit.length > 0 && BudgetRequest != ''">
                                                                        <v-list-item class="justify-end">
                                                                            <span style="color: black;font-weight: bold">งบประมาณที่ขอ: {{BudgetRequest}} บาท </span>
                                                                            <span style="color: black;font-weight: bold;margin-left: 10px">งบเบิก/จ่าย: {{expenseCostSum}} บาท </span>
                                                                            <span style="color: black;font-weight: bold;margin-left: 10px">คงเหลือ {{parseInt(BudgetRequest) - parseInt(expenseCostSum)}} บาท </span>
                                                                        </v-list-item>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-tab-item>
                                                        </v-tabs-items>
                                                    </v-card>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>-->
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(3)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(4)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="5" editable v-if="!roundNeed && ProjectPlan != null" class="font-weight-bold">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วม
                      (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วม</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 5 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 5 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วม</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="5" v-if="!roundNeed && ProjectPlan != null">
                  <v-list>
                    <!--                    <v-list-item-title class="headline mb-1">
                                          ข้อมูลเพิ่มเติมประกอบหน้ารับสมัคร
                                        </v-list-item-title>
                                        <v-list-item>
                                          <v-row>
                                            <v-col
                                              cols="12"
                                              md="6">
                                              <v-textarea label="รายละเอียดประกอบ (แสดงหน้ารับสมัคร)" outlined v-model="Rm3"></v-textarea>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="6">
                                              <v-list-item>
                                                <v-file-input
                                                    v-model="filesRegister"
                                                    color="deep-purple accent-4"
                                                    counter
                                                    label="แนบไฟล์ประกอบ (แสดงหน้ารับสมัคร)"
                                                    multiple
                                                    placeholder="เลือกไฟล์"
                                                    prepend-icon="mdi-paperclip"
                                                    outlined
                                                    :show-size="1000"
                                                    @change="FileRegisterSelect"
                                                >
                                                  <template v-slot:selection="{ index, text }">
                                                    <v-chip
                                                        v-if="index < 5"
                                                        color="deep-purple accent-4"
                                                        dark
                                                        label
                                                        small
                                                    >
                                                      {{ text }}
                                                    </v-chip>

                                                    <span
                                                        v-else-if="index === 5"
                                                        class="overline grey&#45;&#45;text text&#45;&#45;darken-3 mx-2"
                                                    >
                                                    +{{ filesRegister.length - 2 }} File(s)
                                                  </span>
                                                  </template>
                                                </v-file-input>
                                              </v-list-item>
                                              <v-list-item>
                                                <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">**สนับสนุนไฟล์
                                                  PDF เท่านั้น</p>
                                              </v-list-item>
                                              <v-list-item>
                                                <v-alert
                                                    v-if="alertFileRegister"
                                                    prominent
                                                    type="error"
                                                >
                                                  <v-row align="center" v-for="item in txtFileRegisterAlert" :key="item.id">
                                                    <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                                  </v-row>
                                                </v-alert>
                                              </v-list-item>
                                              <v-list-item v-if="FileProjectRegister.length > 0">
                                                <template>
                                                  <v-row>
                                                    <v-col cols="12">
                                                      <v-card>
                                                        <v-card-title>
                                                          ไฟล์ภาพประกอบ
                                                        </v-card-title>
                                                        <v-container fluid>
                                                          <v-row>
                                                            <v-col
                                                                v-for="(file_i, index) in FileProjectRegister"
                                                                :key="index"
                                                                class="d-flex child-flex"
                                                                cols="12"
                                                                md="4"
                                                            >
                                                              <v-card flat tile class="d-flex">
                                                                <v-img
                                                                    v-if="file_i.type == 'image'"
                                                                    :src="file_i.src"
                                                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                                    aspect-ratio="1"
                                                                    class="grey lighten-2"
                                                                >
                                                                  <template v-slot:placeholder>
                                                                    <v-row
                                                                        class="fill-height ma-0"
                                                                        align="center"
                                                                        justify="center"
                                                                    >
                                                                      <v-progress-circular
                                                                          indeterminate
                                                                          color="grey lighten-5"></v-progress-circular>
                                                                    </v-row>
                                                                  </template>
                                                                </v-img>
                                                                <v-img
                                                                    v-if="file_i.type == 'pdf'"
                                                                    src="../../assets/Image/pdf.png"
                                                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                                    aspect-ratio="1"
                                                                    class="grey lighten-2"
                                                                >
                                                                  <template v-slot:placeholder>
                                                                    <v-row
                                                                        class="fill-height ma-0"
                                                                        align="center"
                                                                        justify="center"
                                                                    >
                                                                      <v-progress-circular
                                                                          indeterminate
                                                                          color="grey lighten-5"></v-progress-circular>
                                                                    </v-row>
                                                                  </template>
                                                                </v-img>
                                                                <v-card-actions>
                                                                  <v-btn text
                                                                         @click="ShowData(file_i.src)">
                                                                                                            <span style="color: indigo">
                                                                                                                เรียกดู
                                                                                                            </span>
                                                                  </v-btn>
                                                                </v-card-actions>
                                                              </v-card>
                                                            </v-col>
                                                          </v-row>
                                                        </v-container>
                                                      </v-card>
                                                    </v-col>
                                                  </v-row>
                                                </template>
                                              </v-list-item>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-divider></v-divider>-->
                    <v-list-item-title class="headline mb-1">
                      กลุ่มเป้าหมาย
                    </v-list-item-title>
                    <v-list-item>
                      <v-row class="d-flex">
                        <v-col class="d-flex" cols="12" sm="12">
                          <v-radio-group v-model="targetType" row>
                            <v-radio class="font-weight-bold" label="บุคลากร" value="1"></v-radio>
                            <v-radio class="font-weight-bold" label="นักศึกษา" value="2"></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <template v-if="targetType == '1'">
                      <v-list-item>
                        <v-row class="d-flex">
                          <v-col cols="12" md="4">
                            <v-autocomplete outlined v-model="posiCondi" :items="positions" item-text="PosName"
                              item-value="PosCode" label="ตำแหน่ง"></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row class="d-flex">
                          <v-col cols="6" md="2">
                            <v-text-field outlined type="number" v-model="workAgeStart_Condi" :error="
                                workAgeStart_Condi.length > 2 ||
                                  parseInt(workAgeStart_Condi) < 0
                              " :error-messages="
                                workAgeStart_Condi.length > 2
                                  ? 'จำนวนห้ามเกิน 2 หลัก'
                                  : parseInt(workAgeStart_Condi) < 0
                                  ? 'ห้ามใส่จำนวนติด - '
                                  : ''
                              " label="อายุงานเริ่มต้น" required></v-text-field>
                          </v-col>
                          <v-col cols="6" md="2">
                            <v-text-field outlined type="number" v-model="workAgeEnd_Condi" :error="
                                workAgeEnd_Condi.length > 2 ||
                                  parseInt(workAgeEnd_Condi) < 0
                              " :error-messages="
                                workAgeEnd_Condi.length > 2
                                  ? 'จำนวนห้ามเกิน 2 หลัก'
                                  : parseInt(workAgeEnd_Condi) < 0
                                  ? 'ห้ามใส่จำนวนติด - '
                                  : ''
                              " label="อายุงานสิ้นสุด" required></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <v-list-item>
                        <v-row class="d-flex">
                          <v-col cols="12" md="4">
                            <v-autocomplete outlined disabled label="ชั้นปี"></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </template>
                    <v-list-item class="d-flex">
                      <v-btn outlined color="primary" @click="DataCondiFunc">
                        เพิ่ม
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-data-table :headers="dataHeadersCondi" :items="DataCondi" :search="search" item-key="PosWork"
                        class="elevation-1 mt-4" v-if="DataCondi.length > 0">
                        <template v-slot:header.PosName>
                          <v-label fontSize="16px" fontWeight="bold">
                            เงื่อนไขตำแหน่ง, อายุงาน
                          </v-label>
                        </template>
                        <template v-slot:header.Level>
                          <v-label fontSize="16px" fontWeight="bold">
                            ระดับ
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeStart>
                          <v-label fontSize="16px" fontWeight="bold">
                            อายุงานเริ่มต้น
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeEnd>
                          <v-label fontSize="16px" fontWeight="bold">
                            อายุงานสิ้นสุด
                          </v-label>
                        </template>
                        <template v-slot:item.PosName="{ item }">
                          <v-label>
                            {{ item.PosName }}
                          </v-label>
                        </template>
                        <template v-slot:item.Level="{ item }">
                          <v-label>
                            {{ item.Level }}
                          </v-label>
                        </template>
                        <template v-slot:item.workAgeStart="{ item }">
                          <v-label> {{ item.workAgeStart }} (ปี)</v-label>
                        </template>
                        <template v-slot:item.workAgeEnd="{ item }">
                          <v-label> {{ item.workAgeEnd }} (ปี)</v-label>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-row class="d-flex">
                            <v-col cols="6" md="6">
                              <v-btn outlined color="#BF360C" @click="DeleteDataCondi(item)">
                                ลบ
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-list-item>
                    <v-divider class="mt-6" style="border: 1px solid"></v-divider>
                    <v-list-item-title class="headline mt-6">
                      เงื่อนไขการเข้าร่วม
                    </v-list-item-title>
                    <v-list-item>
                      <v-list-item-subtitle>
                        <h3 class="font-weight-bold">สมัครเข้าร่วมโครงการ</h3>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-radio-group row v-model="ChooseTypRegis">
                        <v-radio class="font-weight-bold" label="อนุญาตสมัครเข้าร่วมโครงการ" value="0"></v-radio>
                        <v-radio class="font-weight-bold" label="ไม่อนุญาตสมัครเข้าร่วมโครงการ" value="1"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-list-item class="d-flex" v-if="ChooseTypRegis == '0'">
                      <v-radio-group row v-model="ChooseTypRegis2">
                        <v-radio class="font-weight-bold" label="ทั้งหมด" value="0" color="green"></v-radio>
                        <v-radio class="font-weight-bold" label="หน่วยงาน" value="1" color="indigo"></v-radio>
                        <v-radio class="font-weight-bold" label="บุคลากรทั่วไป" value="2" color="yellow"></v-radio>
                        <v-radio class="font-weight-bold" label="นักศึกษา" value="3" color="pink"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-list-item class="d-flex" v-if="ChooseTypRegis == '0'">
                      <v-row class="d-flex">
                        <v-col md="2" cols="12">
                          <template>
                            <v-menu v-model="showDateRegStart" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="dateRegStart" label="วันที่เปิดรับสมัคร" hint="YYYY/MM/DD"
                                  persistent-hint readonly :error="dateRegStart == ''" :error-messages="
                                    dateRegStart == ''
                                      ? 'วันที่เปิดรับสมัคร ห้ามว่าง'
                                      : ''
                                  " v-on="on"></v-text-field>
                              </template>
                              <v-date-picker locale="th" v-model="dateRegStart" no-title
                                @input="showDateRegStart = false"></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>
                        <v-col md="2" cols="12">
                          <template>
                            <v-menu v-model="showDateRegEnd" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="dateRegEnd" label="วันที่ปิดรับสมัคร" hint="YYYY/MM/DD"
                                  persistent-hint readonly :error="dateRegEnd == ''" :error-messages="
                                    dateRegEnd == ''
                                      ? 'วันที่ปิดรับสมัคร ห้ามว่าง'
                                      : ''
                                  " v-on="on"></v-text-field>
                              </template>
                              <v-date-picker locale="th" v-model="dateRegEnd" no-title
                                @input="showDateRegEnd = false"></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider style="border: 1px solid"></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        <h3 class="font-weight-bold">การลงทะเบียนเข้าร่วม</h3>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-radio-group row v-model="ChooseTypRegis3">
                        <v-radio label="จำกัดการลงทะเบียนเข้าร่วมตามรายชื่อผู้เข้าร่วม" value="1"
                          class="font-weight-bold"></v-radio>
                        <v-radio label="ไม่จำกัดการลงทะเบียนเข้าร่วมตามรายชื่อผู้เข้าร่วม" value="0"
                          class="font-weight-bold"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-divider style="border: 1px solid"></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        <h3 class="font-weight-bold">ผู้เข้าร่วมโครงการ</h3>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="d-flex">
                        <v-col md="3" cols="12">
                          <v-text-field :disabled="ChkJoinPerson" outlined label="จำนวนผู้เข้าร่วมโครงการ / คน"
                            type="number" v-model="ProjectQuotaCount" :error="
                              !ChkJoinPerson &&
                                (ProjectQuotaCount == '' ||
                                  parseInt(ProjectQuotaCount) == 0)
                            " :error-messages="
                              !ChkJoinPerson &&
                              (ProjectQuotaCount == '' ||
                                parseInt(ProjectQuotaCount) == 0)
                                ? 'จำนวนผู้เข้าร่วมโครงการ / คน (ห้ามว่าง) หรือมีค่ามากกว่า 0'
                                : ''
                            "></v-text-field>
                        </v-col>
                        <v-col md="3" cols="12">
                          <v-checkbox label="ไม่จำกัดผู้เข้าร่วม" color="primary" v-model="ChkJoinPerson"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider style="border: 1px solid"></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        <h3 class="font-weight-bold">
                          โควตาหน่วยงานที่เข้าร่วม
                        </h3>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-radio-group row v-model="ChooseTypeDep">
                        <v-radio class="font-weight-bold" label="หน่วยงาน/ภาควิชา" value="0"></v-radio>
                        <v-radio class="font-weight-bold" label="กลุ่มหน่วยงาน/กลุ่มภาควิชา" value="1"></v-radio>
                        <v-radio class="font-weight-bold" label="นักศึกษา" value="2"></v-radio>
                        <v-radio class="font-weight-bold" label="กลุ่มเทมเพลต (ที่สร้างขึ้น)" value="3"></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="d-flex">
                        <v-col cols="12" md="4">
                          <v-autocomplete v-model="DepQuotaSelect" label="หน่วยงาน/ภาควิชา" :items="depart"
                            item-text="dep_name" item-value="dep_id" persistent-hint outlined
                            v-if="ChooseTypeDep == '0'" clearable>
                          </v-autocomplete>
                          <v-autocomplete v-model="DepQuotaSelect" label="กลุ่มหน่วยงาน/กลุ่มภาควิชา"
                            :items="groupDepart" item-text="dep_name" item-value="dep_group_id" persistent-hint outlined
                            v-else-if="ChooseTypeDep == '1'" clearable>
                          </v-autocomplete>
                          <v-autocomplete v-model="DepQuotaSelect" label="ชั้นปี" persistent-hint outlined
                            v-else-if="ChooseTypeDep == '2'" clearable disabled>
                          </v-autocomplete>
                          <v-autocomplete v-model="DepQuotaSelect" label="กลุ่มเทมเพลต" :items="GroupQuotaMS"
                            item-text="group_name" item-value="id" persistent-hint outlined v-else clearable>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="2">
                          <v-text-field outlined type="number" v-model="DepQuotaCount" label="จำนวน / คน" required
                            v-if="ChooseTypeDep != '3'"></v-text-field>
                          <v-btn @click="ShowGroupDepDetail" outlined color="primary" v-else>
                            รายละเอียด
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-btn outlined color="primary" @click="AddDepQuotaData">
                        เพิ่ม
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="d-flex">
                      <v-data-table :headers="DepQuotaHeader" :items="DepQuotaData" :search="searchDepQuota"
                        class="elevation-1 mt-4" v-if="DepQuotaData.length > 0">
                        <template v-slot:header.type>
                          <v-label fontSize="16px" fontWeight="bold">
                            ประเภท
                          </v-label>
                        </template>
                        <template v-slot:header.dep_name>
                          <v-label fontSize="16px" fontWeight="bold">
                            ภาควิชา/หน่วยงาน
                          </v-label>
                        </template>
                        <template v-slot:header.count>
                          <v-label fontSize="16px" fontWeight="bold">
                            จำนวน/คน
                          </v-label>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-row class="d-flex">
                            <v-col cols="6" md="6">
                              <v-btn outlined color="#BF360C" @click="DeleteDepQuotaCondi(item)">
                                ลบ
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-slot:footer>
                          <template>
                            <div align="center" style="margin-top: 15px">
                              <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน :
                                {{ ProjectQuotaDepCount }} คน</span>
                            </div>
                            <div align="center" v-if="
                                !ChkJoinPerson &&
                                  parseInt(ProjectQuotaCount) > 0
                              ">
                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป :
                                {{
                                parseInt(ProjectQuotaCount) -
                                parseInt(ProjectQuotaDepCount)
                                }}
                                คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                            </div>
                            <div align="center" v-if="
                                !ChkJoinPerson &&
                                  parseInt(ProjectQuotaCount) > 0
                              ">
                              <span style="font-weight: bold;color: #42b983">รวม : {{ ProjectQuotaCount }} คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                            </div>
                          </template>
                        </template>
                      </v-data-table>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(4)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(5)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="6" editable v-if="!roundNeed && ProjectPlan != null" class="font-weight-bold">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">ผู้เข้าร่วม (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>ผู้เข้าร่วม</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 6 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 6 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">เพิ่มผู้เข้าร่วม</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="6" v-if="!roundNeed && ProjectPlan != null">
                  <v-list>
                    <v-list-item>
                      <v-row>
                        <v-col cols="12" md="12">
                          <template v-if="false">
                            <div align="center" class="d-flex d-md-none justify-center">
                              <download-excel class="btn btn-default mr-4" :data="json_data_export"
                                :fields="json_fields_export" worksheet="รายชื่อผู้เข้าร่วม" :name="
                                  'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'
                                ">
                                <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                  Export รายชื่อผู้เข้าร่วม
                                </v-btn>
                              </download-excel>
                            </div>
                            <div align="center" class="d-flex d-md-none justify-center" v-if="false">
                              <v-btn class="mt-4" outlined color="#009688" @click="importExcelData('1')">
                                Import ข้อมูลบุคลากร
                              </v-btn>
                            </div>
                            <div align="center" class="d-flex d-md-none justify-center" v-if="false">
                              <v-btn class="mt-4" outlined color="#009688" @click="importExcelData('2')">
                                Import ข้อมูลนักศึกษาคณะแพทย์
                              </v-btn>
                            </div>
                            <div align="center" class="d-flex d-md-none justify-center" v-if="false">
                              <v-btn v-if="false" class="mt-4" outlined color="#009688" @click="importExcelData('3')">
                                Import ข้อมูลบุคคลภายนอก
                              </v-btn>
                            </div>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="4" class="d-flex justify-center">
                                  <v-btn outlined color="#009688" @click="importExcelData('1')">
                                    Import ข้อมูลบุคลากร
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="d-flex justify-center">
                                  <v-btn class="ml-4" outlined color="#009688" @click="importExcelData('2')">
                                    Import ข้อมูลนักศึกษาคณะแพทย์
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="d-flex justify-center">
                                  <v-btn class="ml-4" outlined color="#009688" @click="importExcelData('3')">
                                    Import ข้อมูลบุคคลภายนอก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </template>
                          <v-card class="mt-7" v-if="JoinPerson.length > 0">
                            <v-toolbar :color="appColor" dark flat>
                              <v-toolbar-title>รายชื่อผู้เข้าร่วม
                                {{ JoinPerson.length }} คน
                              </v-toolbar-title>
                            </v-toolbar>

                            <v-tabs v-model="tab" background-color="transparent" color="basil" show-arrows v-if="false">
                              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                              <v-tab>
                                บุคลากรคณะแพทย์
                              </v-tab>
                              <v-tab>
                                นักศึกษาคณะแพทย์
                              </v-tab>
                              <v-tab>
                                บุคลากรคณะอื่น
                              </v-tab>
                              <v-tab>
                                นักศึกษาคณะอื่น
                              </v-tab>
                              <v-tab>
                                บุคคลภายนอก
                              </v-tab>
                              <v-tab>
                                นักศึกษาภายนอก
                              </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                              <v-tab-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col class="d-flex justify-center" cols="12" md="6">
                                      <v-radio-group v-model="TypeInsert" row>
                                        <v-radio label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                        <v-radio label="ค้นหาโดยตัวเลือก" value="2"></v-radio>
                                      </v-radio-group>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                                  <v-row class="d-flex justify-center">
                                    <v-col cols="12" md="6">
                                      <v-autocomplete v-model="staffSel" label="ค้นหาบุคลากร" :items="staffData"
                                        item-text="customDetail" item-value="perid"
                                        hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล" persistent-hint clearable outlined
                                        @keyup="checkKeyEnter"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="8" md="2" class="d-flex justify-center">
                                      <v-btn outlined color="primary" @click="ChooseEmpolyee_s_owner">
                                        เพิ่ม
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                                  <v-row class="d-flex justify-center">
                                    <v-col cols="12" md="6">
                                      <v-autocomplete v-model="departSel" label="เลือกหน่วยงาน" :items="depart"
                                        item-text="dep_name" item-value="dep_id" flat solo-inverted hide-details
                                        clearable clear-icon="mdi-close-circle-outline"
                                        @change="ChooseEmpolyee"></v-autocomplete>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-row v-if="TypeInsert == '2'">
                                  <v-col cols="12" md="6">
                                    <v-card-text>
                                      <v-treeview :items="items" selected-color="indigo" expand-icon="mdi-chevron-down"
                                        off-icon="mdi-checkbox-blank-circle-outline"
                                        on-icon="mdi-checkbox-marked-circle-outline"
                                        indeterminate-icon="mdi-minus-circle-outline">
                                        <template v-slot:label="{ item }">
                                          <div class="d-flex justify-space-between">
                                            <span
                                              style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                              item.name }}</span>
                                            <v-switch inset :input-value="item.switch"
                                              @change="ChooseEmp(item)"></v-switch>
                                          </div>
                                        </template>
                                      </v-treeview>
                                    </v-card-text>
                                  </v-col>

                                  <!--                                        <v-divider vertical></v-divider>-->

                                  <v-col cols="12" md="6">
                                    <v-card-text>
                                      <div v-if="EmpData.length === 0" key="title"
                                        class="title font-weight-light grey--text pa-4 text-center">
                                        <span
                                          style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วม</span>
                                      </div>

                                      <v-scroll-x-transition group hide-on-leave>
                                        <v-chip v-for="(selection, i) in EmpData" :key="i" color="grey" dark small
                                          class="ma-1">
                                          <v-icon left small>mdi-account-circle
                                          </v-icon>
                                          {{ selection.name }}
                                        </v-chip>
                                      </v-scroll-x-transition>
                                    </v-card-text>
                                  </v-col>
                                </v-row>
                                <v-divider v-if="TypeInsert == '2'"></v-divider>
                                <v-card-actions v-if="TypeInsert == '2'">
                                  <v-btn text @click="EmpData = []">
                                    Reset
                                  </v-btn>

                                  <v-spacer></v-spacer>

                                  <v-btn class="white--text" color="green darken-1" depressed @click="SaveToTable">
                                    Save
                                    <v-icon right>mdi-content-save</v-icon>
                                  </v-btn>
                                </v-card-actions>
                                <div align="center" style="margin-top: 30px">
                                  <v-alert dense outlined type="success" dismissible v-if="ShowAlertSuc">
                                    <div v-html="MessageSuc"></div>
                                  </v-alert>
                                </div>
                                <div align="center" style="margin-top: 30px">
                                  <v-alert dense outlined type="error" dismissible v-if="ShowAlertErr">
                                    <div v-html="MessageError"></div>
                                  </v-alert>
                                </div>
                                <v-list-item class="d-flex justify-center">
                                  <v-alert v-if="alertP" prominent type="error">
                                    <v-row align="center" v-for="item in txtAlertP" :key="item.id">
                                      <v-col class="d-flex grow">- {{ item.Detail }}
                                      </v-col>
                                    </v-row>
                                  </v-alert>
                                </v-list-item>
                                <v-list-item v-if="FilePerson.length > 0">
                                  <template>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-card>
                                          <v-card-title>
                                            ไฟล์ประกอบ
                                          </v-card-title>
                                          <v-container fluid>
                                            <v-row>
                                              <v-col v-for="(file_i,
                                                index) in FilePerson" :key="index" class="d-flex child-flex" cols="12"
                                                md="4">
                                                <v-card flat tile class="d-flex">
                                                  <v-img v-if="
                                                      file_i.type == 'image'
                                                    " :src="file_i.src" :lazy-src="
                                                      `https://picsum.photos/10/6?image=${(index +
                                                        1) *
                                                        5 +
                                                        10}`
                                                    " aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                                    max-height="100px">
                                                    <template v-slot:placeholder>
                                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img v-else-if="
                                                      file_i.type == 'pdf'
                                                    " src="../../assets/Image/pdf.png" :lazy-src="
                                                      `https://picsum.photos/10/6?image=${(index +
                                                        1) *
                                                        5 +
                                                        10}`
                                                    " aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                                    max-height="100px">
                                                    <template v-slot:placeholder>
                                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img v-else-if="
                                                      file_i.type == 'rar' ||
                                                        file_i.type == 'zip'
                                                    " src="../../assets/Image/winzip.png" :lazy-src="
                                                      `https://picsum.photos/10/6?image=${(index +
                                                        1) *
                                                        5 +
                                                        10}`
                                                    " aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                                    max-height="100px">
                                                    <template v-slot:placeholder>
                                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img v-else-if="
                                                      file_i.type == 'word'
                                                    " src="../../assets/Image/word.jpg" :lazy-src="
                                                      `https://picsum.photos/10/6?image=${(index +
                                                        1) *
                                                        5 +
                                                        10}`
                                                    " aspect-ratio="1" class="grey lighten-2">
                                                    <template v-slot:placeholder>
                                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img v-else-if="
                                                      file_i.type == 'ppt'
                                                    " src="../../assets/Image/ppt.jpg" :lazy-src="
                                                      `https://picsum.photos/10/6?image=${(index +
                                                        1) *
                                                        5 +
                                                        10}`
                                                    " aspect-ratio="1" class="grey lighten-2">
                                                    <template v-slot:placeholder>
                                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-card-actions>
                                                    <template v-if="
                                                        file_i.type ==
                                                          'image' ||
                                                          file_i.type == 'pdf'
                                                      ">
                                                      <v-btn text @click="
                                                          ShowData(file_i.src)
                                                        ">
                                                        <span style="color: indigo">
                                                          เรียกดู
                                                        </span>
                                                      </v-btn>
                                                    </template>
                                                  </v-card-actions>
                                                </v-card>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </template>
                                </v-list-item>
                              </v-tab-item>
                              <v-tab-item>
                                <v-row class="d-flex justify-center">
                                  <v-col class="d-flex justify-center" cols="12" md="8">
                                    <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID"
                                      item-text="fullName" v-model="Idstudent" label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา">
                                    </v-autocomplete>
                                    <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                      @click="insertStd('med')">
                                      บันทึก
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-tab-item>
                              <v-tab-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col class="d-flex justify-center" cols="12" md="8">
                                      <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                        item-text="FAC_NAME_THAI" v-model="IdDepart" label="ค้นหาคณะ/สังกัด"
                                        @change="GetPersonalPSU">
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col class="d-flex justify-center" cols="12" md="8">
                                      <v-autocomplete outlined :items="personalMedData" item-value="STAFF_ID"
                                        item-text="FULL_NAME" v-model="IdPersonal"
                                        label="ค้นหา ชื่อ - สกุล รหัสบุคลากร">
                                      </v-autocomplete>
                                      <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                        @click="insertPersonUni()">
                                        บันทึก
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                              </v-tab-item>
                              <v-tab-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col class="d-flex justify-center" cols="12" md="8">
                                      <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                        item-text="FAC_NAME_THAI" v-model="IdDepartStd" label="ค้นหาคณะ"
                                        @change="GetStdPSU">
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col class="d-flex justify-center" cols="12" md="8">
                                      <v-autocomplete outlined :items="studentUniData" item-value="STUDENT_ID"
                                        item-text="fullName" v-model="IdstudentUni"
                                        label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"></v-autocomplete>
                                      <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                        @click="insertStd('other')">
                                        บันทึก
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                              </v-tab-item>
                              <v-tab-item>
                                <v-row class="d-flex justify-center">
                                  <v-col cols="12" md="8">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="NameP" label="ชื่อ (name)" :error-messages="
                                            NameP == '' ? '*' : ''
                                          " :error="NameP == ''">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="SurNameP" label="สกุล (surname)" :error-messages="
                                            SurNameP == '' ? '*' : ''
                                          " :error="SurNameP == ''">
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" md="4">
                                        <v-text-field v-model="idCard" label="รหัสบัตรประชาชน">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="4">
                                        <v-text-field v-model="affiliation" label="สังกัด">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="4">
                                        <v-text-field v-model="position" label="ตำแหน่ง">
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <v-list-item>
                                  <v-row class="justify-center">
                                    <v-col cols="12" md="4">
                                      <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                  <v-btn color="primary" outlined @click="insertDataPerson('person')">
                                    บันทึก
                                  </v-btn>
                                </v-list-item>
                              </v-tab-item>
                              <v-tab-item>
                                <v-row class="d-flex justify-center">
                                  <v-col cols="12" md="8">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="NameStd" label="ชื่อ (name)" :error-messages="
                                            NameStd == '' ? '*' : ''
                                          " :error="NameStd == ''">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="SurNameStd" label="สกุล (surname)" :error-messages="
                                            SurNameStd == '' ? '*' : ''
                                          " :error="SurNameStd == ''">
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="idCardStd" label="รหัสบัตรประชาชน">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field v-model="affiliationStd" label="มหาวิทยาลัย">
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <v-list-item>
                                  <v-row class="justify-center">
                                    <v-col cols="12" md="4">
                                      <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                  <v-btn color="primary" outlined @click="insertDataPerson('Std')">
                                    บันทึก
                                  </v-btn>
                                </v-list-item>
                              </v-tab-item>
                            </v-tabs-items>
                            <v-card-title>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="searchPerson" append-icon="mdi-magnify" label="ค้นหา" single-line
                                  hide-details></v-text-field>
                              </v-list-item>
                            </v-card-title>
                            <v-data-table :headers="headersPerson" :items="JoinPerson" :search="searchPerson">
                              <template v-slot:item.file="{ item }">
                                <div align="center">
                                  <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                                    {{ item.files.length }} ไฟล์
                                  </v-btn>
                                </div>
                              </template>
                              <template v-slot:item.type="{ item }">
                                <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                                  บุคลากรคณะแพทย์
                                </span>
                                <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                  นักศึกษาคณะแพทย์
                                </span>
                                <span v-if="item.registerType_id == '2'" style="color: blue">
                                  บุคลากรคณะอื่น
                                </span>
                                <span v-if="item.registerType_id == '3'" style="color: blue">
                                  นักศึกษาคณะอื่น
                                </span>
                                <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                  บุคคลภายนอก
                                </span>
                                <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                  นักศึกษาภายนอก
                                </span>
                              </template>
                              <template v-slot:item.join_status="{ item }">
                                <span style="font-weight: bold;color: red" v-if="item.join_status == '0'">
                                  รอลงทะเบียน
                                </span>
                                <span style="font-weight: bold;color: forestgreen" v-else>
                                  ลงทะเบียนเข้าร่วม
                                </span>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <v-btn color="#F44336" outlined @click="Del_item(item)">
                                  ลบ
                                </v-btn>
                              </template>
                            </v-data-table>
                            <!--                  <v-list-item class="d-flex justify-center ma-8">-->
                            <!--                    <download-excel-->
                            <!--                        class="btn btn-default"-->
                            <!--                        :data="json_data"-->
                            <!--                        :fields="json_fields"-->
                            <!--                        worksheet="รายชื่อผู้เข้าร่วมโครงการ"-->
                            <!--                        :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"-->
                            <!--                    >-->
                            <!--                      <v-btn outlined color="green" class="darken-3">-->
                            <!--                        Export รายชื่อผู้เข้าร่วมโครงการ-->
                            <!--                      </v-btn>-->
                            <!--                    </download-excel>-->
                            <!--                  </v-list-item>-->
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item v-if="JoinPerson.length > 0">
                      <v-row class="d-flex justify-center"> 
                        <v-col cols="12" md="4">
                          <v-btn outlined color="green" class="darken-3" @click="openExportOptionsDialog">
                            Export รายชื่อผู้เข้าร่วม (บุคลากร)
                          </v-btn>
                        </v-col>
                        <v-col cols="12" md="4">
                          <download-excel class="btn btn-default mr-4" :data="json_data_export"
                            :fields="json_fields_export" worksheet="รายชื่อผู้เข้าร่วม" :title="array_title" :name="
                              'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'
                            ">
                            <v-btn outlined color="green" class="darken-3" @click="ExportData">
                              Export รายชื่อผู้เข้าร่วม (ทั้งหมด)
                            </v-btn>
                          </download-excel>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item v-if="JoinPerson.length == 0">
                      <div align="center;padding: 100px">
                        <span style="font-weight: bold;font-size: 24px;color: #ff6d81">
                          ไม่พบข้อมูลผู้เข้าร่วมโครงการ
                        </span>
                      </div>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(5)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(6)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step step="5" editable v-if="roundNeed && ProjectPlan != null" class="font-weight-bold">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">บันทึกรุ่น (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>บันทึกรุ่น</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                      v-if="e1 == 5 && ProjectPlan != null && IsLog == '1'" @click="unlockProj">ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark
                      v-else-if="e1 == 5 && ProjectPlan != null && IsLog == '0'" @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">บันทึกรุ่น</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content step="5" v-if="roundNeed && ProjectPlan != null">
                  <v-list>
                    <v-list-item class="d-flex justify-center">
                      <v-btn color="primary" dark @click="showDialogRound" class="font-weight-bold">
                        บันทึกรุ่น
                      </v-btn>
                      <v-dialog v-model="dialogRound" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                          <v-app-bar dark :color="appColor" dense fixed>
                            <v-btn icon dark @click="dialogRound = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>กำหนดรุ่น</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn dark class="text-h4" @click="SaveRoundData" v-if="save">
                                บันทึกข้อมูล
                              </v-btn>
                              <v-btn v-if="!save" class="text-h4 darken-4" @click="updateRoundData"
                                style="background-color: yellow;color: black">
                                แก้ไขข้อมูล
                              </v-btn>
                              <v-btn dark class="text-h4 darken-4" @click="dialogRound = false"
                                style="background-color: red">
                                ยกเลิก
                              </v-btn>
                            </v-toolbar-items>
                          </v-app-bar>
                          <v-row class="d-flex justify-center mt-16">
                            <v-col cols="12" md="8">
                              <v-tabs color="red darken-3" show-arrows v-model="tabs">
                                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                                <v-tab key="CoriTab">
                                  รุ่น/กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วม
                                </v-tab>
                                <v-tab key="JoinTab">
                                  ผู้เข้าร่วม
                                  <v-chip color="red" dark class="ml-3">
                                    {{ JoinPerson.length }}
                                  </v-chip>
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="tabs">
                                <v-tab-item key="CoriTab">
                                  <v-list>
                                    <v-list-item-title class="headline mb-1">
                                      กำหนดรุ่น
                                    </v-list-item-title>
                                    <v-list-item>
                                      <v-row class="d-flex">
                                        <v-col cols="12" md="3">
                                          <v-text-field v-model="round" label="รุ่นที่"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                          <v-text-field v-model="round_name" label="ชื่อรุ่น"></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row class="d-flex">
                                        <v-col cols="12" md="3">
                                          <template>
                                            <v-menu v-model="showPickerDateRoundStart" :close-on-content-click="false"
                                              transition="scale-transition" offset-y full-width max-width="290px"
                                              min-width="290px">
                                              <template v-slot:activator="{ on }">
                                                <v-text-field v-model="dateRegS" label="วันที่เริ่มต้น"
                                                  hint="YYYY/MM/DD" persistent-hint readonly :error="dateRegS == ''"
                                                  :error-messages="
                                                    dateRegS == ''
                                                      ? 'วันที่เริ่มต้น ห้ามว่าง'
                                                      : ''
                                                  " v-on="on"></v-text-field>
                                              </template>
                                              <v-date-picker locale="th" v-model="dateRegS" no-title @input="
                                                  showPickerDateRoundStart = false
                                                "></v-date-picker>
                                            </v-menu>
                                          </template>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                          <template>
                                            <v-menu v-model="showPickerDateRoundEnd" :close-on-content-click="false"
                                              transition="scale-transition" offset-y full-width max-width="290px"
                                              min-width="290px">
                                              <template v-slot:activator="{ on }">
                                                <v-text-field v-model="dateRegE" label="วันที่สิ้นสุด" hint="YYYY/MM/DD"
                                                  persistent-hint readonly :error="dateRegE == ''" :error-messages="
                                                    dateRegE == ''
                                                      ? 'วันที่สิ้นสุด ห้ามว่าง'
                                                      : ''
                                                  " v-on="on"></v-text-field>
                                              </template>
                                              <v-date-picker locale="th" v-model="dateRegE" no-title @input="
                                                  showPickerDateRoundEnd = false
                                                "></v-date-picker>
                                            </v-menu>
                                          </template>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row class="d-flex">
                                        <v-col cols="12" md="3">
                                          <v-text-field v-model="time_start" label="เวลาเริ่มต้น"
                                            type="time"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                          <v-text-field v-model="time_end" label="เวลาสิ้นสุด"
                                            type="time"></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item-title class="headline mb-1 mt-8">
                                      กลุ่มเป้าหมาย
                                    </v-list-item-title>
                                    <v-list-item>
                                      <v-row>
                                        <v-col cols="12" md="6">
                                          <v-autocomplete outlined v-model="posiCondi" :items="positions"
                                            item-text="PosName" item-value="PosCode" label="ตำแหน่ง"></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row>
                                        <v-col cols="6" md="3">
                                          <v-text-field outlined type="number" v-model="workAgeStart_Condi"
                                            label="อายุงานเริ่มต้น" :error="
                                              workAgeStart_Condi.length > 2 ||
                                                parseInt(workAgeStart_Condi) < 0
                                            " :error-messages="
                                              workAgeStart_Condi.length > 2
                                                ? 'จำนวนห้ามเกิน 2 หลัก'
                                                : parseInt(workAgeStart_Condi) <
                                                  0
                                                ? 'ห้ามใส่จำนวนติด - '
                                                : ''
                                            " required></v-text-field>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                          <v-text-field outlined type="number" v-model="workAgeEnd_Condi" :error="
                                              workAgeEnd_Condi.length > 2 ||
                                                parseInt(workAgeEnd_Condi) < 0
                                            " :error-messages="
                                              workAgeEnd_Condi.length > 2
                                                ? 'จำนวนห้ามเกิน 2 หลัก'
                                                : parseInt(workAgeEnd_Condi) < 0
                                                ? 'ห้ามใส่จำนวนติด - '
                                                : ''
                                            " label="อายุงานสิ้นสุด" required></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-row class="d-flex">
                                        <v-col cols="6" md="3">
                                          <div align="center">
                                            <v-btn outlined color="primary" @click="DataCondiFunc"
                                              style="text-align: center">
                                              เพิ่ม
                                            </v-btn>
                                          </div>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-data-table :headers="dataHeadersCondi" :items="DataCondi" :search="search"
                                        item-key="PosWork" class="elevation-1 mt-4" v-if="DataCondi.length > 0">
                                        <template v-slot:header.PosName>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            เงื่อนไขตำแหน่ง, อายุงาน
                                          </v-label>
                                        </template>
                                        <template v-slot:header.Level>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            ระดับ
                                          </v-label>
                                        </template>
                                        <template v-slot:header.workAgeStart>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            อายุงานเริ่มต้น
                                          </v-label>
                                        </template>
                                        <template v-slot:header.workAgeEnd>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            อายุงานสิ้นสุด
                                          </v-label>
                                        </template>
                                        <template v-slot:item.PosName="{ item }">
                                          <v-label>
                                            {{ item.PosName }}
                                          </v-label>
                                        </template>
                                        <template v-slot:item.Level="{ item }">
                                          <v-label>
                                            {{ item.Level }}
                                          </v-label>
                                        </template>
                                        <template v-slot:item.workAgeStart="{ item }">
                                          <v-label>
                                            {{ item.workAgeStart }} (ปี)
                                          </v-label>
                                        </template>
                                        <template v-slot:item.workAgeEnd="{ item }">
                                          <v-label>
                                            {{ item.workAgeEnd }} (ปี)
                                          </v-label>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                          <v-row class="d-flex">
                                            <v-col cols="6" md="6">
                                              <v-btn outlined color="#BF360C" @click="DeleteDataCondi(item)">
                                                ลบ
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </template>
                                      </v-data-table>
                                    </v-list-item>
                                    <v-divider class="mt-6" style="border: 1px solid"></v-divider>
                                    <v-list-item-title class="headline mt-6">
                                      เงื่อนไขการเข้าร่วม
                                    </v-list-item-title>
                                    <v-list-item>
                                      <v-list-item-subtitle>
                                        <h3 class="font-weight-bold">
                                          สมัครเข้าร่วมโครงการ
                                        </h3>
                                      </v-list-item-subtitle>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-radio-group row v-model="ChooseTypRegis">
                                        <v-radio label="อนุญาตสมัครเข้าร่วมโครงการ" value="0"></v-radio>
                                        <v-radio label="ไม่อนุญาตสมัครเข้าร่วมโครงการ" value="1"></v-radio>
                                      </v-radio-group>
                                    </v-list-item>
                                    <v-list-item class="d-flex" v-if="ChooseTypRegis == '0'">
                                      <v-radio-group row v-model="ChooseTypRegis2">
                                        <v-radio label="หน่วยงานและบุคลากรทั่วไป" value="0" color="green"></v-radio>
                                        <v-radio label="หน่วยงาน" value="1" color="indigo"></v-radio>
                                        <v-radio label="บุคลากรทั่วไป" value="2" color="yellow"></v-radio>
                                      </v-radio-group>
                                    </v-list-item>
                                    <v-list-item class="d-flex" v-if="ChooseTypRegis == '0'">
                                      <v-row class="d-flex">
                                        <v-col md="2" cols="12">
                                          <template>
                                            <v-menu v-model="showDateRegStart2" :close-on-content-click="false"
                                              transition="scale-transition" offset-y full-width max-width="290px"
                                              min-width="290px">
                                              <template v-slot:activator="{ on }">
                                                <v-text-field v-model="dateRegStart" label="วันที่เปิดรับสมัคร"
                                                  hint="YYYY/MM/DD" persistent-hint readonly :error="dateRegStart == ''"
                                                  :error-messages="
                                                    dateRegStart == ''
                                                      ? 'วันที่เปิดรับสมัคร ห้ามว่าง'
                                                      : ''
                                                  " v-on="on"></v-text-field>
                                              </template>
                                              <v-date-picker locale="th" v-model="dateRegStart" no-title @input="
                                                  showDateRegStart2 = false
                                                "></v-date-picker>
                                            </v-menu>
                                          </template>
                                        </v-col>
                                        <v-col md="2" cols="12">
                                          <template>
                                            <v-menu v-model="showDateRegEnd2" :close-on-content-click="false"
                                              transition="scale-transition" offset-y full-width max-width="290px"
                                              min-width="290px">
                                              <template v-slot:activator="{ on }">
                                                <v-text-field v-model="dateRegEnd" label="วันที่ปิดรับสมัคร"
                                                  hint="YYYY/MM/DD" persistent-hint readonly :error="dateRegEnd == ''"
                                                  :error-messages="
                                                    dateRegEnd == ''
                                                      ? 'วันที่ปิดรับสมัคร ห้ามว่าง'
                                                      : ''
                                                  " v-on="on"></v-text-field>
                                              </template>
                                              <v-date-picker locale="th" v-model="dateRegEnd" no-title
                                                @input="showDateRegEnd2 = false"></v-date-picker>
                                            </v-menu>
                                          </template>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-divider style="border: 1px solid"></v-divider>
                                    <v-list-item>
                                      <v-list-item-subtitle>
                                        <h3 class="font-weight-bold">
                                          การลงทะเบียนเข้าร่วม
                                        </h3>
                                      </v-list-item-subtitle>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-radio-group row v-model="ChooseTypRegis3">
                                        <v-radio label="จำกัดการลงทะเบียนเข้าร่วมตามรายชื่อผู้เข้าร่วม"
                                          value="1"></v-radio>
                                        <v-radio label="ไม่จำกัดการลงทะเบียนเข้าร่วมตามรายชื่อผู้เข้าร่วม"
                                          value="0"></v-radio>
                                      </v-radio-group>
                                    </v-list-item>
                                    <v-divider style="border: 1px solid"></v-divider>
                                    <v-list-item>
                                      <v-list-item-subtitle>
                                        <h3 class="font-weight-bold">
                                          ผู้เข้าร่วมโครงการ
                                        </h3>
                                      </v-list-item-subtitle>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row class="d-flex">
                                        <v-col md="4" cols="12">
                                          <v-text-field :disabled="ChkJoinPerson" outlined
                                            label="จำนวนผู้เข้าร่วมโครงการ / คน" type="number"
                                            v-model="ProjectQuotaCount" :error="
                                              !ChkJoinPerson &&
                                                (ProjectQuotaCount == '' ||
                                                  parseInt(ProjectQuotaCount) ==
                                                    0)
                                            " :error-messages="
                                              !ChkJoinPerson &&
                                              (ProjectQuotaCount == '' ||
                                                parseInt(ProjectQuotaCount) ==
                                                  0)
                                                ? 'จำนวนผู้เข้าร่วมโครงการ / คน (ห้ามว่าง) หรือมีค่ามากกว่า 0'
                                                : ''
                                            "></v-text-field>
                                        </v-col>
                                        <v-col md="4" cols="12">
                                          <v-checkbox label="ไม่จำกัดผู้เข้าร่วม" color="primary"
                                            v-model="ChkJoinPerson"></v-checkbox>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-divider style="border: 1px solid"></v-divider>
                                    <v-list-item>
                                      <v-list-item-subtitle>
                                        <h3 class="font-weight-bold">
                                          โควตาหน่วยงานที่เข้าร่วม
                                        </h3>
                                      </v-list-item-subtitle>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-radio-group row v-model="ChooseTypeDep">
                                        <v-radio label="หน่วยงาน/ภาควิชา" value="0"></v-radio>
                                        <v-radio label="กลุ่มหน่วยงาน/กลุ่มภาควิชา" value="1"></v-radio>
                                        <v-radio label="กลุ่มเทมเพลต (ที่สร้างขึ้น)" value="3"></v-radio>
                                      </v-radio-group>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row class="d-flex justify-center">
                                        <v-col cols="12" md="4">
                                          <v-autocomplete v-model="DepQuotaSelect" label="หน่วยงาน/ภาควิชา"
                                            :items="depart" item-text="dep_name" item-value="dep_id" persistent-hint
                                            outlined v-if="ChooseTypeDep == '0'" clearable>
                                          </v-autocomplete>
                                          <v-autocomplete v-model="DepQuotaSelect" label="กลุ่มหน่วยงาน/กลุ่มภาควิชา"
                                            :items="groupDepart" item-text="dep_name" item-value="dep_group_id"
                                            persistent-hint outlined v-else-if="ChooseTypeDep == '1'" clearable>
                                          </v-autocomplete>
                                          <v-autocomplete v-model="GroupSelect" label="กลุ่มเทมเพลต"
                                            :items="GroupQuotaMS" item-text="group_name" item-value="id" persistent-hint
                                            outlined v-else clearable>
                                          </v-autocomplete>
                                        </v-col>
                                        <v-col cols="6" md="2">
                                          <v-text-field outlined type="number" v-model="DepQuotaCount"
                                            label="จำนวน / คน" required v-if="ChooseTypeDep != '3'"></v-text-field>
                                          <v-btn @click="ShowGroupDepDetail" outlined color="primary" v-else>
                                            รายละเอียด
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-row class="d-flex">
                                        <v-col cols="12" md="6">
                                          <div align="center">
                                            <v-btn outlined color="primary" @click="AddDepQuotaData">
                                              เพิ่ม
                                            </v-btn>
                                          </div>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item class="d-flex">
                                      <v-data-table :headers="DepQuotaHeader" :items="DepQuotaData"
                                        :search="searchDepQuota" class="elevation-1 mt-4"
                                        v-if="DepQuotaData.length > 0">
                                        <template v-slot:header.type>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            ประเภท
                                          </v-label>
                                        </template>
                                        <template v-slot:header.dep_name>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            ภาควิชา/หน่วยงาน
                                          </v-label>
                                        </template>
                                        <template v-slot:header.count>
                                          <v-label fontSize="16px" fontWeight="bold">
                                            จำนวน/คน
                                          </v-label>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                          <v-row class="d-flex">
                                            <v-col cols="6" md="6">
                                              <v-btn outlined color="#BF360C" @click="
                                                  DeleteDepQuotaCondi(item)
                                                ">
                                                ลบ
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </template>
                                        <template v-slot:footer>
                                          <template>
                                            <div align="center" style="margin-top: 15px">
                                              <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน :
                                                {{ ProjectQuotaDepCount }}
                                                คน</span>
                                            </div>
                                            <div align="center" v-if="
                                                !ChkJoinPerson &&
                                                  parseInt(ProjectQuotaCount) >
                                                    0
                                              ">
                                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป :
                                                {{
                                                parseInt(ProjectQuotaCount) -
                                                parseInt(
                                                ProjectQuotaDepCount
                                                )
                                                }}
                                                คน</span>
                                            </div>
                                            <div align="center" v-else>
                                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                                            </div>
                                            <div align="center" v-if="
                                                !ChkJoinPerson &&
                                                  parseInt(ProjectQuotaCount) >
                                                    0
                                              ">
                                              <span style="font-weight: bold;color: #42b983">รวม :
                                                {{ ProjectQuotaCount }} คน</span>
                                            </div>
                                            <div align="center" v-else>
                                              <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                                            </div>
                                          </template>
                                        </template>
                                      </v-data-table>
                                    </v-list-item>
                                  </v-list>
                                </v-tab-item>
                                <v-tab-item key="JoinTab">
                                  <v-list>
                                    <v-list-item class="d-flex justify-center" v-if="false">
                                      <v-row class="d-flex justify-center">
                                        <v-col cols="12" md="4" class="d-flex justify-center">
                                          <v-btn outlined color="#009688" @click="importExcelData('1')">
                                            Import ข้อมูลบุคลากร
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="12" md="4" class="d-flex justify-center">
                                          <v-btn outlined color="#009688" @click="importExcelData('2')">
                                            Import ข้อมูลนักศึกษาคณะแพทย์
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="12" md="4" class="d-flex justify-center">
                                          <v-btn outlined color="#009688" @click="importExcelData('3')">
                                            Import ข้อมูลบุคคลภายนอก
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-card class="mt-7">
                                      <v-toolbar :color="appColor" dark flat>
                                        <v-toolbar-title>รายชื่อผู้เข้าร่วม
                                          {{ JoinPerson.length }}
                                          <span v-if="!ChkJoinPerson">
                                            / {{ ProjectQuotaCount }}</span>
                                          คน
                                        </v-toolbar-title>
                                      </v-toolbar>

                                      <v-tabs v-model="tab" background-color="transparent" color="basil" show-arrows
                                        v-if="false">
                                        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                                        <v-tab>
                                          บุคลากรคณะแพทย์
                                        </v-tab>
                                        <v-tab>
                                          นักศึกษาคณะแพทย์
                                        </v-tab>
                                        <v-tab>
                                          บุคลากรคณะอื่น
                                        </v-tab>
                                        <v-tab>
                                          นักศึกษาคณะอื่น
                                        </v-tab>
                                        <v-tab>
                                          บุคคลภายนอก
                                        </v-tab>
                                        <v-tab>
                                          นักศึกษาภายนอก
                                        </v-tab>
                                      </v-tabs>

                                      <v-tabs-items v-model="tab">
                                        <v-tab-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="6">
                                                <v-radio-group v-model="TypeInsert" row>
                                                  <v-radio label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                                  <v-radio label="ค้นหาโดยตัวเลือก" value="2"></v-radio>
                                                </v-radio-group>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                                            <v-row class="d-flex justify-center">
                                              <v-col cols="12" md="6">
                                                <v-autocomplete v-model="staffSel" label="ค้นหาบุคลากร"
                                                  :items="staffData" item-text="customDetail" item-value="perid"
                                                  hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล" persistent-hint clearable
                                                  outlined @keyup="checkKeyEnter"></v-autocomplete>
                                              </v-col>
                                              <v-col cols="8" md="2" class="d-flex justify-center">
                                                <v-btn outlined color="primary" @click="
                                                    ChooseEmpolyee_s_owner
                                                  ">
                                                  เพิ่ม
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                                            <v-row class="d-flex justify-center">
                                              <v-col cols="12" md="6">
                                                <v-autocomplete v-model="departSel" label="เลือกหน่วยงาน"
                                                  :items="depart" item-text="dep_name" item-value="dep_id" flat
                                                  solo-inverted hide-details clearable
                                                  clear-icon="mdi-close-circle-outline"
                                                  @change="ChooseEmpolyee"></v-autocomplete>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-row v-if="TypeInsert == '2'">
                                            <v-col cols="12" md="6">
                                              <v-card-text>
                                                <v-treeview :items="items" selected-color="indigo"
                                                  expand-icon="mdi-chevron-down"
                                                  off-icon="mdi-checkbox-blank-circle-outline"
                                                  on-icon="mdi-checkbox-marked-circle-outline"
                                                  indeterminate-icon="mdi-minus-circle-outline">
                                                  <template v-slot:label="{ item }">
                                                    <div class="d-flex justify-space-between">
                                                      <span
                                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                                        item.name }}</span>
                                                      <v-switch inset :input-value="
                                                          item.switch
                                                        " @change="
                                                          ChooseEmp(item)
                                                        "></v-switch>
                                                    </div>
                                                  </template>
                                                </v-treeview>
                                              </v-card-text>
                                            </v-col>

                                            <!--                                        <v-divider vertical></v-divider>-->

                                            <v-col cols="12" md="6">
                                              <v-card-text>
                                                <div v-if="EmpData.length === 0" key="title"
                                                  class="title font-weight-light grey--text pa-4 text-center">
                                                  <span
                                                    style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วม</span>
                                                </div>

                                                <v-scroll-x-transition group hide-on-leave>
                                                  <v-chip v-for="(selection,
                                                    i) in EmpData" :key="i" color="grey" dark small class="ma-1">
                                                    <v-icon left small>mdi-account-circle
                                                    </v-icon>
                                                    {{ selection.name }}
                                                  </v-chip>
                                                </v-scroll-x-transition>
                                              </v-card-text>
                                            </v-col>
                                          </v-row>
                                          <v-divider v-if="TypeInsert == '2'"></v-divider>
                                          <v-card-actions v-if="TypeInsert == '2'">
                                            <v-btn text @click="EmpData = []">
                                              Reset
                                            </v-btn>

                                            <v-spacer></v-spacer>

                                            <v-btn class="white--text" color="green darken-1" depressed
                                              @click="SaveToTable">
                                              Save
                                              <v-icon right>mdi-content-save
                                              </v-icon>
                                            </v-btn>
                                          </v-card-actions>
                                          <div align="center" style="margin-top: 30px">
                                            <v-alert dense outlined type="success" dismissible v-if="ShowAlertSuc">
                                              <div v-html="MessageSuc"></div>
                                            </v-alert>
                                          </div>
                                          <div align="center" style="margin-top: 30px">
                                            <v-alert dense outlined type="error" dismissible v-if="ShowAlertErr">
                                              <div v-html="MessageError"></div>
                                            </v-alert>
                                          </div>
                                          <v-list-item class="d-flex justify-center">
                                            <v-alert v-if="alertP" prominent type="error">
                                              <v-row align="center" v-for="item in txtAlertP" :key="item.id">
                                                <v-col class="d-flex grow">- {{ item.Detail }}
                                                </v-col>
                                              </v-row>
                                            </v-alert>
                                          </v-list-item>
                                          <v-list-item v-if="FilePerson.length > 0">
                                            <template>
                                              <v-row>
                                                <v-col cols="12">
                                                  <v-card>
                                                    <v-card-title>
                                                      ไฟล์ประกอบ
                                                    </v-card-title>
                                                    <v-container fluid>
                                                      <v-row>
                                                        <v-col v-for="(file_i,
                                                          index) in FilePerson" :key="index" class="d-flex child-flex"
                                                          cols="12" md="4">
                                                          <v-card flat tile class="d-flex">
                                                            <v-img v-if="
                                                                file_i.type ==
                                                                  'image'
                                                              " :src="file_i.src" :lazy-src="
                                                                `https://picsum.photos/10/6?image=${(index +
                                                                  1) *
                                                                  5 +
                                                                  10}`
                                                              " aspect-ratio="1" class="grey lighten-2"
                                                              max-width="100px" max-height="100px">
                                                              <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center"
                                                                  justify="center">
                                                                  <v-progress-circular indeterminate
                                                                    color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-img v-else-if="
                                                                file_i.type ==
                                                                  'pdf'
                                                              " src="../../assets/Image/pdf.png" :lazy-src="
                                                                `https://picsum.photos/10/6?image=${(index +
                                                                  1) *
                                                                  5 +
                                                                  10}`
                                                              " aspect-ratio="1" class="grey lighten-2"
                                                              max-width="100px" max-height="100px">
                                                              <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center"
                                                                  justify="center">
                                                                  <v-progress-circular indeterminate
                                                                    color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-img v-else-if="
                                                                file_i.type ==
                                                                  'rar' ||
                                                                  file_i.type ==
                                                                    'zip'
                                                              " src="../../assets/Image/winzip.png" :lazy-src="
                                                                `https://picsum.photos/10/6?image=${(index +
                                                                  1) *
                                                                  5 +
                                                                  10}`
                                                              " aspect-ratio="1" class="grey lighten-2"
                                                              max-width="100px" max-height="100px">
                                                              <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center"
                                                                  justify="center">
                                                                  <v-progress-circular indeterminate
                                                                    color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-img v-else-if="
                                                                file_i.type ==
                                                                  'word'
                                                              " src="../../assets/Image/word.jpg" :lazy-src="
                                                                `https://picsum.photos/10/6?image=${(index +
                                                                  1) *
                                                                  5 +
                                                                  10}`
                                                              " aspect-ratio="1" class="grey lighten-2">
                                                              <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center"
                                                                  justify="center">
                                                                  <v-progress-circular indeterminate
                                                                    color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-img v-else-if="
                                                                file_i.type ==
                                                                  'ppt'
                                                              " src="../../assets/Image/ppt.jpg" :lazy-src="
                                                                `https://picsum.photos/10/6?image=${(index +
                                                                  1) *
                                                                  5 +
                                                                  10}`
                                                              " aspect-ratio="1" class="grey lighten-2">
                                                              <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center"
                                                                  justify="center">
                                                                  <v-progress-circular indeterminate
                                                                    color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-card-actions>
                                                              <template v-if="
                                                                  file_i.type ==
                                                                    'image' ||
                                                                    file_i.type ==
                                                                      'pdf'
                                                                ">
                                                                <v-btn text @click="
                                                                    ShowData(
                                                                      file_i.src
                                                                    )
                                                                  ">
                                                                  <span style="color: indigo">
                                                                    เรียกดู
                                                                  </span>
                                                                </v-btn>
                                                              </template>
                                                            </v-card-actions>
                                                          </v-card>
                                                        </v-col>
                                                      </v-row>
                                                    </v-container>
                                                  </v-card>
                                                </v-col>
                                              </v-row>
                                            </template>
                                          </v-list-item>
                                        </v-tab-item>
                                        <v-tab-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12" md="8">
                                              <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID"
                                                item-text="fullName" v-model="Idstudent"
                                                label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา">
                                              </v-autocomplete>
                                              <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                                @click="insertStd('med')">
                                                บันทึก
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-tab-item>
                                        <v-tab-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="8">
                                                <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                                  item-text="FAC_NAME_THAI" v-model="IdDepart" label="ค้นหาคณะ/สังกัด"
                                                  @change="GetPersonalPSU">
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="8">
                                                <v-autocomplete outlined :items="personalMedData" item-value="STAFF_ID"
                                                  item-text="FULL_NAME" v-model="IdPersonal"
                                                  label="ค้นหา ชื่อ - สกุล รหัสบุคลากร">
                                                </v-autocomplete>
                                                <v-btn style="margin-left: 20px;margin-top: 15px" color="primary"
                                                  outlined @click="insertPersonUni()">
                                                  บันทึก
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </v-tab-item>
                                        <v-tab-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="8">
                                                <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                                  item-text="FAC_NAME_THAI" v-model="IdDepartStd" label="ค้นหาคณะ"
                                                  @change="GetStdPSU">
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="8">
                                                <v-autocomplete outlined :items="studentUniData" item-value="STUDENT_ID"
                                                  item-text="fullName" v-model="IdstudentUni"
                                                  label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"></v-autocomplete>
                                                <v-btn style="margin-left: 20px;margin-top: 15px" color="primary"
                                                  outlined @click="insertStd('other')">
                                                  บันทึก
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </v-tab-item>
                                        <v-tab-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col cols="12" md="8">
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="NameP" label="ชื่อ (name)" :error-messages="
                                                      NameP == '' ? '*' : ''
                                                    " :error="NameP == ''">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="SurNameP" label="สกุล (surname)"
                                                    :error-messages="
                                                      SurNameP == '' ? '*' : ''
                                                    " :error="SurNameP == ''">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="idCard" label="รหัสบัตรประชาชน">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="affiliation" label="สังกัด">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="position" label="ตำแหน่ง">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                          <v-list-item>
                                            <v-row class="justify-center">
                                              <v-col cols="12" md="4">
                                                <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-btn color="primary" outlined @click="
                                                insertDataPerson('person')
                                              ">
                                              บันทึก
                                            </v-btn>
                                          </v-list-item>
                                        </v-tab-item>
                                        <v-tab-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col cols="12" md="8">
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="NameStd" label="ชื่อ (name)" :error-messages="
                                                      NameStd == '' ? '*' : ''
                                                    " :error="NameStd == ''">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="SurNameStd" label="สกุล (surname)"
                                                    :error-messages="
                                                      SurNameStd == ''
                                                        ? '*'
                                                        : ''
                                                    " :error="SurNameStd == ''">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="idCardStd" label="รหัสบัตรประชาชน">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="affiliationStd" label="มหาวิทยาลัย">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                          <v-list-item>
                                            <v-row class="justify-center">
                                              <v-col cols="12" md="4">
                                                <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-btn color="primary" outlined @click="insertDataPerson('Std')">
                                              บันทึก
                                            </v-btn>
                                          </v-list-item>
                                        </v-tab-item>
                                      </v-tabs-items>
                                      <v-card-title>
                                        <v-spacer></v-spacer>
                                        <v-text-field v-model="searchPerson" append-icon="mdi-magnify" label="Search"
                                          single-line hide-details></v-text-field>
                                      </v-card-title>
                                      <v-data-table :headers="headersPerson" :items="JoinPerson" :search="searchPerson">
                                        <template v-slot:item.file="{ item }">
                                          <div align="center">
                                            <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0"
                                              color="primary">
                                              {{ item.files.length }} ไฟล์
                                            </v-btn>
                                          </div>
                                        </template>
                                        <template v-slot:item.type="{ item }">
                                          <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                                            บุคลากรคณะแพทย์
                                          </span>
                                          <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                            นักศึกษาคณะแพทย์
                                          </span>
                                          <span v-if="item.registerType_id == '2'" style="color: blue">
                                            บุคลากรคณะอื่น
                                          </span>
                                          <span v-if="item.registerType_id == '3'" style="color: blue">
                                            นักศึกษาคณะอื่น
                                          </span>
                                          <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                            บุคคลภายนอก
                                          </span>
                                          <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                            นักศึกษาภายนอก
                                          </span>
                                        </template>
                                        <template v-slot:item.join_status="{ item }">
                                          <span style="font-weight: bold;color: red" v-if="item.join_status == '0'">
                                            รอลงทะเบียน
                                          </span>
                                          <span style="font-weight: bold;color: forestgreen" v-else>
                                            ลงทะเบียนเข้าร่วม
                                          </span>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                          <v-btn color="#F44336" outlined @click="Del_item(item)">
                                            ลบ
                                          </v-btn>
                                        </template>
                                      </v-data-table>
                                    </v-card> <v-list-item class="d-flex justify-center ma-8">
                                      <v-btn outlined color="green" class="darken-3 mr-4" @click="openExportOptionsDialog">
                                          Export รายชื่อผู้เข้าร่วม (บุคลากร)
                                      </v-btn>
                                      <download-excel class="btn btn-default mr-4" :data="json_data_export"
                                        :fields="json_fields_export" worksheet="รายชื่อผู้เข้าร่วม" :title="array_title"
                                        :name="
                                          'รายชื่อผู้เข้าร่วม ' +
                                            Project_name +
                                            '.xls'
                                        ">
                                        <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                          Export รายชื่อผู้เข้าร่วม (ทั้งหมด)
                                        </v-btn>
                                      </download-excel>
                                    </v-list-item>
                                  </v-list>
                                </v-tab-item>
                              </v-tabs-items>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center mt-8" v-if="RoundData.length > 0">
                      <v-data-table :headers="roundHeader" :items="RoundData" class="elevation-1 mt-4"
                        style="width: 100%">
                        <template v-slot:header.round>
                          <v-label fontSize="16px" fontWeight="bold">
                            รุ่น
                          </v-label>
                        </template>
                        <template v-slot:header.round_name>
                          <v-label fontSize="16px" fontWeight="bold">
                            ชื่อรุ่น
                          </v-label>
                        </template>
                        <template v-slot:header.count_person>
                          <v-label fontSize="16px" fontWeight="bold">
                            จำนวนผู้เข้าร่วม
                          </v-label>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <div align="center">
                            <v-btn text color="primary" @click="GetRoundDetail(item)">
                              รายละเอียด
                            </v-btn>
                            <v-btn text color="red" @click="DelRoundData(item)">
                              ลบ
                            </v-btn>
                          </div>
                        </template>
                      </v-data-table>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(4)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(5)">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step :step="!roundNeed ? '7' : '6'" editable class="font-weight-bold"
                  v-if="ProjectPlan != null">
                  <!--                ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ <div style="color: red" class="ml-4">(หากต้องการแก้ไขข้อมูลฟอร์มโครงการ ควรทำในขั้นตอนสุดท้าย เพื่อป้องกันข้อมูลที่คีย์ไปแล้วนั้นสูญหาย)</div>-->
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">ตัวชี้วัด (ห้ามแก้ไข)</span>
                    <span style="font-weight: bold;color: black" v-else>ตัวชี้วัด</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark v-if="
                        e1 == (!roundNeed ? 7 : 6) &&
                          ProjectPlan != null &&
                          IsLog == '1'
                      " @click="unlockProj">
                      ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark v-else-if="
                        e1 == (!roundNeed ? 7 : 6) &&
                          ProjectPlan != null &&
                          IsLog == '0'
                      " @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">ตัวชี้วัด</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content :step="!roundNeed ? '7' : '6'" v-if="ProjectPlan != null">
                  <v-list>
                    <v-list-item-title class="headline mb-1"><span class="font-weight-bold">ตัวชี้วัด</span>
                    </v-list-item-title>
                    <v-row class="d-flex justify-center">
                      <v-col cols="12">
                        <v-list>
                          <v-list-item>
                            <p class="font-weight-bold">
                              ความพึงพอใจ
                              <!-- <span style="color: #ff6d81">
                                ( 0 น้อยที่สุด - 5 มากที่สุด)</span
                              > -->
                            </p>
                          </v-list-item>

                          <!-- <v-list-item>
                            <v-radio-group v-model="satisfaction" row>
                              <v-radio label="1" value="1"></v-radio>
                              <v-radio label="2" value="2"></v-radio>
                              <v-radio label="3" value="3"></v-radio>
                              <v-radio label="4" value="4"></v-radio>
                              <v-radio label="5" value="5"></v-radio>
                            </v-radio-group>
                          </v-list-item> -->
                          <v-list-item>
                            <v-btn dark class="font-weight-bold mx-2" color="primary" @click="dialogQr = true">แสดง QR
                              CODE/ลิงค์ แบบสอบถาม</v-btn>
                            <v-btn dark class="font-weight-bold mx-2" color="primary" @click="dialogQr2 = true">แสดง QR
                              CODE/ลิงค์ ผลการตอบแบบสอบถาม</v-btn>
                          </v-list-item>
                          <v-divider class="my-4"></v-divider>
                          <v-list-item>
                            <p class="font-weight-bold">
                              สมรรถนะ, ความรู้ความสามารถ ผู้เข้าร่วมโครงการ
                            </p>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="3">
                                <v-text-field class="m-4" type="number" v-model="Knowledge_before"
                                  label="ก่อนเข้าร่วมโครงการ ระบุเป็นตัวเลข (%)"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="3">
                                <v-text-field class="m-4" type="number" v-model="Knowledge_after"
                                  label="หลังเข้าร่วมโครงการ ระบุเป็นตัวเลข (%)"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <p class="font-weight-bold">
                              จำนวนผู้เข้าร่วมโครงการ (รวมทั้งหมด)
                              {{ countAllPerson | currency }} คน
                            </p>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="2">
                                <div align="center">
                                  <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark
                                    @click="insertIndicator">
                                    บันทึกข้อมูลตัวชี้วัด
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" v-if="!roundNeed" @click="backStep(6)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn text color="red" v-else @click="backStep(5)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(7)" :disabled="IsLog == '1'" v-if="!roundNeed">
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                      <v-btn color="primary" @click="nextStep(6)" :disabled="IsLog == '1'" v-else>
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
                <v-stepper-step :step="!roundNeed ? '8' : '7'" :editable="IsLog == '0'" class="font-weight-bold"
                  :disabled="IsLog == '1'" v-if="ProjectPlan != null">
                  <template v-if="TypeInsertProject == '1'">
                    <span style="font-weight: bold;color: red" v-if="IsLog == '1'">ยืนยันข้อมูล
                      (โครงการอยู่ในสถานะถูกล็อค
                      ไม่สามารถยืนยันข้อมูลได้)</span>
                    <span style="font-weight: bold;color: black" v-else>ยืนยันข้อมูล</span>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="green" dark v-if="
                        e1 == (!roundNeed ? 8 : 7) &&
                          ProjectPlan != null &&
                          IsLog == '1'
                      " @click="unlockProj">
                      ปลดล็อคการแก้ไข
                    </v-btn>
                    <v-btn class="font-weight-bold ma-4 darken-4" color="red" dark v-else-if="
                        e1 == (!roundNeed ? 8 : 7) &&
                          ProjectPlan != null &&
                          IsLog == '0'
                      " @click="lockProj">ล็อคการแก้ไข
                    </v-btn>
                  </template>
                  <template v-else>
                    <span style="font-weight: bold;color: black">ยืนยันข้อมูล</span>
                  </template>
                </v-stepper-step>
                <v-stepper-content :step="!roundNeed ? '8' : '7'" v-if="ProjectPlan != null">
                  <v-list>
                    <v-list-item class="justify-center" style="height: 200px">
                      <span style="font-weight: bold;font-size: 30px;color: #ff6d81">ยืนยันข้อมูล</span>
                    </v-list-item>
                    <v-list-item class="justify-center" style="height: 200px">
                      <span
                        style="font-weight: bold;font-size: 30px;color: #ff6d81">กรุณาตรวจสอบข้อมูลให้ครบถ้วนก่อนบันทึกข้อมูล</span>
                    </v-list-item>
                    <v-list-item class="justify-center" style="margin-top: 50px">
                      <v-row class="d-flex justify-center">
                        <v-col class="d-flex justify-center" cols="12" md="6">
                          <v-btn :disabled="btnDisable || IsLog == '1'" x-large outlined color="teal"
                            @click="insertProject('0')">
                            <v-icon left>mdi-content-save-all</v-icon>
                            บันทึกข้อมูล
                          </v-btn>
                        </v-col>
                        <v-col v-if="
                            (TypeInsertProject == '0' && Project == null) ||
                              (TypeInsertProject == '0' &&
                                Project != null &&
                                Project.IsPlanStatus == '4')
                          " class="d-flex justify-center" cols="12" md="6">
                          <v-btn :disabled="btnDisable || IsLog == '1'" x-large outlined color="teal"
                            @click="insertProject('1')">
                            <v-icon left>mdi-content-save-all</v-icon>
                            บันทึกข้อมูลและเสนอโครงการ
                          </v-btn>
                        </v-col>
                        <v-col v-if="
                            TypeInsertProject == '1' &&
                              Project != null &&
                              Project.Status == '0'
                          " class="d-flex justify-center" cols="12" md="6">
                          <v-btn :disabled="btnDisable" x-large outlined color="teal" @click="insertProject('1')">
                            <v-icon left>mdi-content-save-all</v-icon>
                            บันทึกข้อมูลและเสนอโครงการ
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red" @click="backStep(7)" v-if="!roundNeed">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn text color="red" @click="backStep(6)" v-else>
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-stepper-content>
              </template>
            </v-stepper>
          </div>
        </template>
        <template v-else-if="TypeProject == '2'">
          <v-card-title>
            <h1 style="font-weight: bold">เดินทางไปปฏิบัติราชการ</h1>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 pa-md-16">
            <v-list-item>
              <div align="center">
                <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
              </div>
            </v-list-item>
            <v-list-item>
              <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel" :key="fiscalYear.year"
                @change="selProjFiscalYear">
                <v-radio :value="fiscalYear.year" class="font-weight-bold" :label="('' + fiscalYear.yearth)"></v-radio>
              </v-radio-group>
            </v-list-item>
            <v-list-item>
              <v-autocomplete :items="
                  Project_plan.filter(
                    (item) => item.Project_type == TypeProject
                  )
                " item-text="full_Text" item-value="Project_code" item-disabled="disabled" v-model="ProjectPlan"
                outlined label="ข้อมูลเดินทางไปปฏิบัติราชการ" clearable @click:clear="ClearPlanProject"
                @change="showDialogProcess" :loading="isLoading" :disabled="isLoading">
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.full_Text.replaceAll("[^a-zA-Z]+", "") }}
                    <v-chip v-if="
                        StatusProject.filter(
                          (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                      " :color="
                        StatusProject.filter(
                          (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                          ? StatusProject.filter(
                              (staItem) => staItem.id == item.IsPlanStatus
                            )[0].color
                          : ''
                      " style="transform: scale(0.8);color: white">
                      <span style="color: white">{{
                        StatusProject.filter(
                        (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                        ? StatusProject.filter(
                        (staItem) => staItem.id == item.IsPlanStatus
                        )[0].status
                        : ""
                        }}</span>
                    </v-chip>
                    <v-chip v-if="item.IsLog == '1'" color="red" style="transform: scale(0.8);color: white">
                      <span style="color: white">ล็อคการแก้ไข</span>
                    </v-chip>
                    <v-chip v-if="item.IsDataComplete == '0'" color="#E53935"
                      style="transform: scale(0.8);color: white">
                      <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                    </v-chip>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.full_Text.replaceAll("[^a-zA-Z]+", "") }}
                    <v-chip v-if="
                        StatusProject.filter(
                          (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                      " :color="
                        StatusProject.filter(
                          (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                          ? StatusProject.filter(
                              (staItem) => staItem.id == item.IsPlanStatus
                            )[0].color
                          : ''
                      " style="transform: scale(0.8);color: white">
                      <span style="color: white">{{
                        StatusProject.filter(
                        (staItem) => staItem.id == item.IsPlanStatus
                        ).length > 0
                        ? StatusProject.filter(
                        (staItem) => staItem.id == item.IsPlanStatus
                        )[0].status
                        : ""
                        }}</span>
                    </v-chip>
                    <v-chip v-if="item.IsLog == '1'" color="red" style="transform: scale(0.8);color: white">
                      <span style="color: white">ล็อคการแก้ไข</span>
                    </v-chip>
                    <v-chip v-if="item.IsDataComplete == '0'" color="#E53935"
                      style="transform: scale(0.8);color: white">
                      <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                    </v-chip>
                  </span>
                </template>
              </v-autocomplete>
            </v-list-item>
            <v-list-item>
              <v-stepper non-linear style="width: 100%" v-model="tabsTravel">
                <v-stepper-header>
                  <v-stepper-step editable step="1" class="font-weight-bold">
                    <h3>ข้อมูลรายละเอียด</h3>
                    <h3 class="mt-2">(อบรม / เดินทาง)</h3>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <!-- <v-stepper-step editable step="2" class="font-weight-bold">
                    <h3>แบบฟอร์ม,ค่าใช้จ่าย</h3>
                    <h3 class="mt-2">(ขออนุมัติหลักการ)</h3>
                  </v-stepper-step> -->

                  <template v-if="
                      Project != null &&
                        (Project.IsPlanStatus == '2' ||
                          Project.IsPlanStatus == '6' ||
                          Project.IsPlanStatus == '7' ||
                          Project.IsPlanStatus == '8') &&
                        !CheckProcess
                    ">
                    <v-divider></v-divider>

                    <v-stepper-step editable step="3" class="font-weight-bold">
                      <h3>แบบฟอร์ม,ค่าใช้จ่าย</h3>
                      <h3 class="mt-2">(เบิกจ่าย)</h3>
                    </v-stepper-step>
                  </template>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-list>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 style="font-weight: bold">
                                  ประเภทการทำรายการ
                                </h2>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-radio-group v-model="IsProcess" :error="IsProcess == null" :error-messages="
                                    IsProcess == null ? 'ประเภทการทำรายการ' : ''
                                  " persistent-hint :rules="[rules.required]" required ref="IsProcess" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                  <v-radio value="2" class="font-weight-bold" label="เดินทางไปราชการ (ในวิชาชีพ)"
                                    color="green"></v-radio>
                                  <v-radio value="1" class="font-weight-bold" label="เดินทางไปราชการ (นอกวิชาชีพ)"
                                    color="yellow"></v-radio>
                                  <v-radio value="3" class="font-weight-bold"
                                    label="เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)"
                                    color="red"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 style="font-weight: bold">
                                  ประเภทค่าใช้จ่าย
                                </h2>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-radio-group row v-model="IsExpense" :error="IsExpense == null" :error-messages="
                                    IsExpense == null ? 'ประเภทค่าใช้จ่าย' : ''
                                  " persistent-hint :rules="[rules.required]" required :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  " ref="IsExpense">
                                  <v-radio value="1" class="font-weight-bold" label="มีค่าใช้จ่าย"
                                    color="green"></v-radio>
                                  <v-radio value="0" class="font-weight-bold" label="ไม่มีค่าใช้จ่าย"
                                    color="red"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  หน่วยงาน
                                </h2>
                                <v-autocomplete outlined v-model="DepSelect" label="หน่วยงาน" :items="depart"
                                  item-text="dep_name" item-value="dep_id" hint="หน่วยงาน (ห้ามว่าง)" :error-messages="
                                    DepSelect == null
                                      ? 'หน่วยงาน (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint :error="DepSelect == null" clearable :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ปีงบประมาณ
                                </h2>
                                <v-autocomplete outlined v-model="FiscalYear" label="ปีงบประมาณ" :items="FiscalYearData"
                                  item-text="yearth" item-value="year" :error-messages="
                                    FiscalYear == ''
                                      ? 'ปีงบประมาณ (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint :error="FiscalYear == ''" @change="getCourseType" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ประเภทการไปปฏิบัติราชการ
                                </h2>
                                <v-select outlined :error="Project_group == null" v-model="Project_group"
                                  ref="Project_group" :items="
                                    projectGroup.filter(
                                      (item) =>
                                        item.Type == '2' || item.Type == '3'
                                    )
                                  " item-value="Project_group" item-text="Project_group_des"
                                  label="ประเภทการไปปฏิบัติราชการ" :error-messages="
                                    Project_group == null
                                      ? 'ประเภทการไปปฏิบัติราชการ (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint :rules="[rules.required]" required @change="SelProjectGroup"
                                  :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                </v-select>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div v-if="Project_group == '999'">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    อื่นๆ โปรดระบุ
                                  </h2>
                                  <v-text-field outlined :error="
                                      Project_group == '999' &&
                                        txtProject_group == ''
                                    " v-model="txtProject_group" label="อื่นๆ โปรดระบุ" hide-details="auto"
                                    :rules="[rules.required]" required :error-messages="
                                      Project_group == '999' &&
                                      txtProject_group == ''
                                        ? 'อื่นๆ โปรดระบุ'
                                        : ''
                                    " persistent-hint :disabled="
                                      ProjectPlan != null &&
                                        !CheckProcess &&
                                        Project != null &&
                                        Project.IsPlanStatus != '0' &&
                                        Project.IsPlanStatus != '4'
                                    "></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ชื่องาน / กิจกรรม
                                </h2>
                                <v-text-field v-model="Project_name" label="ชื่องาน / กิจกรรม" outlined
                                  :rules="[rules.required]" required hide-details="auto" :error-messages="
                                    Project_name == ''
                                      ? 'ชื่องาน / กิจกรรม (ห้ามว่าง)'
                                      : ''
                                  " :error="Project_name == ''" ref="Project_name" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  " persistent-hint></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  งาน / กิจกรรม ถูกจัดขึ้น
                                </h2>
                                <v-select outlined :items="PLACESelete" item-value="id" item-text="detail"
                                  :error="PLACE == ''" v-model="PLACE" label="งาน / กิจกรรม ถูกจัดขึ้น" :error-messages="
                                    PLACE == ''
                                      ? 'งาน / กิจกรรม ถูกจัดขึ้น (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint required :rules="[rules.required]" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  " @change="CheckPlace">
                                </v-select>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  {{
                                  PLACE == "2"
                                  ? "จังหวัด"
                                  : PLACE == "3"
                                  ? "ประเทศ"
                                  : ""
                                  }}
                                </h2>
                                <div class="d-inline" v-if="PLACE == '2'">
                                  <v-autocomplete outlined :error="Province_id == null" v-model="Province_id"
                                    :items="provinces_Data" item-text="name_th" item-value="code" label="จังหวัด"
                                    :error-messages="
                                      Province_id == null
                                        ? 'จังหวัด (ห้ามว่าง)'
                                        : ''
                                    " persistent-hint required :rules="[rules.required]" :disabled="
                                      ProjectPlan != null &&
                                        !CheckProcess &&
                                        Project != null &&
                                        Project.IsPlanStatus != '0' &&
                                        Project.IsPlanStatus != '4'
                                    "></v-autocomplete>
                                </div>
                                <div class="d-inline" v-if="PLACE == '3'">
                                  <v-autocomplete outlined :error="Country_id == null" v-model="Country_id"
                                    :items="countryData" item-text="ct_nameTHA" item-value="ct_code" label="ประเทศ"
                                    :error-messages="
                                      Country_id == null
                                        ? 'ประเทศ (ห้ามว่าง)'
                                        : ''
                                    " persistent-hint required :rules="[rules.required]" :disabled="
                                      ProjectPlan != null &&
                                        !CheckProcess &&
                                        Project != null &&
                                        Project.IsPlanStatus != '0' &&
                                        Project.IsPlanStatus != '4'
                                    "></v-autocomplete>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  งบประมาณที่ขอ
                                </h2>
                                <v-text-field outlined type="number" :error="BudgetRequest == ''"
                                  v-model="BudgetRequest" label="งบประมาณที่ขอ" hide-details="auto"
                                  :rules="[rules.required]" required :error-messages="
                                    BudgetRequest == ''
                                      ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0'
                                      : ''
                                  " persistent-hint :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  จัดโดย
                                </h2>
                                <v-select outlined :error="WorkBy == ''" v-model="WorkBy" label="จัดโดย"
                                  :items="WorkByData" item-value="id" item-text="detail" :error-messages="
                                    WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''
                                  " persistent-hint required :rules="[rules.required]" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-select>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  วันที่เริ่มต้น
                                </h2>
                                <template>
                                  <v-menu v-model="showPickerDateRoundStart" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field outlined v-model="dateRegS" label="วันที่เริ่มต้น" hint="YYYY/MM/DD"
                                        persistent-hint readonly :error="dateRegS == ''" :error-messages="
                                          dateRegS == ''
                                            ? 'วันที่เริ่มต้น ห้ามว่าง'
                                            : ''
                                        " v-on="on" :disabled="
                                          ProjectPlan != null &&
                                            !CheckProcess &&
                                            Project != null &&
                                            Project.IsPlanStatus != '0' &&
                                            Project.IsPlanStatus != '4'
                                        "></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="dateRegS" no-title
                                      @input="showPickerDateRoundStart = false"></v-date-picker>
                                  </v-menu>
                                </template>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  วันที่สิ้นสุด
                                </h2>
                                <template>
                                  <v-menu v-model="showPickerDateRoundEnd" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field outlined v-model="dateRegE" label="วันที่สิ้นสุด" hint="YYYY/MM/DD"
                                        persistent-hint readonly :error="dateRegE == ''" :error-messages="
                                          dateRegE == ''
                                            ? 'วันที่สิ้นสุด ห้ามว่าง'
                                            : ''
                                        " :disabled="
                                          ProjectPlan != null &&
                                            !CheckProcess &&
                                            Project != null &&
                                            Project.IsPlanStatus != '0' &&
                                            Project.IsPlanStatus != '4'
                                        " v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="dateRegE" no-title
                                      @input="showPickerDateRoundEnd = false"></v-date-picker>
                                  </v-menu>
                                </template>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ชื่อผู้จัด
                                </h2>
                                <v-text-field outlined :error="WorkByName == ''" v-model="WorkByName" label="ชื่อผู้จัด"
                                  hide-details="auto" :error-messages="
                                    WorkByName == ''
                                      ? 'ชื่อผู้จัด (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint required :rules="[rules.required]" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  สถานที่จัด
                                </h2>
                                <v-text-field outlined v-model="Location" label="สถานที่จัด" hide-details="auto"
                                  :error="Location == ''" :error-messages="
                                    Location == ''
                                      ? 'สถานที่จัด (ห้ามว่าง)'
                                      : ''
                                  " :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  เบอร์โทรติดต่อผู้กรอกข้อมูล
                                </h2>
                                <v-text-field outlined :error="WorkByPhone == ''" v-model="WorkByPhone"
                                  label="เบอร์โทรติดต่อผู้กรอกข้อมูล" hide-details="auto" :error-messages="
                                    WorkByPhone == ''
                                      ? 'เบอร์โทรติดต่อผู้กรอกข้อมูล (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint required :rules="[rules.required]" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="mt-4">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  หลักสูตร
                                </h2>
                                <v-autocomplete outlined :items="
                                    courseData.filter(
                                      (item) =>
                                        item.Course_type2 == '2' ||
                                        item.Course_type2 == '3'
                                    )
                                  " item-text="Course_name" item-value="Course_code" v-model="Course_code"
                                  label="หลักสูตร" @change="getCourseType" @click:clear="CheckCourseClear"
                                  persistent-hint clearable :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="Course_code != null">
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  สาขาประเภทหลักสูตร
                                </h2>
                                <v-text-field outlined v-model="course_group" label="สาขาประเภทหลักสูตร" required
                                  disabled></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ระยะเวลา
                                </h2>
                                <v-autocomplete outlined readonly :items="period" item-text="name" item-value="id"
                                  v-model="Period_code" label="ระยะเวลา" required disabled></v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  จำนวน ช.ม
                                </h2>
                                <v-text-field outlined type="number" :error="CalHourse == ''" v-model="CalHourse"
                                  label="จำนวน ช.ม" hide-details="auto" :rules="[rules.required]" required
                                  :error-messages="
                                    CalHourse == ''
                                      ? 'จำนวน ช.ม (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <h2 class="pb-4" style="font-weight: bold">
                                  จำนวน เครดิต
                                </h2>
                                <v-text-field outlined type="number" :error="CalCredit == ''" v-model="CalCredit"
                                  label="จำนวน เครดิต" hide-details="auto" :error-messages="
                                    CalCredit == ''
                                      ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0'
                                      : ''
                                  " persistent-hint :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4 d-flex" style="font-weight: bold">
                                  เพิ่มรายชื่อผู้เข้าร่วมเดินทางและชี้แจงรายละเอียดค่าใช้จ่าย
                                </h2>
                                <v-btn color="green" @click="showDialogAddJoinTravel" class="ml-4 mb-4 font-weight-bold"
                                  x-large @focus="fileName = 'file10'" @focusout="fileName = 'file01'" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                  เพิ่มรายชื่อผู้เข้าร่วมเดินทางและชี้แจงรายละเอียดค่าใช้จ่าย
                                </v-btn>
                                <h2 class="pb-4 d-flex" style="font-weight: bold;color: #364eff"
                                  v-if="JoinTravel.length > 0">
                                  ( มีผู้ร่วมเดินทางจำนวน
                                  {{ JoinTravel.length }} ท่าน )
                                </h2>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <div align="center" class="d-flex justify-center" v-if="JoinTravel.length > 0">
                            <download-excel class="btn btn-default mr-4" :data="json_data"
                              :fields="getFilteredJsonFields()" worksheet="รายชื่อผู้เข้าร่วม" :title="array_title"
                              :name="
                                'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'
                              ">
                              <v-btn x-large outlined color="green" class="darken-3" @click="ExportJoinTravelData">
                                Export รายชื่อผู้เข้าร่วมเดินทาง
                              </v-btn>
                            </download-excel>
                          </div>
                          <v-list-item class="mt-5">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  รายละเอียดเพิ่มเติม (ถ้ามี)
                                </h2>
                                <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Remarks" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  "></v-textarea>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  แนบไฟล์เอกสารประกอบ
                                </h2>
                                <v-file-input v-model="files" color="deep-purple accent-4" counter
                                  label="แนบไฟล์เอกสารประกอบ (เดินทางปฏิบัติงาน)" multiple placeholder="เลือกไฟล์"
                                  prepend-icon="mdi-paperclip" outlined :show-size="1000" @change="FileSelect"
                                  :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                                      {{ text }}
                                    </v-chip>

                                    <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                                      +{{ files.length - 2 }} File(s)
                                    </span>
                                  </template>
                                </v-file-input>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">
                              **สนับสนุนไฟล์ PDF เท่านั้น
                            </p>
                          </v-list-item>
                          <v-list-item>
                            <v-alert v-if="alert" prominent type="error">
                              <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                <v-col class="d-flex grow">- {{ item.Detail }}
                                </v-col>
                              </v-row>
                            </v-alert>
                          </v-list-item>
                          <v-list-item v-if="FileProject.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์ประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col v-for="(file_i, index) in FileProject" :key="index"
                                          class="d-flex child-flex" cols="12" md="6">
                                          <v-btn text @click="ShowData(file_i.src)">
                                            <span style="color: indigo">
                                              {{ file_i.name | truncateText }}
                                            </span>
                                          </v-btn>
                                          <v-btn @click="DeleteFile(file_i)" text color="red" :disabled="
                                              ProjectPlan != null &&
                                                !CheckProcess &&
                                                Project != null &&
                                                Project.IsPlanStatus != '0' &&
                                                Project.IsPlanStatus != '4'
                                            ">
                                            ลบ
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="12" md="5">
                        <v-list>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1">
                                <span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                              </v-list-item-title>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col cols="12" md="12">
                                    <v-row class="d-flex justify-center">
                                      <v-col cols="12" md="12">
                                        <v-responsive>
                                          <v-spacer></v-spacer>
                                          <v-text-field label="ค้นหา สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์"
                                            v-model="searchCompe"></v-text-field>
                                        </v-responsive>
                                        <v-responsive>
                                          <v-treeview v-model="selection" selectable :activatable="true"
                                            :items="CompetencyData" :search="searchCompe" @input="ChooseCompetency"
                                            :disabled="
                                              ProjectPlan != null &&
                                                !CheckProcess &&
                                                Project != null &&
                                                Project.IsPlanStatus != '0' &&
                                                Project.IsPlanStatus != '4'
                                            " ref="Competency">
                                            <template v-slot:prepend="{ item, open }">
                                              <v-icon v-if="!item.file" color="blue lighten-2">
                                                {{
                                                open
                                                ? "mdi-folder-open"
                                                : "mdi-folder"
                                                }}
                                              </v-icon>
                                              <v-icon v-else>
                                                {{ files[item.file] }}
                                              </v-icon>
                                            </template>
                                            <template v-slot:label="{ item, active }">
                                              <div v-if="isMobile" style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                  {{ item.name }}
                                                </span>
                                                <span style="font-size: 12px;color: blue;font-weight: bold" v-else>
                                                  {{ item.name }}
                                                </span>
                                              </div>
                                              <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                                <span :style="{ color: 'black' }" v-if="!active">
                                                  {{ item.name }}
                                                </span>
                                                <span style="font-size: 12px;color: blue;font-weight: bold" v-else>
                                                  {{ item.name }}
                                                </span>
                                                <!--                                                <span style="color: #364eff;font-weight: bold"-->
                                                <!--                                                      v-else>-->
                                                <!--                                                    {{ item.name }}-->
                                                <!--                                                </span>-->
                                              </div>
                                            </template>
                                          </v-treeview>
                                        </v-responsive>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-divider class="mt-6 mb-6"></v-divider>
                              <template v-if="!CheckProcess">
                                <v-list-item class="justify-center">
                                  <v-row justify="center">
                                    <v-col cols="12" md="12">
                                      <h2 class="pb-4" style="font-weight: bold">
                                        ประวัติสถานะขอเดินทางไปปฏิบัติราชการ
                                      </h2>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-btn class="font-weight-bold" outlined color="primary" x-large
                                    @click="openProjectRecord">แสดงประวัติสถานะการทำรายการ
                                  </v-btn>
                                </v-list-item>
                              </template>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <!--                <div style="vertical-align: center">
                                          <v-img style="vertical-align: center"
                                                 :src="require('../../assets/Image/' + fileName + '.png')"></v-img>
                                          &lt;!&ndash;                  <v-app-bar app fixed>
                                                              <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                                              <v-toolbar-title>Fixed Position Screen</v-toolbar-title>
                                                            </v-app-bar>&ndash;&gt;
                                        </div>-->
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-list>
                          <h2 class="mt-6" style="font-weight: bold">
                            ข้อมูลประกอบแบบฟอร์มและชี้แจงรายละเอียดค่าใช้จ่าย
                          </h2>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 style="font-weight: bold">
                                  ส่วนงาน/ภาควิชา
                                </h2>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-autocomplete v-model="DepSelect" label="ส่วนงาน/ภาควิชา" :items="depart"
                                  item-text="dep_name" item-value="dep_id" hint="ส่วนงาน/ภาควิชา (ห้ามว่าง)"
                                  :error-messages="
                                    DepSelect == null
                                      ? 'ส่วนงาน/ภาควิชา (ห้ามว่าง)'
                                      : ''
                                  " persistent-hint :error="DepSelect == null" clearable @focus="fileName = 'file02'"
                                  @focusout="fileName = 'file01'" @change="chooseDepartID" :disabled="
                                    ProjectPlan != null &&
                                      !CheckProcess &&
                                      Project != null &&
                                      Project.IsPlanStatus != '0' &&
                                      Project.IsPlanStatus != '4'
                                  ">
                                </v-autocomplete>
                                <v-text-field outlined label="ส่วนงาน/ภาควิชา" class="mt-4" v-model="departName"
                                  @focus="fileName = 'file02'" @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="4">
                                <h2 class="pb-4" style="font-weight: bold">
                                  เบอร์โทร
                                </h2>
                                <v-text-field outlined label="เบอร์โทร" v-model="phone2" @focus="fileName = 'file03'"
                                  @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4">
                                <h2 class="pb-4" style="font-weight: bold">
                                  เลขที่ มอ
                                </h2>
                                <v-text-field outlined label="เลขที่ มอ" v-model="mororNumber"
                                  @focus="fileName = 'file04'" @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ลงวันที่
                                </h2>
                                <v-menu v-model="showDocDate" :close-on-content-click="false"
                                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field v-model="docDate" label="ลงวันที่" hint="YYYY/MM/DD" persistent-hint
                                      readonly v-on="on" @focus="fileName = 'file05'" @focusout="fileName = 'file01'"
                                      outlined></v-text-field>
                                  </template>
                                  <v-date-picker locale="th" v-model="docDate" no-title
                                    @input="showDocDate = false"></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  เรื่อง
                                </h2>
                                <v-text-field outlined label="ชื่อเรื่อง" v-model="topic" @focus="fileName = 'file06'"
                                  @focusout="fileName = 'file01'" ref="topic"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  เรียน
                                </h2>
                                <v-text-field outlined label="เรียน" v-model="dear" @focus="fileName = 'file07'"
                                  @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  รายละเอียด/ที่มา ของเรื่อง
                                </h2>
                                <v-textarea outlined label="รายละเอียด/ที่มา ของเรื่อง" v-model="detail"
                                  @focus="fileName = 'file08'" @focusout="fileName = 'file01'"></v-textarea>
                                <!--                        <ckeditor v-model="detail" :config="editorConfig2"-->
                                <!--                                  :editor-url="editorUrl2"></ckeditor>-->
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  หมายเหตุ
                                </h2>
                                <v-textarea outlined label="หมายเหตุ" style="white-space: pre-line" v-model="note"
                                  @focus="fileName = 'file10'" @focusout="fileName = 'file01'"></v-textarea>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ลงชื่อ
                                </h2>
                                <v-autocomplete v-model="peridSave" :items="staffData" item-text="customDetail"
                                  item-value="perid" label="รายชื่อบุคลากรในคณะ" outlined @change="choosePeridSave"
                                  @focus="fileName = 'file11'" @focusout="fileName = 'file01'"></v-autocomplete>
                                <v-text-field outlined label="ลงชื่อ" v-model="nameSave" @focus="fileName = 'file11'"
                                  @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ตำแหน่ง
                                </h2>
                                <v-text-field outlined label="ตำแหน่ง" v-model="positionSave"
                                  @focus="fileName = 'file11'" @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ลงชื่อ ผู้มีอำนาจอนุมัติ
                                </h2>
                                <v-autocomplete v-model="peridApprove" :items="staffData" item-text="customDetail"
                                  item-value="perid" label="รายชื่อบุคลากรในคณะ" outlined @change="choosePeridApprove"
                                  @focus="fileName = 'file12'" @focusout="fileName = 'file01'"></v-autocomplete>
                                <v-text-field outlined label="ลงชื่อ ผู้มีอำนาจอนุมัติ" v-model="nameApprove"
                                  @focus="fileName = 'file12'" @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col cols="12" md="12">
                                <h2 class="pb-4" style="font-weight: bold">
                                  ตำแหน่งผู้มีอำนาจอนุมัติ
                                </h2>
                                <v-text-field outlined label="ตำแหน่งผู้มีอำนาจอนุมัติ" v-model="positionApprove"
                                  @focus="fileName = 'file12'" @focusout="fileName = 'file01'"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                        <div align="center" v-if="ProjectPlan != null && !CheckProcess">
                          <v-btn class="ma-4" x-large @click="insertTravelForm" :loading="loadingSaveReport">
                            <h3>บันทึกแบบฟอร์มเสนออนุมัติ</h3>
                          </v-btn>
                        </div>
                        <div align="center" v-if="ProjectPlan != null && !CheckProcess">
                          <v-btn x-large @click="showReport()" :loading="loadingShowReport">
                            <h3>พิมพ์เอกสารแบบฟอร์ม</h3>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="12" md="5">
                        <h2 class="mt-8" style="font-weight: bold">
                          ตัวอย่างแบบฟอร์ม และ ตำแหน่งข้อความ
                        </h2>
                        <div style="vertical-align: center;margin-top: 150px">
                          <v-img style="vertical-align: center" :src="
                              require('../../assets/Image/' + fileName + '.png')
                            "></v-img>
                        </div>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <div align="center">
                      <v-btn x-large color="primary" class="font-weight-bold" @click="showDialogJoinTravelReport">
                        <span>เลือกรายชื่อผู้เดินทาง</span>
                      </v-btn>
                    </div>
                    <template v-if="disPerid != null">
                      <v-row class="mt-4">
                        <v-col cols="12" md="6">
                          <v-list>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เลขที่ มอ
                                  </h2>
                                  <v-text-field outlined label="เลขที่ มอ" v-model="disMororNumber"
                                    @focus="fileName = 'file04'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ลงวันที่ (วันที่ออกเลขหนังสือ)
                                  </h2>
                                  <v-menu v-model="showDisDocDate" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="disDocDate" label="ลงวันที่ (วันที่ออกเลขหนังสือ)"
                                        hint="YYYY/MM/DD" persistent-hint readonly v-on="on"
                                        @focus="fileName = 'file05'" @focusout="fileName = 'file01'"
                                        outlined></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="disDocDate" no-title
                                      @input="showDisDocDate = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ลงวันที่ (วันที่เขียนเบิก)
                                  </h2>
                                  <v-menu v-model="showDocDateWithdraw" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="disDocDateWithdraw" label="ลงวันที่ (วันที่เขียนเบิก)"
                                        hint="YYYY/MM/DD" persistent-hint readonly v-on="on"
                                        @focus="fileName = 'file05'" @focusout="fileName = 'file01'"
                                        outlined></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="disDocDateWithdraw" no-title
                                      @input="showDocDateWithdraw = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เรื่อง
                                  </h2>
                                  <v-text-field outlined label="ชื่อเรื่อง" v-model="disTopic"
                                    @focus="fileName = 'file06'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เรียน
                                  </h2>
                                  <v-text-field outlined label="เรียน" v-model="disDear" @focus="fileName = 'file07'"
                                    @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ตามคำสั่ง/บันทึก ที่
                                  </h2>
                                  <v-text-field outlined label="ตามคำสั่ง/บันทึก ที่" v-model="disMessage1"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ลงวันที่ (วันที่หนังสืออนุมัติ)
                                  </h2>
                                  <v-menu v-model="showDocDateApprove" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="disDocDateApprove" label="ลงวันที่ (วันที่หนังสืออนุมัติ)"
                                        hint="YYYY/MM/DD" persistent-hint readonly v-on="on"
                                        @focus="fileName = 'file05'" @focusout="fileName = 'file01'"
                                        outlined></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="disDocDateApprove" no-title
                                      @input="showDocDateApprove = false"></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ได้อนุมัติให้ข้าพเจ้า (ผู้เบิก)
                                  </h2>
                                  <v-text-field outlined label="ได้อนุมัติให้ข้าพเจ้า (ผู้เบิก)" v-model="disFullName"
                                    @focus="fileName = 'file12'" @focusout="fileName = 'file01'"
                                    readonly></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ตำแหน่ง
                                  </h2>
                                  <v-text-field outlined label="ตำแหน่ง" v-model="disPosition"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"
                                    readonly></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    สังกัด
                                  </h2>
                                  <v-text-field outlined label="สังกัด" v-model="disDepName"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"
                                    readonly></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เดินทางไปปฏิบัติงานที่
                                  </h2>
                                  <v-text-field outlined label="เดินทางไปปฏิบัติงานที่" v-model="disMessage2"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    โดยออกเดินทางจาก
                                  </h2>
                                  <v-radio-group row v-model="disTypeStart">
                                    <v-radio value="1" class="font-weight-bold" label="บ้านพัก">
                                      <template v-slot:label>
                                        <h3>บ้านพัก</h3>
                                      </template>
                                    </v-radio>
                                    <v-radio value="2" class="font-weight-bold" label="สำนักงาน">
                                      <template v-slot:label>
                                        <h3>สำนักงาน</h3>
                                      </template>
                                    </v-radio>
                                    <v-radio value="3" class="font-weight-bold" label="ประเทศไทย">
                                      <template v-slot:label>
                                        <h3>ประเทศไทย</h3>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ตั้งแต่วันที่
                                  </h2>
                                  <v-menu v-model="showDisDateStart" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="disDateStart" label="วันที่เริ่มต้น" hint="YYYY/MM/DD"
                                        persistent-hint readonly v-on="on" @focus="fileName = 'file05'"
                                        @focusout="fileName = 'file01'" outlined></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="disDateStart" no-title
                                      @input="showDisDateStart = false" @change="summaryDateTime"></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เวลา (ออกเดินทาง)
                                  </h2>
                                  <v-text-field type="time" outlined label="เวลา (ออกเดินทาง)" v-model="disTimeStart"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"
                                    @change="summaryDateTime"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    และกลับถึง
                                  </h2>
                                  <v-radio-group row v-model="disTypeEnd">
                                    <v-radio value="1" class="font-weight-bold" label="บัานพัก"></v-radio>
                                    <v-radio value="2" class="font-weight-bold" label="สำนักงาน"></v-radio>
                                    <v-radio value="3" class="font-weight-bold" label="ประเทศไทย"></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    วันที่กลับ
                                  </h2>
                                  <v-menu v-model="showDisDateEnd" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="disDateEnd" label="วันที่กลับ" hint="YYYY/MM/DD"
                                        persistent-hint readonly v-on="on" @focus="fileName = 'file05'"
                                        @focusout="fileName = 'file01'" outlined></v-text-field>
                                    </template>
                                    <v-date-picker locale="th" v-model="disDateEnd" no-title
                                      @input="showDisDateEnd = false" @change="summaryDateTime"></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    เวลา (กลับ)
                                  </h2>
                                  <v-text-field type="time" outlined label="เวลา (กลับ)" v-model="disTimeEnd"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"
                                    @change="summaryDateTime"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    รวมเวลาไปปฏิบัติงานครั้งนี้
                                  </h2>
                                  <v-text-field outlined label="รวมเวลาไปปฏิบัติงานครั้งนี้" v-model="disMessage3"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'" readonly
                                    disabled></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ข้าเจ้าขอเบิกค่าใช้จ่ายในการเดินทางไปปฏิบัติงานสำหรับ
                                  </h2>
                                  <v-radio-group row v-model="disTypeWithdraw" @change="chooseTypeDicProcess">
                                    <v-radio value="1" class="font-weight-bold" label="ข้าพเจ้า">
                                      <template v-slot:label>
                                        <h3>ข้าพเจ้า</h3>
                                      </template>
                                    </v-radio>
                                    <v-radio value="2" class="font-weight-bold" label="คณะเดินทาง">
                                      <template v-slot:label>
                                        <h3>คณะเดินทาง</h3>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <h2 class="pb-4" style="font-weight: bold">
                              ค่าเบี้ยเลี้ยง
                            </h2>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (วัน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (วัน)" v-model="disAllowance_Days"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (เงิน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (เงิน)" v-model="disAllowance"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <h2 class="pb-4" style="font-weight: bold">
                              ค่าเช่าที่พัก
                            </h2>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <v-radio-group row v-model="disAccommodationCost_Type">
                                    <v-radio value="1" class="font-weight-bold" label="จ่ายจริง">
                                      <template v-slot:label>
                                        <h3>จ่ายจริง</h3>
                                      </template>
                                    </v-radio>
                                    <v-radio value="2" class="font-weight-bold" label="เหมาจ่าย">
                                      <template v-slot:label>
                                        <h3>เหมาจ่าย</h3>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (วัน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (วัน)"
                                    v-model="disAccommodationCost_Days" @focus="fileName = 'file07'"
                                    @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (เงิน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (เงิน)"
                                    v-model="disAccommodationCost" @focus="fileName = 'file07'"
                                    @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <h2 class="pb-4" style="font-weight: bold">
                              ค่าพาหนะ
                            </h2>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (วัน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (วัน)"
                                    v-model="disShippingCosts_Days" @focus="fileName = 'file07'"
                                    @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    จำนวน (เงิน)
                                  </h2>
                                  <v-text-field type="number" outlined label="จำนวน (เงิน)" v-model="disShippingCosts"
                                    @focus="fileName = 'file07'" @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <h2 class="pb-4" style="font-weight: bold">
                              ค่าใช้จ่ายอื่น
                            </h2>
                            <v-list-item>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <h2 class="pb-4" style="font-weight: bold">
                                    ค่าใช้จ่ายอื่น
                                  </h2>
                                  <v-text-field type="number" outlined label="ค่าใช้จ่ายอื่น"
                                    v-model="disRegistrationFee" @focus="fileName = 'file07'"
                                    @focusout="fileName = 'file01'"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </v-list>
                          <div align="center">
                            <v-text-field type="number" outlined label="รวมค่าใช้จ่าย"
                              v-model="disSummary"></v-text-field>
                          </div>
                          <div align="center">
                            <v-text-field outlined label="หมายเหตุ" v-model="disNote"></v-text-field>
                          </div>
                          <div align="center">
                            <v-btn class="ma-4" x-large @click="insertTravelDisbursementForm()"
                              :loading="loadingSaveReport2" v-if="disTypeWithdraw == '1'">
                              <h3>บันทึกแบบฟอร์มเบิก (เฉพาะบุคคล)</h3>
                            </v-btn>
                            <v-btn class="ma-4" x-large @click="insertTravelDisbursementForm()"
                              :loading="loadingSaveReport2" v-else-if="disTypeWithdraw == '2'">
                              <h3>บันทึกแบบฟอร์มเบิก (คณะเดินทาง)</h3>
                            </v-btn>
                          </div>
                          <div align="center">
                            <v-btn x-large @click="showReport2()" :loading="loadingShowReport2">
                              <h3>พิมพ์เอกสารแบบฟอร์ม</h3>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <v-divider></v-divider>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-list-item>
            <div align="center">
              <v-btn class="font-weight-bold ma-4 pa-10 darken-4" color="green" dark
                v-if="Project != null && Project.IsLog == '1' && !CheckProcess" @click="unlockTravel(Project, true)">
                <span style="font-weight: bold;font-size: 20px">ปลดล็อคการแก้ไข</span>
              </v-btn>
              <v-btn class="font-weight-bold ma-4 pa-10 darken-4" color="red" dark v-else-if="
                  Project != null && Project.IsLog == '0' && !CheckProcess
                " @click="lockTravel(Project, true)">
                <span style="font-weight: bold;font-size: 20px">ล็อคการแก้ไข</span>
              </v-btn>
              <v-btn class="font-weight-bold ma-4 pa-10 darken-4" color="red" dark v-if="
                  !CheckProcess &&
                    Project != null &&
                    (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '4')
                " @click="DeleteTravelReq()">
                <span style="font-weight: bold;font-size: 20px">ลบข้อมูล</span>
              </v-btn>
            </div>
            <div align="center">
              <v-btn :color="CheckProcess ? appColor : 'yellow'" @click="insertTravelProject('0')"
                :disabled="btnDisable" :dark="CheckProcess" class="pa-10 ma-4" v-if="
                  !(
                    ProjectPlan != null &&
                    !CheckProcess &&
                    Project != null &&
                    Project.IsPlanStatus != '0' &&
                    Project.IsPlanStatus != '4'
                  )
                ">
                <span style="font-weight: bold;font-size: 20px" v-if="CheckProcess">บันทึกเดินทาง (ใหม่)</span>
                <span style="font-weight: bold;font-size: 20px" v-else>แก้ไข</span>
              </v-btn>
              <v-btn :color="appColor" @click="insertTravelProject('1')" :disabled="btnDisable" :dark="CheckProcess"
                class="pa-10 ma-4" v-if="CheckProcess">
                <span style="font-weight: bold;font-size: 20px">บันทึกเดินทางและเสนออนุมัติ (ใหม่)</span>
              </v-btn>
              <v-btn color="yellow" @click="insertTravelProject('1')" :disabled="btnDisable" :dark="CheckProcess"
                class="pa-10 ma-4" v-else-if="
                  !CheckProcess &&
                    Project != null &&
                    (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '4')
                ">
                <span style="font-weight: bold;font-size: 20px">แก้ไขและเสนออนุมัติ</span>
              </v-btn>
            </div>
            <!--            <template v-if="!CheckProcess && Project != null && (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '4')">
                          <v-divider class="mt-4"></v-divider>
                          <div class="mt-4" align="center">
                            <v-btn
                                :loading="btnDelTravelLoading"
                                x-large
                                color="red"
                                @click="DeleteTravelReq()">
                              <span style="font-weight: bold;font-size: 20px">ลบข้อมูล</span>
                            </v-btn>
                          </div>
                        </template>-->
          </v-card-text>
        </template>
      </v-card>
      <div id="printForm" v-html="editorData" class="d-none d-print-block"></div>
      <template>
        <v-dialog v-model="dialogLecturer" fullscreen transition="dialog-bottom-transition">
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn icon @click="dialogLecturer = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                แบบฟอร์มการเป็นวิทยากร
              </span>
            </v-card-title>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="SubjectForLecturer"
                    :error="SubjectForLecturer == ''" :error-messages="
                      SubjectForLecturer == ''
                        ? 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง'
                        : ''
                    "></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-card style="width: 100%" color="#E0F2F1">
                <v-card-subtitle>
                  <span style="color: #364eff" class="font-weight-bold">รายละเอียดเพิ่มเติมการเป็นวิทยากร</span>
                </v-card-subtitle>
                <v-card-text>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="LecturerProjectName" label="โครงการ" :error="LecturerProjectName == ''"
                          :error-messages="
                            LecturerProjectName == '' ? 'โครงการ' : ''
                          "></v-text-field>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-text-field v-model="LecturerHour" label="จำนวน ช.ม." type="number"
                          :error="LecturerHour == ''" :error-messages="
                            LecturerHour == '' ? 'จำนวน ช.ม.' : ''
                          "></v-text-field>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-text-field v-model="LecturerInvite" label="ผู้เชิญ" :error="LecturerInvite == ''"
                          :error-messages="
                            LecturerInvite == '' ? 'ผู้เชิญ' : ''
                          "></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" md="3">
                        <template>
                          <v-menu v-model="showPickerLecturerDateStart" :close-on-content-click="false"
                            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="LecturerDateStart"
                                label="วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน" hint="YYYY/MM/DD"
                                persistent-hint readonly :error="LecturerDateStart == ''" :error-messages="
                                  LecturerDateStart == ''
                                    ? 'วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน'
                                    : ''
                                " v-on="on"></v-text-field>
                            </template>
                            <v-date-picker locale="th" v-model="LecturerDateStart" no-title
                              @input="showPickerLecturerDateStart = false"></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-text-field v-model="LecturerTimeStart" label="เวลาเริ่มการบรรยาย"
                          :error="LecturerTimeStart == ''" :error-messages="
                            LecturerTimeStart == '' ? 'เวลาเริ่มการบรรยาย' : ''
                          " type="time"></v-text-field>
                      </v-col>
                      <v-col cols="6" md="3">
                        <template>
                          <v-menu v-model="showPickerLecturerDateEnd" :close-on-content-click="false"
                            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="LecturerDateEnd"
                                label="วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน" hint="YYYY/MM/DD"
                                persistent-hint readonly :error="LecturerDateEnd == ''" :error-messages="
                                  LecturerDateEnd == ''
                                    ? 'วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน'
                                    : ''
                                " v-on="on"></v-text-field>
                            </template>
                            <v-date-picker locale="th" v-model="LecturerDateEnd" no-title
                              @input="showPickerLecturerDateEnd = false"></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-text-field v-model="LecturerTimeEnd" label="เวลาสิ้นสุดการบรรยาย" type="time"
                          :error="LecturerTimeEnd == ''" :error-messages="
                            LecturerTimeEnd == '' ? 'เวลาสิ้นสุดการบรรยาย' : ''
                          "></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field v-model="LecturerPlace" label="สถานที่" :error="LecturerPlace == ''"
                          :error-messages="LecturerPlace == '' ? 'สถานที่' : ''"></v-text-field>
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-text-field v-model="LecturerDocNo" label="เลขที่หนังสือ" :error="LecturerDocNo == ''"
                          :error-messages="
                            LecturerDocNo == '' ? 'เลขที่หนังสือ' : ''
                          "></v-text-field>
                      </v-col>
                      <v-col cols="6" md="4">
                        <template>
                          <v-menu v-model="showPickerLecturerDateDocOut" :close-on-content-click="false"
                            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="LecturerDateDocOut" label="วันที่ออกหนังสือ" hint="YYYY/MM/DD"
                                persistent-hint readonly :error="LecturerDateDocOut == ''" :error-messages="
                                  LecturerDateDocOut == ''
                                    ? 'วันที่ออกหนังสือ'
                                    : ''
                                " v-on="on"></v-text-field>
                            </template>
                            <v-date-picker locale="th" v-model="LecturerDateDocOut" no-title
                              @input="showPickerLecturerDateDocOut = false"></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <template>
                    <v-menu v-model="showPickerDateS" :close-on-content-click="false" transition="scale-transition"
                      offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="dateSForLecturer" label="วันที่เริ่มต้นจัดงาน" hint="YYYY/MM/DD"
                          persistent-hint readonly :error="dateSForLecturer == ''" :error-messages="
                            dateSForLecturer == ''
                              ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง'
                              : ''
                          " v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="dateSForLecturer" no-title
                        @input="showPickerDateS = false"></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <template>
                    <v-menu v-model="showPickerDateE" :close-on-content-click="false" transition="scale-transition"
                      offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="dateEForLecturer" label="วันที่สิ้นสุดจัดงาน" hint="YYYY/MM/DD"
                          persistent-hint readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="dateEForLecturer" no-title
                        @input="showPickerDateE = false"></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <template>
                    <v-menu v-model="showPickerTravelDateS" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="dateSTravelForLecturer" label="วันที่เดินทาง" hint="YYYY/MM/DD"
                          persistent-hint readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="dateSTravelForLecturer" no-title
                        @input="showPickerTravelDateS = false"></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <template>
                    <v-menu v-model="showPickerTravelDateE" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="dateETravelForLecturer" label="วันที่สิ้นสุดจัดงาน" hint="YYYY/MM/DD"
                          persistent-hint readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="dateETravelForLecturer" no-title
                        @input="showPickerTravelDateE = false"></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <v-text-field type="time" label="เวลาเริ่มต้น" v-model="timeSForLecturer"></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <v-text-field type="time" label="เวลาสิ้นสุด" v-model="timeEForLecturer"></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="10">
                  <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm2"></v-textarea>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-file-input v-model="filesExpert" color="deep-purple accent-4" counter label="แนบไฟล์เอกสารประกอบ"
                multiple placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip" outlined :show-size="1000"
                @change="FileSelectExpert">
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                    {{ text }}
                  </v-chip>

                  <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                    +{{ filesExpert.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-list-item>
            <v-list-item>
              <v-alert v-if="alertExpert" prominent type="error">
                <v-row align="center" v-for="item in txtAlertExpert" :key="item.id">
                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                </v-row>
              </v-alert>
            </v-list-item>
            <v-list-item v-if="FileProjectExpert.length > 0">
              <template>
                <v-row class="d-flex justify-center">
                  <v-col cols="12" md="12">
                    <v-list>
                      <v-list-item-title>
                        ไฟล์ประกอบ
                      </v-list-item-title>
                      <v-list-item>
                        <v-data-table :items="FileProjectExpert" :headers="FileHeader" style="width: 100%">
                          <template v-slot:item.action="{ item }">
                            <v-list-item class="justify-space-around">
                              <v-btn text @click="ShowData(item.src)" color="green">
                                เรียกดู
                              </v-btn>
                              <v-btn @click="DeleteFile2(item)" text color="red">
                                ลบ
                              </v-btn>
                            </v-list-item>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
            <div align="center">
              <v-btn outlined color="primary" @click="
                  Project_group != null && Project_group != '116'
                    ? AddWorkGuest()
                    : AddRecordLecturer()
                ">
                เพิ่มข้อมูล
              </v-btn>
            </div>
            <v-list-item class="d-flex justify-center" style="margin-top: 20px">
              <v-data-table :items="Lecturer" :headers="headerLecturer" class="elevation-2" show-expand
                style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-if="item.Lecturer != null" style="margin-top: 25px">
                      <span style="font-weight: bold">
                        รายละเอียดเพิ่มเติมการเป็นวิทยากร (เพิ่มเติม)
                      </span>
                      <v-list>
                        <v-list-item>
                          โครงการ : {{ item.Lecturer.Project_name }}
                        </v-list-item>
                        <v-list-item>
                          จำนวน ช.ม. : {{ item.Lecturer.Hour }}
                        </v-list-item>
                        <v-list-item>
                          ผู้เชิญ : {{ item.Lecturer.Invite }}
                        </v-list-item>
                        <v-list-item>
                          วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน :
                          {{ item.Lecturer.DateStart | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาเริ่มการบรรยาย : {{ item.Lecturer.TimeStart }} น.
                        </v-list-item>
                        <v-list-item>
                          วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน :
                          {{ item.Lecturer.DateEnd | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาสิ้นสุดการบรรยาย : {{ item.Lecturer.TimeEnd }} น.
                        </v-list-item>
                        <v-list-item>
                          สถุานที่ : {{ item.Lecturer.Place }}
                        </v-list-item>
                        <v-list-item>
                          เลขที่หนังสือ : {{ item.Lecturer.DocNo }}
                        </v-list-item>
                        <v-list-item>
                          วันที่ออกหนังสือ : {{ item.Lecturer.DateDocNo }}
                        </v-list-item>
                        <v-divider></v-divider>
                      </v-list>
                    </div>
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{ file.File_name
                        }}
                      </v-btn>
                    </div>
                    <div style="margin-bottom: 25px">
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item="{ item, index, expand, isExpanded }">
                  <tr>
                    <td>
                      <v-btn icon color="primary" @click="expand(!isExpanded)">
                        <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      {{ item.subject }}
                    </td>
                    <td>
                      <span v-if="item.date_start != '' && item.date_start != null">{{ item.date_start | dateToThai
                        }}</span>
                    </td>
                    <td>
                      <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
                    </td>
                    <td>
                      <span v-if="
                          item.date_travel_start != '' &&
                            item.date_travel_start != null
                        ">{{ item.date_travel_start | dateToThai }}</span>
                    </td>
                    <td>
                      <span v-if="
                          item.date_travel_end != '' &&
                            item.date_travel_end != null
                        ">{{ item.date_travel_end | dateToThai }}</span>
                    </td>
                    <td>
                      {{ item.time_start }}
                    </td>
                    <td>
                      {{ item.time_end }}
                    </td>
                    <td>
                      <v-btn text @click="GetOldData(item)" color="primary">ใช้ข้อมูลเดิม
                      </v-btn>
                      <v-btn text @click="DelLecturer(index)" color="red">ลบ
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-list-item>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined color="green darken-2"
                @click="TypeProject == '1' ? InsertCoordinator(true) : (Project_group != null && Project_group != '116') ? InsertCoordinator(true): addJoinTravel()">
                บันทึก
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogLecturer = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="dialogDetail" max-width="800">
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
                }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span>
                    {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span>
                    {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span>
                    {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span>
                    {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span>
                    จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span>
                    {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogDetail = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="dialogTemplate" max-width="800">
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogTemplate = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <div>
          <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
            :paginate-elements-by-height="1400" filename="Ori" :pdf-quality="2" :manual-pagination="false"
            pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)" ref="html2Pdf">
            <section slot="pdf-content">
              <div style="color: black;margin-top: -520px" v-html="editorData"></div>
              <section style="display: flex;">
                <p style="color: black">test</p>
              </section>
              <!--              <p style="color: black" v-for="(val, key) in 58" :key="key">mดสอบดดดดดดดดดดดด {{val}}</p>-->
            </section>
          </vue-html2pdf>
        </div>
      </template>
      <template>
        <v-dialog v-model="dialogLecturerDetail" max-width="800">
          <v-card>
            <v-card-title class="headline"><span
                style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2" show-expand
                style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <template v-if="item != null">
                    <td :colspan="headers.length">
                      <div v-if="item.Lecturer != null" style="margin-top: 25px">
                        <span style="font-weight: bold">
                          รายละเอียดเพิ่มเติมการเป็นวิทยากร (เพิ่มเติม)
                        </span>
                        <v-list-item>
                          โครงการ : {{ item.Lecturer.Project_name }}
                        </v-list-item>
                        <v-list-item>
                          จำนวน ช.ม. : {{ item.Lecturer.Hour }}
                        </v-list-item>
                        <v-list-item>
                          ผู้เชิญ : {{ item.Lecturer.Invite }}
                        </v-list-item>
                        <v-list-item>
                          วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน :
                          {{ item.Lecturer.DateStart | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาเริ่มการบรรยาย : {{ item.Lecturer.TimeStart }} น.
                        </v-list-item>
                        <v-list-item>
                          วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน :
                          {{ item.Lecturer.DateEnd | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาสิ้นสุดการบรรยาย : {{ item.Lecturer.TimeEnd }} น.
                        </v-list-item>
                        <v-list-item>
                          สถุานที่ : {{ item.Lecturer.Place }}
                        </v-list-item>
                        <v-list-item>
                          เลขที่หนังสือ : {{ item.Lecturer.DocNo }}
                        </v-list-item>
                        <v-list-item>
                          วันที่ออกหนังสือ : {{ item.Lecturer.DateDocNo }}
                        </v-list-item>
                      </div>
                      <div v-if="item.files != null && item.files.length > 0">
                        <span style="font-weight: bold">
                          ไฟล์ประกอบ :
                        </span>
                      </div>
                      <div v-for="(file, idx) in item.files" v-bind:key="idx">
                        <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ :
                          {{ file.File_name | truncateText }}
                        </v-btn>
                      </div>
                      <div style="margin-bottom: 25px">
                        รายละเอียด : {{ item.Rm }}
                      </div>
                    </td>
                  </template>
                </template>
                <template v-slot:item.date_travel_start="{ item }">
                  <span v-if="
                      item.date_travel_start != '0000-00-00' &&
                        item.date_travel_start != null
                    ">{{ item.date_travel_start | dateToThai }}</span>
                </template>
                <template v-slot:item.date_travel_end="{ item }">
                  <span v-if="
                      item.date_travel_end != '0000-00-00' &&
                        item.date_travel_end != null
                    ">{{ item.date_travel_end | dateToThai }}</span>
                </template>
                <template v-slot:item.date_start="{ item }">
                  <span v-if="
                      item.date_start != '0000-00-00' && item.date_start != null
                    ">{{ item.date_start | dateToThai }}</span>
                </template>
                <template v-slot:item.date_end="{ item }">
                  <span v-if="
                      item.date_end != '0000-00-00' && item.date_end != null
                    ">{{ item.date_end | dateToThai }}</span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialogLecturerDetail = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="dialogGroupDetail" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2" v-if="groupDetail != null">
              <span style="font-weight: bold">{{
                groupDetail.group_name
                }}</span>
            </v-card-title>

            <v-card-text v-if="groupQuataDump.length > 0">
              <div v-for="(qroup, idx) in groupQuataDump" :key="idx" style="color: black" class="pa-2">
                <span>{{ idx + 1 }} - {{ qroup.dep_name }} จำนวนผู้เข้าร่วม :
                  {{ qroup.count }} คน</span>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="dialogGroupDetail = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog persistent v-model="dialogAppointment" width="800">
          <v-card>
            <v-card-title>
              <v-icon large color="red darken-2" @click="closeDialogAppoint">
                mdi-close
              </v-icon>
              <v-spacer></v-spacer>
              <span style="font-weight: bold;color: #364eff">{{
                AppointmentObj.Topic
                }}</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="appointmendHeader" :items="appointmentGroup">
                <template v-slot:item.full_Detail="{ item }">
                  <div v-html="item.full_Detail"></div>
                </template>
                <template v-slot:item.phone="{ item }">
                  <v-text-field label="เบอร์โทร" v-model="item.phone" :disabled="item.status" :error="item.phone == ''"
                    :error-messages="
                      item.phone == '' ? 'เบอร์โทร ห้ามว่าง' : ''
                    "></v-text-field>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-switch v-model="item.status" :color="item.status ? 'green' : 'red'"
                    :error-messages="!item.status ? 'ไม่เข้าร่วม' : ''" success-messages="เข้าร่วม"
                    :disabled="item.phone == ''">
                  </v-switch>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="insertAppointment">
                เพิ่มคณะทำงาน
              </v-btn>
              <v-btn color="red" text @click="closeDialogAppoint">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </template>
    <template>
      <v-dialog v-model="dialogCompetency" max-width="800">
        <v-card>
          <v-card-title>
            Competency,Core Value,Strategic Objective
          </v-card-title>
          <v-card-text>
            <template v-if="CompetencyToShow.length > 0">
              <v-treeview :activatable="true" :items="CompetencyToShow">
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file" color="blue lighten-2">
                    {{ open ? "mdi-folder-open" : "mdi-folder" }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item, active }">
                  <div v-if="isMobile" style="cursor: pointer">
                    <span style="font-size: 12px;color: black" v-if="!active">
                      {{ item.name }}
                    </span>
                    <span style="font-size: 12px;color: #364eff;font-weight: bold" v-else>
                      {{ item.name }}
                    </span>
                  </div>
                  <div v-else style="cursor: pointer">
                    <span style="color:black;" v-if="!active">
                      {{ item.name }}
                    </span>
                    <span style="color: #364eff;font-weight: bold" v-else>
                      {{ item.name }}
                    </span>
                  </div>
                </template>
              </v-treeview>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูล Competency,Core Value,Strategic Objective
              </p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" outlined @click="dialogCompetency = false">
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogFile" max-width="800">
        <v-card>
          <v-card-title>
            ไฟล์เอกสารประกอบ
          </v-card-title>
          <v-card-text>
            <template v-if="FileProject.length > 0">
              <v-container fluid>
                <v-row>
                  <v-col v-for="(file_i, index) in FileProject" :key="index" class="d-flex child-flex" cols="12" md="4">
                    <v-card flat tile>
                      <v-img v-if="file_i.type == 'image'" :src="file_i.src" :lazy-src="
                          `https://picsum.photos/10/6?image=${(index + 1) * 5 +
                            10}`
                        " aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img v-if="file_i.type == 'pdf'" src="../../assets/Image/pdf.png" :lazy-src="
                          `https://picsum.photos/10/6?image=${(index + 1) * 5 +
                            10}`
                        " aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text>
                        <span style="font-weight: bold;color: black">
                          {{ file_i.name }}
                        </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text @click="ShowData(file_i.src)">
                          <span style="color: indigo;font-weight: bold">
                            เรียกดู
                          </span>
                        </v-btn>
                        <v-btn @click="DeleteFile(file_i)" text color="red" class="font-weight-bold">
                          ลบ
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลไฟล์เอกสารประกอบ
              </p>
            </template>
            <v-list>
              <v-list-item>
                <v-file-input v-model="files" color="deep-purple accent-4" counter label="แนบไฟล์เอกสารประกอบโครงการ"
                  multiple placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip" outlined :show-size="1000"
                  @change="FileSelect">
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                      {{ text }}
                    </v-chip>

                    <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
              </v-list-item>
              <v-list-item>
                <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">
                  **สนับสนุนไฟล์ PDF เท่านั้น
                </p>
              </v-list-item>
              <v-list-item>
                <v-alert v-if="alert" prominent type="error">
                  <v-row align="center" v-for="item in txtAlert" :key="item.id">
                    <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                  </v-row>
                </v-alert>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" outlined @click="dialogFile = false">
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogLoading" persistent width="300">
        <v-card :color="appColor" dark>
          <v-card-text>
            Loading.....
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogEditObj" persistent width="600">
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">ระบุวัตถุประสงค์</span>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="Objective" outlined name="" label="วัตถุประสงค์" value="" persistent-hint
              :error="Objective == ''" :error-messages="Objective == '' ? 'วัตถุประสงค์ (ห้ามว่าง)' : ''"
              required></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined @click="editObjectProj">
              <span style="color: indigo;font-weight: bold">
                บันทึก
              </span>
            </v-btn>
            <v-btn @click="dialogEditObj = false" text color="red" class="font-weight-bold">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogSaveData" persistent width="600">
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">กรุณาบันทึกข้อมูลก่อนทำรายการล็อคการแก้ไข</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-5">
            <v-row>
              <v-col col="6">
                <v-btn :disabled="btnDisable || IsLog == '1'" x-large outlined color="teal" @click="insertProject('0')">
                  <v-icon left>mdi-content-save-all</v-icon>
                  บันทึกข้อมูล
                </v-btn>
              </v-col>
              <v-col col="6">
                <v-btn :disabled="btnDisable" x-large outlined color="teal" @click="insertProject('1')">
                  <v-icon left>mdi-content-save-all</v-icon>
                  บันทึกข้อมูลและเสนอโครงการ
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogSaveData = false" text color="red" class="font-weight-bold">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-dialog v-model="DialogImportEmp" persistent max-width="500">
      <v-card>
        <v-card-title>
          <span style="font-weight: bold;color: #364eff">Import
            {{
            typeImport == "1"
            ? "ข้อมูลบุคลากร"
            : typeImport == "2"
            ? "ข้อมูลนักศึกษาคณะแพทย์"
            : "ข้อมูลบุคคลภายนอก"
            }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item class="d-flex justify-center mt-6">
              <v-btn text color="primary" @click="downloadTemplateEmp">ดาวน์โหลด Template ตัวอย่าง
              </v-btn>
            </v-list-item>
            <v-list-item class="mt-6">
              <v-file-input v-model="filesImportEmp" color="deep-purple accent-4" counter multiple
                label="แนบไฟล์ (ถ้ามี)" placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip" outlined :show-size="1000"
                @change="FileImport">
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                    {{ text }}
                  </v-chip>

                  <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                    +{{ filesImportEmp.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-list-item>

            <v-list-item v-if="sheets.length > 0">
              <v-select v-model="ChooseSheet" label="เลือก Sheets" :items="sheets" item-text="name" item-value="name"
                @change="ChooseSheetAction">
              </v-select>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeDi_ImportDataEmp">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DialogImportStd" persistent max-width="500">
      <v-card>
        <v-card-title>
          <span style="font-weight: bold;color: #364eff">Import ข้อมูลนักศึกษา</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item class="d-flex justify-center mt-6">
              <v-btn text color="primary" @click="downloadTemplateEmp" disabled>ดาวน์โหลด Template ตัวอย่าง
              </v-btn>
            </v-list-item>
            <v-list-item class="mt-6">
              <v-file-input v-model="filesImportEmp" color="deep-purple accent-4" counter multiple
                label="แนบไฟล์ (ถ้ามี)" placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip" outlined :show-size="1000"
                @change="FileImport" disabled>
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                    {{ text }}
                  </v-chip>

                  <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                    +{{ filesImportEmp.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-list-item>

            <v-list-item v-if="sheets.length > 0">
              <v-select v-model="ChooseSheet" label="เลือก Sheets" :items="sheets" item-text="name" item-value="name"
                @change="ChooseSheetAction" disabled>
              </v-select>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeDi_ImportDataStd">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DialogExamImportEmp" persistent fullscreen scrollable>
      <v-card>
        <v-toolbar dark :color="appColor">
          <v-btn icon dark @click="closeDi_ImportDataEmp">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><span style="font-weight: bold">ตัวอย่างข้อมูลที่ต้องการนำเข้า</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark style="background-color: black" text class="text-h4" @click="ImportDataToDb">
              นำเข้าข้อมูล
            </v-btn>
            <v-btn dark text style="background-color: red" @click="closeDi_ImportDataEmp" class="text-h4">
              ปิด
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 100%" class="mt-6">
          <v-list>
            <v-list-item>
              <v-data-table :headers="
                  TypeProject == '1' ? empHeadersAfter : empHeadersAfter2
                " :items="empData" class="elevation-2" dense style="width: 100%">
                <template v-slot:item.file="{ item }">
                  <div align="center">
                    <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                      {{ item.files.length }} ไฟล์
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.type="{ item }">
                  <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                    บุคลากรคณะแพทย์
                  </span>
                  <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                    นักศึกษาคณะแพทย์
                  </span>
                  <span v-if="item.registerType_id == '2'" style="color: blue">
                    บุคลากรคณะอื่น
                  </span>
                  <span v-if="item.registerType_id == '3'" style="color: blue">
                    นักศึกษาคณะอื่น
                  </span>
                  <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                    บุคคลภายนอก
                  </span>
                  <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                    นักศึกษาภายนอก
                  </span>
                </template>
                <template v-slot:item.join_status="{ item }">
                  <span style="font-weight: bold;color: red" v-if="item.join_status == '0'">
                    รอลงทะเบียน
                  </span>
                  <span style="font-weight: bold;color: forestgreen" v-else>
                    ลงทะเบียนเข้าร่วม
                  </span>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn color="#F44336" outlined @click="Del_item_ImportEmp(item.idEmp)">
                    ลบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-list-item>
            <div align="center" style="margin-top: 30px">
              <v-alert dense outlined type="error" dismissible v-if="ShowAlertErrImp">
                <div v-html="MessageErrorImp"></div>
              </v-alert>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="1200" persistent v-model="dialogJoinTravel">
      <v-card>
        <v-card-title>
          <v-list-item>
            <h2 class="pb-4" style="font-weight: bold">
              เพิ่มข้อมูลรายชื่อผู้เข้าร่วมเดินทาง
            </h2>
            <v-spacer></v-spacer>
            <v-btn outlined color="#009688" @click="importExcelData('1')">
              Import ข้อมูลบุคลากร
            </v-btn>
          </v-list-item>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <v-list>
            <v-list-item class="mt-4 mb-4">
              <v-radio-group row v-model="rdoTypeJoinTravel">
                <v-radio label="เพิ่มรายชื่อผู้เข้าร่วมรอยืนยันข้อมูล" value="1"></v-radio>
                <v-radio label="เพิ่มรายชื่อผู้เข้าร่วมโดยข้อมูลพื้นฐาน" value="2"
                  :disabled="Project_group != null && Project_group == '116'"></v-radio>
              </v-radio-group>
            </v-list-item>
            <v-list-item>
              <v-autocomplete v-model="peridTravel" :items="staffData" item-text="customDetail" item-value="perid"
                label="รายชื่อบุคลากรในคณะ" :error="peridTravel == null" ref="peridTravel" clearable
                :error-messages="peridTravel == null ? '*' : ''" outlined @change="choosePeridTravel" @keyup="checkKeyEnterTravel"></v-autocomplete>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item class="mt-6">
              <v-row>
                <v-col md="2" cols="12">
                  <v-text-field label="คำนำหน้า (ถ้ามี)" v-model="joinTravelprefixFullName" ref="joinTravelprefixFullName"
                    :error="joinTravelprefixFullName == ''"
                    :error-messages="joinTravelprefixFullName == '' ? '*' : ''"></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field label="ชื่อ - สกุล" readonly v-model="joinTravelfullName"
                    :error="joinTravelfullName == ''"
                    :error-messages="joinTravelfullName == '' ? '*' : ''"></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field label="ตำแหน่งระดับ (วันบรรจุ)" v-model="joinTravelPosition"
                    :error="joinTravelPosition == ''"
                    :error-messages="joinTravelPosition == '' ? '*' : ''"></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="mt-6">
              <v-row>
                <v-col md="3" cols="12">
                  <v-text-field label="ค่าเบี้ยเลี้ยง (บาท)" type="number" v-model="joinTravelAllowance"
                    :error="joinTravelAllowance == ''" :error-messages="joinTravelAllowance == '' ? '*' : ''"
                    @keyup="summaryBudget"></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field label="ค่าที่พัก (บาท)" type="number" v-model="joinTravelAccommodationCost"
                    :error="joinTravelAccommodationCost == ''" :error-messages="
                      joinTravelAccommodationCost == '' ? '*' : ''
                    " @keyup="summaryBudget"></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field label="ค่าพาหนะ (บาท)" type="number" v-model="joinTravelShippingCosts"
                    :error="joinTravelShippingCosts == ''" :error-messages="joinTravelShippingCosts == '' ? '*' : ''"
                    @keyup="summaryBudget"></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field label="ค่าลงทะเบียน (บาท)" type="number" v-model="joinTravelRegistrationFee"
                    :error="joinTravelRegistrationFee == ''"
                    :error-messages="joinTravelRegistrationFee == '' ? '*' : ''" @keyup="summaryBudget"></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="mt-6">
              <v-row>
                <v-col md="6" cols="12">
                  <v-text-field label="รวมค่าเดินทาง (บาท)" type="number" readonly
                    v-model="joinTravelAllTravelExpenses"></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field label="งบวิชาการคงเหลือ (บาท)" type="number" readonly
                    v-model="joinTravelRemainingBudget"></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="d-flex justify-center">
              <div align="center">
                <v-btn outlined color="primary" @click="
                    Project_group != null && Project_group != '116'
                      ? addJoinTravel()
                      : openDialogInsertRecordLecturer()
                  " ref="btnAddJoinTravel">
                  เพิ่มรายชื่อ
                </v-btn>
                <v-btn class="ml-3" outlined color="red" @click="clearDataJoinTravel">ล้างข้อมูล
                </v-btn>
              </div>
            </v-list-item>
            <v-list-item>
              <v-data-table class="mt-6" :items="JoinTravel" :headers="JoinTravelHeader" style="width: 100%">
                <template v-slot:header.customTravelDetail>
                  <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                </template>
                <template v-slot:header.position>
                  <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                </template>
                <template v-slot:header.Allowance>
                  <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                </template>
                <template v-slot:header.AccommodationCost>
                  <h3 class="font-weight-bold">ค่าที่พัก</h3>
                </template>
                <template v-slot:header.ShippingCosts>
                  <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                </template>
                <template v-slot:header.RegistrationFee>
                  <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                </template>
                <template v-slot:header.AllTravelExpenses>
                  <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                </template>
                <template v-slot:header.RemainingBudget>
                  <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                </template>
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td>
                      <div v-html="item.customTravelDetail"></div>
                    </td>
                    <td>{{ item.Allowance | currency }}</td>
                    <td>{{ item.AccommodationCost | currency }}</td>
                    <td>{{ item.ShippingCosts | currency }}</td>
                    <td>{{ item.RegistrationFee | currency }}</td>
                    <td>{{ item.AllTravelExpenses | currency }}</td>
                    <td>{{ item.RemainingBudget | currency }}</td>
                    <td>
                      <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text
                        @click="editJoinTravel(index)">แก้ไข
                      </v-btn>
                      <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(index)">
                        ลบ
                      </v-btn>
                      <div>
                        <v-btn text class="font-weight-bold darken-4"
                          v-if="Project_group != null && Project_group == '116'" color="primary"
                          @click="ShowDetailTravelLecturer(item)">
                          ข้อมูลวิทยากร
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                  <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                    <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                </template>
              </v-data-table>
            </v-list-item>
          </v-list>
        </v-card-text>
        <div align="center" class="d-flex justify-center" v-if="JoinTravel.length > 0">
          <download-excel class="btn btn-default mr-4" :data="json_data" :fields="getFilteredJsonFields()"
            worksheet="รายชื่อผู้เข้าร่วม" :title="array_title" :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'">
            <v-btn x-large outlined color="green" class="darken-3" @click="ExportJoinTravelData">
              Export รายชื่อผู้เข้าร่วมเดินทาง
            </v-btn>
          </download-excel>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogJoinTravel = false">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogProcess" max-width="600" persistent>
      <v-card class="mt-6">
        <v-card-title>
          กรุณาเลือกหัวข้อที่ต้องการทำรายการ
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col v-if="
                  Project_plan.filter(
                    (item) =>
                      item.Project_code == ProjectPlan &&
                      (item.IsPlanStatus == '0' ||
                        item.IsPlanStatus == '2' ||
                        item.IsPlanStatus == '4') &&
                      item.IsLog == '1'
                  ).length > 0
                " class="d-flex justify-center" cols="12" md="6">
                <v-list-item>
                  <v-btn class="font-weight-bold ma-4 pa-10 darken-4" color="green" dark @click="
                      unlockTravel(
                        Project_plan.filter(
                          (item) =>
                            item.Project_code == ProjectPlan &&
                            item.active == '1'
                        ).length > 0
                          ? Project_plan.filter(
                              (item) =>
                                item.Project_code == ProjectPlan &&
                                item.active == '1'
                            )[0]
                          : null,
                        false
                      )
                    ">
                    <span style="font-weight: bold;font-size: 20px">ปลดล็อคการแก้ไข</span>
                  </v-btn>
                </v-list-item>
              </v-col>
              <v-col v-if="
                  Project_plan.filter(
                    (item) =>
                      item.Project_code == ProjectPlan &&
                      (item.IsPlanStatus == '0' ||
                        item.IsPlanStatus == '2' ||
                        item.IsPlanStatus == '4') &&
                      item.IsLog == '0'
                  ).length > 0
                " class="d-flex justify-center" cols="12" md="6">
                <v-btn class="font-weight-bold ma-4 pa-10 darken-4" color="red" dark @click="
                    lockTravel(
                      Project_plan.filter(
                        (item) =>
                          item.Project_code == ProjectPlan && item.active == '1'
                      ).length > 0
                        ? Project_plan.filter(
                            (item) =>
                              item.Project_code == ProjectPlan &&
                              item.active == '1'
                          )[0]
                        : null,
                      false
                    )
                  ">
                  <span style="font-weight: bold;font-size: 20px">ล็อคการแก้ไข</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col v-if="
                  Project_plan.filter(
                    (item) =>
                      item.Project_code == ProjectPlan &&
                      (item.IsPlanStatus == '0' ||
                        item.IsPlanStatus == '2' ||
                        item.IsPlanStatus == '4') &&
                      item.IsLog == '0'
                  ).length > 0
                " class="d-flex justify-center" cols="12" md="6">
                <v-btn color="yellow" class="pa-10" @click="GetTravelToForm(false)">
                  <span style="font-weight: bold;font-size: 20px">แก้ไขรายการ</span>
                </v-btn>
              </v-col>
              <v-col class="d-flex justify-center" cols="12" md="6">
                <v-btn color="primary" class="pa-10" @click="GetTravelToForm(true)">
                  <span style="font-weight: bold;font-size: 20px">ใช้เป็นข้อมูลตั้งต้น</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <template v-if="
              Project_plan.filter(
                (item) =>
                  item.Project_code == ProjectPlan &&
                  (item.IsPlanStatus == '0' || item.IsPlanStatus == '4') &&
                  item.IsLog == '0'
              ).length > 0
            ">
            <v-divider class="mt-4"></v-divider>
            <v-list-item class="mt-4">
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12" md="6">
                  <v-btn color="red" class="pa-10" @click="DeleteTravelReq()" :loading="btnDelTravelLoading">
                    <span style="font-weight: bold;font-size: 20px">ลบข้อมูล</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeDialogProcess">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog fullscreen scrollable hide-overlay transition="dialog-bottom-transition" v-model="dialogJoinTravelReport">
      <v-card>
        <v-card-title>
          <h2 class="pb-4" style="font-weight: bold">รายชื่อผู้เดินทาง</h2>
          <v-spacer></v-spacer>
          <v-btn x-large class="font-weight-bold darken-4 ma-2" color="#80CBC4" @click="printGroupReport()"
            :loading="loadingPrintGroupReport">พิมพ์ใบเบิกคณะเดินทาง
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <v-list>
            <v-list-item>
              <v-responsive>
                <v-data-table class="mt-6" :items="JoinTravel" :headers="JoinTravelDisHeader" style="width: 100%">
                  <template v-slot:header.customTravelDetail>
                    <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                  </template>
                  <template v-slot:header.position>
                    <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                  </template>
                  <template v-slot:header.Allowance>
                    <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                  </template>
                  <template v-slot:header.AccommodationCost>
                    <h3 class="font-weight-bold">ค่าที่พัก</h3>
                  </template>
                  <template v-slot:header.ShippingCosts>
                    <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                  </template>
                  <template v-slot:header.RegistrationFee>
                    <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                  </template>
                  <template v-slot:header.Summary>
                    <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                  </template>
                  <template v-slot:header.RemainingBudget>
                    <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <div v-html="item.customTravelDetail"></div>
                      </td>
                      <td>
                        <v-text-field v-model="item.Allowance" :error="
                            item.Allowance == '' || item.Allowance == null
                          " :error-messages="
                            item.Allowance == '' || item.Allowance == null
                              ? '*'
                              : ''
                          " @keyup="summaryMoney(item)" type="number"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.AccommodationCost" :error="
                            item.AccommodationCost == '' ||
                              item.AccommodationCost == null
                          " :error-messages="
                            item.AccommodationCost == '' ||
                            item.AccommodationCost == null
                              ? '*'
                              : ''
                          " @keyup="summaryMoney(item)" type="number"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.ShippingCosts" :error="
                            item.ShippingCosts == '' ||
                              item.ShippingCosts == null
                          " :error-messages="
                            item.ShippingCosts == '' ||
                            item.ShippingCosts == null
                              ? '*'
                              : ''
                          " @keyup="summaryMoney(item)" type="number"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.RegistrationFee" :error="
                            item.RegistrationFee == '' ||
                              item.RegistrationFee == null
                          " :error-messages="
                            item.RegistrationFee == '' ||
                            item.RegistrationFee == null
                              ? '*'
                              : ''
                          " @keyup="summaryMoney(item)" type="number"></v-text-field>
                      </td>
                      <td>
                        {{
                        (parseFloat(item.Allowance) +
                        parseFloat(item.AccommodationCost) +
                        parseFloat(item.ShippingCosts) +
                        parseFloat(item.RegistrationFee))
                        | currency
                        }}
                      </td>
                      <td>{{ item.RemainingBudget | currency }}</td>
                      <td>
                        <div>
                          <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text
                            @click="choosePeridTravelReport(item, '1')">ใบเบิก
                          </v-btn>
                        </div>
                        <div>
                          <v-btn class="font-weight-bold darken-4" style="color: #ff6d81" text
                            :loading="loadingShowReport2" @click="showReport2(item.uid)">พิมพ์ใบเบิก
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                    <v-divider></v-divider>
                    <tr class="mt-2">
                      <td>
                        <h4 style="color: blue">ข้อมูลยืมเงิน</h4>
                        <h4 style="color: blue">คุณ : {{ item.full_Name }}</h4>
                      </td>
                      <td>
                        <v-text-field v-model="item.LoanNumber" @keyup="summaryMoney(item)"
                          label="สัญญาเงินยืมเลขที่"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.LoanAmount" @keyup="summaryMoney(item)" type="number"
                          label="จำนวนเงินที่ยืม"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.DateReceipt" @keyup="summaryMoney(item)" type="date"
                          label="วันที่รับเงิน"></v-text-field>
                      </td>

                      <td>
                        <v-text-field v-model="item.AmountRequest" @keyup="summaryMoney(item)" type="number"
                          label="จำนวนเงินทีขอรับ"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.Remark" @keyup="summaryMoney(item)" label="หมายเหตุ"></v-text-field>
                      </td>
                    </tr>
                    <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                      <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                  </template>
                </v-data-table>
              </v-responsive>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large color="red" @click="dialogJoinTravelReport = false">
            <h4>Close</h4>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogShowProjectRecord" persistent max-width="600">
      <v-card>
        <v-card-title class="font-weight-bold">
          <span>ประวัติสถานะการทำรายการ</span>
        </v-card-title>
        <v-card-text>
          <template v-if="RecordData.length > 0">
            <v-list-item class="justify-center">
              <v-row justify="center">
                <v-col cols="12" md="12">
                  <v-list-item>
                    <v-expansion-panels popout>
                      <v-expansion-panel v-for="(item, i) in RecordData" :key="i">
                        <v-expansion-panel-header>
                          <span style="color: #364eff;margin-left: 15px;font-weight: bold">{{ item.Date_Approve |
                            DateToThai }}</span><span style="font-weight: bold;color: blue">(
                            {{
                            item.Type == "1"
                            ? "คณะ"
                            : item.Type == "2"
                            ? "หน่วยงาน"
                            : "ผู้มีอำนาจ(หน่วยงาน)"
                            }}
                            )</span>
                          สถานะ :
                          <v-chip v-if="
                              StatusProject.filter(
                                (staItem) => staItem.id == item.Status
                              ).length > 0
                            " :color="
                              StatusProject.filter(
                                (staItem) => staItem.id == item.Status
                              ).length > 0
                                ? StatusProject.filter(
                                    (staItem) => staItem.id == item.Status
                                  )[0].color
                                : ''
                            " style="transform: scale(0.8);color: white" class="d-flex justify-center">
                            <span style="color: white">{{
                              StatusProject.filter(
                              (staItem) => staItem.id == item.Status
                              ).length > 0
                              ? StatusProject.filter(
                              (staItem) => staItem.id == item.Status
                              )[0].status
                              : ""
                              }}</span>
                          </v-chip>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-if="item.Status != '1'">
                          <p>เหตุผล : {{ item.Remark }}</p>
                          <div v-for="(file, idx) in item.files" v-bind:key="idx" style="color: #ff6d81">
                            ไฟล์ประกอบ :
                            <v-btn text @click="ShowData(Openfile + file.File_path)">
                              {{ file.File_name | truncateText }}
                            </v-btn>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
              ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!
            </p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large color="red" dark @click="dialogShowProjectRecord = false">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCreateNameHistoryExpense" max-width="600">
      <v-card>
        <v-card-title class="font-weight-bold">
          <span>สร้างชื่อรายการประวัติค่าใช้จ่าย</span>
        </v-card-title>
        <v-card-text>
          <v-list-item class="justify-center">
            <v-row justify="center">
              <v-col cols="12" md="12">
                <v-list-item>
                  <v-text-field label="สร้างชื่อรายการประวัติค่าใช้จ่าย" v-model="nameHistoryExpense"
                    :error="nameHistoryExpense == ''"
                    :error-messages="nameHistoryExpense == '' ? '*' : ''"></v-text-field>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogCreateNameHistoryExpense = false">Close
          </v-btn>
          <v-btn color="#009688" @click="SaveHistoryExpenseData()" dark>สร้าง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogShowHistoryExpense" max-width="1000" persistent>
      <v-card>
        <v-card-title class="font-weight-bold" v-if="groupExpenseObj != null">
          <span>รายละเอียดค่าใช้จ่าย : {{ groupExpenseObj.Expense_name }}</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="showAddBudgetHistory" :disabled="IsLog == '1'">
            <v-icon left>mdi-plus</v-icon>
            เพิ่มรายการค่าใช้จ่าย
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="budgetHistoryDetailData.length > 0">
            <v-list-item>
              <div class="d-flex flex-column justify-stretch" style="width: 100%">
                <v-data-table :headers="budgetHeader" :items="budgetHistoryDetailData" class="elevation-1">
                  <template v-slot:header.Custom_Expense_des>
                    <span style="font-weight: bold;font-size: 16px">รายการ</span>
                  </template>
                  <template v-slot:header.SumMoney>
                    <span style="font-weight: bold;font-size: 16px">จำนวนเงินรวม (ทั้งสิ้น)</span>
                  </template>
                  <template v-slot:item.Custom_Expense_des="props">
                    <div v-html="props.item.Custom_Expense_des"></div>
                  </template>
                  <template v-slot:item.SumMoney="props">
                    <p style="font-weight: bold">{{ props.item.SumMoney | currency }}</p>
                  </template>
                  <template v-slot:item.ReqMoney="props">
                    <p style="font-weight: bold">{{ props.item.ReqMoney | currency }}</p>
                  </template>
                  <!-- เพิ่ม action ปุ่ม แก้ไขและ ปุ่มลบ สวยๆ -->
                  <template v-slot:item.action="{ item }">
                    <v-btn color="blue" class="mr-2" outlined @click="showEditBudgetHistory(item)"
                      :disabled="IsLog == '1'">
                      แก้ไข
                    </v-btn>
                    <v-btn color="red" outlined @click="delBudgetHistory(item)" :disabled="IsLog == '1'">
                      ลบ
                    </v-btn>
                  </template>
                  <template v-slot:footer>
                    <template v-if="budgetHistoryDetailData > 0">
                      <!-- <div align="center" style="margin-top: 15px">
                    <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ : {{
                        BudgetRequest | currency
                      }}</span>
                      </div> -->
                      <div align="right">
                        <span style="font-weight: bold;color: #ff6d81;font-size: 16px">รวมค่าใช้จ่าย : {{
                          ExpenseGroupDetail | currency
                          }}</span>
                      </div>
                      <!-- <div align="center">
                    <span
                        style="font-weight: bold;color: #42b983">คงเหลือ : {{
                        BudgetRequest - Expense | currency
                      }}</span>
                      </div> -->
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
              ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large color="red" dark @click="dialogShowHistoryExpense = false">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog เพิ่มข้อมูลค่าใช้จ่าย -->
    <v-dialog v-model="dialogAddBudgetHistory" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          เพิ่มข้อมูลค่าใช้จ่าย
        </v-card-title>
        <v-card-text>
          <v-list-item class="text-center">
            <v-card color="#F5F5F5" elevation="3" style="width: 100%">
              <v-card-title class="pb-2">
                <v-icon left color="primary">mdi-plus-circle</v-icon>
                <span class="text-h6 font-weight-bold">เพิ่มรายการค่าใช้จ่าย</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-4">
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col cols="12" md="7">
                      <v-autocomplete v-model="newExpenseCost" :items="expense_Data" item-text="cost_desc"
                        item-value="cost_id" label="รายการค่าใช้จ่าย" clearable outlined
                        prepend-inner-icon="mdi-format-list-bulleted"
                        :rules="[v => !!v || 'กรุณาเลือกรายการค่าใช้จ่าย']"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="newRm" outlined label="รายละเอียด" prepend-inner-icon="mdi-text"
                        :error="newExpenseCost != null && newRm == ''" :error-messages="
                          newExpenseCost != null && newRm == ''
                            ? 'รายละเอียด (ห้ามว่าง)'
                            : ''
                        " :rules="[v => !!v || 'กรุณากรอกรายละเอียด']"></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row class="justify-center">
                    <v-col cols="12" md="4">
                      <v-text-field @keyup="SumMoneyFuc3" v-model="newReqMoney" outlined label="อัตรา (บาท)"
                        type="number" prepend-inner-icon="mdi-currency-usd" :error="
                          TypeProject == '1' &&
                            newExpenseCost != null &&
                            newReqMoney == ''
                        " :error-messages="
                          TypeProject == '1' &&
                          newExpenseCost != null &&
                          newReqMoney == ''
                            ? 'อัตรา (บาท) (ห้ามว่าง)'
                            : ''
                        " :rules="[v => !!v || 'กรุณากรอกอัตรา (บาท)']"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field @keyup="SumMoneyFuc3" v-model="newReqPerson" outlined label="อัตรา (คน)"
                        type="number" prepend-inner-icon="mdi-account-group" :error="
                          TypeProject == '1' &&
                            newExpenseCost != null &&
                            (newReqPerson == '' ||
                              parseInt(newReqPerson) <= 0)
                        " :error-messages="
                          TypeProject == '1' &&
                          newExpenseCost != null &&
                          (newReqPerson == '' ||
                            parseInt(newReqPerson) <= 0)
                            ? 'อัตรา (คน) (ห้ามว่าง)'
                            : ''
                        " :rules="[v => !!v && v > 0 || 'กรุณากรอกจำนวนคน (มากกว่า 0)']"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="newMoneySummary" type="number" outlined label="จำนวนเงินรวม (ทั้งสิ้น)"
                        prepend-inner-icon="mdi-calculator-variant" readonly :error="
                          newExpenseCost != null && newMoneySummary == ''
                        " :error-messages="
                          newExpenseCost != null && newMoneySummary == ''
                            ? 'จำนวนเงินรวม (ทั้งสิ้น) (ห้ามว่าง)'
                            : ''
                        " class="font-weight-bold" color="success"></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>

                <div class="d-flex justify-center mt-4">
                  <v-btn color="primary" large @click="addBudgetHistoryData()"
                    :disabled="!newExpenseCost || !newRm || !newReqMoney || !newReqPerson || !newMoneySummary"
                    class="px-8">
                    <v-icon left>mdi-plus</v-icon>
                    เพิ่มรายการ
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAddBudgetHistory = false" color="red" text x-large class="px-8 py-2">
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogShowHistoryExpenseReal" max-width="1000" persistent>
      <v-card>
        <v-card-title class="font-weight-bold" v-if="groupExpenseRealObj != null">
          <span>รายละเอียดการเบิกจ่าย : {{ groupExpenseRealObj.Item }}</span>
        </v-card-title>
        <v-card-text>
          <template v-if="expenseDetailRealHistotyData.length > 0">
            <v-list-item>
              <div class="d-flex flex-column justify-stretch" style="width: 100%">
                <v-data-table :headers="expenseDetailRealHistotyHeader" :items="expenseDetailRealHistotyData"
                  class="elevation-1">
                  <template v-slot:item.Mon_debit="props">
                    <p style="font-weight: bold">{{ props.item.Mon_debit | currency }}</p>
                  </template>
                  <template v-slot:item.Monthly="props">
                    <p style="font-weight: bold">{{ props.item.Monthly | monthToThai }}</p>
                  </template>
                  <template v-slot:footer>
                    <template v-if="expenseDetailRealHistotyData > 0">
                      <!-- <div align="center" style="margin-top: 15px">
                    <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ : {{
                        BudgetRequest | currency
                      }}</span>
                      </div> -->
                      <!-- <div align="right">
                      <span style="font-weight: bold;color: #ff6d81;font-size: 16px">รวมจำนวนเงินที่เบิกจ่าย : {{
                          ExpenseRealSummay | currency
                        }}</span>
                      </div> -->
                      <!-- <div align="center">
                    <span
                        style="font-weight: bold;color: #42b983">คงเหลือ : {{
                        BudgetRequest - Expense | currency
                      }}</span>
                      </div> -->
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
              ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large color="red" dark @click="dialogShowHistoryExpenseReal = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogQr" max-width="800px" persistent>
      <v-card v-if="Project != null">
        <v-card-title>
          QR Code ตัวชี้วัด แบบสอบถาม : {{ Project.Project_name.replace(/&quot;/g, '"') }}
        </v-card-title>
        <v-card-text>
          <template v-if="urlSatisfaction != ''">
            <div align="center">
              <v-img :src="qrUrl" max-width="600px" max-height="600px"></v-img>
            </div>

          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" text style="font-weight: bold" @click="downloadURI(qrUrl)">ดาวน์โหลด QR CODE</v-btn>
          <CopyToClipboard :text="urlSatisfaction + Project.Project_code">
            <v-list-item-title @click="CopySuccess(urlSatisfaction + Project.Project_code)">
              <v-btn text style="font-weight: bold;color: #42b983">คัดลอกลิงค์</v-btn>
            </v-list-item-title>
          </CopyToClipboard>
          <v-btn @click="dialogQr = false" color="red" text> ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogQr2" max-width="800px" persistent>
      <v-card v-if="Project != null">
        <v-card-title>
          QR Code ตัวชี้วัด ผลการตอบแบบสอบถาม : {{ Project.Project_name.replace(/&quot;/g, '"') }}
        </v-card-title>
        <v-card-text>
          <template v-if="urlSatisfaction2 != ''">
            <div align="center">
              <v-img :src="qrUrl2" max-width="600px" max-height="600px"></v-img>
            </div>

          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" text style="font-weight: bold" @click="downloadURI(qrUrl2)">ดาวน์โหลด QR CODE</v-btn>
          <CopyToClipboard :text="urlSatisfaction2 + Project.Project_code">
            <v-list-item-title @click="CopySuccess(urlSatisfaction2 + Project.Project_code)">
              <v-btn text style="font-weight: bold;color: #42b983">คัดลอกลิงค์</v-btn>
            </v-list-item-title>
          </CopyToClipboard>
          <v-btn @click="dialogQr2 = false" color="red" text> ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog แก้ไข รายการค่าใช้จ่าย -->
    <v-dialog v-model="dialogEditExpense" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          แก้ไขข้อมูลค่าใช้จ่าย
        </v-card-title>
        <v-card-text>
          <v-list-item class="text-center" v-if="expenseObj != null">
            <v-card color="#F5F5F5" elevation="3" style="width: 100%">
              <v-card-title class="pb-2">
                <v-icon left color="primary">mdi-calculator</v-icon>
                <span class="text-h6 font-weight-bold">เพิ่มรายการค่าใช้จ่าย</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-4">
                <v-list-item>
                  <v-row class="justify-center">
                    <v-col cols="12" md="7">
                      <v-autocomplete v-model="expenseObj.Expense_id" :items="expense_Data" item-text="cost_desc"
                        item-value="cost_id" label="รายการค่าใช้จ่าย" clearable outlined
                        prepend-inner-icon="mdi-format-list-bulleted"
                        :rules="[v => !!v || 'กรุณาเลือกรายการค่าใช้จ่าย']"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="expenseObj.Rm" outlined label="รายละเอียด" prepend-inner-icon="mdi-text"
                        :error="expenseObj.cost_id != null && expenseObj.Rm == ''" :error-messages="
                      expenseObj.cost_id != null && expenseObj.Rm == ''
                      ? 'รายละเอียด (ห้ามว่าง)'
                      : ''
                    " :rules="[v => !!v || 'กรุณากรอกรายละเอียด']"></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row class="justify-center">
                    <v-col cols="12" md="4">
                      <v-text-field @keyup="SumMoneyFuc2" v-model="expenseObj.ReqMoney" outlined label="อัตรา (บาท)"
                        type="number" prepend-inner-icon="mdi-currency-usd" :error="
                      TypeProject == '1' &&
                      expenseObj.cost_id != null &&
                      expenseObj.ReqMoney == ''
                    " :error-messages="
                      TypeProject == '1' &&
                      expenseObj.cost_id != null &&
                      expenseObj.ReqMoney == ''
                      ? 'อัตรา (บาท) (ห้ามว่าง)'
                      : ''
                    " :rules="[v => !!v || 'กรุณากรอกอัตรา (บาท)']"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field @keyup="SumMoneyFuc2" v-model="expenseObj.ReqPerson" outlined label="อัตรา (คน)"
                        type="number" prepend-inner-icon="mdi-account-group" :error="
                      TypeProject == '1' &&
                      expenseObj.cost_id != null &&
                      (expenseObj.ReqPerson == '' ||
                        parseInt(expenseObj.ReqPerson) <= 0)
                    " :error-messages="
                      TypeProject == '1' &&
                      expenseObj.cost_id != null &&
                      (expenseObj.ReqPerson == '' ||
                      parseInt(expenseObj.ReqPerson) <= 0)
                      ? 'อัตรา (คน) (ห้ามว่าง)'
                      : ''
                    " :rules="[v => !!v && v > 0 || 'กรุณากรอกจำนวนคน (มากกว่า 0)']"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="expenseObj.SumMoney" type="number" outlined label="จำนวนเงินรวม (ทั้งสิ้น)"
                        prepend-inner-icon="mdi-calculator-variant" readonly :error="
                      expenseObj.cost_id != null && expenseObj.SumMoney == ''
                    " :error-messages="
                      expenseObj.cost_id != null && expenseObj.SumMoney == ''
                      ? 'จำนวนเงินรวม (ทั้งสิ้น) (ห้ามว่าง)'
                      : ''
                    " class="font-weight-bold" color="success"></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>

                <div class="d-flex justify-center mt-4">
                  <v-btn outlined color="orange" large @click="isEditExpense ? updateExpense() : editBudgetHistory()"
                    :disabled="!expenseObj.Expense_id || !expenseObj.Rm || !expenseObj.ReqMoney || !expenseObj.ReqPerson || !expenseObj.SumMoney || IsLog == '1'"
                    class="px-8">
                    <v-icon left>mdi-pencil</v-icon>
                    แก้ไขรายการ
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-list-item>
          <v-list-item v-else>
            <p class="text-center" style="font-size: 20px; color: #ff6d81; font-weight: bold;">
              ไม่พบข้อมูลรายการค่าใช้จ่าย
            </p>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green" text @click="updateExpense">บันทึก</v-btn> -->
          <v-btn @click="dialogEditExpense = false" color="red" text x-large class="px-8 py-2">
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExportOptions" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span>เลือกข้อมูลสำหรับการ Export</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4" v-for="(field, key) in exportFields" :key="key">
                <v-checkbox v-model="field.value" :label="field.label" :disabled="field.disabled"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogExportOptions = false">
            ยกเลิก
          </v-btn>
          <download-excel class="btn btn-default" :data="json_data" :fields="json_fields" worksheet="รายชื่อผู้เข้าร่วม"
            :title="array_title" :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'">
            <v-btn color="green darken-1" text @click="confirmExportWithOptions">
              Export
            </v-btn>
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
// import Allfunc from '../../FuncGlobal/ALlFunc'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import VueHtml2pdf from "vue-html2pdf";
import Vue from "vue";
import TinyURL from "tinyurl";
import queryString from "query-string";
import Allfunc from "@/FuncGlobal/ALlFunc";
import readXlsxFile from "read-excel-file";
import QRCode from 'qrcode'
import CopyToClipboard from 'vue-copy-to-clipboard'


// import CopyToClipboard from "vue-copy-to-clipboard";

// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
// import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
// import ExportPdf from '@ckeditor/ckeditor5-export-pdf/src/exportpdf';
// import ExportWord from '@ckeditor/ckeditor5-export-word/src/exportword';
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
// import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
// import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
// import Code from '@ckeditor/ckeditor5-basic-styles/src/code';
// import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
// import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
// import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
// import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
// import Font from '@ckeditor/ckeditor5-font/src/font';
// import Heading from '@ckeditor/ckeditor5-heading/src/heading';
// import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
// import Image from '@ckeditor/ckeditor5-image/src/image';
// import Indent from '@ckeditor/ckeditor5-indent/src/indent';
// import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
// import List from '@ckeditor/ckeditor5-list/src/list';
// import paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import Mediaembed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
// import Pastefromoffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
// import Undo from '@ckeditor/ckeditor5-undo/src/undo';
// import Table from '@ckeditor/ckeditor5-table/src/table';
// import Typing from '@ckeditor/ckeditor5-typing/src/typing';
// import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak';
// import Enter from '@ckeditor/ckeditor5-enter/src/enter';
// import ShiftEnter from '@ckeditor/ckeditor5-enter/src/shiftenter';
// import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed';
// import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  name: "InsertProject",
  components: {
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
    VueHtml2pdf,
    CopyToClipboard
    // CopyToClipboard
  },
  data() {
    return {
      newExpenseCost: null,
      newRm: "",
      newReqMoney: 0,
      newReqPerson: 0,
      newMoneySummary: 0,
      dialogAddBudgetHistory: false,
      dialogEditExpense: false,
      expenseObj: null,
      isEditExpense: false,
      dialogQr: false,
      urlSatisfaction: "https://assess.medicine.psu.ac.th/assess_forms.php?assess_id=MTE0MQ==&vch=1&vproject=",
      qrUrl: "",
      dialogQr2: false,
      urlSatisfaction2: "https://assess.medicine.psu.ac.th/assess_result_detail.php?assess_id=1141&vproject=",
      qrUrl2: "",
      FiscalYearDataSel: [],
      fiscalYear: new Date().getFullYear(),
      ExpenseRealSummay: 0,
      ExpenseDetailRealSummay: 0,
      ExpenseGroup: 0,
      ExpenseGroupDetail: 0,
      groupExpenseObj: null,
      groupExpenseRealObj: null,
      dialogShowHistoryExpense: false,
      dialogShowHistoryExpenseReal: false,
      expenseRealData: [],
      budgetHistoryDetailData: [],
      expenseDetailRealHistotyData: [],
      budgetHistoryData: [],
      budgetRealHistotyData: [],
      expenseRealHeader: [
        {text: "ชื่อรายการ", value: "Item"},
        {text: "จำนวนเงิน", value: "Mon_total"},
        {text: "", value: "action"},
      ],
      budgetHistotyHeader: [
        {text: "ชื่อรายการ", value: "Expense_name"},
        {text: "วันที่สร้าง", value: "Create_Time"},
        {text: "จำนวนเงินรวม", value: "SumMoney"},
        {text: "", value: "action"},
      ],
      expenseDetailRealHistotyHeader: [
        {text: "ชื่อรายการ", value: "Expense_des"},
        {text: "ชื่อรายการ", value: "Mon_debit"},
        {text: "เดือนที่ทำรายการ", value: "Monthly"},
        {text: "", value: "action"},
      ],
      budgetHistotyDetailHeader: [
        {text: "ชื่อรายการ", value: "Expense_name"},
        {text: "วันที่สร้าง", value: "Create_Time"},
        {text: "", value: "action"},
      ],
      nameHistoryExpense: '',
      dialogCreateNameHistoryExpense: false,
      TypeBuggetProject: "1",
      countAllPerson: 0,
      Knowledge_after: 0,
      Knowledge_before: 0,
      satisfaction: 1,
      typeImport: null,
      rdoTypeJoinTravel: "1",
      btnDelTravelLoading: false,
      dialogShowProjectRecord: false,
      loadingPrintGroupReport: false,
      loadingPrintReport: false,
      dialogPeridProcess: false,
      loadingShowReport: false,
      loadingSaveReport: false,
      loadingShowReport2: false,
      loadingSaveReport2: false,
      dialogJoinTravelReport: false,
      showDisDocDate: false,
      showDocDateWithdraw: false,
      showDisDateStart: false,
      showDisDateEnd: false,
      showDisDateReceipt: false,
      showDocDateApprove: false,
      formId: null,
      disId: null,
      disPerid: null,
      disFullName: "",
      disPosition: "",
      disDepName: "",
      disTypeStart: "1",
      disDateStart: "",
      disTimeStart: "",
      disTypeEnd: "1",
      disDateEnd: "",
      disTimeEnd: "",
      disAllowance: 0,
      disAllowance_Days: 0,
      disAccommodationCost: 0,
      disAccommodationCost_Type: "1",
      disAccommodationCost_Days: 0,
      disShippingCosts: 0,
      disShippingCosts_Days: 0,
      disRegistrationFee: 0,
      disSummary: 0,
      disDateReceipt: "",
      disRemark: "",
      disLoanNumber: "",
      disLoanAmount: 0,
      disMororNumber: "",
      disDocDate: "",
      disDocDateWithdraw: "",
      disTopic: "",
      disDear: "",
      disMessage1: "",
      disDocDateApprove: "",
      disPeridSave: "",
      disNameSave: "",
      disMessage2: "",
      disMessage3: "",
      disTypeWithdraw: "1",
      disNote: " - ผู้จัดเลี้ยงอาหารมื้อเช้า/กลางวัน/เย็น รวม",
      showDocDate: false,
      RecordData: [],
      CompetencyDataDump: [],
      CheckProcess: true,
      dialogProcess: false,
      departName: "",
      phone2: "",
      mororNumber: "",
      docDate: "",
      topic: "",
      dear: "",
      detail: "",
      note: "",
      peridSave: null,
      nameSave: "",
      positionSave: "",
      peridApprove: null,
      nameApprove: "",
      positionApprove: "",
      txtProject_group: "",
      IsExpense: null,
      joinTravelprefixFullName: "",
      joinTravelfullName: "",
      joinTravelPosition: "",
      joinTravelAllowance: "0",
      joinTravelAccommodationCost: "0",
      joinTravelShippingCosts: "0",
      joinTravelRegistrationFee: "0",
      joinTravelAllTravelExpenses: "0",
      joinTravelRemainingBudget: "0",
      dialogJoinTravel: false,
      fileName: "file01",
      DialogImportStd: false,
      empHeaders: [],
      empHeadersAfter: [
        {text: "รหัส", value: "uid"},
        {text: "ชื่อ - สกุล", value: "full_Name"},
        {text: "สังกัด", value: "affiliation"},
        {text: "ไฟล์", value: "file"},
        {text: "ประเภท", value: "type"},
        {text: "สถานะลงทะเบียน", value: "join_status"},
        {text: "", value: "action"},
      ],
      empHeadersAfter2: [
        {text: "รหัส", value: "uid"},
        {text: "ชื่อ - สกุล", value: "full_Name"},
        {text: "สังกัด", value: "affiliation"},
        {text: "ไฟล์", value: "file"},
        {text: "ประเภท", value: "type"},
        {text: "", value: "action"},
      ],
      empData: [],
      phoneOther: "",
      DialogImportEmp: false,
      targetType: "1",
      json_fields_export: {
        ลำดับ: "index",
        "รหัสบุคลากร/นักศึกษา/อ้างอิงบุคคลภายนอก": "uid",
        "ชื่อ - สกุล": "full_Name",
        สังกัด: "affiliation",
        ประเภท: "type_details",
      },
      json_data_export: [],
      showDateRegStart: false,
      showDateRegEnd: false,
      showDateRegStart2: false,
      showDateRegEnd2: false,
      showPickerDateRoundStart: false,
      showPickerDateRoundEnd: false,
      isLoading: false,
      TemplateProject: [],
      showPickerDateS: false,
      showPickerDateE: false,
      showPickerTravelDateS: false,
      showPickerTravelDateE: false,
      showPickerLecturerDateDocOut: false,
      showPickerLecturerDateStart: false,
      showPickerLecturerDateEnd: false,
      TypeInsertProject: "1",
      dialogSaveData: false,
      dialogCompetency: false,
      dialogEditObj: false,
      dialogFile: false,
      CompetencyToShow: [],
      episode: null,
      dialogLoading: false,
      pageMessage: "ปิดปรับปรุงระบบชั่วคราว",
      maintain: false,
      headerAxios: {
        headers: {
          "Content-Type": "application/json",
        },
      },
      headerAxiosPut: {
        headers: {
          "Content-Type": "application/json",
          "X-REST-METHOD": "PUT",
        },
      },
      IsPlan: "0",
      IsPlanCordi: true,
      LogObjProject: null,
      isFormExec: false,
      editorUrl: "https://cdn.ckeditor.com/4.24.0-lts/full-all/ckeditor.js",
      editorUrl2: "https://cdn.ckeditor.com/4.24.0-lts/full-all/ckeditor.js",
      editorConfig: {
        height: 700,
        width: "100%",
        allowedContent: true,
        bodyClass: "document-editor",
        contentsCss: [
          "https://cdn.ckeditor.com/4.24.0-lts/full-all/contents.css",
          "../../css/mystyles.css",
        ],
        tabSpaces: 4,
        // font_defaultLabel: 'Sarabun',
        font_names:
            "Sarabun;Angsana New;Tahoma;;" +
            "Arial/Arial, Helvetica, sans-serif;" +
            "Times New Roman/Times New Roman, Times, serif;" +
            "Verdana",
        skin: "kama",
        removeButtons: "ExportPdf,Print",
      },
      editorConfig2: {
        height: 300,
        width: "100%",
        allowedContent: true,
        // bodyClass: 'document-editor',
        // contentsCss: ['https://cdn.ckeditor.com/4.22.1/full-all/contents.css', '../../css/mystyles.css'],
        tabSpaces: 4,
        // font_defaultLabel: 'Sarabun',
        font_names:
            "Sarabun;Angsana New;Tahoma;;" +
            "Arial/Arial, Helvetica, sans-serif;" +
            "Times New Roman/Times New Roman, Times, serif;" +
            "Verdana",
        skin: "kama",
        removeButtons: "ExportPdf,Print",
      },
      config: {
        events: {
          initialized: function () {
            console.log("initialized");
          },
        },
        height: 700,
        tabSpaces: 6,
        fontFamily: {
          "Sarabun,sans-serif": "Sarabun",
        },
        fontSize: [
          "8",
          "10",
          "12",
          "14",
          "16",
          "18",
          "20",
          "22",
          "24",
          "28",
          "30",
          "32",
          "60",
          "96",
        ],
        fontSizeDefaultSelection: "16",
        fontSizeUnit: "px",
        lineHeights: {
          Default: "1",
          Single: "1",
          "1.15": "1.15",
          "1.5": "1.5",
          Double: "2",
          "3": "3",
          "3.5": "3.5",
          "4": "4",
          "5": "5",
        },
      },
      form1: true,
      form2: false,
      form3: false,
      Project: null,
      LinkGen: "",
      url: "",
      messageFormApprove: "",
      positionFormApprove: "",
      full_NameFormApprove: "",
      LecturerDateStart: "",
      LecturerDateEnd: "",
      LecturerTimeStart: "",
      LecturerTimeEnd: "",
      LecturerDateDocOut: "",
      LecturerDocNo: "",
      LecturerPlace: "",
      LecturerInvite: "",
      LecturerHour: "",
      LecturerProjectName: "",
      dialogAppointment: false,
      AppointmentSel: "",
      AppointmentObj: "",
      RoundDataDump: null,
      groupDetail: null,
      groupQuataDump: [],
      dialogGroupDetail: false,
      appointmentGroup: [],
      appointmendHeader: [
        {text: "ชื่อ-สกุล", value: "full_Detail"},
        {text: "ตำแหน่ง", value: "committee_des"},
        {text: "เบอร์โทร", value: "phone"},
        {text: "", value: "status"},
      ],
      roundHeader: [
        {text: "รุ่น", value: "round"},
        {text: "ชื่อรุ่น", value: "round_name"},
        {text: "จำนวนผู้เข้าร่วม", value: "count_person"},
        {text: "", value: "action"},
      ],
      roundNeed: false,
      RoundData: [],
      round: "",
      round_name: "",
      dateRegS: "",
      dateRegE: "",
      time_start: "",
      time_end: "",
      tabs: null,
      tabsTravel: null,
      dialogRound: false,
      // Export options dialog properties
      dialogExportOptions: false,
      exportFields: {
        employeeId: { label: 'รหัสบุคลากร', value: true, disabled: true },
        prefix: { label: 'คำนำหน้า', value: true, disabled: true },
        firstName: { label: 'ชื่อ', value: true, disabled: true },
        lastName: { label: 'นามสกุล', value: true, disabled: true },
        department: { label: 'หน่วยงาน', value: true, disabled: true },
        position: { label: 'ตำแหน่ง', value: true, disabled: true },
        religion: { label: 'ศาสนา', value: true, disabled: true },
        academicBudget: { label: 'งบวิชาการตามสิทธิ์ที่ได้รับ', value: true, disabled: false },
        remarks: { label: 'หมายเหตุ', value: true, disabled: false },
        licenseNumber: { label: 'เลขใบอนุญาต', value: true, disabled: false },
      },
      array_title: [],
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
        "เลขใบอนุญาต": 'license_id',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      Project_code_dump: "",
      itemCode: "",
      ProjectPlan: null,
      Project_plan: [],
      TypeCreateProject: "0",
      FiscalYearData: [],
      rdoRegisterProject: "0",
      ProjectQuotaDepCount: 0,
      dateRegStart: "",
      dateRegEnd: "",
      MessageSuc: "",
      MessageError: "",
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: "",
      ChooseTypRegis: "1",
      ChooseTypRegis2: "0",
      ChooseTypRegis3: "0",
      ChkJoinPerson: true,
      ProjectQuotaCount: "",
      DepQuotaCount: "",
      groupDepart: [],
      ChooseTypeDep: "0",
      DepQuotaSelect: "",
      GroupSelect: "",
      CheckSubAdmin: false,
      CheckAdmin: false,
      Rm2: "",
      Rm3: "",
      WorkGroupData: [],
      Openfile: ConstData.ConnectionHost + "/rest/files",
      JoinTravel: [],
      JoinTravelDis: [],
      JoinTravelHeader: [
        {text: "ผู้เดินทาง", value: "customTravelDetail"},
        {text: "ค่าเบี้ยเลี้ยง", value: "Allowance"},
        {text: "ค่าที่พัก", value: "AccommodationCost"},
        {text: "ค่าพาหนะ", value: "ShippingCosts"},
        {text: "ค่าลงทะเบียน", value: "RegistrationFee"},
        {text: "รวมค่าเดินทาง", value: "AllTravelExpenses"},
        {text: "งบวิชาการคงเหลือ", value: "RemainingBudget"},
        {text: "", value: "action"},
      ],
      JoinTravelDisHeader: [
        {text: "ผู้เดินทาง", value: "customTravelDetail"},
        {text: "ค่าเบี้ยเลี้ยง", value: "Allowance"},
        {text: "ค่าที่พัก", value: "AccommodationCost"},
        {text: "ค่าพาหนะ", value: "ShippingCosts"},
        {text: "ค่าลงทะเบียน", value: "RegistrationFee"},
        {text: "รวมค่าเดินทาง", value: "Summary"},
        {text: "งบวิชาการคงเหลือ", value: "RemainingBudget"},
        {text: "", value: "action"},
      ],
      FileHeader: [
        {text: "ชื่อไฟล์", value: "File_name"},
        {text: "ประเภทไฟล์", value: "File_type"},
        {text: "", value: "action"},
      ],
      DepQuotaHeader: [
        {text: "ประเภท", value: "type"},
        {text: "ภาควิชา/หน่วยงาน", value: "dep_name"},
        {text: "จำนวน", value: "count"},
        {text: "", value: "action"},
      ],
      filesExpert: [],
      alertExpert: false,
      txtAlertExpert: [],
      FileProjectExpert: "",
      dateSTravelForLecturer: "",
      dateETravelForLecturer: "",
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: null,
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: "หัวข้อเรื่อง", value: "subject"},
        {text: "วันที่จัดงานเริ่มต้น", value: "date_start"},
        {text: "วันที่จัดงานสิ้นสุด", value: "date_end"},
        {text: "วันที่เดินทาง", value: "date_travel_start"},
        {text: "วันที่กลับ", value: "date_travel_end"},
        {text: "เวลาเริ่มต้น", value: "time_start"},
        {text: "เวลาสิ้นสุด", value: "time_end"},
        {text: "", value: "action"},
      ],
      SubjectForLecturer: "",
      dateSForLecturer: "",
      dateEForLecturer: "",
      timeSForLecturer: "",
      timeEForLecturer: "",
      formprint1: "", // หลักการและเหตุผล
      formprint2: "", // วัตถุประสงค์
      formprint3: "", // กลุ่มเป้าหมาย
      formprint4: "", // วิธีการจัดอบรม
      formprint5: "", // ระยะเวลาการจัดอบรม
      formprint6: "", // สถานที่จัดอบรม
      formprint7: "", // ผลที่คาดว่าจะได้รับ
      formprint8: "", // ผู้รับผิดชอบโครงการ
      formprint9: "", // ผู้รับผิดชอบโครงการ
      formprint10: "", // วิทยากร
      formprint11: "", // งบประมาณ
      formprint12: "", // หมายเหตุ
      editor: DecoupledEditor,
      editorDataDump: "",
      editorData: "",
      editorDataDump2: "",
      editorData2: "",
      editorDataDump3: "",
      editorData3: "",
      Expense: 0,
      btnDisable: false,
      snack: false,
      snackColor: "",
      snackText: "",
      ReqMoney: 0,
      ReqPerson: 0,
      MoneySummary: 0,
      Rm: "",
      selection: [],
      logSelection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: "",
      isMobile: false,
      SelDelvNo: "",
      itemsSel: [],
      CompetencyData: [],
      Period_code: "",
      period: [
        {
          name: "ระยะสั้น (ไม่เกิน 1 เดือน)",
          id: "2",
        },
        {
          name: "ระยะยาว (มากกว่า 1 เดือน)",
          id: "3",
        },
      ],
      IdDepartStd: "",
      IdDepart: "",
      Idstudent: "",
      IdstudentUni: "",
      IdPersonal: "",
      personalMedData: [],
      studentData: [],
      studentUniData: [],
      AllDepartData: [],
      cardSel: "",
      staffSel: "",
      NameP: "",
      items: [],
      SurNameP: "",
      affiliation: "",
      position: "",
      idCard: "",
      NameStd: "",
      SurNameStd: "",
      affiliationStd: "",
      idCardStd: "",
      departSel: null,
      EmpData: [],
      sheets: [],
      ChooseSheet: "",
      Exec: false,
      DialogExamImportEmp: false,
      personObj: null,
      alertP: false,
      ShowAlertErrImp: false,
      MessageErrorImp: "",
      txtAlertP: [],
      filesP: [],
      filesImportEmp: [],
      FilePerson: [],
      color: "black",
      text: "",
      snackbar: false,
      TypeInsert: "0",
      ApproveRadio: "0",
      DepSelect: null,
      FileProject: [],
      LogFileProject: [],
      FileProjectOld: [],
      FileProjectRegister: [],
      alert: false,
      alert2: false,
      alertFileRegister: false,
      txtAlert: [],
      txtAlert2: [],
      txtFileRegisterAlert: [],
      tab: null,
      tabPersonal: null,
      Competency_code: "",
      UPercent: "",
      competencyHeader: [
        {text: "Competency", value: "Competency_des"},
        {text: "", value: "action"},
      ],
      budgetHeader: [
        {text: "รายการ", value: "Custom_Expense_des"},
        {text: "จำนวนอัตรา", value: "SumMoney"},
        {text: "", value: "action"},
      ],
      budgetData: [],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: "",
      expenseCost: null,
      moneyCost: "",
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      CheckStep3: true,
      e1: 1,
      steps: 8,
      vertical: false,
      altLabels: false,
      editable: true,
      full_name: "",
      phone: "",
      perid: "",
      peridTravel: null,
      peridCost: "",
      peridCommittee: "",
      Committee_code: "",
      radioGroup: "0",
      radioGroup2: "0",
      level: null,
      files: [],
      filesRegister: [],
      ChooseCourse: "",
      posiCondi: "",
      levelCondi: "",
      workAgeStart_Condi: "",
      workAgeEnd_Condi: "",
      Course_Choose: "",
      DataCondi: [],
      courseCondi: [],
      Project_code: "",
      Project_name: "",
      Course_code: null,
      course_group: "",
      FiscalYear: null,
      IsProcess: null,
      Project_category: "1",
      Project_type: "1",
      WorkBy: "",
      WorkByName: "",
      WorkByPhone: "",
      Location: "",
      DateStart: "",
      DateEnd: "",
      CalHourse: "0",
      CalCredit: "0",
      PLACE: "",
      Province_id: null,
      Status: "",
      Objective: "",
      TargetGroup: "",
      Remarks: "",
      ProjectLevel: "",
      App_doc_no: "",
      BudgetRequest: "0",
      ExpenseSummary: 0,
      BudgetArrove: "",
      MoneyDisburse: "",
      Project_group: null,
      Create_By: "",
      Create_Time: "",
      IsLog: "0",
      D_Project: {
        Project_code: "",
        Project_name: "",
        Course_code: null,
        course_group: "",
        IsProcess: null,
        IsExpense: null,
        Project_category: "",
        Project_type: "",
        WorkBy: "",
        WorkByName: "",
        WorkByPhone: "",
        Location: "",
        DateStart: "",
        DateEnd: "",
        CalHourse: "0",
        CalCredit: "0",
        PLACE: "",
        Province_id: "",
        Status: "0",
        Objective: "",
        TargetGroup: "",
        Remarks: "",
        ProjectLevel: "",
        App_doc_no: "",
        BudgetRequest: "",
        ExpenseSummary: 0,
        // BudgetArrove: '',
        MoneyDisburse: "",
        Project_group: "",
        Project_group_other: "",
        Approve: "",
        FiscalYear: "",
        IsPlan: "",
        Status_Reg: "",
        Status_Type_Reg: "",
        Status_Type_Reg2: "",
        DateS_Reg: "",
        DateE_Reg: "",
        Status_Count_Reg: "",
        Count_Reg: "",
        Dep_Code: "",
        IsRoundStatus: "",
        IsLog: "",
        satisfaction: 0,
        Knowledge_before: 0,
        Knowledge_after: 0,
      },
      expanded: [],
      singleExpand: false,
      search: "",
      CoordinatorHeader: [
        {text: "ชื่อ - สกุล", value: "Name"},
        {text: "ตำแหน่ง", value: "Committee_des"},
        {text: "เบอรโ์โทร", value: "TEL"},
        {text: "สถานะ", value: "Committee_type"},
        {text: "วิทยากร/คณะกรรมการ/นำเสนอผลงาน", value: "Lecturer"},
        {text: "", value: "action"},
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: "หลักสูตร", value: "Course_name"},
        {text: "", value: "action"},
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: "ตำแหน่ง", value: "PosName"},
        {text: "อายุงานเริ่มต้น", value: "workAgeStart"},
        {text: "อายุงานสิ้นสุด", value: "workAgeEnd"},
        {text: "", value: "action"},
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: "0",
          detail: "ภายในคณะ",
        },
        {
          id: "1",
          detail: "ภายในมหาวิทยาลัย",
        },
        {
          id: "2",
          detail: "ภายในประเทศ",
        },
        {
          id: "3",
          detail: "ต่างประเทศ",
        },
        {
          id: "4",
          detail: "online",
        },
      ],
      WorkByData: [
        {
          id: "D",
          detail: "หน่วยงาน",
        },
        {
          id: "F",
          detail: "คณะ",
        },
        {
          id: "U",
          detail: "หน่วยงาน/คณะ มหาวิทยาลัย",
        },
        {
          id: "P",
          detail: "ภายนอก",
        },
        {
          id: "C",
          detail: "ร่วมโครงการ",
        },
      ],
      Menu: [
        {
          id: 1,
          value: "จัดโครงการ",
        },
        {
          id: 2,
          value: "จัดการข้อมูลโครงการ",
        },
        {
          id: 3,
          value: "ข้อมูลเบิกจ่ายเงินโครงการ",
        },
      ],
      projectType: [
        {
          id: "0",
          details: "อบรม",
        },
        {
          id: "1",
          details: "ดูงาน",
        },
        {
          id: "2",
          details: "ประชุม",
        },
        {
          id: "3",
          details: "นำเสนองาน",
        },
      ],
      workBy: ["Depart", "Faculty", "University", "Public C", "Co-Project"],
      CourseType: ["ทั่วไป", "เฉพาะตำแหน่ง"],
      searchPerson: "",
      headersPerson: [
        // {text: 'ลำดับ', value: 'idx'},
        {text: "#", value: "uid"},
        {text: "ชื่อ - สกุล", value: "full_Name"},
        {text: "สังกัด", value: "affiliation"},
        // {text: 'ไฟล์', value: 'file'},
        {text: "ประเภท", value: "type"},
        {text: "สถานะลงทะเบียน", value: "join_status"},
        // {text: 'ลงทะเบียน', value: 'status_reg'},
        // {text: "", value: "action"},
      ],
      JoinPerson: [],
      rules: {
        required: (value) => !!value || "Required.",
        counterCourse: (value) => value.length <= 8 || "Max 8 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    vertical() {
      this.e1 = 2;
      requestAnimationFrame(() => (this.e1 = 1)); // Workarounds
    },
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents;
    },
    ...mapGetters({
      MeData: "Staff/getMeData",
      levelData: "Level/getLevel",
      projectData: "Project/getProject",
      ProjectFromFiscalYearUser: "Project/getProjectFromFiscalYearUser",
      committee_Posi: "Project/getComitteeType",
      ProjectCommittee: "Project/getProjectCommittee",
      provinces_Data: "Project/getProvince",
      expense_Data: "Project/getExpense",
      Competency_Data: "Project/getCompetency",
      projectGroup: "Project/getProjectGroup",
      textForPrint: "Project/getTextForPrint",
      countryData: "Project/getCountry",
      projectPalnData: "Project/getProjectPlan",
      GroupExamData: "Project/getGroupExamProject",
      QuotaDepartData: "Project/getQuotaDepart",
      JoinProjectData: "Project/getJoinProject",
      GroupQuotaData: "Project/getGroupQuota",
      GroupQuotaMS: "Project/getGroupQuota_Ms",
      ProjectRound: "Project/getProjectRound",
      ProjectExpense: "Project/getProjectExpense",
      projectForApprove: "Project/getProjectForApprove",
      staffData: "Staff/getStaff",
      positions: "Staff/getPosition",
      CardData: "Staff/getCard",
      ApproveMaster: "Staff/getApproveMaster",
      AcademicFundsByPerson: "Staff/getAcademicFundsByPerson",
      depart: "Depart/getDepart",
      courseData: "Course/getCourse",
      Competency: "Competency/getCompetency",
      ProjectCompetency: "Project/getCompetency",
      AllDepPermission: "Permission/getAllDepUserPermission",
      DepPermission: "Permission/getDepUserPermission",
      AllPermission: "Permission/getAllUserPermission",
      Permission: "Permission/getPermissionUser",
      Permission_Ms: "Permission/getPermissionMs",
      Permission_Dep_User: "Permission/getPermissionDepUser",
      Permission_Dep: "Permission/getPermissionDep",
      Approve_Ms: "Permission/getApproveMs",
      Approve: "Permission/getApprove",
      SubMenuPermiss: "Permission/getSubMenuPermiss",
      PermissionAdmin: "Permission/getPermission",
      PermissionApprove: "Permission/getPermissionApprove",
      PermissionUserApprove: "Permission/getPermissionUserApprove",
      OptPermission: "Permission/getOptPermission",
      getOptUserPermission: "Permission/getOptUserPermission",
      IgnoreMenuPermiss: "Permission/getIgnoreMenuPermiss",
      IgnoreSubMenuPermiss: "Permission/getIgnoreSubMenuPermiss",
      Appointment: "Appointment/getAppointmentData",
      AppointmentGroup: "Appointment/getAppointmentGroupData",
      LogProject: "Project/getLogProject",
      LogCompetencyProject: "Project/getLogCompetency",
      LogFiles: "Project/getLogFiles",
      TypeProject: "Project/getTypeProject",
      HeaderPage: "Project/getHeaderPage",
      ManageProjectPage: "Project/getManageProjectPage",
      appColor: "Page/getColor",
      appHeaderName: "Page/getHeaderName",
      StatusProject: "Project/getStatusProject",
    }),
  },
  methods: {
    ...mapActions({
      initMeData: "Staff/initMeData",
      initlevelData: "Level/initLevelData",
      initDepartData: "Depart/initDepartData",
      initCourseData: "Course/initCourseData",
      initProjectData: "Project/initProjectData",
      initProjDataFromFiscalYearUser: "Project/initProjDataFromFiscalYearUser",
      initComitteeData: "Project/initComitteeData",
      initComitteeType: "Project/initComitteeType",
      initProjCommittee: "Project/initProjCommittee",
      initProvincesData: "Project/initProvincesData",
      initExpenseData: "Project/initExpenseData",
      MangeTextForPrint: "Project/MangeTextForPrint",
      initCountryData: "Project/initCountryData",
      initProjectExpenseData: "Project/initProjectExpenseData",
      initCompetencyData: "Competency/initCompetencyData",
      initProjectCompetencyData: "Project/initCompetencyData",
      initProjectGroupData: "Project/initProjectGroupData",
      initProjectPlanData: "Project/initProjectPlanData",
      initGroup_Quota: "Project/initGroup_Quota",
      initGroup_Quota_Ms: "Project/initGroup_Quota_Ms",
      getProjectRoundData: "Project/getProjectRoundData",
      getGroupExamProjectByCordi: "Project/getGroupExamProjectByCordi",
      getQuotaDepartRegisterByCordi: "Project/getQuotaDepartRegisterByCordi",
      getJoinProjectByCordi: "Project/getJoinProjectByCordi",
      initProjectDataForApprove: "Project/initProjectDataForApprove",
      initStaffData: "Staff/initStaffData",
      initPositionsData: "Staff/initPositionsData",
      initCardData: "Staff/initCardData",
      initApproveMasterByType: "Staff/initApproveMasterByType",
      initAcademicFundsByPerson: "Staff/initAcademicFundsByPerson",
      initPermissionDepUserAllData: "Permission/initPermissionDepUserAllData",
      initPermissionDepUserData: "Permission/initPermissionDepUserData",
      initPermissionUserData: "Permission/initPermissionUserData",
      initPermissionMsData: "Permission/initPermissionMsData",
      getPermissionUserData: "Permission/getPermissionUserData",
      getPermissionDep: "Permission/getPermissionDepData",
      initPermissionDepData: "Permission/initPermissionDepData",
      getPermissionDepUserData: "Permission/getPermissionDepUserData",
      initApproveMsData: "Permission/initApproveMsData",
      initApproveData: "Permission/initApproveData",
      getPermissionData: "Permission/getPermissionData",
      getPermissionByApprove: "Permission/getPermissionByApprove",
      getPermissionUserByApprove: "Permission/getPermissionUserByApprove",
      initPermissionOptionData: "Permission/initPermissionOptionData",
      initPermissionOptionUserData: "Permission/initPermissionOptionUserData",
      getSubMenuPermissData: "Permission/getSubMenuPermissData",
      initPermissionData: "Permission/initPermissionData",
      getIgnoreSubMenuPermissData: "Permission/getIgnoreSubMenuPermissData",
      initAppointment: "Appointment/initAppointment",
      getAppointmentGroup: "Appointment/getAppointmentGroup",
      initLogProject: "Project/initLogProject",
      initLogCompetencyProject: "Project/initLogCompetencyProject",
      initLogFileProject: "Project/initLogFileProject",
      changeHeaderPage: "Project/changeHeaderPage",
      changeManageProjectPage: "Project/changeManageProjectPage",
    }),
    saveForm() {
      console.log(this.editorData);
    },
    ImportDataToDb() {
      this.$swal
          .fire({
            title: "ยืนยันการทำรายการ",
            text: "คุณต้องการนำเข้าข้อมูลบุคลากรใช่หรือไม่ ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.value) {
              this.dialogLoading = true;
              if (this.empData.length > 0) {
                if (this.TypeProject == "1") {
                  this.empData.map(async (staff_I, idx) => {
                    this.JoinPerson.unshift(staff_I);
                    if (idx == this.empData.length - 1) {
                      this.dialogLoading = false;
                      this.closeDi_ImportDataEmp();
                      // this.getJoinProject()
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: "success",
                        title: "บันทึกข้อมูลผู้เข้าร่วม จากไฟล์นำเข้า สำเร็จ!!",
                      });
                    }
                  });
                } else {
                  this.empData.map(async (staff_I, idx) => {
                    this.JoinTravel.unshift({
                      ...staff_I,
                      id: this.JoinTravel.length + 1,
                      prefix: staff_I.iname,
                      full_name: staff_I.full_Name,
                      customTravelDetail:
                          '<p style="font-weight: bold">' +
                          staff_I.full_Name +
                          "</p>" +
                          '<p style="font-weight: bold">ตำแหน่ง: ' +
                          staff_I.pos_name +
                          "</p>",
                      position: staff_I.pos_name,
                      Allowance: "0",
                      AccommodationCost: "0",
                      ShippingCosts: "0",
                      RegistrationFee: "0",
                      AllTravelExpenses: "0",
                      RemainingBudget: "0",
                      Lecturer:
                          this.Project_group != null && this.Project_group != ""
                              ? this.Project_group == "116"
                                  ? this.Lecturer
                                  : null
                              : null,
                      files: [],
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      phone: "",
                      registerType_id: 0,
                    });
                    if (idx == this.empData.length - 1) {
                      this.dialogLoading = false;
                      this.closeDi_ImportDataEmp();
                      // this.getJoinProject()
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: "success",
                        title: "บันทึกข้อมูลผู้เข้าร่วม จากไฟล์นำเข้า สำเร็จ!!",
                      });
                    }
                  });
                }
              } else {
                this.dialogLoading = false;
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่สามารถนำเข้าข้อมูลบุคลากรได้ เนื่องจากไม่พบข้อมูลรายชื่อบุคลากรที่ต้องการจะนำเข้า",
                });
              }
            }
          });
    },
    importExcelData(type) {
      this.typeImport = type;
      this.DialogImportEmp = true;
    },
    ChooseSheetAction() {
      this.empHeaders = [];
      this.empData = [];
      this.Exec = false;
      this.ShowAlertErrImp = false;
      this.MessageErrorImp = "";
      var CheckDupe = false;
      var empDataDump = [];
      var textID = "";
      readXlsxFile(this.filesImportEmp[0], {sheet: this.ChooseSheet}).then(
          (row) => {
            row.map((items, index) => {
              var obj = {};
              items.map((data, idx) => {
                if (index == 0) {
                  this.empHeaders.push({
                    text: data,
                    value: "keys" + idx,
                  });
                } else {
                  obj["keys" + idx] = data;
                  textID += "'" + data + "',";
                  if (idx == items.length - 1) {
                    empDataDump.push(obj);
                  }
                }
              });
            });
            if (textID != "") {
              textID = textID.slice(0, -1);
            }
            if (this.typeImport == "1") {
              if (empDataDump.length > 0) {
                empDataDump.map((itemEmp) => {
                  CheckDupe = false;
                  this.staffData.map(async (staff_I) => {
                    if (staff_I.perid == itemEmp.keys0) {
                      if (
                          this.JoinPerson.filter(
                              (item) => item.uid == staff_I.perid
                          ).length > 0
                      ) {
                        CheckDupe = true;
                      }
                      if (!CheckDupe) {
                        this.empData.push({
                          idEmp: this.empData.length,
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          position: "",
                          phone: "",
                          registerType_id: 0,
                          join_status: "0",
                          files: [],
                        });
                      } else {
                        this.MessageErrorImp +=
                            '<p style="font-weight: bold;color: red"">' +
                            staff_I.full_Name +
                            " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                        this.ShowAlertErrImp = true;
                      }
                    }
                  });
                });
              }
            } else if (this.typeImport == "2") {
              axios
                  .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                    queryName: "getStdMedPSU",
                    param: btoa(
                        encodeURIComponent(
                            JSON.stringify({
                              queryId: textID,
                            })
                        )
                    ),
                  })
                  .then((res) => {
                    if (res.data.length > 0) {
                      if (empDataDump.length > 0) {
                        empDataDump.map((itemEmp) => {
                          CheckDupe = false;
                          res.data.map(async (stdI) => {
                            if (stdI.STUDENT_ID == itemEmp.keys0) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) => item.uid == stdI.STUDENT_ID
                                  ).length > 0
                              ) {
                                CheckDupe = true;
                              }
                              if (!CheckDupe) {
                                this.empData.push({
                                  idEmp: this.empData.length,
                                  ...stdI,
                                  uid: stdI.STUDENT_ID,
                                  full_Name:
                                      stdI.STUD_NAME_THAI +
                                      " " +
                                      stdI.STUD_SNAME_THAI,
                                  name: stdI.STUD_NAME_THAI,
                                  sname: stdI.STUD_SNAME_THAI,
                                  idCard: stdI.CITIZEN_ID,
                                  affiliation: "นักศึกษาคณะแพทย์",
                                  position: "",
                                  phone: "",
                                  registerType_id: 1,
                                  join_status: "0",
                                  files: [],
                                  type_details: "นักศึกษาคณะแพทย์",
                                });
                              } else {
                                this.MessageErrorImp +=
                                    '<p style="font-weight: bold;color: red"">' +
                                    stdI.STUD_NAME_THAI +
                                    " " +
                                    stdI.STUD_SNAME_THAI +
                                    " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                this.ShowAlertErrImp = true;
                              }
                            }
                          });
                        });
                      }
                    }
                  });
            } else {
              if (empDataDump.length > 0) {
                var count = 0;
                empDataDump.map((itemEmp) => {
                  CheckDupe = false;
                  if (itemEmp.keys0 != null) {
                    if (
                        this.JoinPerson.filter(
                            (item) =>
                                item.name == itemEmp.keys0 &&
                                item.sname == itemEmp.keys1
                        ).length > 0
                    ) {
                      CheckDupe = true;
                    }
                    if (!CheckDupe) {
                      if (this.JoinPerson.length > 0) {
                        while (
                            this.JoinPerson.filter(
                                (item) => item.uid == "P_" + count
                            ).length > 0 ||
                            this.empData.filter((item) => item.uid == "P_" + count)
                                .length > 0
                            ) {
                          count++;
                        }
                      } else if (this.empData.length > 0) {
                        while (
                            this.empData.filter((item) => item.uid == "P_" + count)
                                .length > 0
                            ) {
                          count++;
                        }
                      }
                      this.empData.push({
                        idEmp: this.empData.length,
                        uid: "P_" + count,
                        full_Name: itemEmp.keys0 + " " + itemEmp.keys1,
                        name: itemEmp.keys0,
                        sname: itemEmp.keys1,
                        idCard: "",
                        affiliation: itemEmp.keys2,
                        position: itemEmp.keys3,
                        phone: "",
                        registerType_id: 4,
                        join_status: "0",
                        files: [],
                        type_details: "บุคคลภายนอก",
                      });
                    } else {
                      this.MessageErrorImp +=
                          '<p style="font-weight: bold;color: red"">' +
                          itemEmp.keys0 +
                          " " +
                          itemEmp.keys1 +
                          " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                      this.ShowAlertErrImp = true;
                    }
                  }
                });
              }
            }

            if (this.MessageErrorImp != "") {
              this.ShowAlertErrImp = true;
            }
            this.DialogExamImportEmp = true;
          }
      );
    },
    closeDi_ImportDataEmp() {
      this.ShowAlertErrImp = false;
      this.MessageErrorImp = "";
      this.empData = [];
      this.sheets = [];
      this.ChooseSheet = "";
      this.Exec = false;
      this.filesImportEmp = [];
      this.DialogExamImportEmp = false;
      this.DialogImportEmp = false;
    },
    closeDi_ImportDataStd() {
      this.ShowAlertErrImp = false;
      this.MessageErrorImp = "";
      this.empData = [];
      this.sheets = [];
      this.ChooseSheet = "";
      this.Exec = false;
      this.filesImportEmp = [];
      this.DialogExamImportEmp = false;
      this.DialogImportStd = false;
    },
    ChangeForm(idForm) {
      if (idForm == "1") {
        this.form1 = true;
        this.form2 = false;
        this.form3 = false;
      } else if (idForm == "2") {
        this.form1 = false;
        this.form2 = true;
        this.form3 = false;
      } else {
        this.form1 = false;
        this.form2 = false;
        this.form3 = true;
      }
    },
    clearRoundData() {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ โปรดอ่าน !!",
          text: "หากมีการเปลื่ยนแปลงข้อมูลการกำหนดรุ่น ระบบจะทำการยกเลิกรายชื่อผู้เข้าร่วมและการลงทะเบียนทั้งหมดในโครงการนี้ ท่านยืนยันที่จะทำรายการนี้หรือไม่ ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
              {
                queryName: "setIsProjectRound",
                param: btoa(
                  encodeURIComponent(
                    JSON.stringify({
                      Project_code: this.Project_code_dump,
                      IsRoundStatus: this.roundNeed ? "1" : "0",
                      permiss_check: this.MeData[0].perid,
                    })
                  )
                ),
              }).then((res) => {
                if (res.data.status) {
                  this.$swal.fire({
                    icon: "success",
                    title: "เปลื่ยนแปลงข้อมูลสำเร็จ",
                    text: "ระบบได้ทำการยกเลิกรายชื่อผู้เข้าร่วมและการลงทะเบียนทั้งหมดในโครงการนี้แล้ว",
                  });
                  this.posiCondi = null;
                  this.workAgeStart_Condi = "";
                  this.workAgeEnd_Condi = "";
                  this.DataCondi = [];
                  this.JoinPerson = [];
                  this.DepQuotaData = [];
                  this.ChooseTypRegis = "1";
                  this.ChooseTypRegis2 = "0";
                  this.ChooseTypRegis3 = "0";
                  this.dateRegStart = "";
                  this.dateRegEnd = "";
                  this.ProjectQuotaCount = "";
                  this.ProjectQuotaDepCount = 0;
                  this.ChkJoinPerson = true;
                  this.ChooseTypeDep = "";
                  this.DepQuotaSelect = "";
                  this.DepQuotaCount = "";
                  this.DepQuotaData = [];
                }
              })
          } else {
            this.roundNeed = false
          }
        })
    },
    Copy() {
      this.$swal.fire({
        position: "top-end",
        icon: "success",
        title: "คัดลอกลิงค์",
        showConfirmButton: false,
        timer: 1000,
      });
      // var copyText = this.url
      //
      // /* Select the text field */
      // copyText.select();
      // copyText.setSelectionRange(0, 99999); /* For mobile devices */
      //
      // /* Copy the text inside the text field */
      // document.execCommand("copy");
    },
    GenerateUrl() {
      return new Promise((resolve) => {
        TinyURL.shorten(ConstData.ProjectGenerateLink + this.LinkGen).then(
            function (res) {
              resolve(res);
            },
            function (err) {
              console.log(err);
            }
        );
      });
    },
    insertAppointment() {
      if (this.Coordinator.length > 0) {
        var CheckCupe = false;
        this.appointmentGroup.map((a_item) => {
          if (a_item.status) {
            CheckCupe = false;
            this.Coordinator.map((CoorItem) => {
              if (
                  CoorItem.Name == a_item.full_Name &&
                  CoorItem.Committee_code == a_item.C_Committee_code
              ) {
                CheckCupe = true;
              }
            });

            if (CheckCupe) {
              this.alert2 = true;
              this.txtAlert2.push({
                id: this.txtAlert.length + 1,
                Detail:
                    "พบข้อมูลรายชื่อ " +
                    this.full_name +
                    " และตำแหน่งที่เลือกในระบบอยู่แล้ว",
              });
            } else {
              this.staffData.map((item) => {
                if (item.perid == a_item.perid) {
                  this.Coordinator.push({
                    ...item,
                    idx: this.Coordinator.length,
                    Project_code: this.Project_code,
                    Committee_code: a_item.C_Committee_code,
                    Committee_type: "0",
                    Committee_des: a_item.committee_des,
                    Name: a_item.full_Name,
                    Perid: a_item.perid,
                    TEL: a_item.phone,
                  });
                }
              });
              this.Committee_ToShow = this.Coordinator.filter(
                  (itemLecturer) =>
                      itemLecturer.Committee_code != "6" &&
                      itemLecturer.Committee_code != "23" &&
                      itemLecturer.Committee_code != "24"
              );
              this.LecturerToShow = this.Coordinator.filter(
                  (itemLecturer) =>
                      itemLecturer.Committee_code == "6" ||
                      itemLecturer.Committee_code == "23" ||
                      itemLecturer.Committee_code == "24"
              );
              if (this.Committee_ToShow.length > 0) {
                this.Committee_ToShow.map((Committee_i, idx) => {
                  Committee_i.index = idx + 1;
                });
              }
              if (this.LecturerToShow.length > 0) {
                this.LecturerToShow.map((lecture_i, idx) => {
                  lecture_i.index = idx + 1;
                });
              }
            }
          }
        });
      } else {
        this.appointmentGroup.map((a_item) => {
          if (a_item.status) {
            this.staffData.map((item) => {
              if (item.perid == a_item.perid) {
                this.Coordinator.push({
                  ...item,
                  idx: this.Coordinator.length,
                  Project_code: this.Project_code,
                  Committee_code: a_item.C_Committee_code,
                  Committee_type: "0",
                  Committee_des: a_item.committee_des,
                  Name: a_item.full_Name,
                  Perid: a_item.perid,
                  TEL: a_item.phone,
                });
              }
            });
            this.Committee_ToShow = this.Coordinator.filter(
                (itemLecturer) =>
                    itemLecturer.Committee_code != "6" &&
                    itemLecturer.Committee_code != "23" &&
                    itemLecturer.Committee_code != "24"
            );
            this.LecturerToShow = this.Coordinator.filter(
                (itemLecturer) =>
                    itemLecturer.Committee_code == "6" ||
                    itemLecturer.Committee_code == "23" ||
                    itemLecturer.Committee_code == "24"
            );
            if (this.Committee_ToShow.length > 0) {
              this.Committee_ToShow.map((Committee_i, idx) => {
                Committee_i.index = idx + 1;
              });
            }
            if (this.LecturerToShow.length > 0) {
              this.LecturerToShow.map((lecture_i, idx) => {
                lecture_i.index = idx + 1;
              });
            }
          }
        });
      }
      setTimeout(() => {
        this.alert2 = false;
      }, 5000);
      this.dialogAppointment = false;
      this.AppointmentSel = "";
    },
    GetAppointmentGroupFn() {
      this.appointmentGroup = [];
      this.AppointmentObj = null;
      var Result = this.Appointment.filter(
          (item) => item.id == this.AppointmentSel
      );
      if (Result.length > 0) {
        this.AppointmentObj = Result[0];
        this.getAppointmentGroup({
          Ref_id: Result[0].Ref_id,
        })
            .then((res) => {
              if (res) {
                if (this.AppointmentGroup.length > 0) {
                  this.AppointmentGroup.map((item) => {
                    this.appointmentGroup.push({
                      ...item,
                      full_Detail:
                          '<span style="color: darkmagenta">' +
                          item.full_Name +
                          " (" +
                          item.perid +
                          ")" +
                          "</span>" +
                          '<div><span style="color: cadetblue">' +
                          item.dep_name +
                          "</span></div>",
                      phone: "",
                      status: false,
                    });
                  });
                  this.dialogAppointment = true;
                }
              }
            })
            .catch((res) => {
              if (res) {
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่พบข้อมูลคณะกรรมการในการแต่งตั้งกรรมการ " +
                      this.AppointmentObj.Topic,
                });
              }
            });
      }
    },
    closeDialogAppoint() {
      this.dialogAppointment = false;
      this.AppointmentSel = "";
    },
    ShowGroupDepDetail() {
      if (this.GroupSelect != "") {
        this.groupDetail = null;
        this.groupDetail = this.GroupQuotaMS.filter(
            (item) => item.id == this.GroupSelect
        )[0];
        this.groupQuataDump = [];
        this.groupQuataDump = this.GroupQuotaData.filter(
            (itemG) => itemG.group_quota_ms_id == this.GroupSelect
        );
        if (this.groupQuataDump.length > 0) {
          this.groupQuataDump.map((qua_i) => {
            this.depart.map((depart) => {
              if (qua_i.dep_id == depart.dep_id) {
                qua_i.dep_name = depart.dep_name;
              }
            });
          });
        }
        this.dialogGroupDetail = true;
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาเลือกกลุ่มเทมเพลต",
        });
      }
    },
    showDialogRound() {
      this.round = "";
      this.round_name = "";
      this.dateRegS = "";
      this.dateRegE = "";
      this.time_start = "";
      this.time_end = "";
      this.DataCondi = [];
      this.ChooseTypRegis = "1";
      this.ChooseTypRegis2 = "0";
      this.ChooseTypRegis3 = "0";
      this.dateRegStart = "";
      this.dateRegEnd = "";
      this.ChkJoinPerson = true;
      this.ProjectQuotaCount = "";
      this.ProjectQuotaDepCount = 0;
      this.DepQuotaData = [];
      this.JoinPerson = [];
      this.MessageSuc = "";
      this.ShowAlertSuc = false;
      this.MessageError = "";
      this.ShowAlertErr = false;
      this.staffSel = "";
      this.departSel = "";
      this.dialogRound = true;
      this.RoundDataDump = null;
      this.save = true;
    },
    updateRoundData() {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ",
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการแก้ไขข้อมูล",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            if (this.dateRegS == "" || this.dateRegE == "") {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาระบุวันที่ เริ่มต้น - สิ้นสุดให้ ครบถ้วน!",
              });
            } else if (
                this.ChooseTypRegis == "0" &&
                (this.dateRegStart == "" || this.dateRegEnd == "")
            ) {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาระบุวันที่ เปิด - ปิด รับสมัคร ให้ครบถ้วน",
              });
            } else {
              /* this.RoundData.map((Round_i) => {
                if (Round_i.id == this.RoundDataDump.id) {
                  Round_i.round = this.round;
                  Round_i.round_name = this.round_name;
                  Round_i.dateRegS =
                      this.dateRegS == null || this.dateRegS == "0000-00-00"
                          ? ""
                          : this.dateRegS;
                  Round_i.dateRegE =
                      this.dateRegE == null || this.dateRegE == "0000-00-00"
                          ? ""
                          : this.dateRegE;
                  Round_i.time_start =
                      this.time_start == null || this.time_start == "00:00"
                          ? ""
                          : this.time_start;
                  Round_i.time_end =
                      this.time_end == null || this.time_end == "00:00"
                          ? ""
                          : this.time_end;
                  Round_i.WorkAgeData = this.DataCondi;
                  Round_i.ChooseTypRegis = this.ChooseTypRegis;
                  Round_i.ChooseTypRegis2 = this.ChooseTypRegis2;
                  Round_i.ChooseTypRegis3 = this.ChooseTypRegis3;
                  Round_i.dateRegStart =
                      this.dateRegStart == null || this.dateRegStart == "0000-00-00"
                          ? ""
                          : this.dateRegStart;
                  Round_i.dateRegEnd =
                      this.dateRegEnd == null || this.dateRegEnd == "0000-00-00"
                          ? ""
                          : this.dateRegEnd;
                  Round_i.ChkJoinPerson = this.ChkJoinPerson;
                  Round_i.ProjectQuotaCount = this.ProjectQuotaCount;
                  Round_i.DepQuotaData = this.DepQuotaData;
                  Round_i.JoinPersonData = this.JoinPerson;
                  Round_i.count_person = this.JoinPerson.length;
                }
              });
              this.dialogRound = false; */

              axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                    {
                      queryName: "updateProjectRound",
                      param: btoa(
                          encodeURIComponent(
                              JSON.stringify({
                                RoundData: [{
                                  id: Allfunc.uniqueid(),
                                  Ref_id: this.RoundDataDump.Ref_id,
                                  round: this.round,
                                  round_name: this.round_name,
                                  DateS: this.dateRegS,
                                  DateE: this.dateRegE,
                                  TimeS: this.time_start,
                                  TimeE: this.time_end,
                                  Project_code: this.Project_code_dump,
                                  Status_Reg: this.ChooseTypRegis,
                                  Status_Type_Reg: this.ChooseTypRegis2,
                                  Status_Type_Reg2: this.ChooseTypRegis3,
                                  DateS_Reg: this.dateRegStart,
                                  DateE_Reg: this.dateRegEnd,
                                  Status_Count_Reg: this.ChkJoinPerson == true ? "1" : "0",
                                  Count_Reg: this.ProjectQuotaCount,
                                }],
                                Project_code: this.Project_code_dump,
                                WorkAgeData: this.DataCondi,
                                DepQuotaData: this.DepQuotaData,
                                Create_By: this.MeData[0].perid,
                                permiss_check: this.MeData[0].perid,
                                Create_Time: "now()",
                              })
                          )
                      ),
                    }
                )
                .then((res) => {
                  if (res.data.status) {
                    this.dialogLoading = true
                    this.dialogRound = false;
                    this.$swal.fire({
                      icon: "success",
                      title: "บันทึกข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.getRoundData().then(res => {
                      if (res) {
                        this.dialogLoading = false
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาดไม่สามารถเรียกข้อมูลรุ่นโครงการได้ โปรดลองอีกครั้ง!",
                        });
                      }
                    })
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title: "พบข้อผิดพลาดในการบันทึกข้อมูล โปรดติดต่อผู้ดูแลระบบ",
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        })
    },
    GetRoundDetail(item) {
      this.save = false;
      this.RoundDataDump = null;
      this.RoundDataDump = item;
      this.ProjectQuotaDepCount = 0;
      var RoundDump = this.RoundData.filter((Round_i) => Round_i.id == item.id);
      if (RoundDump.length > 0) {
        this.round = RoundDump[0].round;
        this.round_name = RoundDump[0].round_name;
        this.dateRegS =
            RoundDump[0].dateRegS == null || RoundDump[0].dateRegS == "0000-00-00"
                ? ""
                : RoundDump[0].dateRegS;
        this.dateRegE =
            RoundDump[0].dateRegE == null || RoundDump[0].dateRegE == "0000-00-00"
                ? ""
                : RoundDump[0].dateRegE;
        this.time_start =
            RoundDump[0].time_start == null || RoundDump[0].time_start == "00:00"
                ? ""
                : RoundDump[0].time_start;
        this.time_end =
            RoundDump[0].time_end == null || RoundDump[0].time_end == "00:00"
                ? ""
                : RoundDump[0].time_end;
        this.DataCondi = RoundDump[0].WorkAgeData;
        if (this.DataCondi.length > 0) {
          this.DataCondi.map((dataI) => {
            dataI.workAgeStart = dataI.WSYear;
            dataI.workAgeEnd = dataI.WEYear;
          });
        }
        this.ChooseTypRegis = RoundDump[0].ChooseTypRegis;
        this.ChooseTypRegis2 = RoundDump[0].ChooseTypRegis2;
        this.ChooseTypRegis3 = RoundDump[0].ChooseTypRegis3;
        this.dateRegStart =
            RoundDump[0].dateRegStart == null ||
            RoundDump[0].dateRegStart == "0000-00-00"
                ? ""
                : RoundDump[0].dateRegStart;
        this.dateRegEnd =
            RoundDump[0].dateRegEnd == null ||
            RoundDump[0].dateRegEnd == "0000-00-00"
                ? ""
                : RoundDump[0].dateRegEnd;
        this.ChkJoinPerson = RoundDump[0].ChkJoinPerson;
        if (RoundDump[0].ProjectQuotaCount == "0") {
          this.ProjectQuotaCount = "";
        } else {
          this.ProjectQuotaCount = RoundDump[0].ProjectQuotaCount;
        }

        this.DepQuotaData = RoundDump[0].DepQuotaData;
        if (this.DepQuotaData.length > 0) {
          this.DepQuotaData.map((Group_I) => {
            this.ProjectQuotaDepCount += parseInt(Group_I.count);
          });
        }
        this.JoinPerson = RoundDump[0].JoinPersonData;
        // this.JoinPerson.map(item => {
        //   item.idx = this.JoinPerson.length + 1
        // })
      }
      this.dialogRound = true;
    },
    DelRoundData(item) {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ",
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการลบข้อมูล",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                {
                  queryName: "delProjectRound",
                  param: btoa(
                      encodeURIComponent(
                          JSON.stringify({
                            No: item.No,
                            id: item.Ref_id,
                            Project_code: this.Project_code_dump,
                            permiss_check: this.MeData[0].perid,
                          })
                      )
                  ),
                }
            ).then((res) => {
              if (res.data.status) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: "success",
                  title: "ลบข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getRoundData()
              } else {
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่สามารถลบข้อมูลได้ เนื่องจากมีผู้เข้าร่วมโครงการในรุ่นนี้อยู่แล้ว",
                });
              }
            }).catch((err) => {
              console.log(err);
            });
          }
        });
    },
    getRoundData() {
      return new Promise(resolve => {
        var CheckJoin = false;
        this.RoundData = [];
        axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
            {
              queryName: "getProjectRound",
              param: btoa(
                encodeURIComponent(
                  JSON.stringify({
                    Project_code: this.ProjectPlan,
                    permiss_check: this.MeData[0].perid,
                  })
                )
              ),
            }
        ).then((res) => {
          if (res.data.status) {
            if (res.data.Project_round.length > 0) {
              var QuotaDepDump = [];
              res.data.Project_round.map((itemR) => {
                this.countAllPerson += itemR.joinPerjData.length;
                QuotaDepDump = []
                if (itemR.DepQuotaData.length > 0) {
                  var type = "";
                  itemR.DepQuotaData.map((item_qua) => {
                    type = "";
                    if (item_qua.dep_type == "0") {
                      type = "หน่วยงาน/ภาควิชา";
                    } else {
                      type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                    }
                    QuotaDepDump.push({
                      quotaType: item_qua.dep_type,
                      type: type,
                      type_id: item_qua.dep_type,
                      dep_name: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_name,
                      dep_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_id,
                      dep_group_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_group_id,
                      count: item_qua.count,
                    });
                  });
                }
                if (itemR.Status_Count_Reg == "0") {
                  CheckJoin = false;
                } else {
                  CheckJoin = true;
                }
                this.RoundData.push({
                  id: this.RoundData.length,
                  No: itemR.No,
                  Ref_id: itemR.id,
                  round: itemR.Round,
                  round_name: itemR.Round_name,
                  dateRegS: itemR.DateS,
                  dateRegE: itemR.DateE,
                  time_start: itemR.TimeS,
                  time_end: itemR.TimeE,
                  WorkAgeData: itemR.personLvData,
                  ChooseTypRegis: itemR.Status_Reg,
                  ChooseTypRegis2: itemR.Status_Type_Reg,
                  ChooseTypRegis3: itemR.Status_Type_Reg2,
                  dateRegStart: itemR.DateS_Reg,
                  dateRegEnd: itemR.DateE_Reg,
                  ChkJoinPerson: CheckJoin,
                  ProjectQuotaCount: itemR.Count_Reg,
                  DepQuotaData: QuotaDepDump,
                  JoinPersonData: itemR.joinPerjData,
                  count_person: itemR.joinPerjData.length,
                });
              });
            }
            resolve(true);
          }
        }).catch((err) => {
          console.log(err);
          resolve(false);
        });
      })
    },
    SaveRoundData() {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ",
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            if (this.dateRegS == "" || this.dateRegE == "") {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาระบุวันที่ เริ่มต้น - สิ้นสุดให้ ครบถ้วน!",
              });
            } else if (this.ChooseTypRegis == "0" && (this.dateRegStart == "" || this.dateRegEnd == "")) {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาระบุวันที่ เปิด - ปิด รับสมัคร ให้ครบถ้วน",
              });
            } else {
              /* this.RoundData.push({
                id: this.RoundData.length + 1,
                Ref_id: Allfunc.uniqueid(),
                round: this.round,
                round_name: this.round_name,
                dateRegS:
                    this.dateRegS == null || this.dateRegS == "0000-00-00"
                        ? ""
                        : this.dateRegS,
                dateRegE:
                    this.dateRegE == null || this.dateRegE == "0000-00-00"
                        ? ""
                        : this.dateRegE,
                time_start:
                    this.time_start == null || this.time_start == "00:00"
                        ? ""
                        : this.time_start,
                time_end:
                    this.time_end == null || this.time_end == "00:00"
                        ? ""
                        : this.time_end,
                WorkAgeData: this.DataCondi,
                ChooseTypRegis: this.ChooseTypRegis,
                ChooseTypRegis2: this.ChooseTypRegis2,
                ChooseTypRegis3: this.ChooseTypRegis3,
                dateRegStart:
                    this.dateRegStart == null || this.dateRegStart == "0000-00-00"
                        ? ""
                        : this.dateRegStart,
                dateRegEnd:
                    this.dateRegEnd == null || this.dateRegEnd == "0000-00-00"
                        ? ""
                        : this.dateRegEnd,
                ChkJoinPerson: this.ChkJoinPerson,
                ProjectQuotaCount: this.ProjectQuotaCount,
                DepQuotaData: this.DepQuotaData,
                JoinPersonData: this.JoinPerson,
                count_person: this.JoinPerson.length,
              });
              this.dialogRound = false; */

                axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                    {
                      queryName: "insertProjectRound",
                      param: btoa(
                          encodeURIComponent(
                              JSON.stringify({
                                RoundData: [{
                                  id: Allfunc.uniqueid(),
                                  round: this.round,
                                  round_name: this.round_name,
                                  DateS: this.dateRegS,
                                  DateE: this.dateRegE,
                                  TimeS: this.time_start,
                                  TimeE: this.time_end,
                                  Project_code: this.Project_code_dump,
                                  Status_Reg: this.ChooseTypRegis,
                                  Status_Type_Reg: this.ChooseTypRegis2,
                                  Status_Type_Reg2: this.ChooseTypRegis3,
                                  DateS_Reg: this.dateRegStart,
                                  DateE_Reg: this.dateRegEnd,
                                  Status_Count_Reg: this.ChkJoinPerson == true ? "1" : "0",
                                  Count_Reg: this.ProjectQuotaCount,
                                }],
                                Project_code: this.Project_code_dump,
                                WorkAgeData: this.DataCondi,
                                DepQuotaData: this.DepQuotaData,
                                Create_By: this.MeData[0].perid,
                                permiss_check: this.MeData[0].perid,
                                Create_Time: "now()",
                              })
                          )
                      ),
                    }
                )
                .then((res) => {
                  if (res.data.status) {
                    this.dialogLoading = true
                    this.dialogRound = false;
                    this.$swal.fire({
                      icon: "success",
                      title: "บันทึกข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.getRoundData().then(res => {
                      if (res) {
                        this.dialogLoading = false
                      } else {
                        this.dialogLoading = false
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาดไม่สามารถเรียกข้อมูลรุ่นโครงการได้ โปรดลองอีกครั้ง!",
                        });
                      }
                    })
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title: "พบข้อผิดพลาดในการบันทึกข้อมูล โปรดติดต่อผู้ดูแลระบบ",
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
        }
      });
    },    
    openExportOptionsDialog() {
      // เปิด dialog เพื่อให้ผู้ใช้เลือก field ที่ต้องการ export
      // console.log("Opening export options dialog");
      this.dialogExportOptions = true;
    },    
    confirmExportWithOptions() {
      this.dialogExportOptions = false;
      this.ExportEmpData();
    },    
    getFilteredJsonFields() {
      // กรองข้อมูลจาก exportFields ที่มีค่า value = true
      const filteredFields = {};
      
      // สร้าง mapping ระหว่าง exportFields keys กับ json_fields keys ตามของเดิม
      const fieldMapping = {
        employeeId: 'รหัสบุคลากร',      // 'perid'
        prefix: 'คำนำหน้า',            // 'iname'
        firstName: 'ชื่อ',             // 'name'
        lastName: 'นามสกุล',          // 'surname'
        department: 'หน่วยงาน',        // 'dep_name'
        position: 'ตำแหน่ง',          // 'pos_name'
        religion: 'ศาสนา',            // 'religion_name'
        academicBudget: 'งบวิชาการตามสิทธิ์ที่ได้รับ', // 'money_permiss'
        remarks: 'หมายเหตุ',           // 'remark'
        licenseNumber: 'เลขใบอนุญาต'  // 'LicenseID'
      };

      // กำหนด json_fields เดิมทั้งหมดเพื่อใช้เป็นฐาน
      const originalJsonFields = {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name_old',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
        "เลขใบอนุญาต": 'license_id',
      };

      // เพิ่มลำดับเป็น field แรกเสมอ
      filteredFields['ลำดับ'] = originalJsonFields['ลำดับ'];

      // วนลูปตรวจสอบ exportFields และเพิ่มเฉพาะ fields ที่ถูกเลือก
      Object.keys(this.exportFields).forEach(key => {
        if (this.exportFields[key].value && fieldMapping[key]) {
          const fieldLabel = fieldMapping[key];
          if (originalJsonFields[fieldLabel]) {
            filteredFields[fieldLabel] = originalJsonFields[fieldLabel];
          }
        }
      });

      return filteredFields;
    },
    ExportEmpData() {
      this.json_data = [];
      this.array_title = [];
      var staff = [];
      if (this.DateStart == "" || this.DateEnd == "") {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน",
        });
      } else {
        this.array_title.push(this.Project_name);
        if (this.RoundDataDump != null) {
          this.array_title.push(
              "รุ่นที่ " +
              this.RoundDataDump.round +
              " ชื่อรุ่น " +
              this.RoundDataDump.round_name
          );
          this.array_title.push(
              "วันที่ " +
              Vue.filter("DateToThai")(this.dateRegS) +
              " ถึง " +
              Vue.filter("DateToThai")(this.dateRegE)
          );
        } else {
          this.array_title.push(
              "วันที่ " +
              Vue.filter("DateToThai")(this.DateStart) +
              " ถึง " +
              Vue.filter("DateToThai")(this.DateEnd)
          );
        }
        this.array_title.push("สถานที่ " + this.Location);
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            staff = this.staffData.filter((value) => value.perid == item.uid);
            if (staff.length > 0) {
              if (parseInt(staff[0].salary) > 20000) {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  iname: staff[0].iname,
                  name: staff[0].name,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name_old,
                  dep_group_name: staff[0].dep_group_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: "",
                  index: idx + 1,
                  money_permiss: "15500",
                  license_id: staff[0].license_id || "", // เพิ่มเลขใบอนุญาต
                });
              } else {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  iname: staff[0].iname,
                  name: staff[0].name,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name_old,
                  dep_group_name: staff[0].dep_group_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: "",
                  index: idx + 1,
                  money_permiss: "11000",
                  license_id: staff[0].license_id || "", // เพิ่มเลขใบอนุญาต
                });
              }
            }
          });
          this.json_data = this.json_data.sort((a, b) =>
              a.dep_id.localeCompare(b.dep_id)
          );
          this.json_data.map((item, idx) => {
            item.index = idx + 1;
          });
        }
      }
    },
    ExportData() {
      this.json_data_export = [];
      this.array_title = [];
      if (this.DateStart == "" || this.DateEnd == "") {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน",
        });
      } else {
        this.array_title.push(this.Project_name);
        if (this.RoundDataDump != null) {
          this.array_title.push(
              "รุ่นที่ " +
              this.RoundDataDump.round +
              " ชื่อรุ่น " +
              this.RoundDataDump.round_name
          );
          this.array_title.push(
              "วันที่ " +
              Vue.filter("DateToThai")(this.dateRegS) +
              " ถึง " +
              Vue.filter("DateToThai")(this.dateRegE)
          );
        } else {
          this.array_title.push(
              "วันที่ " +
              Vue.filter("DateToThai")(this.DateStart) +
              " ถึง " +
              Vue.filter("DateToThai")(this.DateEnd)
          );
        }
        this.array_title.push("สถานที่ " + this.Project.Location);
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            this.json_data_export.push({
              ...item,
              index: idx + 1,
              full_Name: item.name + " " + item.sname,
            });
          });
        }
        this.json_data_export = this.json_data_export.sort((a, b) =>
            a.dep_id.localeCompare(b.dep_id)
        );
        this.json_data_export.map((item, idx) => {
          item.index = idx + 1;
        });
      }
    },
    ExportJoinTravelData() {
      this.json_data = [];
      this.array_title = [];
      var staff = [];
      if (this.dateRegS == "" || this.dateRegE == "") {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน",
        });
      } else {
        this.array_title.push(this.Project_name);
        this.array_title.push(
            "วันที่ " +
            Vue.filter("DateToThai")(this.dateRegS) +
            " ถึง " +
            Vue.filter("DateToThai")(this.dateRegE)
        );
        this.array_title.push("สถานที่ " + this.Location);
        if (this.JoinTravel.length > 0) {
          this.JoinTravel.map((item, idx) => {
            staff = this.staffData.filter((value) => value.perid == item.uid);
            if (staff.length > 0) {
              if (parseInt(staff[0].salary) > 20000) {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: "",
                  index: idx + 1,
                  money_permiss: "15500",
                });
              } else {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: "",
                  index: idx + 1,
                  money_permiss: "11000",
                });
              }
            }
          });
          this.json_data = this.json_data.sort((a, b) =>
              a.dep_id.localeCompare(b.dep_id)
          );
          this.json_data.map((item, idx) => {
            item.index = idx + 1;
          });
        }
      }
    },
    ClearData() {
      this.ProjectPlan = null;
      this.Project_code = "";
      this.Project_name = "";
      this.Course_code = null;
      this.course_group = "";
      this.IsProcess = null;
      this.IsExpense = null;
      this.Project_category = "1";
      this.Project_type = this.TypeProject;
      this.Objective = "";
      this.TargetGroup = "";
      this.Remarks = "";
      this.CalCredit = "0";
      this.CalHourse = "0";
      this.PLACE = "";
      this.Province_id = null;
      this.Country_id = null;
      this.BudgetRequest = "0";
      this.ExpenseSummary = 0;
      this.Location = "";
      this.WorkBy = "";
      this.WorkByName = "";
      this.WorkByPhone = "";
      this.DateStart = "";
      this.DateEnd = "";
      this.DepSelect = null;
      this.Project_group = null;
      this.txtProject_group = "";
      this.FiscalYear =
          this.FiscalYearData.length > 0
              ? this.FiscalYearData[this.FiscalYearData.length - 1].year
              : null;
      this.itemCode = "";
      this.FileProject = [];
      this.files = [];
      this.CheckProcess = true;
    },
    GetCurrentDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      return (today = yyyy + "-" + mm + "-" + dd);
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(
          anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0
      ).getDate();
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(
          Date.UTC(
              date_2.getUTCFullYear(),
              date_2.getUTCMonth(),
              date_2.getUTCDate()
          )
      );
      var date1_UTC = new Date(
          Date.UTC(
              date_1.getUTCFullYear(),
              date_1.getUTCMonth(),
              date_1.getUTCDate()
          )
      );

      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {
        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    AddDepQuotaData() {
      var CheckMatch = false;
      var Depart = [];
      var type = "";
      if (this.ChooseTypeDep == "3") {
        var count = this.GroupQuotaData.reduce(
            (prev, cur) => prev + parseInt(cur.count),
            0
        );

        if (
            !this.ChkJoinPerson &&
            parseInt(count) + parseInt(this.ProjectQuotaDepCount) >
            parseInt(this.ProjectQuotaCount)
        ) {
          this.$swal.fire({
            icon: "error",
            title:
                "ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด",
          });
        } else {
          this.GroupQuotaData.map((Group_I, idx) => {
            CheckMatch = false;
            if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((itemDepQ) => {
                if (itemDepQ.type_id == "0") {
                  if (Group_I.dep_id == itemDepQ.dep_id) {
                    CheckMatch = true;
                  }
                } else {
                  Depart = this.depart.filter(
                      (item) => item.dep_group_id == itemDepQ.dep_group_id
                  );
                  if (
                      Depart.filter((item) => item.dep_id == Group_I.dep_id)
                          .length > 0
                  ) {
                    CheckMatch = true;
                  }
                }
              });

              if (!CheckMatch) {
                this.DepQuotaData.push({
                  quotaType: "0",
                  type: "หน่วยงาน/ภาควิชา",
                  type_id: "0",
                  dep_name: this.depart.filter(
                      (item) => item.dep_id == Group_I.dep_id
                  )[0].dep_name,
                  dep_id: this.depart.filter(
                      (item) => item.dep_id == Group_I.dep_id
                  )[0].dep_id,
                  dep_group_id: this.depart.filter(
                      (item) => item.dep_id == Group_I.dep_id
                  )[0].dep_group_id,
                  count: Group_I.count,
                });

                this.ProjectQuotaDepCount += parseInt(Group_I.count);
              }
            } else {
              this.DepQuotaData.push({
                quotaType: "0",
                type: "หน่วยงาน/ภาควิชา",
                type_id: "0",
                dep_name: this.depart.filter(
                    (item) => item.dep_id == Group_I.dep_id
                )[0].dep_name,
                dep_id: this.depart.filter(
                    (item) => item.dep_id == Group_I.dep_id
                )[0].dep_id,
                dep_group_id: this.depart.filter(
                    (item) => item.dep_id == Group_I.dep_id
                )[0].dep_group_id,
                count: Group_I.count,
              });

              this.ProjectQuotaDepCount += parseInt(Group_I.count);
            }

            if (idx == this.GroupQuotaData.length - 1) {
              this.GroupSelect = "";
            }
          });
        }

        ///////////////////////////////////////////////////////
      } else {
        if (this.DepQuotaSelect != "" && this.DepQuotaCount != "") {
          if (
              !this.ChkJoinPerson &&
              parseInt(this.DepQuotaCount) + parseInt(this.ProjectQuotaDepCount) >
              parseInt(this.ProjectQuotaCount)
          ) {
            this.$swal.fire({
              icon: "error",
              title:
                  "ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด",
            });
          } else {
            if (parseInt(this.DepQuotaCount) > 0) {
              if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((itemDepQ) => {
                  if (itemDepQ.type_id == "0") {
                    if (this.ChooseTypeDep == "0") {
                      if (this.DepQuotaSelect == itemDepQ.dep_id) {
                        CheckMatch = true;
                      }
                    } else {
                      Depart = this.depart.filter(
                          (item) => item.dep_group_id == this.DepQuotaSelect
                      );
                      if (
                          Depart.filter((item) => item.dep_id == itemDepQ.dep_id)
                              .length > 0
                      ) {
                        CheckMatch = true;
                      }
                    }
                  } else {
                    Depart = this.depart.filter(
                        (item) => item.dep_group_id == itemDepQ.dep_group_id
                    );
                    if (
                        Depart.filter(
                            (item) => item.dep_id == this.DepQuotaSelect
                        ).length > 0
                    ) {
                      CheckMatch = true;
                    }
                  }
                });

                if (CheckMatch) {
                  this.$swal.fire({
                    icon: "error",
                    title:
                        "พบข้อมูลหน่วยงาน อยู่แล้วไม่สามารถบันทึกข้อมูลหน่วยงานเพิ่มได้อีก",
                  });
                } else {
                  if (this.ChooseTypeDep == "0") {
                    type = "หน่วยงาน/ภาควิชา";
                  } else {
                    type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                  }
                  this.DepQuotaData.push({
                    quotaType: this.ChooseTypeDep,
                    type: type,
                    type_id: this.ChooseTypeDep,
                    dep_name: this.depart.filter(
                        (item) => item.dep_id == this.DepQuotaSelect
                    )[0].dep_name,
                    dep_id: this.depart.filter(
                        (item) => item.dep_id == this.DepQuotaSelect
                    )[0].dep_id,
                    dep_group_id: this.depart.filter(
                        (item) => item.dep_id == this.DepQuotaSelect
                    )[0].dep_group_id,
                    count: this.DepQuotaCount,
                  });

                  this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount);
                  this.DepQuotaSelect = "";
                  this.DepQuotaCount = "";
                }
              } else {
                if (this.ChooseTypeDep == "0") {
                  type = "หน่วยงาน/ภาควิชา";
                } else {
                  type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                }
                this.DepQuotaData.push({
                  quotaType: this.ChooseTypeDep,
                  type: type,
                  type_id: this.ChooseTypeDep,
                  dep_name: this.depart.filter(
                      (item) => item.dep_id == this.DepQuotaSelect
                  )[0].dep_name,
                  dep_id: this.depart.filter(
                      (item) => item.dep_id == this.DepQuotaSelect
                  )[0].dep_id,
                  dep_group_id: this.depart.filter(
                      (item) => item.dep_id == this.DepQuotaSelect
                  )[0].dep_group_id,
                  count: this.DepQuotaCount,
                });

                this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount);
                this.DepQuotaSelect = "";
                this.DepQuotaCount = "";
              }
            } else {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาระบุจำนวนผู้เข้าร่วมอย่างน้อย 1 คน",
              });
            }
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "กรุณาระบุข้อมูลหน่วยงาน และจำนวนผู้เข้าร่วมให้ครบถ้วน",
          });
        }
      }
    },
    RemoveJoinProject() {
      if (this.JoinPerson.length > 0) {
        this.JoinPerson = [];
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    ClearPlanProject() {
      this.Project = null;
      this.ProjectPlan = null;
      this.Project_code = "";
      this.Project_name = "";
      this.Project_code_dump = "";
      this.Course_code = null;
      this.course_group = "";
      this.Period_code = null;
      this.IsProcess = null;
      this.IsExpense = null;
      this.Project_category = "1";
      this.Project_type = this.TypeProject;
      this.Remarks = "";
      this.CalCredit = "0";
      this.CalHourse = "0";
      this.PLACE = "";
      this.Province_id = null;
      this.Country_id = null;
      this.BudgetRequest = "0";
      this.ExpenseSummary = 0;
      this.Expense = 0;
      this.Location = "";
      this.WorkBy = "";
      this.WorkByName = "";
      this.WorkByPhone = "";
      this.DateStart = "";
      this.DateEnd = "";
      this.IsPlan = "0";
      this.IsLog = "0";
      this.DepSelect = this.MeData[0].dep_id;
      this.episode = null;
      this.Project_group = null;
      this.txtProject_group = "";
      this.FiscalYear =
          this.FiscalYearData.length > 0
              ? this.FiscalYearData[this.FiscalYearData.length - 1].year
              : null;
      this.itemCode = "";
      this.files = [];
      this.FileProject = [];
      this.LogFileProject = [];
      this.selection = [];
      this.logSelection = [];
      this.LogObjProject = null;
      this.isFormExec = false;
      this.ApproveRadio = "0";
      this.budgetData = [];
      this.Coordinator = [];
      this.JoinPerson = [];
      this.roundNeed = false;
      this.CheckProcess = true;
      this.Create_By = "";
      this.Create_Time = "";

      this.departName = "";
      this.IsProcess = null;
      this.IsExpense = null;
      this.Project_group = null;
      this.PLACE = "";
      this.BudgetRequest = "0";
      this.WorkBy = "";
      this.dateRegS = "";
      this.dateRegE = "";
      this.WorkByName = "";
      this.Location = "";
      this.WorkByPhone = "";
      this.phone2 = "";
      this.mororNumber = "";
      this.docDate = "";
      this.topic = "";
      this.dear = "";
      this.detail = "";
      this.note = "";
      this.peridSave = null;
      this.nameSave = "";
      this.positionSave = "";
      this.peridApprove = null;
      this.nameApprove = "";
      this.positionApprove = "";
      this.rdoTypeJoinTravel = "1";
      this.JoinTravel = [];
      this.RecordData = [];
      this.chooseDepartID();
    },
    GetPlanToForm() {
      this.Project = null;
      this.LogObjProject = null;
      this.Project_code = "";
      this.Project_name = "";
      this.Project_code_dump = "";
      this.Course_code = null;
      this.course_group = "";
      this.IsProcess = null;
      this.IsExpense = null;
      this.Project_category = "1";
      this.Project_type = this.TypeProject;
      this.Objective = "";
      this.TargetGroup = "";
      this.Remarks = "";
      this.CalCredit = "0";
      this.CalHourse = "0";
      this.PLACE = "";
      this.Province_id = null;
      this.Country_id = null;
      this.BudgetRequest = "0";
      this.ExpenseSummary = 0;
      this.Location = "";
      this.WorkBy = "";
      this.WorkByName = "";
      this.WorkByPhone = "";
      this.DateStart = "";
      this.DateEnd = "";
      this.DepSelect = null;
      this.episode = null;
      this.Project_group = null;
      this.txtProject_group = "";
      this.FiscalYear =
          this.FiscalYearData.length > 0
              ? this.FiscalYearData[this.FiscalYearData.length - 1].year
              : null;
      this.itemCode = "";
      this.FileProject = [];
      this.LogFileProject = [];
      this.FileProjectOld = [];
      this.budgetData = [];
      this.Coordinator = [];
      this.JoinPerson = [];
      this.isFormExec = false;
      this.IsPlan = "0";
      this.ApproveRadio = "0";
      this.IsLog = "0";
      this.CheckProcess = true;
      this.satisfaction = 0
      this.Knowledge_before = 0
      this.Knowledge_after = 0
      this.countAllPerson = 0
      if (this.ProjectPlan != null) {
        var qr = ''
        var opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 1,
          margin: 1,
          scale: 20
        }
        QRCode.toDataURL(this.urlSatisfaction + this.ProjectPlan + '&vname=' + this.Project_name, opts, (err, url) => {
          qr = url
        })
        this.qrUrl = qr
        QRCode.toDataURL(this.urlSatisfaction2 + this.ProjectPlan, opts, (err, url) => {
          qr = url
        })
        this.qrUrl2 = qr

        var ProjectData = this.Project_plan.filter(projI => projI.Project_code == this.ProjectPlan)
          if (ProjectData.length > 0) {
            this.Project = ProjectData[0];
            this.LogObjProject = ProjectData[0];
            this.Project_code = ProjectData[0].Project_code;
            this.Project_code_dump = ProjectData[0].Project_code;
            this.Project_name = ProjectData[0].Project_name;
            if (ProjectData[0].Course_code == "" || ProjectData[0].Course_code == null) {
              this.Course_code = null;
            } else {
              this.Course_code = ProjectData[0].Course_code;
            }
            this.course_group = ProjectData[0].Course_group;
            this.Period_code = ProjectData[0].Period_code;
            this.IsProcess = ProjectData[0].IsProcess;
            this.Project_category = ProjectData[0].Project_category;
            // this.Project_type = ProjectData[0].Project_type
            this.Objective = ProjectData[0].Objective;
            this.TargetGroup = ProjectData[0].TargetGroup;
            this.Remarks = ProjectData[0].Remarks;
            this.CalCredit = ProjectData[0].CalCredit;
            this.CalHourse = ProjectData[0].CalHourse;
            this.PLACE = ProjectData[0].PLACE;
            this.Province_id = ProjectData[0].Province_id;
            this.Country_id = ProjectData[0].Country_id;
            this.BudgetRequest = ProjectData[0].BudgetRequest;
            this.Location = ProjectData[0].Location;
            this.WorkBy = ProjectData[0].WorkBy;
            this.WorkByName = ProjectData[0].WorkByName;
            this.WorkByPhone = ProjectData[0].WorkByPhone;
            this.Status = ProjectData[0].Status;
            this.episode = ProjectData[0].DatePeriod;
            this.DateStart = ProjectData[0].DateStart;
            this.DateEnd = ProjectData[0].DateEnd;
            this.DepSelect = ProjectData[0].Dep_Code;
            (this.Project_group =
                this.projectGroup.filter(
                    (projG) => projG.Project_group == ProjectData[0].Project_group
                ).length > 0
                    ? this.projectGroup.filter(
                        (projG) => projG.Project_group == ProjectData[0].Project_group
                    )[0].Project_group
                    : null),
                (this.txtProject_group = ProjectData[0].Project_group_other);
            this.FiscalYear = parseInt(ProjectData[0].FiscalYear);
            this.itemCode = ProjectData[0].Item_Code;
            this.IsPlan =
                ProjectData[0].IsPlan == null || ProjectData[0].IsPlan == ""
                    ? "0"
                    : ProjectData[0].IsPlan;
            this.ApproveRadio = ProjectData[0].Approve;
            this.ChooseTypRegis = ProjectData[0].Status_Reg;
            this.ChooseTypRegis2 = ProjectData[0].Status_Type_Reg;
            this.ChooseTypRegis3 = ProjectData[0].Status_Type_Reg2;
            this.dateRegStart =
                ProjectData[0].DateS_Reg == null || ProjectData[0].DateS_Reg == "0000-00-00"
                    ? ""
                    : ProjectData[0].DateS_Reg;
            this.dateRegEnd =
                ProjectData[0].DateE_Reg == null || ProjectData[0].DateE_Reg == "0000-00-00"
                    ? ""
                    : ProjectData[0].DateE_Reg;
            this.ProjectQuotaCount = ProjectData[0].Count_Reg;
            this.IsLog =
                ProjectData[0].IsLog == null || ProjectData[0].IsLog == ""
                    ? "0"
                    : ProjectData[0].IsLog;
            this.satisfaction = ProjectData[0].indicators.length > 0 ? ProjectData[0].indicators[0].satisfaction == null ? 0 : parseFloat(ProjectData[0].indicators[0].satisfaction) : 0;
            this.Knowledge_before = ProjectData[0].indicators.length > 0 ? ProjectData[0].indicators[0].Knowledge_before == null ? 0 : parseFloat(ProjectData[0].indicators[0].Knowledge_before) : 0;
            this.Knowledge_after = ProjectData[0].indicators.length > 0 ? ProjectData[0].indicators[0].Knowledge_after == null ? 0 : parseFloat(ProjectData[0].indicators[0].Knowledge_after) : 0;
            if (ProjectData[0].IsRoundStatus == "0") {
              this.roundNeed = false;

              if (ProjectData[0].Status_Count_Reg == "0") {
                this.ChkJoinPerson = false;
              } else {
                this.ChkJoinPerson = true;
              }
            } else {
              this.roundNeed = true;
              this.getRoundData()
            }
            this.SelProjectGroup();
            this.getCompetency();
            this.initLogProject({
              Project_code: this.Project_code,
            });
            this.GetFileProject();
            this.initProjCommittee({
              Project_code: this.Project_code,
              permiss_check: this.MeData[0].perid,
            }).then((res) => {
              if (res) {
                if (this.ProjectCommittee.length > 0) {
                  this.Coordinator = JSON.parse(JSON.stringify(this.ProjectCommittee))
                }
              }
            });
            // this.getCourseType()

            if (ProjectData[0].IsRoundStatus == "0") {
              this.IsRoundStatus = "0";
              axios
                  .get(
                      ConstData.ConnectionHost +
                      "/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/" +
                      this.ProjectPlan +
                      "/active/1/?limit=9999"
                  )
                  .then((res) => {
                    if (res.data) {
                      var type = "";
                      if (res.data.length > 0) {
                        this.projectNeed = true;
                        res.data.map((item_qua) => {
                          type = "";
                          if (item_qua.dep_type == "0") {
                            type = "หน่วยงาน/ภาควิชา";
                          } else {
                            type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                          }
                          this.DepQuotaData.push({
                            quotaType: item_qua.dep_type,
                            type: type,
                            type_id: item_qua.dep_type,
                            dep_name: this.depart.filter(
                                (item) => item.dep_id == item_qua.dep_id
                            )[0].dep_name,
                            dep_id: this.depart.filter(
                                (item) => item.dep_id == item_qua.dep_id
                            )[0].dep_id,
                            dep_group_id: this.depart.filter(
                                (item) => item.dep_id == item_qua.dep_id
                            )[0].dep_group_id,
                            count: item_qua.count,
                          });
                        });
                      } else {
                        this.projectNeed = true;
                        type = "";
                        if (res.data.dep_type == "0") {
                          type = "หน่วยงาน/ภาควิชา";
                        } else {
                          type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                        }
                        this.DepQuotaData.push({
                          quotaType: res.data.dep_type,
                          type: type,
                          type_id: res.data.dep_type,
                          dep_name: this.depart.filter(
                              (item) => item.dep_id == res.data.dep_id
                          )[0].dep_name,
                          dep_id: this.depart.filter(
                              (item) => item.dep_id == res.data.dep_id
                          )[0].dep_id,
                          dep_group_id: this.depart.filter(
                              (item) => item.dep_id == res.data.dep_id
                          )[0].dep_group_id,
                          count: res.data.count,
                        });
                      }

                      if (this.DepQuotaData.length > 0) {
                        this.DepQuotaData.map((item_dep_q) => {
                          this.ProjectQuotaDepCount += parseInt(
                              item_dep_q.count
                          );
                        });
                      }
                    } else {
                      this.projectNeed = false;
                      this.DepQuotaData = [];
                    }
                  });
            }

            if (ProjectData[0].IsRoundStatus == "0") {
              axios
                  .get(
                      ConstData.ConnectionHost +
                      "/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/" +
                      this.ProjectPlan +
                      "/active/1/?limit=9999"
                  )
                  .then((res) => {
                    if (res.data) {
                      if (res.data.length > 0) {
                        this.projectNeed = true;
                        this.DataCondi = res.data;
                      } else {
                        this.projectNeed = true;
                        this.DataCondi.push(res.data);
                      }
                      if (this.DataCondi.length > 0) {
                        this.DataCondi.map((item) => {
                          item.workAgeStart = item.WSYear;
                          item.workAgeEnd = item.WEYear;
                        });
                      }
                    } else {
                      this.projectNeed = false;
                      this.DataCondi = [];
                    }
                  });
            }

            if (ProjectData[0].IsRoundStatus == "0") {
              var checkMatch = false;
              axios
                  .get(
                      ConstData.ConnectionHost +
                      "/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/" +
                      this.ProjectPlan +
                      "/active/1/?limit=9999"
                  )
                  .then((res) => {
                    if (res.data) {
                      if (res.data.length > 0) {
                        res.data.map((item) => {
                          this.countAllPerson++
                          checkMatch = false;
                          this.staffData.map((staff_i) => {
                            if (staff_i.perid == item.uid) {
                              checkMatch = true;
                              this.JoinPerson.push({
                                ...item,
                                ...staff_i,
                                full_Name: item.name + " " + item.sname,
                                idCard: item.id_card,
                                status_reg: item.join_status,
                              });
                            }
                          });
                          if (!checkMatch) {
                            this.JoinPerson.push({
                              ...item,
                              full_Name: item.name + " " + item.sname,
                              idCard: item.id_card,
                              status_reg: item.join_status,
                            });
                          }
                        });
                        if (this.JoinPerson.length > 0) {
                          this.JoinPerson.map((item, idx) => {
                            item.idx = this.JoinPerson.length - (idx + 1) + 1;
                          });
                        }
                      } else {
                        checkMatch = false;
                        this.staffData.map((staff_i) => {
                          if (staff_i.perid == res.data.uid) {
                            checkMatch = true;
                            this.JoinPerson.push({
                              ...res.data,
                              ...staff_i,
                              idx: this.JoinPerson.length + 1,
                              full_Name: res.data.name + " " + res.data.sname,
                              idCard: res.data.id_card,
                              status_reg: res.data.join_status,
                            });
                          }
                        });
                        if (!checkMatch) {
                          this.JoinPerson.push({
                            ...res.data,
                            idx: this.JoinPerson.length + 1,
                            full_Name: res.data.name + " " + res.data.sname,
                            idCard: res.data.id_card,
                            status_reg: res.data.join_status,
                          });
                        }
                        if (this.JoinPerson.length > 0) {
                          this.JoinPerson.map((item, idx) => {
                            item.idx = this.JoinPerson.length - (idx + 1) + 1;
                          });
                        }
                      }
                    } else {
                      this.JoinPerson = [];
                    }
                  });
            }
          }
      }
    },
    async GetTravelToForm(param) {
      this.dialogLoading = true;
      this.dialogProcess = false;
      var checkMatch = false;
      var urlExpert = "";
      this.Project = null;
      this.LogObjProject = null;
      this.formId = null;
      this.CheckProcess = param;
      this.Project_code = "";
      this.Project_name = "";
      this.Project_code_dump = "";
      this.Course_code = null;
      this.course_group = "";
      this.IsProcess = null;
      this.IsExpense = null;
      this.Project_category = "1";
      this.Project_type = this.TypeProject;
      this.Objective = "";
      this.TargetGroup = "";
      this.Remarks = "";
      this.CalCredit = "0";
      this.CalHourse = "0";
      this.PLACE = "";
      this.Province_id = null;
      this.Country_id = null;
      this.BudgetRequest = "0";
      this.ExpenseSummary = 0;
      this.Location = "";
      this.WorkBy = "";
      this.WorkByName = "";
      this.WorkByPhone = "";
      this.DateStart = "";
      this.DateEnd = "";
      this.dateRegS = "";
      this.dateRegE = "";
      this.DepSelect = null;
      this.episode = null;
      this.Project_group = null;
      this.txtProject_group = "";
      this.FiscalYear =
          this.FiscalYearData.length > 0
              ? this.FiscalYearData[this.FiscalYearData.length - 1].year
              : null;
      this.itemCode = "";
      this.FileProject = [];
      this.LogFileProject = [];
      this.FileProjectOld = [];
      this.budgetData = [];
      this.Coordinator = [];
      this.JoinPerson = [];
      this.JoinTravel = [];
      this.RecordData = [];
      this.isFormExec = false;
      this.IsPlan = "0";
      this.ApproveRadio = "0";
      this.IsLog = "0";
      this.initMeData().then((res) => {
        if (res) {
          if (this.ProjectPlan != null) {
            /*this.disPerid = '46792'
        this.disFullName = 'ธวัชชัย จันรทิพย์'
        this.disPosition = 'นักวิชาการคอมพิวเตอร์'
        this.disDepName = 'ฝ่ายเทคโนโลยีสารสนเทศ'
        this.disTypeStart = '1'
        this.disDateStart = '2024-01-01'
        this.disTimeStart = '15:00'
        this.disTypeEnd = '1'
        this.disDateEnd = '2024-01-10'
        this.disTimeEnd = '17:00'
        this.disAllowance = 500
        this.disAllowance_Days = 2
        this.disAccommodationCost = 1500
        this.disAccommodationCost_Type = '1'
        this.disAccommodationCost_Days = 3
        this.disShippingCosts = 300
        this.disRegistrationFee = 700
        this.disDateReceipt = '2024-01-02'
        this.disRemark = 'test'
        this.disLoanNumber = 'ย1244563'
        this.disLoanAmount = 3000
        this.disMororNumber = 'มอ 102/22135'
        this.disDocDate = '2024-01-01'
        this.disDocDateWithdraw = '2024-01-05'
        this.disTopic = 'ขออนุมัติเบิกค่าใช้จ่ายในการเดินทางไปปฏิบัติงาน'
        this.disDear = 'คณบดี'
        this.disMessage1 = 'มอ 102/554631'
        this.disDocDateApprove = '2024-01-06'
        this.disPeridSave = '46792'
        this.disNameSave = 'ธวัชชัย จันรทิพย์1'
        this.disMessage2 = 'ประชุมหัวข้อ'
        this.disMessage3 = '2 วัน 13 ชั่วโมง 30 นาที'
        this.disTypeWithdraw = '1'
        this.disNote = 'ผู้จัดเลี้ยงอาหารมื้อเช้า/กลางวัน/เย็น รวม 3 มื้อ'*/

            // this.insertTravelDisbursement(this.ProjectPlan).then(res => {
            //   if (res) {
            //     this.insertTravelDisbursementForm(this.ProjectPlan)
            //   }
            // })

            axios
                .get(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/D_travel_view/active/1/Project_code/" +
                    this.ProjectPlan +
                    "/?limit=9999"
                )
                .then(async (res) => {
                  if (res.data) {
                    this.Project = res.data;
                    this.LogObjProject = res.data;
                    this.Project_code = res.data.Project_code;
                    this.Project_code_dump = res.data.Project_code;
                    this.Project_name = res.data.Project_name;
                    if (
                        res.data.Course_code == "" ||
                        res.data.Course_code == null
                    ) {
                      this.Course_code = null;
                    } else {
                      this.Course_code = res.data.Course_code;
                    }
                    this.course_group = res.data.Course_group;
                    this.Period_code = res.data.Period_code;
                    this.IsProcess = res.data.IsProcess;
                    this.Project_category = res.data.Project_category;
                    // this.Project_type = res.data.Project_type
                    this.Objective = res.data.Objective;
                    this.TargetGroup = res.data.TargetGroup;
                    this.Remarks = res.data.Remarks;
                    this.CalCredit = res.data.CalCredit;
                    this.CalHourse = res.data.CalHourse;
                    this.PLACE = res.data.PLACE;
                    this.Province_id = res.data.Province_id;
                    this.Country_id = res.data.Country_id;
                    this.BudgetRequest = res.data.BudgetRequest;
                    this.Location = res.data.Location;
                    this.WorkBy = res.data.WorkBy;
                    this.WorkByName = res.data.WorkByName;
                    this.WorkByPhone = res.data.WorkByPhone;
                    this.Status = res.data.Status;
                    this.episode = res.data.DatePeriod;
                    this.dateRegS = res.data.DateStart;
                    this.dateRegE = res.data.DateEnd;
                    this.DepSelect = res.data.Dep_Code;
                    (this.Project_group =
                        this.projectGroup.filter(
                            (projG) => projG.Project_group == res.data.Project_group
                        ).length > 0
                            ? this.projectGroup.filter(
                                (projG) =>
                                    projG.Project_group == res.data.Project_group
                            )[0].Project_group
                            : null),
                        (this.txtProject_group = res.data.Project_group_other);
                    this.FiscalYear = parseInt(res.data.FiscalYear);
                    this.itemCode = res.data.Item_Code;
                    this.IsPlan =
                        res.data.IsPlan == null || res.data.IsPlan == ""
                            ? "0"
                            : res.data.IsPlan;
                    this.ApproveRadio = res.data.Approve;
                    this.ChooseTypRegis = res.data.Status_Reg;
                    this.ChooseTypRegis2 = res.data.Status_Type_Reg;
                    this.ChooseTypRegis3 = res.data.Status_Type_Reg2;
                    this.dateRegStart =
                        res.data.DateS_Reg == null ||
                        res.data.DateS_Reg == "0000-00-00"
                            ? ""
                            : res.data.DateS_Reg;
                    this.dateRegEnd =
                        res.data.DateE_Reg == null ||
                        res.data.DateE_Reg == "0000-00-00"
                            ? ""
                            : res.data.DateE_Reg;
                    this.ProjectQuotaCount = res.data.Count_Reg;
                    this.IsLog =
                        res.data.IsLog == null || res.data.IsLog == ""
                            ? "0"
                            : res.data.IsLog;
                    this.formId = res.data.form_id;
                    this.departName = res.data.depart_name;
                    this.phone2 = res.data.phone;
                    this.mororNumber = res.data.moror_number;
                    this.docDate = res.data.doc_date;
                    this.topic = res.data.topic;
                    this.dear = res.data.dear;
                    this.detail = res.data.detail;
                    this.note = res.data.note;
                    this.peridSave = res.data.perid_save;
                    this.nameSave = res.data.name_save;
                    this.positionSave = res.data.position_save;
                    this.peridApprove = res.data.perid_approve;
                    this.nameApprove = res.data.name_approve;
                    this.positionApprove = res.data.position_approve;
                    this.IsExpense = res.data.IsExpense;

                    // this.SelProjectGroup()
                    this.getCompetency();
                    this.GetFileProject();
                    this.GetProjectRecord(this.ProjectPlan);

                    urlExpert =
                        this.IsProcess == "3" && this.IsExpense == "0"
                            ? "History_Experts_Temp"
                            : "History_Experts";
                    await axios
                        .get(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/" +
                            urlExpert +
                            "/Project_code/" +
                            this.ProjectPlan +
                            "/type/6/active/1/?limit=9999"
                        )
                        .then((res) => {
                          if (res.data) {
                            if (res.data.length > 0) {
                              this.Lecturer = res.data;
                            } else {
                              this.Lecturer.push(res.data);
                            }

                            if (this.Lecturer.length > 0) {
                              this.Lecturer.map((item_w) => {
                                this.getLecturer(item_w).then((resLec) => {
                                  if (resLec.status) {
                                    item_w.Lecturer = resLec.data[0];
                                    this.getTrainFiles(item_w.Ref_id).then(
                                        (resfile) => {
                                          if (resfile.status) {
                                            item_w.files = resfile.data;
                                          } else {
                                            item_w.files = [];
                                          }
                                        }
                                    );
                                  } else {
                                    item_w.Lecturer = null;
                                  }
                                });
                              });
                            }
                          } else {
                            this.Lecturer = [];
                          }
                        });

                    await axios
                        .get(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/join_travel_view/Project_code/" +
                            this.ProjectPlan +
                            "/active/1/?limit=9999"
                        )
                        .then((res) => {
                          if (res.data) {
                            if (res.data.length > 0) {
                              res.data.map((item) => {
                                checkMatch = false;
                                this.staffData.map((staff_i) => {
                                  if (staff_i.perid == item.uid) {
                                    checkMatch = true;
                                    this.JoinTravel.push({
                                      ...item,
                                      ...staff_i,
                                      idx: this.JoinTravel.length + 1,
                                      full_Name: item.full_name,
                                      customTravelDetail:
                                          '<p style="font-weight: bold">' +
                                          (item.prefix == null || item.prefix == ""
                                              ? ""
                                              : item.prefix + " ") +
                                          item.full_name +
                                          "</p>" +
                                          '<p style="font-weight: bold">ตำแหน่ง: ' +
                                          item.position +
                                          "</p>",
                                      AllTravelExpenses:
                                          parseFloat(item.Allowance) +
                                          parseFloat(item.AccommodationCost) +
                                          parseFloat(item.ShippingCosts) +
                                          parseFloat(item.RegistrationFee),
                                      Lecturer:
                                          this.Lecturer.length > 0
                                              ? this.Lecturer.filter(
                                                  (lecI) => lecI.perid == item.uid
                                              ).length > 0
                                                  ? this.Lecturer.filter(
                                                      (lecI) => lecI.perid == item.uid
                                                  )
                                                  : null
                                              : null,
                                      files: [],
                                      idCard: item.id_card,
                                      status_reg: item.join_status,
                                      Ref_id: this.getRandomFileName(),
                                    });
                                  }
                                });
                                if (!checkMatch) {
                                  this.JoinTravel.push({
                                    ...item,
                                    idx: this.JoinTravel.length + 1,
                                    full_Name: item.full_name,
                                    customTravelDetail:
                                        '<p style="font-weight: bold">' +
                                        (item.prefix == null || item.prefix == ""
                                            ? ""
                                            : item.prefix + " ") +
                                        item.full_name +
                                        "</p>" +
                                        '<p style="font-weight: bold">ตำแหน่ง: ' +
                                        item.position +
                                        "</p>",
                                    AllTravelExpenses:
                                        parseFloat(item.Allowance) +
                                        parseFloat(item.AccommodationCost) +
                                        parseFloat(item.ShippingCosts) +
                                        parseFloat(item.RegistrationFee),
                                    Lecturer:
                                        this.Lecturer.length > 0
                                            ? this.Lecturer.filter(
                                                (lecI) => lecI.perid == item.uid
                                            ).length > 0
                                                ? this.Lecturer.filter(
                                                    (lecI) => lecI.perid == item.uid
                                                )
                                                : null
                                            : null,
                                    files: [],
                                    idCard: item.id_card,
                                    status_reg: item.join_status,
                                    Ref_id: this.getRandomFileName(),
                                  });
                                }
                              });
                              if (this.JoinTravel.length > 0) {
                                this.JoinTravel.map((item, idx) => {
                                  item.idx = this.JoinTravel.length - (idx + 1) + 1;
                                });
                              }
                            } else {
                              checkMatch = false;
                              this.staffData.map((staff_i) => {
                                if (staff_i.perid == res.data.uid) {
                                  checkMatch = true;
                                  this.JoinTravel.push({
                                    ...res.data,
                                    ...staff_i,
                                    idx: this.JoinTravel.length + 1,
                                    customTravelDetail:
                                        '<p style="font-weight: bold">' +
                                        (res.data.prefix == null ||
                                        res.data.prefix == ""
                                            ? ""
                                            : res.data.prefix + " ") +
                                        res.data.full_name +
                                        "</p>" +
                                        '<p style="font-weight: bold">ตำแหน่ง: ' +
                                        res.data.position +
                                        "</p>",
                                    AllTravelExpenses:
                                        parseFloat(res.data.Allowance) +
                                        parseFloat(res.data.AccommodationCost) +
                                        parseFloat(res.data.ShippingCosts) +
                                        parseFloat(res.data.RegistrationFee),
                                    Lecturer:
                                        this.Lecturer.length > 0
                                            ? this.Lecturer.filter(
                                                (lecI) => lecI.perid == res.data.uid
                                            ).length > 0
                                                ? this.Lecturer.filter(
                                                    (lecI) => lecI.perid == res.data.uid
                                                )
                                                : null
                                            : null,
                                    files: [],
                                    full_Name: res.data.name + " " + res.data.sname,
                                    idCard: res.data.id_card,
                                    status_reg: res.data.join_status,
                                    Ref_id: this.getRandomFileName(),
                                  });
                                }
                              });
                              if (!checkMatch) {
                                this.JoinTravel.push({
                                  ...res.data,
                                  idx: this.JoinTravel.length + 1,
                                  full_Name: res.data.full_name,
                                  customTravelDetail:
                                      '<p style="font-weight: bold">' +
                                      (res.data.prefix == null ||
                                      res.data.prefix == ""
                                          ? ""
                                          : res.data.prefix + " ") +
                                      res.data.full_name +
                                      "</p>" +
                                      '<p style="font-weight: bold">ตำแหน่ง: ' +
                                      res.data.position +
                                      "</p>",
                                  AllTravelExpenses:
                                      parseFloat(res.data.Allowance) +
                                      parseFloat(res.data.AccommodationCost) +
                                      parseFloat(res.data.ShippingCosts) +
                                      parseFloat(res.data.RegistrationFee),
                                  Lecturer:
                                      this.Lecturer.length > 0
                                          ? this.Lecturer.filter(
                                              (lecI) => lecI.perid == res.data.uid
                                          ).length > 0
                                              ? this.Lecturer.filter(
                                                  (lecI) => lecI.perid == res.data.uid
                                              )
                                              : null
                                          : null,
                                  files: [],
                                  idCard: res.data.id_card,
                                  status_reg: res.data.join_status,
                                  Ref_id: this.getRandomFileName(),
                                });
                              }
                              if (this.JoinTravel.length > 0) {
                                this.JoinTravel.map((item, idx) => {
                                  item.idx = this.JoinTravel.length - (idx + 1) + 1;
                                });
                              }
                            }
                          } else {
                            this.JoinTravel = [];
                          }
                        });
                  }
                  this.dialogLoading = false;
                })
                .catch((resCatch) => {
                  if (resCatch) {
                    this.dialogLoading = false;
                    this.$swal.fire({
                      icon: "error",
                      title: "ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง",
                    });
                  }
                });
          }
        }
      });
    },
    DeleteTravelReq() {
      this.initMeData().then((res) => {
        if (res) {
          if (this.ProjectPlan != null) {
            this.$swal
                .fire({
                  title: "ยืนยันการทำรายการ",
                  text:
                      "คุณต้องการลบข้อมูล " +
                      (this.Project_name == ""
                          ? this.Project_plan.filter(
                              (item) => item.Project_code == this.ProjectPlan.length
                          ) > 0
                              ? this.Project_plan.filter(
                                  (item) => item.Project_code == this.ProjectPlan
                              )[0].Project_name
                              : ""
                          : this.Project_name) +
                      " ใช่หรือไม่ ?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "ตกลง",
                  cancelButtonText: "ยกเลิก",
                })
                .then((result) => {
                  if (result.value) {
                    this.dialogLoading = true;
                    this.btnDelTravelLoading = true;
                    this.CheckPermission().then((resPermiss) => {
                      if (resPermiss) {
                        axios
                            .post(
                                ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                                {
                                  queryName: "deleteProjData",
                                  param: btoa(
                                      JSON.stringify({
                                        id: this.ProjectPlan,
                                        Update_By: this.MeData[0].perid,
                                      })
                                  ),
                                }
                            )
                            .then((res) => {
                              if (res.data.status) {
                                this.projectForApprove.map((itemP, index) => {
                                  if (itemP.Project_code == this.ProjectPlan) {
                                    this.projectForApprove.splice(index, 1);
                                  }
                                });
                                this.init();
                                this.$swal.fire({
                                  icon: "success",
                                  title: "บันทึกข้อมูลสำเร็จ",
                                });
                                this.ProjectPlan = null;
                                this.btnDelTravelLoading = false;
                                this.dialogProcess = false;
                                this.dialogLoading = false;
                              } else {
                                this.$swal.fire({
                                  icon: "error",
                                  title:
                                      "ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อฝ่าย IT !",
                                });
                              }
                            })
                            .catch((res) => {
                              if (res) {
                                document.cookie =
                                    "vurl=" + ConstData.ConnectionHost + "/HrTrain2";
                                window.location.href =
                                    ConstData.ConnectionHost + "/SingleSign/";
                              }
                            });
                      } else {
                        this.btnDelTravelLoading = false;
                        this.dialogLoading = false;
                        this.$swal.fire({
                          icon: "error",
                          title:
                              "ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้",
                        });
                      }
                    });
                  }
                });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "กรุณราเลือกหัวข้อเดินทางก่อนทำรายการ !",
            });
          }
        }
      });
    },
    closeDialogProcess() {
      this.dialogProcess = false;
      this.ClearPlanProject();
    },
    showDialogProcess() {
      this.initMeData().then((res) => {
        if (res) {
          if (this.ProjectPlan != null) {
            this.rdoTypeJoinTravel = "1";
            this.dialogProcess = true;
          }
        }
      });
    },
    getCompetency() {
      this.logSelection = [];
      this.selection = [];
      this.initProjectCompetencyData({
        Project_code: this.ProjectPlan,
      }).then((res) => {
        if (res) {
          this.ProjectCompetency.map((ProjectCom) => {
            this.selection.push(ProjectCom.DelvNo);
          });
          this.logSelection = this.selection;
        }
      });
    },
    ExecQuotaDepartRegisterProject(Project_code, objItem) {
      var QuotaDepDump = [];
      return new Promise((resolve) => {
        this.getQuotaDepartRegisterByCordi({
          Project_code: Project_code,
          id: objItem.id,
        })
            .then((resQuota) => {
              if (resQuota) {
                if (this.QuotaDepartData.length > 0) {
                  var type = "";
                  this.QuotaDepartData.map((item_qua) => {
                    type = "";
                    if (item_qua.dep_type == "0") {
                      type = "หน่วยงาน/ภาควิชา";
                    } else {
                      type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                    }
                    QuotaDepDump.push({
                      quotaType: item_qua.dep_type,
                      type: type,
                      type_id: item_qua.dep_type,
                      dep_name: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_name,
                      dep_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_id,
                      dep_group_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_group_id,
                      count: item_qua.count,
                    });
                  });
                }
                resolve(QuotaDepDump);
              }
            })
            .catch((reason) => {
              if (reason) {
                resolve([]);
              }
            });
      });
    },
    ExecJoinProject(Project_code, objItem) {
      var JoinPersonDump = [];
      var checkMatch = false;
      return new Promise((resolve) => {
        this.getJoinProjectByCordi({
          Project_code: Project_code,
          id: objItem.id,
        })
            .then((resJoin) => {
              if (resJoin) {
                if (this.JoinProjectData.length > 0) {
                  this.JoinProjectData.map((item) => {
                    checkMatch = false;
                    this.staffData.map((staff_i) => {
                      if (staff_i.perid == item.uid) {
                        checkMatch = true;
                        JoinPersonDump.push({
                          ...item,
                          ...staff_i,
                          full_Name: item.name + " " + item.sname,
                          idCard: item.id_card,
                          status_reg: item.join_status,
                        });
                      }
                    });
                    if (!checkMatch) {
                      JoinPersonDump.push({
                        ...item,
                        full_Name: item.name + " " + item.sname,
                        idCard: item.id_card,
                        status_reg: item.join_status,
                      });
                    }
                  });
                }
                if (JoinPersonDump.length > 0) {
                  JoinPersonDump.map((item, idx) => {
                    item.idx = JoinPersonDump.length - (idx + 1) + 1;
                  });
                }
                resolve(JoinPersonDump);
              }
            })
            .catch((reason) => {
              if (reason) {
                resolve([]);
              }
            });
      });
    },
    ExecGroupExamProject(Project_code, objItem) {
      return new Promise((resolve) => {
        this.getGroupExamProjectByCordi({
          Project_code: Project_code,
          id: objItem.id,
        })
            .then((resGroup) => {
              if (resGroup) {
                if (this.GroupExamData.length > 0) {
                  resolve(this.GroupExamData);
                }
              }
            })
            .catch((reason) => {
              if (reason) {
                resolve([]);
              }
            });
      });
    },
    CheckPlace() {
      if (this.PLACE == "2") {
        this.Country_id = null;
      } else if (this.PLACE == "3") {
        this.Province_id = null;
      }
    },
    CheckKeyPress(event) {
      if (event.key == "Enter") {
        console.log("here");
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = [];
      if (item.history_expert == null) {
        this.$swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูลวิทยากร",
        });
      } else {
        this.LecturerDetail = item.history_expert
        this.dialogLecturerDetail = true;
      }
    },
    ShowDetailTravelLecturer(item) {
      this.LecturerDetail = [];
      this.alertExpert = false;
      this.FileProjectExpert = [];
      this.txtAlertExpert = [];
      this.LecturerDetail = this.JoinTravel.filter(
          (L_item) => L_item.perid == item.perid
      )[0].Lecturer;
      this.dialogLecturerDetail = true;
    },
    onProgress(evt) {
      console.log(evt);
      this.percent = 0;
      this.percent = evt;
    },
    hasGenerated(evt) {
      console.log(evt);
    },
    hasStartedGeneration(evt) {
      console.log(evt);
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    async ExportToDocx() {
      var preHtml =
          "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
          preHtml + (this.form1 ? this.editorData : this.editorData2) + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
          "data:application/vnd.ms-word;charset=utf-8," +
          encodeURIComponent(html);

      // Specify file name
      var filename =
          (this.form1 ? "ฟอร์มตัวอย่างโครงการ" : "ใบปะหน้าบันทึกข้อความ") +
          ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({
        name: "PrintData",
        query: {
          data: this.form1
              ? this.editorData
              : this.form2
                  ? this.editorData2
                  : this.editorData3,
        },
      });
      window.open(
          routeData.href,
          "_blank",
          "location=yes,height=800,width=800,scrollbars=yes,status=yes"
      );
    },
    SelProjectGroup() {
      // if (this.Project_group == '108' || this.Project_group == '109') {
      //   this.rdoRegisterProject = '1'
      //   if (this.JoinPerson.length > 0) {
      //     this.JoinPerson.map(item => {
      //       item.status_reg = '1'
      //     })
      //   }
      // } else {
      //   this.rdoRegisterProject = '0'
      // }
      this.rdoTypeJoinTravel = "1";
      if (
          this.projectGroup.filter(
              (item) => item.Project_group == this.Project_group
          ).length > 0
      ) {
        this.projectGroupToShow = this.projectGroup.filter(
            (item) => item.Project_group == this.Project_group
        )[0].Project_group_des;
      } else {
        this.projectGroupToShow = "";
      }
      if (
          this.Project_group != null &&
          this.Project_group != "" &&
          this.JoinTravel.length > 0
      ) {
        this.$swal.fire({
          icon: "warning",
          title:
              "หากเปลื่ยนประเภทการไปปฏิบัติราชการ จะต้องทำการระบุผู้เข้าร่วมเดินทางใหม่อีกครั้ง!",
        });
        this.JoinTravel = [];
      }
    },
    AddWorkGuest() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (
          this.SubjectForLecturer != "" &&
          this.dateSForLecturer != "" &&
          this.LecturerProjectName != "" &&
          this.LecturerHour != "" &&
          this.LecturerInvite != "" &&
          this.LecturerPlace != "" &&
          this.LecturerDocNo != "" &&
          this.LecturerDateDocOut != "" &&
          this.LecturerDateStart != "" &&
          this.LecturerTimeStart != "" &&
          this.LecturerDateEnd != "" &&
          this.LecturerTimeEnd != ""
      ) {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.perid,
          Project_code: this.Project_code,
          Project_name: this.Project_name,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(
              (item) => item.perid == this.perid
          )[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: this.Committee_code,
          type_name: this.committee_Posi.filter(
              (item) => item.Committee_code == this.Committee_code
          )[0].committee_des,
          files: this.FileProjectExpert,
          Rm: this.Rm2,
          Ref_id: this.getRandomFileName(),
          Lecturer:
              this.Committee_code == "6" ||
              this.Committee_code == "23" ||
              this.Committee_code == "24"
                  ? {
                    Project_name: this.LecturerProjectName,
                    Hour: this.LecturerHour,
                    Invite: this.LecturerInvite,
                    Place: this.LecturerPlace,
                    DocNo: this.LecturerDocNo,
                    DateDocNo: this.LecturerDateDocOut,
                    DateStart: this.LecturerDateStart,
                    TimeStart: this.LecturerTimeStart,
                    DateEnd: this.LecturerDateEnd,
                    TimeEnd: this.LecturerTimeEnd,
                  }
                  : null,
        });
        this.SubjectForLecturer = "";
        this.dateSTravelForLecturer = "";
        this.dateETravelForLecturer = "";
        this.dateSForLecturer = "";
        this.dateEForLecturer = "";
        this.timeSForLecturer = "";
        this.timeEForLecturer = "";
        this.LecturerProjectName = "";
        this.LecturerHour = "";
        this.LecturerInvite = "";
        this.LecturerPlace = "";
        this.LecturerDocNo = "";
        this.LecturerDateDocOut = "";
        this.LecturerDateStart = "";
        this.LecturerTimeStart = "";
        this.LecturerDateEnd = "";
        this.LecturerTimeEnd = "";
        this.FileProjectExpert = [];
        this.filesExpert = [];
        this.txtAlertExpert = [];
        this.alertExpert = false;
        this.Rm2 = "";
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุข้อมูลให้ครบถ้วน",
        });
      }
    },
    AddRecordLecturer() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (
          this.SubjectForLecturer != "" &&
          this.dateSForLecturer != "" &&
          this.LecturerProjectName != "" &&
          this.LecturerHour != "" &&
          this.LecturerInvite != "" &&
          this.LecturerPlace != "" &&
          this.LecturerDocNo != "" &&
          this.LecturerDateDocOut != "" &&
          this.LecturerDateStart != "" &&
          this.LecturerTimeStart != "" &&
          this.LecturerDateEnd != "" &&
          this.LecturerTimeEnd != ""
      ) {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.perid,
          Project_code: this.Project_code,
          Project_name: this.Project_name,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(
              (item) => item.perid == (this.TypeProject == '1' ? this.perid : this.peridTravel)
          )[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: "6",
          type_name: "วิทยากร",
          files: this.FileProjectExpert,
          Rm: this.Rm2,
          Ref_id: this.getRandomFileName(),
          Lecturer: {
            Project_name: this.LecturerProjectName,
            Hour: this.LecturerHour,
            Invite: this.LecturerInvite,
            Place: this.LecturerPlace,
            DocNo: this.LecturerDocNo,
            DateDocNo: this.LecturerDateDocOut,
            DateStart: this.LecturerDateStart,
            TimeStart: this.LecturerTimeStart,
            DateEnd: this.LecturerDateEnd,
            TimeEnd: this.LecturerTimeEnd,
          },
        });
        this.SubjectForLecturer = "";
        this.dateSTravelForLecturer = "";
        this.dateETravelForLecturer = "";
        this.dateSForLecturer = "";
        this.dateEForLecturer = "";
        this.timeSForLecturer = "";
        this.timeEForLecturer = "";
        this.LecturerProjectName = "";
        this.LecturerHour = "";
        this.LecturerInvite = "";
        this.LecturerPlace = "";
        this.LecturerDocNo = "";
        this.LecturerDateDocOut = "";
        this.LecturerDateStart = "";
        this.LecturerTimeStart = "";
        this.LecturerDateEnd = "";
        this.LecturerTimeEnd = "";
        this.FileProjectExpert = [];
        this.filesExpert = [];
        this.txtAlertExpert = [];
        this.alertExpert = false;
        this.Rm2 = "";
        console.log(this.Lecturer);
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุข้อมูลให้ครบถ้วน",
        });
      }
    },
    AddRecordLecturerTravel() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (
          this.SubjectForLecturer != "" &&
          this.dateSForLecturer != "" &&
          this.LecturerProjectName != "" &&
          this.LecturerHour != "" &&
          this.LecturerInvite != "" &&
          this.LecturerPlace != "" &&
          this.LecturerDocNo != "" &&
          this.LecturerDateDocOut != "" &&
          this.LecturerDateStart != "" &&
          this.LecturerTimeStart != "" &&
          this.LecturerDateEnd != "" &&
          this.LecturerTimeEnd != ""
      ) {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.peridTravel,
          Project_code: this.Project_code,
          Project_name: this.Project_name,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(
              (item) => item.perid == this.peridTravel
          )[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: "6",
          type_name: "วิทยากร",
          files: this.FileProjectExpert,
          Rm: this.Rm2,
          Ref_id: this.getRandomFileName(),
          Lecturer: {
            Project_name: this.LecturerProjectName,
            Hour: this.LecturerHour,
            Invite: this.LecturerInvite,
            Place: this.LecturerPlace,
            DocNo: this.LecturerDocNo,
            DateDocNo: this.LecturerDateDocOut,
            DateStart: this.LecturerDateStart,
            TimeStart: this.LecturerTimeStart,
            DateEnd: this.LecturerDateEnd,
            TimeEnd: this.LecturerTimeEnd,
          },
        });
        this.SubjectForLecturer = "";
        this.dateSTravelForLecturer = "";
        this.dateETravelForLecturer = "";
        this.dateSForLecturer = "";
        this.dateEForLecturer = "";
        this.timeSForLecturer = "";
        this.timeEForLecturer = "";
        this.LecturerProjectName = "";
        this.LecturerHour = "";
        this.LecturerInvite = "";
        this.LecturerPlace = "";
        this.LecturerDocNo = "";
        this.LecturerDateDocOut = "";
        this.LecturerDateStart = "";
        this.LecturerTimeStart = "";
        this.LecturerDateEnd = "";
        this.LecturerTimeEnd = "";
        this.FileProjectExpert = [];
        this.filesExpert = [];
        this.txtAlertExpert = [];
        this.alertExpert = false;
        this.Rm2 = "";
        console.log(this.Lecturer);
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุข้อมูลให้ครบถ้วน",
        });
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData;
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios
          .post("http://localhost:3006/exec/docx", {
            data: {
              val1: this.formprint1, // หลักการและเหตุผล
              val2: this.formprint2, // วัตถุประสงค์
              val3: this.formprint3, // กลุ่มเป้าหมาย
              val4: this.formprint4, // วิธีการจัดอบรม
              val5: this.formprint5, // ระยะเวลาการจัดอบรม
              val6: this.formprint6, // สถานที่จัดอบรม
              val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
              val8: this.formprint8, // ผู้รับผิดชอบโครงการ
              val9: this.formprint9, // ผู้รับผิดชอบโครงการ
              val10: this.formprint10, // วิทยากร
              val11: this.formprint11, // งบประมาณ
              val12: this.formprint12, // หมายเหตุ
              budget: this.budgetData,
              Lecturer: this.LecturerToShow,
              Committee: this.Committee_ToShow,
              projectGroup: this.projectGroupToShow,
              projectname: this.Project_name,
              projectcode: "01010-0220-1541",
            },
          })
          .then((res) => {
            console.log(res.data);
          });
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
          .getEditableElement()
          .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
      );
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    },
    SumMoneyFuc() {
      this.MoneySummary =
          parseFloat(this.ReqPerson) > 0
              ? parseFloat(this.ReqMoney) * parseFloat(this.ReqPerson)
              : parseFloat(this.ReqMoney);
    },
    SumMoneyFuc2() {
      // สำหรับแก้ไขค่าใช้จ่าย expenseObj ใส่ if ไว้ด้วย ป้องกัน error
      if (this.expenseObj.ReqPerson == null || this.expenseObj.ReqMoney == null) {
        this.expenseObj.ReqPerson = 0;
        this.expenseObj.ReqMoney = 0;
      }
      this.expenseObj.SumMoney =
          parseFloat(this.expenseObj.ReqPerson) > 0
              ? parseFloat(this.expenseObj.ReqMoney) * parseFloat(this.expenseObj.ReqPerson)
              : parseFloat(this.expenseObj.ReqMoney);
    },
    SumMoneyFuc3() {
      if (this.newReqPerson == null || this.newReqMoney == null) {
        this.newReqPerson = 0;
        this.newReqMoney = 0;
      }
      this.newMoneySummary =
          parseFloat(this.newReqPerson) > 0
              ? parseFloat(this.newReqMoney) * parseFloat(this.newReqPerson)
              : parseFloat(this.newReqMoney);
    },
    AddExpenseData() {
      if (this.BudgetRequest != "") {
        if (
            this.TypeProject == "1" &&
            (this.expenseCost == null ||
                this.ReqMoney == 0 ||
                this.ReqMoney == "" ||
                parseFloat(this.ReqPerson) <= 0 ||
                this.MoneySummary == 0 ||
                this.MoneySummary == "" ||
                this.Rm == "")
        ) {
          this.$swal.fire({
            icon: "error",
            title:
                "กรุณาระบุรายการค่าใช้จ่าย และ จำนวนเงิน เรทอัตรา ให้ครบถ้วน",
          });
        } else if (
            this.TypeProject == "2" &&
            (this.expenseCost == null ||
                this.MoneySummary == 0 ||
                this.MoneySummary == "" ||
                this.Rm == "")
        ) {
          this.$swal.fire({
            icon: "error",
            title: "กรุณาระบุรายการค่าใช้จ่าย และ จำนวนเงินรวม ให้ครบถ้วน",
          });
        } else {
          // if ((this.Expense + (parseFloat(this.ReqPerson) > 0 ? parseFloat(this.ReqMoney) * parseFloat(this.ReqPerson) : parseFloat(this.ReqMoney))) > parseFloat(this.BudgetRequest)) {
          //   this.$swal.fire({
          //     icon: 'error',
          //     title: 'กรุณาระบุค่าใช้จ่าย ห้ามเกินงบประมาณที่ขอ'
          //   })
          // } else {
          var ResultExpenseData = this.expense_Data.filter(
              (item) => item.cost_id == this.expenseCost
          );
          /*console.log('--------------------start----------------------------------')
          console.log(ResultExpenseData[0].cost_desc + ' ' + this.Rm + ' จำนวน ' + this.ReqMoney + ' ต่อ ' + this.ReqPerson + ' รวม ' + this.MoneySummary)
          console.log('MoneySummary = ' + parseFloat(this.MoneySummary))
          console.log('Expense = ' + this.Expense)*/
          this.Expense += parseFloat(this.MoneySummary);
          /*console.log('Expense += parseFloat(this.MoneySummary) = ' + this.Expense)
          console.log('--------------------end----------------------------------')*/
          if (ResultExpenseData.length > 0) {
            this.budgetData.push({
              index: this.budgetData.length + 1,
              Expense_id: ResultExpenseData[0].cost_id,
              Expense_des: ResultExpenseData[0].cost_desc,
              ReqMoney: this.ReqMoney,
              Rm: this.Rm,
              ReqPerson: this.ReqPerson,
              SumMoney: this.MoneySummary,
              Custom_Expense_des:
                  this.ReqPerson > 0
                      ? '<p style="font-weight: bold;color: #364eff">' +
                      ResultExpenseData[0].cost_desc +
                      "</p>" +
                      '<p style="font-weight: bold;color: cornflowerblue">' +
                      this.Rm +
                      "</p>" +
                      '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' +
                      Vue.filter("currency")(this.ReqMoney) +
                      " บาท ต่อ " +
                      this.ReqPerson +
                      " คน</p>  รวมทั้งสิ้น : " +
                      Vue.filter("currency")(this.MoneySummary) +
                      " บาท"
                      : '<p style="font-weight: bold;color: #364eff">' +
                      ResultExpenseData[0].cost_desc +
                      "</p>" +
                      '<p style="font-weight: bold;color: cornflowerblue">' +
                      this.Rm +
                      "</p>" +
                      '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' +
                      Vue.filter("currency")(this.ReqMoney) +
                      " บาท รวมทั้งสิ้น : " +
                      Vue.filter("currency")(this.MoneySummary) +
                      " บาท",
            });
            this.budgetData.map((budI, idx) => {
              budI.index = idx;
            });
            this.expenseCost = null;
            this.ReqMoney = 0;
            this.Rm = "";
            this.ReqPerson = 0;
            this.MoneySummary = 0;
          }
          // }
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุงบประมาณ",
        });
      }
    },
    showDialogEditExpense(item) {
      this.expenseObj = item;
      this.isEditExpense = true;
      this.dialogEditExpense = true;
    },
    updateExpense() {
      this.budgetData.map((bud_I) => {
        if (bud_I.index == this.expenseObj.index) {
          /*console.log('****************start*************************')
          console.log('Expense = ' + this.Expense)
          console.log('SumMoney = ' + parseFloat(this.expenseObj.SumMoney))*/
          // this.Expense -= parseFloat(bud_I.SumMoney);
          bud_I.Expense_id = this.expenseObj.Expense_id;
          bud_I.Expense_des = this.expense_Data.filter(
            (item) => item.cost_id == this.expenseObj.Expense_id
          )[0].cost_desc;
          bud_I.ReqMoney = this.expenseObj.ReqMoney;
          bud_I.Rm = this.expenseObj.Rm;
          bud_I.ReqPerson = this.expenseObj.ReqPerson;
          bud_I.SumMoney = this.expenseObj.SumMoney;
          bud_I.Custom_Expense_des = this.expenseObj.ReqPerson > 0
            ? '<p style="font-weight: bold;color: #364eff">' +
            this.expense_Data.filter(
              (item) => item.cost_id == this.expenseObj.Expense_id
            )[0].cost_desc +
            "</p>" +
            '<p style="font-weight: bold;color: cornflowerblue">' +
            this.expenseObj.Rm +
            "</p>" +
            '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' +
            Vue.filter("currency")(this.expenseObj.ReqMoney) +
            " บาท ต่อ " +
            this.expenseObj.ReqPerson +
            " คน</p>  รวมทั้งสิ้น : " +
            Vue.filter("currency")(this.expenseObj.SumMoney) +
            " บาท"
            : '<p style="font-weight: bold;color: #364eff">' +
            this.expense_Data.filter(
              (item) => item.cost_id == this.expenseObj.Expense_id
            )[0].cost_desc +
            "</p>" +
            '<p style="font-weight: bold;color: cornflowerblue">' +
            this.expenseObj.Rm +
            "</p>" +
            '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' +
            Vue.filter("currency")(this.expenseObj.ReqMoney) +
            " บาท รวมทั้งสิ้น : " +
            Vue.filter("currency")(this.expenseObj.SumMoney) +
            " บาท";
          /*console.log('Summary = ' + this.Expense)
          console.log('****************end*************************')*/
        }
      });
      this.expenseObj = null;
      this.dialogEditExpense = false;
      this.$swal.fire({
        icon: "success",
      });
      // 
      // const updatedBudgetData = this.budgetData.map((bud_I) => {
      //   if (bud_I.index == this.expenseObj.index) {
      //     /*console.log('****************start*************************')
      //     console.log('Expense = ' + this.Expense)
      //     console.log('SumMoney = ' + parseFloat(this.expenseObj.SumMoney))*/
      //     // this.Expense -= parseFloat(bud_I.SumMoney);
      //     return {
      //       ...bud_I,
      //       Expense_id: this.expenseObj.Expense_id,
      //       Expense_des: this.expenseObj.Expense_des,
      //       ReqMoney: this.expenseObj.ReqMoney,
      //       Rm: this.expenseObj.Rm,
      //       ReqPerson: this.expenseObj.ReqPerson,
      //       SumMoney: this.expenseObj.SumMoney,
      //       Custom_Expense_des: this.expenseObj.Custom_Expense_des,
      //     };
      //     /*console.log('Summary = ' + this.Expense)
      //     console.log('****************end*************************')*/
      //   }
      //   return bud_I;
      // });
      // this.budgetData = updatedBudgetData;
      // console.log("Updated budgetData:", this.budgetData);
      // this.$swal.fire({
      //   icon: "success",
      // });
    },
    DelExpense(item) {
      /*console.log('////////////////////////////////////')
      console.log(this.budgetData.filter(bud_I => bud_I.index == item.index))
      console.log('////////////////////////////////////')*/
      this.budgetData.map((bud_I, idx) => {
        if (bud_I.index == item.index) {
          /*console.log('****************start*************************')
          console.log('Expense = ' + this.Expense)
          console.log('SumMoney = ' + parseFloat(item.SumMoney))*/
          this.Expense -= parseFloat(item.SumMoney);
          this.budgetData.splice(idx, 1);
          /*console.log('Summary = ' + this.Expense)
          console.log('****************end*************************')*/
        }
      });
      this.budgetData.map((budI, idx) => {
        budI.index = idx;
      });
    },
    addBudgetHistoryData() {
      this.$swal.fire({
          title: "ยืนยันการเพิ่มข้อมูล",
          text: "คุณต้องการเพิ่มข้อมูลค่าใช้จ่ายนี้หรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.dialogLoading = true;
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'addExpenseDetailProject',
              param: btoa(encodeURIComponent(JSON.stringify({
                Group_Expense_id: this.groupExpenseObj.id,
                Project_code: this.groupExpenseObj.Project_code,
                Expense_id: this.newExpenseCost,
                ReqMoney: this.newReqMoney,
                Rm: this.newRm,
                ReqPerson: this.newReqPerson,
                SumMoney: this.newMoneySummary,
                permiss_check: this.MeData[0].perid,
              })))
            }).then(res => {
              this.budgetHistoryDetailData = [];
              this.ExpenseGroupDetail = 0
              if (res.data.status && res.data.data.length > 0) {
                res.data.data.map((item) => {
                  this.ExpenseGroupDetail += parseFloat(item.SumMoney)
                  this.budgetHistoryDetailData.push({
                    ...item,
                    Expense_id: item.Expense_id,
                    Expense_des: item.cost_desc,
                    Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                    '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
                  })
                })
              }
              this.budgetHistoryData.map((bud_I) => {
                if (bud_I.id == this.groupExpenseObj.id) {
                  bud_I.SumMoney = this.ExpenseGroupDetail;
                }
              });

              this.ExpenseGroup = this.ExpenseGroupDetail;
              this.newExpenseCost = null;
              this.newRm = "";
              this.newReqMoney = 0;
              this.newReqPerson = 0;
              this.newMoneySummary = 0;
              this.$swal.fire({
                icon: "success",
                title: "เพิ่มข้อมูลเรียบร้อยแล้ว",
                text: "ข้อมูลค่าใช้จ่ายได้ถูกเพิ่มเรียบร้อยแล้ว",
              });
            }).catch((err) => {
              console.log(err);
              this.$swal.fire({
                icon: "error",
                title: "พบข้อผิดพลาด",
                text: "ไม่สามารถเพิ่มข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
              });
            }).finally(() => {
              this.dialogLoading = false;
            });
          }
        });
    },
    delBudgetHistory(item) {
      this.$swal.fire({
          title: "ยืนยันการลบข้อมูล",
          text: "คุณต้องการลบข้อมูลค่าใช้จ่ายนี้หรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.dialogLoading = true;
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'delExpenseDetailProject',
              param: btoa(encodeURIComponent(JSON.stringify({
                Group_Expense_id: this.groupExpenseObj.id,
                id: item.id,
                Project_code: this.groupExpenseObj.Project_code,
                permiss_check: this.MeData[0].perid,
              })))
            }).then(res => {
              this.budgetHistoryDetailData = [];
              this.ExpenseGroupDetail = 0
              if (res.data.status && res.data.data.length > 0) {
                res.data.data.map((item) => {
                  this.ExpenseGroupDetail += parseFloat(item.SumMoney)
                  this.budgetHistoryDetailData.push({
                    ...item,
                    Expense_id: item.Expense_id,
                    Expense_des: item.cost_desc,
                    Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                    '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
                  })
                })
              }
              this.budgetHistoryData.map((bud_I) => {
                if (bud_I.id == this.groupExpenseObj.id) {
                  bud_I.SumMoney = this.ExpenseGroupDetail;
                }
              });

              this.ExpenseGroup = this.ExpenseGroupDetail;
              this.dialogEditExpense = false;
              this.$swal.fire({
                icon: "success",
                title: "ลบข้อมูลเรียบร้อยแล้ว",
                text: "ข้อมูลค่าใช้จ่ายได้ถูกลบเรียบร้อยแล้ว",
              });
            }).catch((err) => {
              console.log(err);
              this.$swal.fire({
                icon: "error",
                title: "พบข้อผิดพลาด",
                text: "ไม่สามารถลบข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
              });
            }).finally(() => {
              this.dialogLoading = false;
            });
          }
        });
    },
    showEditBudgetHistory(item) {
      this.expenseObj = item
      this.isEditExpense = false;
      this.dialogEditExpense = true;
    },
    editBudgetHistory() {
      this.$swal.fire({
          title: "ยืนยันการแก้ไขข้อมูล",
          text: "คุณต้องการแก้ไขข้อมูลค่าใช้จ่ายนี้หรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.dialogLoading = true;
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'editExpenseDetailProject',
              param: btoa(encodeURIComponent(JSON.stringify({
                Group_Expense_id: this.groupExpenseObj.id,
                id: this.expenseObj.id,
                Project_code: this.groupExpenseObj.Project_code,
                Expense_id: this.expenseObj.Expense_id,
                ReqMoney: this.expenseObj.ReqMoney,
                Rm: this.expenseObj.Rm,
                ReqPerson: this.expenseObj.ReqPerson,
                SumMoney: this.expenseObj.SumMoney,
                permiss_check: this.MeData[0].perid,
              })))
            }).then(res => {
              if (res.data.status && res.data.data.length > 0) {
                this.budgetHistoryDetailData = [];
                this.ExpenseGroupDetail = 0
                res.data.data.map((item) => {
                  this.ExpenseGroupDetail += parseFloat(item.SumMoney)
                  this.budgetHistoryDetailData.push({
                    ...item,
                    Expense_id: item.Expense_id,
                    Expense_des: item.cost_desc,
                    Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                    '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                    '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                    '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
                  })
                })
                // นำผลรวมค่าใช้จ่ายที่แก้ไขแล้วมาอัพเดทใน budgetData และแก้ไขจำนวนเงินรวมใน budgetData SumMoney เท่ากับ the ExpenseGroupDetail
                this.budgetHistoryData.map((bud_I) => {
                  if (bud_I.index == this.expenseObj.index) {
                    bud_I.SumMoney = this.ExpenseGroupDetail;
                  }
                });

                this.ExpenseGroup = this.ExpenseGroupDetail;
                this.dialogEditExpense = false;
                this.$swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลเรียบร้อยแล้ว",
                text: "ข้อมูลค่าใช้จ่ายได้ถูกแก้ไขเรียบร้อยแล้ว",
                  });
              } else {
                this.$swal.fire({
                icon: "warning",
                title: "ไม่พบข้อมูลที่แก้ไข",
                text: "โปรดตรวจสอบข้อมูลที่แก้ไขอีกครั้ง",
                  });
              }
            }).catch((err) => {
              console.log(err);
              this.$swal.fire({
                icon: "error",
                title: "พบข้อผิดพลาด",
                text: "ไม่สามารถแสดงข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
              });
            }).finally(() => {
              this.dialogLoading = false;
            });
          }
        });
      // this.expenseObj = { ...this.expenseObj };
      /* this.budgetHistoryDetailData = [];
      this.groupExpenseObj = item
      this.ExpenseGroupDetail = 0
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getExpenseDetailProject',
        param: btoa(encodeURIComponent(JSON.stringify({
          id: item.id,
          permiss_check: this.MeData[0].perid,
        })))
      }).then(res => {
        if (res.data.status && res.data.data.length > 0) {
          res.data.data.map((item) => {
            this.ExpenseGroupDetail += parseFloat(item.SumMoney)
            this.budgetHistoryDetailData.push({
              ...item,
              Expense_id: item.cost_id,
              Expense_des: item.cost_desc,
              Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                  '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
            })
          })
          this.dialogShowHistoryExpense = true;
        }
      }).catch((err) => {
        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด",
          text: "ไม่สามารถแสดงข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
        });
      }) */
    },
    ShowDetail(item) {
      this.dialogDetail = true;
      this.itemToShow = null;
      this.itemToShow = item;
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s_owner();
      }
    },
    insertPersonUni() {
      this.personalMedData.map((value) => {
        if (this.IdPersonal == value.STAFF_ID) {
          this.JoinPerson.unshift({
            ...value,
            idx: this.JoinPerson.length + 1,
            uid: value.STAFF_ID,
            full_Name: value.STAFF_NAME_THAI + " " + value.STAFF_SNAME_THAI,
            name: value.STAFF_NAME_THAI,
            sname: value.STAFF_SNAME_THAI,
            idCard: value.STAFF_PERS_ID,
            affiliation: value.FAC_NAME_THAI,
            position: "",
            phone: "",
            registerType_id: 2,
            join_status: "0",
            files: [],
            type_details: "บุคลากรคณะอื่น",
          });
          this.IdPersonal = "";
        }
      });
    },
    insertStd(msg) {
      if (msg == "med") {
        this.studentData.map((value) => {
          if (this.Idstudent == value.STUDENT_ID) {
            this.JoinPerson.unshift({
              idx: this.JoinPerson.length + 1,
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + " " + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: "คณะแพทยศาสตร์",
              position: "",
              phone: "",
              registerType_id: 1,
              join_status: "0",
              files: [],
              type_details: "นักศึกษาคณะแพทย์",
            });
            this.Idstudent = "";
          }
        });
      } else {
        this.studentUniData.map((value) => {
          if (this.IdstudentUni == value.STUDENT_ID) {
            this.JoinPerson.unshift({
              idx: this.JoinPerson.length + 1,
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + " " + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: value.FAC_NAME_THAI,
              registerType_id: 3,
              join_status: "0",
              files: [],
              type_details: "นักศึกษาคณะอื่น",
            });
            this.IdstudentUni = "";
          }
        });
      }
    },
    Del_item_ImportEmp(idx) {
      this.empData.map((item, index) => {
        if (item.idEmp == idx) {
          this.empData.splice(index, 1);
        }
      });
    },
    Del_item(item) {
      this.JoinPerson = this.JoinPerson.filter(
          (value) => value.uid != item.uid
      );
    },
    GetStdPSU() {
      this.studentUniData = [];
      axios
          .get(
              ConstData.ConnectionHost +
              "/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/" +
              this.IdDepartStd +
              "/?sort=STUDENT_ID_ASC&limit=99999"
          )
          .then((res) => {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.map((item) => {
                  this.studentUniData.push({
                    ...item,
                    fullName:
                        "รหัสนักศึกษา : " +
                        item.STUDENT_ID +
                        " ชื่อ-สกุล " +
                        item.STUD_NAME_THAI +
                        " " +
                        item.STUD_SNAME_THAI,
                  });
                });
              } else {
                this.studentUniData.push({
                  ...res.data,
                  fullName:
                      "รหัสนักศึกษา : " +
                      res.data[0].STUDENT_ID +
                      " ชื่อ-สกุล " +
                      res.data[0].STUD_NAME_THAI +
                      " " +
                      res.data[0].STUD_SNAME_THAI,
                });
              }
            } else {
              this.studentUniData = [];
            }
          });
    },
    GetPersonalPSU() {
      axios
          .get(
              ConstData.ConnectionHost +
              "/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/" +
              this.IdDepart +
              "/?sort=STAFF_ID_ASC&limit=99999"
          )
          .then((res) => {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.map((item) => {
                  this.personalMedData.push({
                    ...item,
                    FULL_NAME: item.STAFF_NAME_THAI + " " + item.STAFF_SNAME_THAI,
                  });
                });
              } else {
                this.personalMedData.push(res.data);
              }
            } else {
              this.personalMedData = [];
            }
          });
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true;
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true;
              } else {
                child_i.switch = false;
              }
              this.EmpData.push(child_i);
            });
          }
        } else {
          this.EmpData.push(item);
        }
      } else {
        item.switch = false;
        if (item.header) {
          this.EmpData = [];
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false;
            });
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1);
              }
            });
          }
        }
      }
    },
    ChooseEmpolyee_c(event) {
      var GetData = [];
      if (event.key == "Enter") {
        GetData = this.CardData.filter(
            (value) => value.CARD_NO == this.cardSel
        );
        if (GetData.length > 0) {
          GetData = this.staffData.filter(
              (value) => value.perid == GetData[0].PERID
          );
          this.JoinPerson.push({
            idx: this.JoinPerson.length + 1,
            ...GetData[0],
            uid: GetData[0].perid,
            name: GetData[0].name,
            sname: GetData[0].surname,
            idCard: GetData[0].citizen_id,
            affiliation: GetData[0].dep_name,
            position: "",
            phone: "",
            registerType_id: 0,
          });
          this.cardSel = "";
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false;
      var CheckDepMatch = false;
      // var CheckQuotaProject = false
      var CheckGroupExample = [];
      if (
          !this.ChkJoinPerson &&
          this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)
      ) {
        this.$swal.fire({
          icon: "error",
          title:
              "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด",
        });
      } else {
        this.staffData.map((staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.DataCondi.length > 0) {
              CheckGroupExample = this.DataCondi.filter(
                  (item) =>
                      item.PosCode == staff_I.pos_id &&
                      this.getAge(new Date(staff_I.date_in), new Date())[0] >=
                      item.workAgeStart &&
                      this.getAge(new Date(staff_I.date_in), new Date())[0] <=
                      item.workAgeEnd
              );

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map((dep_quota, idx) => {
                    if (dep_quota.type_id == "0" && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true;
                        if (this.JoinPerson.length > 0) {
                          if (
                              this.JoinPerson.filter(
                                  (item) => item.dep_id == staff_I.dep_id
                              ).length < parseInt(dep_quota.count)
                          ) {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.uid == staff_I.perid
                                ).length > 0
                            ) {
                              CheckDupe = true;
                            }

                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                              });
                              this.staffSel = "";
                              this.ExportData();
                            } else {
                              this.staffSel = "";
                              this.$swal.fire({
                                icon: "error",
                                title:
                                    "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                              });
                            }
                          } else {
                            this.staffSel = "";
                            this.$swal.fire({
                              icon: "error",
                              title:
                                  "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน " +
                                  staff_I.dep_name +
                                  " เกินกำหนดที่ตั้งไว้",
                            });
                          }
                        } else {
                          if (
                              this.JoinPerson.filter(
                                  (item) => item.uid == staff_I.perid
                              ).length > 0
                          ) {
                            CheckDupe = true;
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              idx: this.JoinPerson.length + 1,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: "",
                              phone: "",
                              registerType_id: 0,
                            });
                            this.staffSel = "";
                            this.ExportData();
                          } else {
                            this.staffSel = "";
                            this.$swal.fire({
                              icon: "error",
                              title:
                                  "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                            });
                          }
                        }
                      } else {
                        if (
                            !CheckDepMatch &&
                            idx == this.DepQuotaData.length - 1
                        ) {
                          if (this.ChkJoinPerson) {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.uid == staff_I.perid
                                ).length > 0
                            ) {
                              CheckDupe = true;
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                              });
                              this.staffSel = "";
                              this.ExportData();
                            } else {
                              this.staffSel = "";
                              this.$swal.fire({
                                icon: "error",
                                title:
                                    "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                              });
                            }
                          } else {
                            if (
                                this.JoinPerson.length +
                                parseInt(this.ProjectQuotaDepCount) <
                                parseInt(this.ProjectQuotaCount)
                            ) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) => item.uid == staff_I.perid
                                  ).length > 0
                              ) {
                                CheckDupe = true;
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  idx: this.JoinPerson.length + 1,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: "",
                                  phone: "",
                                  registerType_id: 0,
                                });
                                this.staffSel = "";
                                this.ExportData();
                              } else {
                                this.staffSel = "";
                                this.$swal.fire({
                                  icon: "error",
                                  title:
                                      "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                                });
                              }
                            } else {
                              this.staffSel = "";
                              this.$swal.fire({
                                icon: "error",
                                title:
                                    "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข",
                              });
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(
                            (item) => item.dep_group_id == dep_quota.dep_id
                        );
                        if (DepGroup.length > 0) {
                          if (
                              DepGroup.filter(
                                  (item) => item.dep_id == staff_I.dep_id
                              ).length > 0
                          ) {
                            CheckDepMatch = true;
                            if (this.JoinPerson.length > 0) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) =>
                                          item.dep_group_id == staff_I.dep_group_id
                                  ).length < parseInt(dep_quota.count)
                              ) {
                                if (
                                    this.JoinPerson.filter(
                                        (item) => item.uid == staff_I.perid
                                    ).length > 0
                                ) {
                                  CheckDupe = true;
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    idx: this.JoinPerson.length + 1,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: "",
                                    phone: "",
                                    registerType_id: 0,
                                  });
                                  this.staffSel = "";
                                  this.ExportData();
                                } else {
                                  this.staffSel = "";
                                  this.$swal.fire({
                                    icon: "error",
                                    title:
                                        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                                  });
                                }
                              } else {
                                this.staffSel = "";
                                this.$swal.fire({
                                  icon: "error",
                                  title:
                                      "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) " +
                                      staff_I.dep_name +
                                      " เกินกำหนดที่ตั้งไว้",
                                });
                              }
                            } else {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                              });
                              this.staffSel = "";
                              this.ExportData();
                            }
                          }
                        }
                      }
                    }
                  });
                } else {
                  if (
                      this.JoinPerson.length < parseInt(this.ProjectQuotaCount)
                  ) {
                    if (
                        this.JoinPerson.filter(
                            (item) => item.uid == staff_I.perid
                        ).length > 0
                    ) {
                      CheckDupe = true;
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        idx: this.JoinPerson.length + 1,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: "",
                        phone: "",
                        registerType_id: 0,
                      });
                      this.staffSel = "";
                      this.ExportData();
                    } else {
                      this.staffSel = "";
                      this.$swal.fire({
                        icon: "error",
                        title:
                            "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                      });
                    }
                  } else {
                    this.staffSel = "";
                    this.$swal.fire({
                      icon: "error",
                      title:
                          "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด",
                    });
                  }
                }
              } else {
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก",
                });
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((dep_quota, idx) => {
                if (dep_quota.type_id == "0" && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true;
                    if (this.JoinPerson.length > 0) {
                      if (
                          this.JoinPerson.filter(
                              (item) => item.dep_id == staff_I.dep_id
                          ).length < parseInt(dep_quota.count)
                      ) {
                        if (
                            this.JoinPerson.filter(
                                (item) => item.uid == staff_I.perid
                            ).length > 0
                        ) {
                          CheckDupe = true;
                        }

                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            idx: this.JoinPerson.length + 1,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: "",
                            phone: "",
                            registerType_id: 0,
                          });
                          this.staffSel = "";
                          this.ExportData();
                        } else {
                          this.staffSel = "";
                          this.$swal.fire({
                            icon: "error",
                            title:
                                "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                          });
                        }
                      } else {
                        this.staffSel = "";
                        this.$swal.fire({
                          icon: "error",
                          title:
                              "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน " +
                              staff_I.dep_name +
                              " เกินกำหนดที่ตั้งไว้",
                        });
                      }
                    } else {
                      if (
                          this.JoinPerson.filter(
                              (item) => item.uid == staff_I.perid
                          ).length > 0
                      ) {
                        CheckDupe = true;
                      }
                      if (!CheckDupe) {
                        this.JoinPerson.unshift({
                          ...staff_I,
                          idx: this.JoinPerson.length + 1,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg: this.rdoRegisterProject,
                          position: "",
                          phone: "",
                          registerType_id: 0,
                        });
                        this.staffSel = "";
                        this.ExportData();
                      } else {
                        this.staffSel = "";
                        this.$swal.fire({
                          icon: "error",
                          title:
                              "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                        });
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.ChkJoinPerson) {
                        if (
                            this.JoinPerson.filter(
                                (item) => item.uid == staff_I.perid
                            ).length > 0
                        ) {
                          CheckDupe = true;
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            idx: this.JoinPerson.length + 1,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: "",
                            phone: "",
                            registerType_id: 0,
                          });
                          this.staffSel = "";
                          this.ExportData();
                        } else {
                          this.staffSel = "";
                          this.$swal.fire({
                            icon: "error",
                            title:
                                "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                          });
                        }
                      } else {
                        if (
                            this.JoinPerson.length +
                            parseInt(this.ProjectQuotaDepCount) <
                            parseInt(this.ProjectQuotaCount)
                        ) {
                          if (
                              this.JoinPerson.filter(
                                  (item) => item.uid == staff_I.perid
                              ).length > 0
                          ) {
                            CheckDupe = true;
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              idx: this.JoinPerson.length + 1,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: "",
                              phone: "",
                              registerType_id: 0,
                            });
                            this.staffSel = "";
                            this.ExportData();
                          } else {
                            this.staffSel = "";
                            this.$swal.fire({
                              icon: "error",
                              title:
                                  "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                            });
                          }
                        } else {
                          this.staffSel = "";
                          this.$swal.fire({
                            icon: "error",
                            title:
                                "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข",
                          });
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(
                        (item) => item.dep_group_id == dep_quota.dep_id
                    );
                    if (DepGroup.length > 0) {
                      if (
                          DepGroup.filter((item) => item.dep_id == staff_I.dep_id)
                              .length > 0
                      ) {
                        CheckDepMatch = true;
                        if (this.JoinPerson.length > 0) {
                          if (
                              this.JoinPerson.filter(
                                  (item) =>
                                      item.dep_group_id == staff_I.dep_group_id
                              ).length < parseInt(dep_quota.count)
                          ) {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.uid == staff_I.perid
                                ).length > 0
                            ) {
                              CheckDupe = true;
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                              });
                              this.staffSel = "";
                              this.ExportData();
                            } else {
                              this.staffSel = "";
                              this.$swal.fire({
                                icon: "error",
                                title:
                                    "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                              });
                            }
                          } else {
                            this.staffSel = "";
                            this.$swal.fire({
                              icon: "error",
                              title:
                                  "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) " +
                                  staff_I.dep_name +
                                  " เกินกำหนดที่ตั้งไว้",
                            });
                          }
                        } else {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            idx: this.JoinPerson.length + 1,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: "",
                            phone: "",
                            registerType_id: 0,
                          });
                          this.staffSel = "";
                          this.ExportData();
                        }
                      }
                    }
                  }
                }
              });
            } else {
              if (
                  this.JoinPerson.filter((item) => item.uid == staff_I.perid)
                      .length > 0
              ) {
                CheckDupe = true;
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...staff_I,
                  idx: this.JoinPerson.length + 1,
                  uid: staff_I.perid,
                  name: staff_I.name,
                  sname: staff_I.surname,
                  idCard: staff_I.citizen_id,
                  affiliation: staff_I.dep_name,
                  status_reg: this.rdoRegisterProject,
                  position: "",
                  phone: "",
                  registerType_id: 0,
                });
                this.staffSel = "";
                this.ExportData();
              } else {
                this.staffSel = "";
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
                });
              }
            }
          }
        });
      }
    },
    ChooseEmpolyee_s_owner() {
      var CheckDupe = false;
      this.staffData.map((staff_I) => {
        if (staff_I.perid == this.staffSel) {
          if (
              this.JoinPerson.filter((item) => item.uid == staff_I.perid).length >
              0
          ) {
            CheckDupe = true;
          }
          if (!CheckDupe) {
            this.JoinPerson.unshift({
              ...staff_I,
              idx: this.JoinPerson.length + 1,
              uid: staff_I.perid,
              name: staff_I.name,
              sname: staff_I.surname,
              idCard: staff_I.citizen_id,
              affiliation: staff_I.dep_name,
              status_reg: this.rdoRegisterProject,
              position: "",
              phone: "",
              registerType_id: 0,
              join_status: "0",
              files: [],
              type_details: "บุคลากรคณะแพทย์",
              extra_type: "1",
            });
            this.staffSel = "";
          } else {
            this.staffSel = "";
            this.$swal.fire({
              icon: "error",
              title: "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว",
            });
          }
        }
      });
    },
    ChooseEmpolyee() {
      this.items = [];
      this.AutoMateitems();
    },
    AutoMateitems() {
      var children = [];
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push({
                    ...staff_i,
                    header: false,
                    switch: false,
                    id: parseInt(idx + 1),
                    name: staff_i.full_Name,
                  });
                }
              });
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1;
            });
            this.items = [
              {
                id: 1,
                name: depart_i.dep_name,
                header: true,
                switch: false,
                children,
              },
            ];
          }
        });
      }
    },
    insertDataPerson(type) {
      var CheckDupe = false;
      if (type == "person") {
        if (this.NameP != "" && this.SurNameP != "") {
          if (
              this.JoinPerson.filter(
                  (item) => item.uid == "P_" + this.JoinPerson.length
              ).length > 0
          ) {
            CheckDupe = true;
          }
          this.JoinPerson.unshift({
            idx: this.JoinPerson.length + 1,
            uid: !CheckDupe
                ? "P_" + this.JoinPerson.length
                : "P_" + (this.JoinPerson.length + 1),
            full_Name: this.NameP + " " + this.SurNameP,
            name: this.NameP,
            sname: this.SurNameP,
            idCard: this.idCard,
            affiliation: this.affiliation,
            position: this.position,
            phone: this.phoneOther,
            registerType_id: 4,
            join_status: "0",
            files: [],
            type_details: "บุคคลภายนอก",
          });
          this.NameP = "";
          this.SurNameP = "";
          this.idCard = "";
          this.affiliation = "";
          this.position = "";
          this.phoneOther = "";
        } else {
          this.$swal.fire({
            icon: "error",
            title: "โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน",
          });
        }
      } else {
        if (this.NameStd != "" && this.SurNameStd != "") {
          if (
              this.JoinPerson.filter(
                  (item) => item.uid == "S_" + this.JoinPerson.length
              ).length > 0
          ) {
            CheckDupe = true;
          }
          this.JoinPerson.unshift({
            idx: this.JoinPerson.length + 1,
            uid: !CheckDupe
                ? "S_" + this.JoinPerson.length
                : "S_" + (this.JoinPerson.length + 1),
            full_Name: this.NameStd + " " + this.SurNameStd,
            name: this.NameStd,
            sname: this.SurNameStd,
            idCard: this.idCardStd,
            affiliation: this.affiliationStd,
            position: "",
            phone: this.phoneOther,
            registerType_id: 5,
            join_status: "0",
            files: [],
            type_details: "นักศึกษาภายนอก",
          });
          this.NameStd = "";
          this.SurNameStd = "";
          this.idCardStd = "";
          this.affiliationStd = "";
          this.phoneOther = "";
        } else {
          this.$swal.fire({
            icon: "error",
            title: "โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน",
          });
        }
      }
    },
    SaveToTable() {
      // this.EmpData.map((item) => {
      //   this.JoinPerson.push({
      //     ...item,
      //     uid: item.perid,
      //     name: item.name,
      //     sname: item.surname,
      //     idCard: item.citizen_id,
      //     affiliation: item.dep_name,
      //     position: '',
      //     phone: '',
      //     registerType_id: 0,
      //   })
      // })
      // this.EmpData = []
      // this.items = []
      // this.departSel = ''
      var CheckDupe = false;
      var CheckDepMatch = false;
      var CheckGroupExample = [];
      this.ShowAlertSuc = false;
      this.ShowAlertErr = false;
      this.MessageSuc = "";
      this.MessageError = "";

      if (
          this.ChkJoinPerson &&
          this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)
      ) {
        this.$swal.fire({
          icon: "error",
          title:
              "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด",
        });
      } else {
        this.EmpData.map((item, EmpIdx) => {
          CheckDupe = false;
          CheckDepMatch = false;
          CheckGroupExample = [];
          this.staffData.map((staff_I) => {
            if (staff_I.perid == item.perid) {
              if (this.DataCondi.length > 0) {
                CheckGroupExample = this.DataCondi.filter(
                    (item) =>
                        item.PosCode == staff_I.pos_id &&
                        this.getAge(new Date(staff_I.date_in), new Date())[0] >=
                        item.workAgeStart &&
                        this.getAge(new Date(staff_I.date_in), new Date())[0] <=
                        item.workAgeEnd
                );

                if (CheckGroupExample.length > 0) {
                  if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((dep_quota, idx) => {
                      if (dep_quota.type_id == "0" && !CheckDepMatch) {
                        if (staff_I.dep_id == dep_quota.dep_id) {
                          CheckDepMatch = true;
                          if (this.JoinPerson.length > 0) {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.dep_id == staff_I.dep_id
                                ).length < parseInt(dep_quota.count)
                            ) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) => item.uid == staff_I.perid
                                  ).length > 0
                              ) {
                                CheckDupe = true;
                              }

                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  idx: this.JoinPerson.length + 1,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: "",
                                  phone: "",
                                  registerType_id: 0,
                                  join_status: "0",
                                  files: [],
                                  type_details: "บุคลากรคณะแพทย์",
                                });
                                this.MessageSuc +=
                                    '<p style="font-weight: bold;color: green">' +
                                    item.full_Name +
                                    " บันทึกข้อมูลสำเร็จ !!</p>";
                                this.ShowAlertSuc = true;
                              } else {
                                this.MessageError +=
                                    '<p style="font-weight: bold;color: red">' +
                                    item.full_Name +
                                    " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                this.ShowAlertErr = true;
                              }
                            } else {
                              this.MessageError +=
                                  '<p style="font-weight: bold;color: chocolate">' +
                                  item.full_Name +
                                  " ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน " +
                                  staff_I.dep_name +
                                  " เกินกำหนดที่ตั้งไว้</p>";
                              this.ShowAlertErr = true;
                            }
                          } else {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.uid == staff_I.perid
                                ).length > 0
                            ) {
                              CheckDupe = true;
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                                join_status: "0",
                                files: [],
                                type_details: "บุคลากรคณะแพทย์",
                              });
                              this.MessageSuc +=
                                  '<p style="font-weight: bold;color: green">' +
                                  item.full_Name +
                                  " บันทึกข้อมูลสำเร็จ !!</p>";
                              this.ShowAlertSuc = true;
                            } else {
                              this.MessageError +=
                                  '<p style="font-weight: bold;color: red">' +
                                  item.full_Name +
                                  " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                              this.ShowAlertErr = true;
                            }
                          }
                        } else {
                          if (
                              !CheckDepMatch &&
                              idx == this.DepQuotaData.length - 1
                          ) {
                            if (this.ChkJoinPerson) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) => item.uid == staff_I.perid
                                  ).length > 0
                              ) {
                                CheckDupe = true;
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  idx: this.JoinPerson.length + 1,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: "",
                                  phone: "",
                                  registerType_id: 0,
                                  join_status: "0",
                                  files: [],
                                  type_details: "บุคลากรคณะแพทย์",
                                });
                                this.MessageSuc +=
                                    '<p style="font-weight: bold;color: green">' +
                                    item.full_Name +
                                    " บันทึกข้อมูลสำเร็จ !!</p>";
                                this.ShowAlertSuc = true;
                              } else {
                                this.MessageError +=
                                    '<p style="font-weight: bold;color: red">' +
                                    item.full_Name +
                                    " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                this.ShowAlertErr = true;
                              }
                            } else {
                              if (
                                  this.JoinPerson.length +
                                  parseInt(this.ProjectQuotaDepCount) <
                                  parseInt(this.ProjectQuotaCount)
                              ) {
                                if (
                                    this.JoinPerson.filter(
                                        (item) => item.uid == staff_I.perid
                                    ).length > 0
                                ) {
                                  CheckDupe = true;
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    idx: this.JoinPerson.length + 1,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: "",
                                    phone: "",
                                    registerType_id: 0,
                                    join_status: "0",
                                    files: [],
                                    type_details: "บุคลากรคณะแพทย์",
                                  });
                                  this.MessageSuc +=
                                      '<p style="font-weight: bold;color: green">' +
                                      item.full_Name +
                                      " บันทึกข้อมูลสำเร็จ !!</p>";
                                  this.ShowAlertSuc = true;
                                } else {
                                  this.MessageError +=
                                      '<p style="font-weight: bold;color: red">' +
                                      item.full_Name +
                                      " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                  this.ShowAlertErr = true;
                                }
                              } else {
                                this.MessageError +=
                                    '<p style="font-weight: bold;color: blueviolet">' +
                                    item.full_Name +
                                    " หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>";
                                this.ShowAlertErr = true;
                              }
                            }
                          }
                        }
                      } else {
                        //// ตรงนี้ต้องเช็ค
                        if (!CheckDepMatch) {
                          var DepGroup = this.depart.filter(
                              (item) => item.dep_group_id == dep_quota.dep_id
                          );
                          if (DepGroup.length > 0) {
                            if (
                                DepGroup.filter(
                                    (item) => item.dep_id == staff_I.dep_id
                                ).length > 0
                            ) {
                              CheckDepMatch = true;
                              if (this.JoinPerson.length > 0) {
                                if (
                                    this.JoinPerson.filter(
                                        (item) =>
                                            item.dep_group_id == staff_I.dep_group_id
                                    ).length < parseInt(dep_quota.count)
                                ) {
                                  if (
                                      this.JoinPerson.filter(
                                          (item) => item.uid == staff_I.perid
                                      ).length > 0
                                  ) {
                                    CheckDupe = true;
                                  }
                                  if (!CheckDupe) {
                                    this.JoinPerson.unshift({
                                      ...staff_I,
                                      idx: this.JoinPerson.length + 1,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_reg: this.rdoRegisterProject,
                                      position: "",
                                      phone: "",
                                      registerType_id: 0,
                                      join_status: "0",
                                      files: [],
                                      type_details: "บุคลากรคณะแพทย์",
                                    });
                                    this.MessageSuc +=
                                        '<p style="font-weight: bold;color: green"">' +
                                        item.full_Name +
                                        " บันทึกข้อมูลสำเร็จ !!</p>";
                                    this.ShowAlertSuc = true;
                                  } else {
                                    this.MessageError +=
                                        '<p style="font-weight: bold;color: red"">' +
                                        item.full_Name +
                                        " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                    this.ShowAlertErr = true;
                                  }
                                } else {
                                  this.MessageError +=
                                      '<p style="font-weight: bold;color: chocolate"">' +
                                      item.full_Name +
                                      " ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน " +
                                      staff_I.dep_name +
                                      " เกินกำหนดที่ตั้งไว้</p>";
                                  this.ShowAlertErr = true;
                                }
                              } else {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  idx: this.JoinPerson.length + 1,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: "",
                                  phone: "",
                                  registerType_id: 0,
                                  join_status: "0",
                                  files: [],
                                  type_details: "บุคลากรคณะแพทย์",
                                });
                                this.MessageSuc +=
                                    '<p style="font-weight: bold;color: green"">' +
                                    item.full_Name +
                                    " บันทึกข้อมูลสำเร็จ !!</p>";
                                this.ShowAlertSuc = true;
                              }
                            }
                          }
                        }
                      }
                    });
                  } else {
                    if (
                        this.JoinPerson.filter(
                            (item) => item.uid == staff_I.perid
                        ).length > 0
                    ) {
                      CheckDupe = true;
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        idx: this.JoinPerson.length + 1,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: "",
                        phone: "",
                        registerType_id: 0,
                        join_status: "0",
                        files: [],
                        type_details: "บุคลากรคณะแพทย์",
                      });
                      this.MessageSuc +=
                          '<p style="font-weight: bold;color: green">' +
                          item.full_Name +
                          " บันทึกข้อมูลสำเร็จ !!</p>";
                      this.ShowAlertSuc = true;
                    } else {
                      this.MessageError +=
                          '<p style="font-weight: bold;color: red"">' +
                          item.full_Name +
                          " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                      this.ShowAlertErr = true;
                    }
                  }
                } else {
                  this.MessageError +=
                      '<p style="font-weight: bold;color: darkcyan">' +
                      item.full_Name +
                      " ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>";
                  this.ShowAlertErr = true;
                }
              } else if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.type_id == "0" && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true;
                      if (this.JoinPerson.length > 0) {
                        if (
                            this.JoinPerson.filter(
                                (item) => item.dep_id == staff_I.dep_id
                            ).length < parseInt(dep_quota.count)
                        ) {
                          if (
                              this.JoinPerson.filter(
                                  (item) => item.uid == staff_I.perid
                              ).length > 0
                          ) {
                            CheckDupe = true;
                          }

                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              idx: this.JoinPerson.length + 1,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: "",
                              phone: "",
                              registerType_id: 0,
                              join_status: "0",
                              files: [],
                              type_details: "บุคลากรคณะแพทย์",
                            });
                            this.MessageSuc +=
                                '<p style="font-weight: bold;color: green"">' +
                                item.full_Name +
                                " บันทึกข้อมูลสำเร็จ !!</p>";
                            this.ShowAlertSuc = true;
                          } else {
                            this.MessageError +=
                                '<p style="font-weight: bold;color: red"">' +
                                item.full_Name +
                                " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                            this.ShowAlertErr = true;
                          }
                        } else {
                          this.MessageError +=
                              '<p style="font-weight: bold;color: chocolate"">' +
                              item.full_Name +
                              " ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน " +
                              staff_I.dep_name +
                              " เกินกำหนดที่ตั้งไว้</p>";
                          this.ShowAlertErr = true;
                        }
                      } else {
                        if (
                            this.JoinPerson.filter(
                                (item) => item.uid == staff_I.perid
                            ).length > 0
                        ) {
                          CheckDupe = true;
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            idx: this.JoinPerson.length + 1,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: "",
                            phone: "",
                            registerType_id: 0,
                            join_status: "0",
                            files: [],
                            type_details: "บุคลากรคณะแพทย์",
                          });
                          this.MessageSuc +=
                              '<p style="font-weight: bold;color: green"">' +
                              item.full_Name +
                              " บันทึกข้อมูลสำเร็จ !!</p>";
                          this.ShowAlertSuc = true;
                        } else {
                          this.MessageError +=
                              '<p style="font-weight: bold;color: red"">' +
                              item.full_Name +
                              " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                          this.ShowAlertErr = true;
                        }
                      }
                    } else {
                      if (
                          !CheckDepMatch &&
                          idx == this.DepQuotaData.length - 1
                      ) {
                        if (this.ChkJoinPerson) {
                          if (
                              this.JoinPerson.filter(
                                  (item) => item.uid == staff_I.perid
                              ).length > 0
                          ) {
                            CheckDupe = true;
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              idx: this.JoinPerson.length + 1,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: "",
                              phone: "",
                              registerType_id: 0,
                              join_status: "0",
                              files: [],
                              type_details: "บุคลากรคณะแพทย์",
                            });
                            this.MessageSuc +=
                                '<p style="font-weight: bold;color: green"">' +
                                item.full_Name +
                                " บันทึกข้อมูลสำเร็จ !!</p>";
                            this.ShowAlertSuc = true;
                          } else {
                            this.MessageError +=
                                '<p style="font-weight: bold;color: red"">' +
                                item.full_Name +
                                " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                            this.ShowAlertErr = true;
                          }
                        } else {
                          if (
                              this.JoinPerson.length +
                              parseInt(this.ProjectQuotaDepCount) <
                              parseInt(this.ProjectQuotaCount)
                          ) {
                            if (
                                this.JoinPerson.filter(
                                    (item) => item.uid == staff_I.perid
                                ).length > 0
                            ) {
                              CheckDupe = true;
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                idx: this.JoinPerson.length + 1,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: "",
                                phone: "",
                                registerType_id: 0,
                                join_status: "0",
                                files: [],
                                type_details: "บุคลากรคณะแพทย์",
                              });
                              this.MessageSuc +=
                                  '<p style="font-weight: bold;color: green"">' +
                                  item.full_Name +
                                  " บันทึกข้อมูลสำเร็จ !!</p>";
                              this.ShowAlertSuc = true;
                            } else {
                              this.MessageError +=
                                  '<p style="font-weight: bold;color: red"">' +
                                  item.full_Name +
                                  " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                              this.ShowAlertErr = true;
                            }
                          } else {
                            this.MessageError +=
                                '<p style="font-weight: bold;color: blueviolet">' +
                                item.full_Name +
                                " หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>";
                            this.ShowAlertErr = true;
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(
                          (item) => item.dep_group_id == dep_quota.dep_id
                      );
                      if (DepGroup.length > 0) {
                        if (
                            DepGroup.filter(
                                (item) => item.dep_id == staff_I.dep_id
                            ).length > 0
                        ) {
                          CheckDepMatch = true;
                          if (this.JoinPerson.length > 0) {
                            if (
                                this.JoinPerson.filter(
                                    (item) =>
                                        item.dep_group_id == staff_I.dep_group_id
                                ).length < parseInt(dep_quota.count)
                            ) {
                              if (
                                  this.JoinPerson.filter(
                                      (item) => item.uid == staff_I.perid
                                  ).length > 0
                              ) {
                                CheckDupe = true;
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  idx: this.JoinPerson.length + 1,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: "",
                                  phone: "",
                                  registerType_id: 0,
                                  join_status: "0",
                                  files: [],
                                  type_details: "บุคลากรคณะแพทย์",
                                });
                                this.MessageSuc +=
                                    '<p style="font-weight: bold;color: green"">' +
                                    item.full_Name +
                                    " บันทึกข้อมูลสำเร็จ !!</p>";
                                this.ShowAlertSuc = true;
                              } else {
                                this.MessageError +=
                                    '<p style="font-weight: bold;color: red"">' +
                                    item.full_Name +
                                    " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                                this.ShowAlertErr = true;
                              }
                            } else {
                              this.MessageError +=
                                  '<p style="font-weight: bold;color: chocolate"">' +
                                  item.full_Name +
                                  " ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน " +
                                  staff_I.dep_name +
                                  " เกินกำหนดที่ตั้งไว้</p>";
                              this.ShowAlertErr = true;
                            }
                          } else {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              idx: this.JoinPerson.length + 1,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: "",
                              phone: "",
                              registerType_id: 0,
                              join_status: "0",
                              files: [],
                              type_details: "บุคลากรคณะแพทย์",
                            });
                            this.MessageSuc +=
                                '<p style="font-weight: bold;color: green"">' +
                                item.full_Name +
                                " บันทึกข้อมูลสำเร็จ !!</p>";
                            this.ShowAlertSuc = true;
                          }
                        }
                      }
                    }
                  }
                });
              } else {
                if (
                    this.JoinPerson.filter((item) => item.uid == staff_I.perid)
                        .length > 0
                ) {
                  CheckDupe = true;
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...staff_I,
                    idx: this.JoinPerson.length + 1,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    status_reg: this.rdoRegisterProject,
                    position: "",
                    phone: "",
                    registerType_id: 0,
                    join_status: "0",
                    files: [],
                    type_details: "บุคลากรคณะแพทย์",
                  });
                  this.MessageSuc +=
                      '<p style="font-weight: bold;color: green"">' +
                      item.full_Name +
                      " บันทึกข้อมูลสำเร็จ !!</p>";
                  this.ShowAlertSuc = true;
                } else {
                  this.MessageError +=
                      '<p style="font-weight: bold;color: red"">' +
                      item.full_Name +
                      " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
                  this.ShowAlertErr = true;
                }
              }
            }
          });
          if (EmpIdx == this.EmpData.length - 1) {
            this.EmpData = [];
            this.items = [];
            this.departSel = "";
          }
        });
      }
    },
    SaveToTable_owner() {
      var CheckDupe = false;
      this.MessageError = "";
      this.MessageSuc = "";
      this.EmpData.map((item) => {
        CheckDupe = false;
        if (
            this.JoinPerson.filter((Join_I) => Join_I.uid == item.perid).length >
            0
        ) {
          CheckDupe = true;
        }
        if (!CheckDupe) {
          this.JoinPerson.unshift({
            ...item,
            idx: this.JoinPerson.length + 1,
            uid: item.perid,
            name: item.name,
            sname: item.surname,
            idCard: item.citizen_id,
            affiliation: item.dep_name,
            status_reg: this.rdoRegisterProject,
            position: "",
            phone: "",
            registerType_id: 0,
          });
          this.MessageSuc +=
              '<p style="font-weight: bold;color: green">' +
              item.full_Name +
              " บันทึกข้อมูลสำเร็จ !!</p>";
          this.ShowAlertSuc = true;
        } else {
          this.MessageError +=
              '<p style="font-weight: bold;color: red">' +
              item.full_Name +
              " พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>";
          this.ShowAlertErr = true;
        }
      });
      this.EmpData = [];
      this.items = [];
      this.departSel = "";
    },
    showDetails: function (item) {
      if (this.Details_Cordi) {
        this.project = null;
        this.Details_Cordi = false;
      } else {
        this.project = item;
        this.Details_Cordi = true;
      }
    },
    DeleteCompetency(item) {
      this.competency_DataForSubmit = this.competency_DataForSubmit.filter(
          (value) => value.Competency_code != item.Competency_code
      );
    },
    downloadTemplateEmp() {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute(
          "download",
          "Template ตัวอย่าง การนำเข้าข้อมูลบุคลากรผู้เข้าร่วม"
      );
      link.href =
          "https://medhr.medicine.psu.ac.th/HrTrain2/" +
          (this.typeImport == "1"
              ? "TemplateEmp.xlsx"
              : this.typeImport == "2"
                  ? "TemplateStudent.xlsx"
                  : "TemplateEmpOther.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadFiles(item) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute("download", item.File_name);
      link.href = this.Openfile + item.File_path;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          "_blank" // <- This is what makes it open in a new window.
      );
    },
    GetFileProject() {
      return new Promise((resolve) => {
        this.FileProject = [];
        if (this.ProjectPlan != null) {
          axios
              .get(
                  ConstData.ConnectionHost +
                  "/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/" +
                  this.ProjectPlan +
                  "/active/1"
              )
              .then((res) => {
                if (res.data) {
                  if (res.data.length > 0) {
                    res.data.map((item) => {
                      switch (item.File_type) {
                        case "image/jpg":
                        case "image/jpeg":
                        case "image/gif":
                        case "image/bmp":
                        case "image/png":
                          this.FileProject.push({
                            index: this.FileProject.length + 1,
                            id: item.id,
                            name: item.File_name,
                            src:
                                ConstData.ConnectionHost +
                                "/rest/files" +
                                item.File_path,
                            path: item.File_path,
                            type: "image",
                            type_Img: item.File_type,
                          });
                          break;
                        case "application/pdf":
                          this.FileProject.push({
                            index: this.FileProject.length + 1,
                            id: item.id,
                            name: item.File_name,
                            src:
                                ConstData.ConnectionHost +
                                "/rest/files" +
                                item.File_path,
                            path: item.File_path,
                            type: "pdf",
                            type_Img: item.File_type,
                          });
                          break;
                        default:
                          break;
                      }
                    });
                  } else {
                    switch (res.data.File_type) {
                      case "image/jpg":
                      case "image/jpeg":
                      case "image/gif":
                      case "image/bmp":
                      case "image/png":
                        this.FileProject.push({
                          index: this.FileProject.length + 1,
                          id: res.data.id,
                          name: res.data.File_name,
                          src:
                              ConstData.ConnectionHost +
                              "/rest/files" +
                              res.data.File_path,
                          path: res.data.File_path,
                          type: "image",
                          type_Img: res.data.File_type,
                        });
                        break;
                      case "application/pdf":
                        this.FileProject.push({
                          index: this.FileProject.length + 1,
                          id: res.data.id,
                          name: res.data.File_name,
                          src:
                              ConstData.ConnectionHost +
                              "/rest/files" +
                              res.data.File_path,
                          path: res.data.File_path,
                          type: "pdf",
                          type_Img: res.data.File_type,
                        });
                        break;
                      default:
                        break;
                    }
                  }
                  this.FileProjectOld = this.FileProject;
                } else {
                  this.FileProject = [];
                }
                resolve(true);
              })
              .catch((res) => {
                if (res) {
                  resolve(false);
                }
              });
        } else {
          resolve(true);
        }
      });
    },
    GetProjectRecord(ProjectCode) {
      return new Promise((resolve) => {
        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/" +
                ProjectCode +
                "/?sort=id_DESC"
            )
            .then((res) => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.RecordData = res.data;
                } else {
                  this.RecordData.push(res.data);
                }
                this.RecordData.map((item) => {
                  item.files = [];
                });

                axios
                    .get(
                        ConstData.ConnectionHost +
                        "/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/" +
                        ProjectCode +
                        "/?sort=id_DESC"
                    )
                    .then((res) => {
                      if (res.data) {
                        if (res.data.length > 0) {
                          res.data.map((file_i) => {
                            this.RecordData.map((record_i) => {
                              if (
                                  record_i.Project_code == file_i.Project_code &&
                                  record_i.id == file_i.project_record_id
                              ) {
                                record_i.files.push(file_i);
                              }
                            });
                          });
                        } else {
                          this.RecordData.map((record_i) => {
                            if (
                                record_i.Project_code == res.data.Project_code &&
                                record_i.id == res.data.project_record_id
                            ) {
                              record_i.files.push(res.data);
                            }
                          });
                        }
                      }
                      resolve(true);
                    });
              } else {
                this.RecordData = [];
                resolve(true);
              }
            });
      });
    },
    FileImport() {
      this.sheets = [];
      this.ChooseSheet = "";
      this.Exec = false;
      readXlsxFile(this.filesImportEmp[0], {getSheets: true}).then(
          (sheets) => {
            this.sheets = sheets;
          }
      );
    },
    FileSelect: function () {
      this.GetFileProject().then((resFile) => {
        if (resFile) {
          this.txtAlert = [];
          this.alert = false;
          if (this.files.length > 0) {
            this.files.map((item) => {
              var Checkfile = false;
              switch (item.type) {
                  // case 'image/jpg':
                  // case 'image/jpeg':
                  // case 'image/gif':
                  // case 'image/bmp':
                  // case 'image/png':
                  //   Checkfile = true;
                  //   break
                case "application/pdf":
                  Checkfile = true;
                  break;
                default:
                  Checkfile = false;
                  break;
              }

              if (Checkfile) {
                if (item.size > 25000000) {
                  this.txtAlert.push({
                    id: this.txtAlert.length + 1,
                    Detail: "ไฟล์ " + item.name + " ขนาดเกิน 25 mb*",
                  });
                }
              } else {
                this.txtAlert.push({
                  id: this.txtAlert.length + 1,
                  Detail:
                      "ไม่สนับสนุนนามสกุลไฟล์ " +
                      item.type.split("/")[1] +
                      " ( " +
                      item.name +
                      " ) ",
                });
              }
            });
          }
          if (this.txtAlert.length == 0) {
            this.files.map((item) => {
              const fd = new FormData();
              fd.append("file", item, item.name);
              const headerAxios = {
                headers: {
                  "Content-Type": "multipart/form-data",
                  WithCredentials: true,
                  "Access-Control-Allow-Origin": "*",
                  // "Accept": 'multipart/form-data'
                },
              };

              axios
                  .post(
                      ConstData.ConnectionHost + "/rest/v1/hrcardnew/uploadfile",
                      fd,
                      headerAxios
                  )
                  .then((res) => {
                    if (res.data.status) {
                      switch (item.type) {
                          // case 'image/jpg':
                          // case 'image/jpeg':
                          // case 'image/gif':
                          // case 'image/bmp':
                          // case 'image/png':
                          //   this.FileProject.push({
                          //     name: item.name,
                          //     src: URL.createObjectURL(item),
                          //     path: res.data.path,
                          //     type: 'image',
                          //     type_Img: item.type
                          //   })
                          //   break
                        case "application/pdf":
                          this.FileProject.push({
                            index: this.FileProject.length + 1,
                            name: item.name,
                            src: URL.createObjectURL(item),
                            path: res.data.path,
                            type: "pdf",
                            type_Img: item.type,
                          });
                          break;
                        default:
                          break;
                      }

                      // count++
                      //
                      // if (count === this.files.length) {
                      //     this.FileProjectPdf = []
                      //     this.FileProject = []
                      // }
                    }
                  });
            });
          } else {
            this.alert = true;
          }
        }
      });
    },
    FileRegisterSelect: function () {
      // var count = 0
      this.txtFileRegisterAlert = [];
      this.FileProjectRegister = [];
      this.alertFileRegister = false;
      if (this.filesRegister.length > 0) {
        this.filesRegister.map((item) => {
          var Checkfile = false;
          switch (item.type) {
              // case 'image/jpg':
              // case 'image/jpeg':
              // case 'image/gif':
              // case 'image/bmp':
              // case 'image/png':
              //   Checkfile = true;
              //   break
            case "application/pdf":
              Checkfile = true;
              break;
            default:
              Checkfile = false;
              break;
          }

          if (Checkfile) {
            if (item.size > 25000000) {
              this.txtFileRegisterAlert.push({
                id: this.txtFileRegisterAlert.length + 1,
                Detail: "ไฟล์ " + item.name + " ขนาดเกิน 25 mb*",
              });
            }
          } else {
            this.txtFileRegisterAlert.push({
              id: this.txtFileRegisterAlert.length + 1,
              Detail:
                  "ไม่สนับสนุนนามสกุลไฟล์ " +
                  item.type.split("/")[1] +
                  " ( " +
                  item.name +
                  " ) ",
            });
          }
        });
      }

      if (this.txtFileRegisterAlert.length == 0) {
        this.filesRegister.map((item) => {
          const fd = new FormData();
          fd.append("file", item, item.name);
          const headerAxios = {
            headers: {
              "Content-Type": "multipart/form-data",
              WithCredentials: true,
              "Access-Control-Allow-Origin": "*",
              // "Accept": 'multipart/form-data'
            },
          };

          axios
              .post(
                  ConstData.ConnectionHost + "/rest/v1/hrcardnew/uploadfile",
                  fd,
                  headerAxios
              )
              .then((res) => {
                if (res.data.status) {
                  switch (item.type) {
                      // case 'image/jpg':
                      // case 'image/jpeg':
                      // case 'image/gif':
                      // case 'image/bmp':
                      // case 'image/png':
                      //   this.FileProject.push({
                      //     name: item.name,
                      //     src: URL.createObjectURL(item),
                      //     path: res.data.path,
                      //     type: 'image',
                      //     type_Img: item.type
                      //   })
                      //   break
                    case "application/pdf":
                      this.FileProjectRegister.push({
                        index: this.FileProject.length + 1,
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: "pdf",
                        type_Img: item.type,
                      });
                      break;
                    default:
                      break;
                  }

                  // count++
                  //
                  // if (count === this.files.length) {
                  //     this.FileProjectPdf = []
                  //     this.FileProject = []
                  // }
                }
              });
        });
      } else {
        this.alertFileRegister = true;
      }
    },
    FileSelectExpert: function () {
      // var count = 0
      this.txtAlert = [];
      this.FileProjectExpert = [];
      this.alertExpert = false;
      if (this.filesExpert.length > 0) {
        this.filesExpert.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case "image/jpg":
            case "image/jpeg":
            case "image/gif":
            case "image/bmp":
            case "image/png":
              Checkfile = true;
              break;
            case "application/pdf":
              Checkfile = true;
              break;
            default:
              Checkfile = false;
              break;
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlertExpert.push({
                id: this.txtAlertExpert.length + 1,
                Detail: "ไฟล์ " + item.name + " ขนาดเกิน 8 mb*",
              });
            }
          } else {
            this.txtAlertExpert.push({
              id: this.txtAlertExpert.length + 1,
              Detail:
                  "ไม่สนับสนุนนามสกุลไฟล์ " +
                  item.type.split("/")[1] +
                  " ( " +
                  item.name +
                  " ) ",
            });
          }
        });
      }

      if (this.txtAlertExpert.length == 0) {
        this.filesExpert.map((item) => {
          const fd = new FormData();
          fd.append("file", item, item.name);
          const headerAxios = {
            headers: {
              "Content-Type": "multipart/form-data",
              WithCredentials: true,
              "Access-Control-Allow-Origin": "*",
              // "Accept": 'multipart/form-data'
            },
          };

          axios
              .post(
                  ConstData.ConnectionHost + "/rest/v1/hrcardnew/uploadfile",
                  fd,
                  headerAxios
              )
              .then((res) => {
                if (res.data.status) {
                  switch (item.type) {
                    case "image/jpg":
                    case "image/jpeg":
                    case "image/gif":
                    case "image/bmp":
                    case "image/png":
                      this.FileProjectExpert.push({
                        File_name: item.name,
                        src: URL.createObjectURL(item),
                        File_path: res.data.path,
                        File_type: "image",
                        type_Img: item.type,
                      });
                      break;
                    case "application/pdf":
                      this.FileProjectExpert.push({
                        File_name: item.name,
                        src: URL.createObjectURL(item),
                        File_path: res.data.path,
                        File_type: "pdf",
                        type_Img: item.type,
                      });
                      break;
                    default:
                      break;
                  }

                  // count++
                  //
                  // if (count === this.files.length) {
                  //     this.FileProjectPdf = []
                  //     this.FileProject = []
                  // }
                }
              });
        });
      } else {
        this.alertExpert = true;
      }
    },
    DeleteExpense_p(item) {
      this.expense_p_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_p_DataForSubmit.splice(idx, 1);
        }
      });
    },
    DeleteExpense(item) {
      this.expense_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_DataForSubmit.splice(idx, 1);
        }
      });
    },
    InsertCompetency() {
      if (this.Competency_code == "" || this.UPercent == "") {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
        });
      } else {
        if (this.competency_DataForSubmit.length > 0) {
          this.competency_DataForSubmit.map((compe_i_s) => {
            if (compe_i_s.Competency_code == this.Competency_code) {
              this.$swal.fire({
                icon: "error",
                title:
                    "มี Competency นี้อยู่แล้ว !! ไม่สามารถเพิ่มข้อมูลได้อีก",
              });
            } else {
              this.Competency_Data.map((compe_i) => {
                if (compe_i.Competency_code == this.Competency_code) {
                  this.competency_DataForSubmit.push({
                    Project_code: this.Project_code,
                    Competency_code: this.Competency_code,
                    Competency_des: compe_i.Competency_des,
                    UPercent: this.UPercent,
                  });
                }
              });
            }
          });
        } else {
          this.Competency_Data.map((compe_i) => {
            if (compe_i.Competency_code == this.Competency_code) {
              this.competency_DataForSubmit.push({
                Project_code: this.Project_code,
                Competency_code: this.Competency_code,
                Competency_des: compe_i.Competency_des,
                UPercent: this.UPercent,
              });
            }
          });
        }
      }
      this.Competency_code = "";
      this.UPercent = "";
    },
    AddExpense() {
      var CheckDupe = false;
      var CheckDupeExpense = false;
      var CheckDep = false;
      if (this.radioGroup2 == "0") {
        if (this.moneyCost == "" || this.expenseCost == null) {
          this.$swal.fire({
            icon: "error",
            title: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
          });
        } else {
          if (this.expense_p_DataForSubmit.length > 0) {
            this.expense_p_DataForSubmit.map((item) => {
              item.Expense_data.map((item_expense) => {
                if (item_expense.Expense_id == this.expenseCost) {
                  CheckDupe = true;
                }
              });
            });
          }
          if (CheckDupe) {
            this.$swal.fire({
              icon: "error",
              title:
                  "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว",
            });
          } else {
            if (this.expense_p_DataForSubmit.length > 0) {
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false;
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost,
                        });
                        item.SumCost += parseInt(this.moneyCost);
                        this.expenseCostSum += parseInt(this.moneyCost);
                      }
                    });
                    CheckDep = true;
                  }
                });
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: "",
                        Dep_Cost_Name: "",
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost,
                      });
                      item.SumCost += parseInt(this.moneyCost);
                      this.expenseCostSum += parseInt(this.moneyCost);
                    }
                  });
                }
              });
            } else {
              this.expense_p_DataForSubmit.push({
                id: this.expense_p_DataForSubmit.length + 1,
                Project_code: this.Project_code,
                SumCost: 0,
                Expense_data: [],
              });
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false;
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost,
                        });
                        item.SumCost += parseInt(this.moneyCost);
                        this.expenseCostSum += parseInt(this.moneyCost);
                      }
                    });
                    CheckDep = true;
                  }
                });
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: "",
                        Dep_Cost_Name: "",
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost,
                      });
                      item.SumCost += parseInt(this.moneyCost);
                      this.expenseCostSum += parseInt(this.moneyCost);
                    }
                  });
                }
              });
            }
          }
          this.peridCost = "";
          this.moneyCost = "";
          this.expenseCost = null;
        }
      } else {
        if (
            this.peridCost == "" ||
            this.moneyCost == "" ||
            this.expenseCost == null
        ) {
          this.$swal.fire({
            icon: "error",
            title: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
          });
        } else {
          if (this.expense_DataForSubmit.length > 0) {
            this.expense_DataForSubmit.map((item) => {
              if (item.PERID == this.peridCost) {
                CheckDupe = true;
                this.expense_p_DataForSubmit.map((item) => {
                  item.Expense_data.map((item_expense) => {
                    if (item_expense.Expense_id == this.expenseCost) {
                      CheckDupeExpense = true;
                    }
                  });
                });
              }
            });
          }
          if (CheckDupe) {
            if (CheckDupeExpense) {
              this.$swal.fire({
                icon: "error",
                title:
                    "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว",
              });
            } else {
              if (this.expense_DataForSubmit.length > 0) {
                this.expense_DataForSubmit.map((item) => {
                  if (item.PERID == this.peridCost) {
                    CheckDep = false;
                    this.depart.map((dep_i) => {
                      if (dep_i.dep_id == this.DepCost) {
                        this.expense_Data.map((expense_i) => {
                          if (expense_i.Expense_id == this.expenseCost) {
                            item.Expense_data.push({
                              Dep_Cost: this.DepCost,
                              Dep_Cost_Name: dep_i.dep_name,
                              Expense_id: this.expenseCost,
                              Expense_des: expense_i.Expense_des,
                              ReqMoney: this.moneyCost,
                            });
                            item.SumCost += parseInt(this.moneyCost);
                            this.expenseCostSum += parseInt(this.moneyCost);
                          }
                        });
                        CheckDep = true;
                      }
                    });
                    if (!CheckDep) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: "",
                            Dep_Cost_Name: "",
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost,
                          });
                          item.SumCost += parseInt(this.moneyCost);
                          this.expenseCostSum += parseInt(this.moneyCost);
                        }
                      });
                    }
                  }
                });
              }
            }
          } else {
            this.staffData.map((staff_i) => {
              if (staff_i.perid == this.peridCost) {
                this.expense_DataForSubmit.push({
                  id: this.expense_DataForSubmit.length + 1,
                  PERID: this.peridCost,
                  full_Name: staff_i.full_Name,
                  Dep_Code: this.dep_id,
                  Dep_name: staff_i.dep_name,
                  Project_code: this.Project_code,
                  SumCost: 0,
                  Expense_data: [],
                });
              }
            });
            if (this.expense_DataForSubmit.length > 0) {
              this.expense_DataForSubmit.map((item) => {
                if (item.PERID == this.peridCost) {
                  CheckDep = false;
                  this.depart.map((dep_i) => {
                    if (dep_i.dep_id == this.DepCost) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: this.DepCost,
                            Dep_Cost_Name: dep_i.dep_name,
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost,
                          });
                          item.SumCost += parseInt(this.moneyCost);
                          this.expenseCostSum += parseInt(this.moneyCost);
                        }
                      });
                      CheckDep = true;
                    }
                  });
                  if (!CheckDep) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: "",
                          Dep_Cost_Name: "",
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost,
                        });
                        item.SumCost += parseInt(this.moneyCost);
                        this.expenseCostSum += parseInt(this.moneyCost);
                      }
                    });
                  }
                }
              });
            }
          }
          this.peridCost = "";
          this.moneyCost = "";
          this.expenseCost = null;
        }
      }
    },
    onInput(val) {
      this.steps = parseInt(val);
    },
    backStep(n) {
      this.e1 = n;
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
        if (this.e1 == 2) {
          if (
              this.Project_name == "" ||
              this.Project_group == null ||
              this.PLACE == "" ||
              this.WorkBy == "" ||
              this.Location == "" ||
              this.DateStart == "" ||
              this.DateEnd == "" ||
              this.BudgetRequest == "" ||
              this.CalCredit == "" ||
              this.CalHourse == ""
          ) {
            this.CheckStep1 = false;
          } else {
            if (this.PLACE == "2" && this.Province_id == null) {
              this.CheckStep1 = false;
            } else if (this.PLACE == "3" && this.Country_id == null) {
              this.CheckStep1 = false;
            } else {
              this.CheckStep1 = true;
            }
          }
        }

        if (this.e1 == 4) {
          if (this.Coordinator.length == 0) {
            this.CheckStep3 = false;
          } else {
            this.CheckStep3 = true;
          }
        }
      }
    },
    ExecForm() {
      if (!this.isFormExec && this.ProjectPlan == null) {
        // var GroupExample = ''
        var committeeTxt = "";
        var lecturerTxt = "";
        var budgetTxt = "";
        if (this.Committee_ToShow.length > 0) {
          this.Committee_ToShow.map((item, idx) => {
            committeeTxt +=
                '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Name +
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                item.Committee_des +
                "</span></p>";
          });
        }
        /*if (this.DataCondi.length > 0) {
          this.DataCondi.map((item, idx) => {
            if (item.workAgeStart != item.workAgeEnd) {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
            } else {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

            }
          })
        }*/
        if (this.LecturerToShow.length > 0) {
          this.LecturerToShow.map((item, idx) => {
            if (item.Perid != "") {
              if (
                  this.levelData.filter((lv_i) => lv_i.LevelCode == item.pos_lv)
                      .length > 0
              ) {
                lecturerTxt +=
                    '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                    (idx + 1) +
                    ". " +
                    item.Name +
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    item.pos_name +
                    this.levelData.filter(
                        (lv_i) => lv_i.LevelCode == item.pos_lv
                    )[0].LevelName +
                    "</span></p>";
              } else {
                lecturerTxt +=
                    '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                    (idx + 1) +
                    ". " +
                    item.Name +
                    "</span></p>";
              }
            } else {
              lecturerTxt +=
                  '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Name +
                  "</span></p>";
            }
          });
        }
        if (this.budgetData.length > 0) {
          this.budgetData.map((item, idx) => {
            if (item.Rm != "" && item.ReqPerson > 0) {
              budgetTxt +=
                  '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Expense_des +
                  "(" +
                  item.Rm +
                  ") &nbsp;&nbsp;  จำนวน &nbsp;&nbsp;" +
                  Vue.filter("currency")(item.ReqMoney) +
                  "  บาท X " +
                  item.ReqPerson +
                  " คน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(item.SumMoney) +
                  " บาท</span></p>";
            } else if (item.Rm != "" && item.ReqPerson == 0) {
              budgetTxt +=
                  '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Expense_des +
                  "(" +
                  item.Rm +
                  ") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  item.SumMoney +
                  "  บาท</span></p>";
            } else if (item.Rm == "" && item.ReqPerson > 0) {
              budgetTxt +=
                  '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Expense_des +
                  " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  จำนวน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(item.ReqMoney) +
                  "  บาท X " +
                  item.ReqPerson +
                  " คน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(item.SumMoney) +
                  " บาท</span></p>";
            } else if (item.Rm == "" && item.ReqPerson == 0) {
              budgetTxt +=
                  '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Expense_des +
                  " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(item.SumMoney) +
                  "  บาท</span></p>";
            } else {
              budgetTxt +=
                  '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Expense_des +
                  " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(item.SumMoney) +
                  "  บาท</span></p>";
            }
            if (idx == this.budgetData.length - 1) {
              budgetTxt +=
                  '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' +
                  " รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  Vue.filter("currency")(this.Expense) +
                  "  บาท</span></p>";
            }
          });
        }
        if (this.DateStart == "" || this.DateEnd == "") {
          this.editorData =
              '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' +
              this.projectGroupToShow +
              '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' +
              this.Project_name +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Objective +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.TargetGroup +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Location +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' +
              committeeTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' +
              lecturerTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' +
              budgetTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>';
          this.editorData2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลักการในการจัดโครงการอบรมเพื่อพัฒนาบุคลากรพร้อมงบประมาณค่าใช้จ่าย' +
              this.Project_name +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span style="font-family: Sarabun, sans-serif;margin-left: 80px">ด้วย ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " มีความประสงค์จะจัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)  เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "  ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "  พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span>" +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
          this.editorData3 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติ&nbsp; &nbsp;  &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; &nbsp;เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการฯ</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; เบิกจ่ายเงินค่าใช้จ่ายในการจัดโครงการอบรมเพื่อพัฒนาบุคลากร</div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ตามบันทึกข้อความที่ มอ 104.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ลงวันที่ ......................... ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " ได้รับอนุมัติหลักการให้จัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)&nbsp; เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "&nbsp; ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "&nbsp; พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span></span></span></span></span></span></span></p>" +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span></span></span></span><span lang="TH" ><span style="line-height:107%"><span style="font-family: Sarabun, sans-serif"><span style="color:black">บัดนี้&nbsp; การจัดโครงการดังกล่าวได้ดำเนินการเสร็จสิ้นแล้ว จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ</span></span></span></span></p>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการตามใบสรุปที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เบิกจ่ายเงินค่าใช้จ่ายโครงการฯ ตามรายละเอียดและหลักฐานการการจ่ายที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เป็นเงินจำนวนทั้งสิ้น .................. บาท (อักษรเงิน)&nbsp; ให้แก่</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล / ชื่อหน่วยงาน)&nbsp; ผู้ทดรองจ่าย&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล)&nbsp; ผู้ยืมเงิน&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท&nbsp; </span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">เพื่อชดใช้เงินยืมเลขที่ ......................................</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        } else {
          this.editorData =
              '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' +
              this.projectGroupToShow +
              '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' +
              this.Project_name +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Objective +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.TargetGroup +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' +
              Vue.filter("DateToThai")(this.DateStart) +
              "&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;" +
              Vue.filter("DateToThai")(this.DateEnd) +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Location +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' +
              committeeTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' +
              lecturerTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' +
              budgetTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;';
          this.editorData2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลักการในการจัดโครงการอบรมเพื่อพัฒนาบุคลากรพร้อมงบประมาณค่าใช้จ่าย' +
              this.Project_name +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span style="font-family: Sarabun, sans-serif;margin-left: 80px">ด้วย ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " มีความประสงค์จะจัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)  เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "  ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "  พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span>" +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
          this.editorData3 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติ&nbsp; &nbsp;  &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; &nbsp;เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการฯ</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; เบิกจ่ายเงินค่าใช้จ่ายในการจัดโครงการอบรมเพื่อพัฒนาบุคลากร</div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ตามบันทึกข้อความที่ มอ 104.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ลงวันที่ ......................... ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " ได้รับอนุมัติหลักการให้จัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)&nbsp; เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "&nbsp; ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "&nbsp; พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span></span></span></span></span></span></span></p>" +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span></span></span></span><span lang="TH" ><span style="line-height:107%"><span style="font-family: Sarabun, sans-serif"><span style="color:black">บัดนี้&nbsp; การจัดโครงการดังกล่าวได้ดำเนินการเสร็จสิ้นแล้ว จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ</span></span></span></span></p>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการตามใบสรุปที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เบิกจ่ายเงินค่าใช้จ่ายโครงการฯ ตามรายละเอียดและหลักฐานการการจ่ายที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เป็นเงินจำนวนทั้งสิ้น .................. บาท (อักษรเงิน)&nbsp; ให้แก่</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล / ชื่อหน่วยงาน)&nbsp; ผู้ทดรองจ่าย&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล)&nbsp; ผู้ยืมเงิน&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท&nbsp; </span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">เพื่อชดใช้เงินยืมเลขที่ ......................................</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        }
        this.isFormExec = true;
        this.editorDataDump = this.editorData;
        this.editorDataDump2 = this.editorData2;
        this.editorDataDump3 = this.editorData3;
      }
    },
    generateNewForm() {
      // var GroupExample = ''
      var committeeTxt = "";
      var lecturerTxt = "";
      var budgetTxt = "";
      if (this.Committee_ToShow.length > 0) {
        this.Committee_ToShow.map((item, idx) => {
          committeeTxt +=
              '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
              (idx + 1) +
              ". " +
              item.Name +
              "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
              item.Committee_des +
              "</span></p>";
        });
      }
      /*if (this.DataCondi.length > 0) {
        this.DataCondi.map((item, idx) => {
          if (item.workAgeStart != item.workAgeEnd) {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
          } else {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

          }
        })
      }*/
      if (this.LecturerToShow.length > 0) {
        this.LecturerToShow.map((item, idx) => {
          if (item.Perid != "") {
            if (
                this.levelData.filter((lv_i) => lv_i.LevelCode == item.pos_lv)
                    .length > 0
            ) {
              lecturerTxt +=
                  '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Name +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  item.pos_name +
                  this.levelData.filter(
                      (lv_i) => lv_i.LevelCode == item.pos_lv
                  )[0].LevelName +
                  "</span></p>";
            } else {
              lecturerTxt +=
                  '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                  (idx + 1) +
                  ". " +
                  item.Name +
                  "</span></p>";
            }
          } else {
            lecturerTxt +=
                '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Name +
                "</span></p>";
          }
        });
      }
      if (this.budgetData.length > 0) {
        this.budgetData.map((item, idx) => {
          if (item.Rm != "" && item.ReqPerson > 0) {
            budgetTxt +=
                '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Expense_des +
                "(" +
                item.Rm +
                ") &nbsp;&nbsp;  จำนวน &nbsp;&nbsp;" +
                Vue.filter("currency")(item.ReqMoney) +
                "  บาท X " +
                item.ReqPerson +
                " คน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.SumMoney) +
                " บาท</span></p>";
          } else if (item.Rm != "" && item.ReqPerson == 0) {
            budgetTxt +=
                '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Expense_des +
                "(" +
                item.Rm +
                ") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.SumMoney) +
                "  บาท</span></p>";
          } else if (item.Rm == "" && item.ReqPerson > 0) {
            budgetTxt +=
                '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Expense_des +
                " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  จำนวน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.ReqMoney) +
                "  บาท X " +
                item.ReqPerson +
                " คน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.SumMoney) +
                " บาท</span></p>";
          } else if (item.Rm == "" && item.ReqPerson == 0) {
            budgetTxt +=
                '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Expense_des +
                " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.SumMoney) +
                "  บาท</span></p>";
          } else {
            budgetTxt +=
                '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
                (idx + 1) +
                ". " +
                item.Expense_des +
                " &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(item.SumMoney) +
                "  บาท</span></p>";
          }
          if (idx == this.budgetData.length - 1) {
            budgetTxt +=
                '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' +
                " รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                Vue.filter("currency")(this.Expense) +
                "  บาท</span></p>";
          }
        });
      }
      if (this.DateStart == "" || this.DateEnd == "") {
        if (this.form1) {
          this.editorData =
              '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' +
              this.projectGroupToShow +
              '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' +
              this.Project_name +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Objective +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.TargetGroup +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Location +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' +
              committeeTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' +
              lecturerTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' +
              budgetTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>';
        } else if (this.form2) {
          this.editorData2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลักการในการจัดโครงการอบรมเพื่อพัฒนาบุคลากรพร้อมงบประมาณค่าใช้จ่าย' +
              this.Project_name +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span style="font-family: Sarabun, sans-serif;margin-left: 80px">ด้วย ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " มีความประสงค์จะจัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)  เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "  ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "  พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span>" +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        } else {
          this.editorData3 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติ&nbsp; &nbsp;  &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; &nbsp;เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการฯ</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; เบิกจ่ายเงินค่าใช้จ่ายในการจัดโครงการอบรมเพื่อพัฒนาบุคลากร</div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ตามบันทึกข้อความที่ มอ 104.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ลงวันที่ ......................... ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " ได้รับอนุมัติหลักการให้จัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)&nbsp; เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "&nbsp; ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "&nbsp; พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span></span></span></span></span></span></span></p>" +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span></span></span></span><span lang="TH" ><span style="line-height:107%"><span style="font-family: Sarabun, sans-serif"><span style="color:black">บัดนี้&nbsp; การจัดโครงการดังกล่าวได้ดำเนินการเสร็จสิ้นแล้ว จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ</span></span></span></span></p>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการตามใบสรุปที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เบิกจ่ายเงินค่าใช้จ่ายโครงการฯ ตามรายละเอียดและหลักฐานการการจ่ายที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เป็นเงินจำนวนทั้งสิ้น .................. บาท (อักษรเงิน)&nbsp; ให้แก่</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล / ชื่อหน่วยงาน)&nbsp; ผู้ทดรองจ่าย&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล)&nbsp; ผู้ยืมเงิน&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท&nbsp; </span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">เพื่อชดใช้เงินยืมเลขที่ ......................................</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        }
      } else {
        if (this.form1) {
          this.editorData =
              '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' +
              this.projectGroupToShow +
              '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' +
              this.Project_name +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Objective +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.TargetGroup +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' +
              Vue.filter("DateToThai")(this.DateStart) +
              "&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;" +
              Vue.filter("DateToThai")(this.DateEnd) +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Location +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' +
              committeeTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' +
              lecturerTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' +
              budgetTxt +
              '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>';
        } else if (this.form2) {
          this.editorData2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลักการในการจัดโครงการอบรมเพื่อพัฒนาบุคลากรพร้อมงบประมาณค่าใช้จ่าย' +
              this.Project_name +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span style="font-family: Sarabun, sans-serif;margin-left: 80px">ด้วย ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " มีความประสงค์จะจัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)  เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "  ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "  พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span>" +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        } else {
          this.editorData3 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="60" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              "</div>" +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              '</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 5px">..............................</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">มอ. 104</span> <span style="font-family: Sarabun, sans-serif;margin-left: 60px;font-weight: bold">/</span> <span style="font-family: Sarabun, sans-serif;margin-left: 80px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' +
              Vue.filter("DateToThai")(this.GetCurrentDate()) +
              "</span></div>" +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติ&nbsp; &nbsp;  &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; &nbsp;เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการฯ</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (&nbsp; &nbsp; )&nbsp; &nbsp; เบิกจ่ายเงินค่าใช้จ่ายในการจัดโครงการอบรมเพื่อพัฒนาบุคลากร</div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ตามบันทึกข้อความที่ มอ 104.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ลงวันที่ ......................... ' +
              (this.depart.filter((dep_item) => dep_item.dep_id == this.DepSelect)
                  .length > 0
                  ? this.depart.filter(
                      (dep_item) => dep_item.dep_id == this.DepSelect
                  )[0].dep_name
                  : "") +
              " ได้รับอนุมัติหลักการให้จัดโครงการอบรมเพื่อพัฒนา (แพทย์/พยาบาล/.....)&nbsp; เรื่อง " +
              this.Project_name +
              " วันที่ " +
              (this.DateStart == "" || this.DateEnd == ""
                  ? ""
                  : this.DateStart == this.DateEnd
                      ? Vue.filter("DateToThai")(this.DateStart)
                      : Vue.filter("DateToThai")(this.DateStart) +
                      " ถึง " +
                      Vue.filter("DateToThai")(this.DateEnd)) +
              "&nbsp; ณ " +
              this.Location +
              " ตามแผนงบประมาณรายจ่ายประจำปี รหัสโครงการที่ " +
              this.Project_code +
              "&nbsp; พร้อมงบประมาณค่าใช้จ่ายตามรายละเอียดโครงการที่แนบ นั้น</span></span></span></span></span></span></span></p>" +
              '<p style="margin-left: 30px"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span></span></span></span></span><span lang="TH" ><span style="line-height:107%"><span style="font-family: Sarabun, sans-serif"><span style="color:black">บัดนี้&nbsp; การจัดโครงการดังกล่าวได้ดำเนินการเสร็จสิ้นแล้ว จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ</span></span></span></span></p>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เปลี่ยนแปลงรายละเอียดและรายการค่าใช้จ่ายโครงการตามใบสรุปที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เบิกจ่ายเงินค่าใช้จ่ายโครงการฯ ตามรายละเอียดและหลักฐานการการจ่ายที่แนบ</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เป็นเงินจำนวนทั้งสิ้น .................. บาท (อักษรเงิน)&nbsp; ให้แก่</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล / ชื่อหน่วยงาน)&nbsp; ผู้ทดรองจ่าย&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp; )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (ชื่อ-สกุล)&nbsp; ผู้ยืมเงิน&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; จำนวน ................................... บาท&nbsp; </span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span <span style="text-justify:inter-cluster"><span style="line-height:normal"><span style="font-family:Sarabun, sans-serif"><span lang="TH" ><span style="font-family: Sarabun, sans-serif"><span style="color:black">เพื่อชดใช้เงินยืมเลขที่ ......................................</span></span></span></span></span></span></span></div>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 110px">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติด้วย จะเป็นพระคุณยิ่ง</span></p>' +
              '<div style="line-height: 2;margin-left: 30px;">&nbsp;</div>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 380px">(.............................................................)</span></p>' +
              '<p><span style="font-family: Sarabun, sans-serif;margin-left: 410px">หัวหน้าสาขาวิชา/หน่วยงาน</span></p>' +
              "</p>";
        }
      }
      // this.isFormExec = true
      // this.editorDataDump = this.editorData
      // this.editorDataDump2 = this.editorData2
    },
    FeedDataForm() {
      if (this.ProjectPlan != null) {
        this.dialogLoading = true;
        this.TemplateProject = [];
        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/" +
                this.ProjectPlan +
                "/active/1"
            )
            .then((res) => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.projectNeed = true;
                  this.TemplateProject = res.data;
                } else {
                  this.projectNeed = true;
                  this.TemplateProject.push(res.data);
                }
                if (this.TemplateProject.length > 0) {
                  if (this.form1) {
                    this.editorDataFormDB = this.TemplateProject[0].Template;
                    this.editorData = this.editorDataFormDB.replaceAll(
                        "&quot;",
                        '"'
                    );
                  } else if (this.form2) {
                    this.editorData2 =
                        this.TemplateProject.length > 0
                            ? this.TemplateProject[0].CoverSheet == null
                                ? ""
                                : this.TemplateProject[0].CoverSheet.replaceAll(
                                    "&quot;",
                                    '"'
                                )
                            : "";
                  } else {
                    this.editorData3 =
                        this.TemplateProject.length > 0
                            ? this.TemplateProject[0].Template2 == null
                                ? ""
                                : this.TemplateProject[0].Template2.replaceAll(
                                    "&quot;",
                                    '"'
                                )
                            : "";
                  }
                }
              } else {
                this.TemplateProject = [];
              }
              this.dialogLoading = false;
            })
            .catch((res) => {
              if (res) {
                this.dialogLoading = false;
                this.TemplateProject = [];
                this.$swal.fire({
                  icon: "error",
                  title: "ไม่พบข้อมูลแบบฟอร์มที่ถูกบันทึกไว้ในระบบ !!",
                });
              }
            });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาเลือกข้อมูลแผน !!",
        });
      }
    },
    ExecNewForm() {
      this.generateNewForm();
    },
    ClearForm() {
      if (this.form1) {
        this.editorData = this.editorDataDump;
      } else if (this.form2) {
        this.editorData2 = this.editorDataDump2;
      } else {
        this.editorData3 = this.editorDataDump3;
      }
    },
    DeleteCoordinator(param, idx) {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ",
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการลบข้อมูล",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                {
                  queryName: "deleteProjectCommittee",
                  param: btoa(
                      encodeURIComponent(
                          JSON.stringify({
                            id: param.id,
                            Committee_code: param.Committee_code,
                            Project_code: this.Project_code,
                            permiss_check: this.MeData[0].perid,
                          })
                      )
                  ),
                }
            ).then((res) => {
              if (res.data.status) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: "success",
                  title: "ลบข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                });

                this.Coordinator.splice(idx, 1);
                // Remove all matching WorkGroupData items (not just by index, but all that match)
                this.WorkGroupData = this.WorkGroupData.filter(
                  (workI) => !(workI.perid == param.Perid && param.Committee_code == workI.type)
                );
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่สามารถลบข้อมูลได้ โปรดตรวจสอบข้อมูลที่ลบอีกครั้ง !",
                });
              }
            }).catch((err) => {
              this.dialogLoading = false
              console.log(err);
            });
          }
        });
    },
    UpdateName() {
      switch (this.radioGroup) {
        case "0":
          this.staffData.map((item) => {
            if (item.perid == this.perid) {
              this.full_name = item.full_Name;
            }
          });
          break;
        case "1":
          this.studentData.map((item) => {
            if (item.STUDENT_ID == this.Idstudent) {
              this.full_name = item.STUD_NAME_THAI + " " + item.STUD_SNAME_THAI;
            }
          });
          break;
        case "2":
          this.personalMedData.map((item) => {
            if (item.STAFF_ID == this.IdPersonal) {
              this.full_name = item.FULL_NAME;
            }
          });
          break;
        case "3":
          this.studentUniData.map((item) => {
            if (item.STUDENT_ID == this.IdstudentUni) {
              this.full_name = item.STUD_NAME_THAI + " " + item.STUD_SNAME_THAI;
            }
          });
          break;
        case "4":
          if (this.NameP != "" && this.SurNameP != "") {
            this.full_name = this.NameP + " " + this.SurNameP;
          }
          break;
        case "5":
          if (this.NameStd != "" && this.SurNameStd != "") {
            this.full_name = this.NameStd + " " + this.SurNameStd;
          }
          break;
        default:
      }
    },
    InsertCoordinator(Condi) {
      var committ_desc = "";
      var CheckCupe = false;
      if (this.full_name != "" && this.Committee_code != "") {
        if ((this.Committee_code == "6" || this.Committee_code == "23" || this.Committee_code == "24") && !Condi) {
          if (this.radioGroup != "0") {
            if (this.committee_Posi.filter((commit_i) => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter((commit_i) => commit_i.Committee_code == this.Committee_code)[0].committee_des;
            }

            if (this.Coordinator.length > 0) {
              if (this.Coordinator.filter((CoorItem) =>CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code).length > 0) {
                this.$swal.fire({
                  icon: "error",
                  title: "ข้อมูลนี้ถูกเพิ่มไปแล้ว",
                });
              } else {
                this.AddCoordinator({
                  idx: this.Coordinator.length,
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: "",
                  TEL: this.phone,
                }, []).then((res) => {
                  if (res) {
                    this.chooseCommitteeType()
                  }
                });
              }
            } else {
                this.AddCoordinator({
                  idx: this.Coordinator.length,
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: "",
                  TEL: this.phone,
                }, []).then((res) => {
                  if (res) {
                    this.chooseCommitteeType()
                  }
                });
            }
          } else {
            this.dialogLecturer = true;
            this.LecturerProjectName = this.Project_name;
            this.LecturerHour = this.CalHourse;
            this.LecturerInvite = this.WorkByName;
            this.LecturerPlace = this.Location;
            this.dateSForLecturer = this.DateStart;
            this.dateEForLecturer = this.DateEnd;
          }
        } else {
          if ((this.Committee_code == "6" || this.Committee_code == "23" || this.Committee_code == "24") && this.Lecturer.length == 0) {
            this.$swal.fire({
              icon: "error",
              title: "กรุณากรอกข้อมูลการเป็นวิทยากร",
            });
          } else {
            this.dialogLecturer = false;
            // this.WorkGroupData = this.WorkGroupData.concat(this.Lecturer);

            if (this.committee_Posi.filter((commit_i) => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter((commit_i) => commit_i.Committee_code == this.Committee_code)[0].committee_des;
            }

            if (this.Coordinator.length > 0) {
              CheckCupe = false;
              this.Coordinator.map((CoorItem) => {
                if (
                    CoorItem.Name == this.full_name &&
                    CoorItem.Committee_code == this.Committee_code
                ) {
                  CheckCupe = true;
                }
              });
              if (CheckCupe) {
                this.$swal.fire({
                  icon: "error",
                  title:"พบข้อมูลรายชื่อ " + this.full_name + " และตำแหน่งที่เลือกในระบบอยู่แล้ว",
                });
              } else {
                this.AddCoordinator({
                  idx: this.Coordinator.length,
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: "",
                  TEL: this.phone,
                }, this.Lecturer).then((res) => {
                  if (res) {
                    this.chooseCommitteeType()
                    this.SubjectForLecturer = "";
                    this.dateSTravelForLecturer = "";
                    this.dateETravelForLecturer = "";
                    this.dateSForLecturer = "";
                    this.dateEForLecturer = "";
                    this.timeSForLecturer = "";
                    this.timeEForLecturer = "";
                    this.LecturerProjectName = "";
                    this.LecturerHour = "";
                    this.LecturerInvite = "";
                    this.LecturerPlace = "";
                    this.LecturerDocNo = "";
                    this.LecturerDateDocOut = "";
                    this.FileProjectExpert = [];
                    this.filesExpert = [];
                    this.txtAlertExpert = [];
                    this.Lecturer = [];
                  }
                })
              }
            } else {
              this.AddCoordinator({
                idx: this.Coordinator.length,
                Project_code: this.Project_code,
                Committee_code: this.Committee_code,
                Committee_type: this.radioGroup,
                Committee_des: committ_desc,
                Name: this.full_name,
                Perid: "",
                TEL: this.phone,
              }, this.Lecturer).then((res) => {
                if (res) {
                  this.chooseCommitteeType()
                  this.SubjectForLecturer = "";
                  this.dateSTravelForLecturer = "";
                  this.dateETravelForLecturer = "";
                  this.dateSForLecturer = "";
                  this.dateEForLecturer = "";
                  this.timeSForLecturer = "";
                  this.timeEForLecturer = "";
                  this.LecturerProjectName = "";
                  this.LecturerHour = "";
                  this.LecturerInvite = "";
                  this.LecturerPlace = "";
                  this.LecturerDocNo = "";
                  this.LecturerDateDocOut = "";
                  this.FileProjectExpert = [];
                  this.filesExpert = [];
                  this.txtAlertExpert = [];
                  this.Lecturer = [];
                }
              })
            }
          }
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณากรอกชื่อ-สกุล ตำแหน่ง,ข้อมูลคณะทำงานโครงการให้ครบถ้วน",
        });
      }
    },
    getCourseType() {
      console.log("Course");
      // if (this.Course_code == '') {
      //   this.course_group = ''
      //   this.Project_code = ''
      //   this.Period_code = 0
      //   this.CalHourse = 0
      //   this.CalCredit = 0
      // } else {
      //   this.courseData.map((item) => {
      //     if (item.Course_code == this.Course_code) {
      //       this.course_group = item.Course_type_des
      //       this.Project == null ? this.Project_code = ((parseInt(this.FiscalYear) + 543).toString().substring(2)) + '-' + this.Project_category + this.Project_type + this.IsPlan + '0-' + '???' : this.Project_code
      //       this.Period_code = item.Period_code
      //       this.CalHourse = item.Course_hour
      //       this.CalCredit = item.General_credit
      //     }
      //   })
      // }
    },
    CheckCourseClear() {
      this.course_group = "";
      this.Project_code = "";
      this.Period_code = "0";
      this.CalHourse = "0";
      this.CalCredit = "0";
    },
    DeleteDataCondi(DataCor) {
      // this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DataCondi.map((item, index) => {
        if (item.PosCode == DataCor.PosCode) {
          this.DataCondi.splice(index, 1);
        }
      });
    },
    DeleteDepQuotaCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count);
      this.DepQuotaData.map((item, index) => {
        if (item.dep_id == DataCor.dep_id) {
          this.DepQuotaData.splice(index, 1);
        }
      });
    },
    DataCondiFunc() {
      var CheckDupe = false;
      if (parseInt(this.workAgeStart_Condi) > parseInt(this.workAgeEnd_Condi)) {
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง",
        });
      } else if (this.workAgeStart_Condi == "" || this.workAgeEnd_Condi == "") {
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด โปรดกรอกอายุงานให้ครบถ้วน",
        });
      } else if (
          this.workAgeStart_Condi.length > 2 ||
          parseInt(this.workAgeStart_Condi) < 0 ||
          this.workAgeEnd_Condi.length > 2 ||
          parseInt(this.workAgeEnd_Condi) < 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง",
        });
      } else {
        this.DataCondi.map((item) => {
          if (item.PosCode == this.posiCondi) {
            if (
                this.workAgeStart_Condi >= item.workAgeStart &&
                this.workAgeStart_Condi <= item.workAgeEnd
            ) {
              CheckDupe = true;
            } else if (
                this.workAgeEnd_Condi >= item.workAgeStart &&
                this.workAgeEnd_Condi <= item.workAgeEnd
            ) {
              CheckDupe = true;
            }
          }
        });
        if (CheckDupe) {
          this.$swal.fire({
            icon: "error",
            title:
                "พบข้อผิดพลาด อายุงานที่เลือก มีในระบบอยู่แล้ว โปรดตรวจสอบข้อมูลอายุงาน",
          });
        } else {
          this.positions.map((item) => {
            if (item.PosCode == this.posiCondi) {
              this.DataCondi.push({
                ...item,
                workAgeStart: this.workAgeStart_Condi,
                workAgeEnd: this.workAgeEnd_Condi,
                WSYear: this.workAgeStart_Condi,
                WEYear: this.workAgeEnd_Condi,
              });
            }
          });
          this.posiCondi = "";
          this.levelCondi = "";
          this.workAgeStart_Condi = "";
          this.workAgeEnd_Condi = "";
          this.Course_Choose = "";
        }
      }
    },
    DeleteCourse(DataCourse) {
      this.courseCondi.map((item, index) => {
        if (item.Course_code == DataCourse.Course_code) {
          this.courseCondi.splice(index, 1);
        }
      });
    },
    CourseCondiFunc() {
      var CheckDupe = false;
      this.courseCondi.map((item) => {
        if (item.Course_code == this.ChooseCourse) {
          CheckDupe = true;
        }
      });
      if (CheckDupe) {
        this.$swal.fire({
          icon: "error",
          title: "มีข้อมูลหลักสูตรแล้ว ไม่สามารถเพิ่มข้อมูลได้อีก",
        });
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.ChooseCourse) {
            this.courseCondi.push(item);
          }
        });
        this.ChooseCourse = "";
      }
    },
    dateFunctionEvents(date) {
      const [, , day] = date.split("-");
      if ([12, 17, 28].includes(parseInt(day, 10))) return true;
      if ([1, 19, 22].includes(parseInt(day, 10))) return ["red", "#00f"];
      return false;
    },
    monthFunctionEvents(date) {
      const month = parseInt(date.split("-")[1], 10);
      if ([1, 3, 7].includes(month)) return true;
      if ([2, 5, 12].includes(month))
        return ["error", "purple", "rgba(0, 128, 0, 0.5)"];
      return false;
    },
    ExecInsertProject(Status) {
      return new Promise((resolve) => {
        if (this.ProjectPlan == null) {
          this.D_Project.Create_By = this.MeData[0].perid;
          this.D_Project.Create_Time = "now()";
          axios
              .post(
                  ConstData.ConnectionHost + "/app-api/v2/?/apis/hrtrain/D_project",
                  this.D_Project,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      "X-REST-METHOD": "PUT",
                    },
                  }
              )
              .then((res) => {
                if (res.data.status) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              })
              .catch((res) => {
                if (res) {
                  resolve(true);
                }
              });
        } else {
          // this.D_Project.IsPlan = '0'
          if (
              this.Project != null &&
              this.Project.Approve == "0" &&
              this.Project.IsPlanStatus == "4"
          ) {
            this.D_Project.IsPlanStatus = Status;
          }
          this.D_Project.Update_By = this.MeData[0].perid;
          axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
            queryName: "insertProject",
            param: btoa(encodeURIComponent(
                    JSON.stringify({
                      ...this.D_Project,
                      coordinator: this.Coordinator,
                      workgroup: this.WorkGroupData,
                      course: this.courseCondi,
                      condition: this.DataCondi,
                      depQuota: this.DepQuotaData,
                      fileProject: this.FileProject,
                      fileProjectOld: this.FileProjectOld,
                      // joinPerson: this.JoinPerson,
                      // roundData: this.RoundData,
                      // conpetency: this.selection,
                      permiss_check: this.MeData[0].perid,
                    })
                )
            ),
          })
              .then((res) => {
                if (res.data.status) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              })
              .catch((res) => {
                if (res) {
                  resolve(true);
                }
              });
        }
      });
    },
    ExecInsertTravel(Status, Ref_id) {
      return new Promise((resolve) => {
        this.D_Project.IsLog = Status == "1" ? "1" : "0";
        if (
            this.ProjectPlan == null ||
            (this.ProjectPlan != null && this.CheckProcess)
        ) {
          this.D_Project.Create_By = this.MeData[0].perid;
          this.D_Project.Create_Time = "now()";
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'insertTravelProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              Project: this.D_Project,
              Status: Status,
              permiss_check: this.MeData[0].perid,
              FileProject: this.FileProject,
              FileProjectOld: this.FileProjectOld,
              Ref_id: Ref_id,
            })))
          }).then((res) => {
            if (res.data.length > 0) {
              this.RecordData = [];
              this.FileProject = [];
              this.FileProjectOld = [];
              resolve({
                status: true,
                Project_code: res.data[0].Project_code,
              });
            } else {
              resolve(false);
            }
          }).catch((res) => {
            if (res) {
              resolve(false);
            }
          });
        } else {
          if (this.Project != null && this.Project.IsPlanStatus == "4") {
            this.D_Project.IsPlanStatus = Status;
          }
          this.D_Project.Update_By = this.MeData[0].perid;
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'updateTravelProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              Project: this.D_Project,
              Project_code: this.Project_code_dump,
              Status: Status,
              FileProject: this.FileProject,
              FileProjectOld: this.FileProjectOld,
              permiss_check: this.MeData[0].perid,
            })))
          }).then((res) => {
            if (res.data.status) {
              this.RecordData = [];
              this.FileProject = [];
              this.FileProjectOld = [];
              resolve({
                status: true,
                Project_code: this.Project_code_dump,
              });
            } else {
              resolve(false);
            }
          }).catch((res) => {
            if (res) {
              resolve(false);
            }
          });
        }
      });
    },
    ExecInsertLogTravel(ProjectCode, Status) {
      return new Promise((resolve) => {
        var param = {
          Project_code: ProjectCode,
          Type: "2",
          Status: Status,
          Remark: "",
          Date_Approve: this.getDateNowToDB(),
          Create_By: this.MeData[0].perid,
          Create_Time: "now()",
        };
        axios
            .post(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/D_project_record/",
                param,
                {
                  headers: {
                    "Content-Type": "application/json",
                    "X-REST-METHOD": "PUT",
                  },
                }
            )
            .then((res) => {
              if (res.data.status) {
                this.RecordData = [];
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((res) => {
              if (res) {
                resolve(false);
              }
            });
      });
    },
    insertTravelData(
        ProjectCode,
        Status,
        Project_name,
        credit,
        hour,
        Project_group,
        DateStart,
        DateEnd,
        IsProcess,
        IsExpense
    ) {
      var Ref_id = this.getRandomFileName();
      this.ExpenseSummary = this.Expense;
      this.CheckProjectCode(ProjectCode).then((res) => {
        if (res) {
          this.dialogLoading = false;
          this.btnDisable = false;
          this.$swal.fire({
            icon: "error",
            title: "พบข้อผิดพลาด",
            text:
                "ไม่สามารถใช้รหัสโครงการนี้ได้ เนื่องจากมีข้อมูลอยู่แล้ว โปรดติดต่อฝ่ายเทคโนโลยีสารสนเทศ !!",
          });
        } else {
          this.D_Project.Project_code = ProjectCode;
          this.D_Project.Project_name = Project_name;
          this.courseData.map((item) => {
            if (item.Course_code == this.Course_code) {
              this.D_Project.Course_code = item.Course_code;
              this.D_Project.course_group = item.Course_group;
            }
          });
          this.D_Project.Project_group = Project_group;
          this.D_Project.Project_group_other = this.txtProject_group;
          this.D_Project.IsProcess = IsProcess;
          this.D_Project.IsExpense = IsExpense;
          this.D_Project.Project_category = this.Project_category;
          this.D_Project.Project_type = this.Project_type;
          this.D_Project.Objective = this.Objective;
          this.D_Project.TargetGroup = this.TargetGroup;
          this.D_Project.Remarks = this.Remarks;
          this.D_Project.CalCredit = this.CalCredit;
          this.D_Project.CalHourse = this.CalHourse;
          this.D_Project.PLACE = this.PLACE;
          this.D_Project.Province_id = this.Province_id;
          this.D_Project.Country_id = this.Country_id;
          this.D_Project.BudgetRequest = this.BudgetRequest;
          this.D_Project.ExpenseSummary = this.ExpenseSummary;
          this.D_Project.Location = this.Location;
          this.D_Project.WorkBy = this.WorkBy;
          this.D_Project.WorkByName = this.WorkByName;
          this.D_Project.WorkByPhone = this.WorkByPhone;
          this.D_Project.DateStart = DateStart;
          this.D_Project.DateEnd = DateEnd;
          this.D_Project.Approve = this.ApproveRadio;
          this.D_Project.FiscalYear = this.FiscalYear;
          this.D_Project.IsPlan = this.IsPlan;
          // this.D_Project.Status = Status == '1' ? this.Project.Status : Status
          this.D_Project.Status = this.Status == "1" ? this.Status : Status;
          this.D_Project.IsPlanStatus = Status;
          // this.D_Project.IsLog = this.Status == '1' ? '1' : '0'
          this.D_Project.IsLog = this.IsLog;
          this.D_Project.Status_Reg = this.ChooseTypRegis;
          this.D_Project.Status_Type_Reg = this.ChooseTypRegis2;
          this.D_Project.Status_Type_Reg2 = this.ChooseTypRegis3;
          this.D_Project.DateS_Reg = this.dateRegStart;
          this.D_Project.DateE_Reg = this.dateRegEnd;
          if (this.ChkJoinPerson) {
            this.D_Project.Status_Count_Reg = "1";
          } else {
            this.D_Project.Status_Count_Reg = "0";
          }
          this.D_Project.Count_Reg = this.ProjectQuotaCount;
          this.D_Project.Dep_Code = this.DepSelect;
          this.D_Project.Approve = "1";

          if (this.roundNeed) {
            this.D_Project.IsRoundStatus = "1";
          } else {
            this.D_Project.IsRoundStatus = "0";
          }
          this.ExecInsertTravel(Status, Ref_id).then(async (resExec) => {
            if (resExec.status) {
              ProjectCode = resExec.Project_code;
              this.insertTravelDataToDb(
                  ProjectCode,
                  Project_name,
                  credit,
                  hour,
                  Project_group,
                  DateStart,
                  DateEnd
              ).then((resForm) => {
                if (resForm) {
                  this.AddCompetency(ProjectCode).then(resCompre => {
                    if (resCompre) {
                      if (
                          Status == "1" &&
                          this.Project_type == "2" &&
                          this.IsProcess == "3" &&
                          this.IsExpense == "0"
                      ) {
                        this.initApproveMasterByType({
                          type: "1",
                        }).then((res) => {
                          if (res) {
                            if (this.ApproveMaster.length > 0) {
                              var SendMailApprove = this.ApproveMaster.filter(
                                  (Approveitem) =>
                                      Approveitem.type == "1" &&
                                      Approveitem.sendmail == "1" &&
                                      Approveitem.readonly == "0" &&
                                      Approveitem.project_type != "1"
                              );
                              if (SendMailApprove.length > 0) {
                                SendMailApprove.map((SendMailI) => {
                                  this.SendMailApproveForHR(
                                      SendMailI.perid,
                                      this.MeData[0].perid,
                                      ProjectCode,
                                      this.Project_name
                                  );
                                });
                              }
                            }
                          }
                        });
                      } else {
                        this.execProcessSendMail(
                            "1",
                            this.DepSelect != null
                                ? this.DepSelect
                                : null,
                            null,
                            this.MeData[0].perid,
                            ProjectCode,
                            this.Project_name
                        );
                      }

                      this.selProjFiscalYear()
                      this.clearTravel(ProjectCode)
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        title: "พบข้อผิดพลาด ในการบันทึกข้อมูล โปรดติดต่อผู้ดูแลระบบ",
                      });
                    }
                  })
                }
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "พบข้อผิดพลาด",
                text: "ไม่สามารถบันทึกข้อมูลได้",
              });

              this.dialogLoading = false;
              this.btnDisable = false;

              // this.DepSelect = ''
              this.Project_code = "";
              this.Project_name = "";
              this.Course_code = null;
              this.course_group = "";
              this.Project_group = null;
              this.txtProject_group = "";
              this.Objective = "";
              this.TargetGroup = "";
              this.Remarks = "";
              this.WorkBy = "";
              this.WorkByName = "";
              this.WorkByPhone = "";
              this.Location = "";
              this.DateStart = "";
              this.DateEnd = "";
              this.CalHourse = "0";
              this.CalCredit = "0";
              this.PLACE = "";
              this.Province_id = null;
              this.Country_id = null;
              this.BudgetRequest = "0";
              this.ExpenseSummary = 0;
              this.ChooseTypeDep = "0";
              this.ChooseTypRegis = "1";
              this.ChooseTypRegis2 = "0";
              this.ChooseTypRegis3 = "0";
              this.dateRegStart = "";
              this.dateRegEnd = "";
              this.ProjectQuotaCount = "";
              this.ProjectQuotaDepCount = 0;
              this.MessageSuc = "";
              this.MessageError = "";
              this.ChkJoinPerson = true;
              this.ShowAlertErr = false;
              this.ShowAlertSuc = false;
              this.DepQuotaSelect = "";
              this.DepQuotaCount = "";
              this.FiscalYear =
                  this.FiscalYearData.length > 0
                      ? this.FiscalYearData[this.FiscalYearData.length - 1].year
                      : null;
              this.files = [];
              this.ProjectPlan = null;
              this.roundNeed = false;
              this.IsProcess = null;
              this.Project_category = "1";
              this.Project_type = this.TypeProject;
              this.IsPlan = "0";
              this.IsLog = "0";
              this.CheckProcess = true;
              // travel ----
              this.departName = "";
              this.IsExpense = null;
              this.Project_group = null;
              this.PLACE = "";
              this.BudgetRequest = "0";
              this.WorkBy = "";
              this.dateRegS = "";
              this.dateRegE = "";
              this.WorkByName = "";
              this.Location = "";
              this.WorkByPhone = "";
              this.phone2 = "";
              this.mororNumber = "";
              this.docDate = "";
              this.topic = "";
              this.dear = "";
              this.detail = "";
              this.note = "";
              this.peridSave = null;
              this.nameSave = "";
              this.positionSave = "";
              this.peridApprove = null;
              this.nameApprove = "";
              this.positionApprove = "";
              this.CheckProcess = true;
              this.formId = null;
              this.rdoTypeJoinTravel = "1";
              this.JoinTravel = [];
            }
          });
        }
      });
    },
    clearTravel(ProjectCode) {
      this.init();
      // this.showReport(ProjectCode);
      this.$swal.fire({
        icon: "success",
        title: "บันทึกข้อมูลสำเร็จ",
        text: "รหัสโครงการ : " + ProjectCode,
      });

      this.dialogLoading = false;
      this.btnDisable = false;

      this.e1 = "1";

      // this.DepSelect = ''
      this.Period_code = "";
      this.Project_code = "";
      this.Project_name = "";
      this.Course_code = null;
      this.course_group = "";
      this.Project_group = null;
      this.txtProject_group = "";
      this.Objective = "";
      this.TargetGroup = "";
      this.Remarks = "";
      this.WorkBy = "";
      this.WorkByName = "";
      this.WorkByPhone = "";
      this.Location = "";
      this.DateStart = "";
      this.DateEnd = "";
      this.CalHourse = "0";
      this.CalCredit = "0";
      this.PLACE = "";
      this.Province_id = null;
      this.Country_id = null;
      this.BudgetRequest = "0";
      this.ExpenseSummary = 0;
      this.Expense = 0;
      this.ChooseTypeDep = "0";
      this.ChooseTypRegis = "1";
      this.ChooseTypRegis2 = "0";
      this.ChooseTypRegis3 = "0";
      this.dateRegStart = "";
      this.dateRegEnd = "";
      this.ProjectQuotaCount = "";
      this.ProjectQuotaDepCount = 0;
      this.MessageSuc = "";
      this.MessageError = "";
      this.ChkJoinPerson = true;
      this.ShowAlertErr = false;
      this.ShowAlertSuc = false;
      this.DepQuotaSelect = "";
      this.DepQuotaCount = "";
      this.FiscalYear =
          this.FiscalYearData.length > 0
              ? this.FiscalYearData[this.FiscalYearData.length - 1].year
              : null;
      this.files = [];
      this.DataCondi = [];
      this.ProjectPlan = null;
      this.Project_plan = [];
      this.roundNeed = false;
      this.IsProcess = null;
      this.Project_category = "1";
      this.Project_type = this.TypeProject;
      this.IsPlan = "0";
      this.IsLog = "0";
      // travel ----
      this.departName = "";
      this.IsExpense = null;
      this.Project_group = null;
      this.PLACE = "";
      this.BudgetRequest = "0";
      this.WorkBy = "";
      this.dateRegS = "";
      this.dateRegE = "";
      this.WorkByName = "";
      this.Location = "";
      this.WorkByPhone = "";
      this.phone2 = "";
      this.mororNumber = "";
      this.docDate = "";
      this.topic = "";
      this.dear = "";
      this.detail = "";
      this.note = "";
      this.peridSave = null;
      this.nameSave = "";
      this.positionSave = "";
      this.peridApprove = null;
      this.nameApprove = "";
      this.positionApprove = "";
      this.CheckProcess = true;
      this.formId = null;
      this.rdoTypeJoinTravel = "1";
      this.JoinTravel = [];
    },
    insertData(ProjectCode, Status) {
      /* var Ref_id = this.getRandomFileName();
      // var Project_code = this.Project_code
      var Project_group = this.Project_group;
      var Project_name = this.Project_name;
      var DateStart = this.DateStart;
      var DateEnd = this.DateEnd; */
      this.ExpenseSummary = this.Expense;
      this.CheckProjectCode(ProjectCode).then((res) => {
        if (res) {
          this.dialogLoading = false;
          this.btnDisable = false;
          this.$swal.fire({
            icon: "error",
            title: "พบข้อผิดพลาด",
            text:
                "ไม่สามารถใช้รหัสโครงการนี้ได้ เนื่องจากมีข้อมูลอยู่แล้ว โปรดติดต่อฝ่ายเทคโนโลยีสารสนเทศ !!",
          });
        } else {
          this.D_Project.Project_code = ProjectCode;
          this.D_Project.Project_name = this.Project_name;
          this.courseData.map((item) => {
            if (item.Course_code == this.Course_code) {
              this.D_Project.Course_code = item.Course_code;
              this.D_Project.course_group = item.Course_group;
            }
          });
          this.D_Project.Project_group = this.Project_group;
          this.D_Project.Project_group_other = this.txtProject_group;
          this.D_Project.IsProcess = this.IsProcess;
          this.D_Project.Project_category = this.Project_category;
          this.D_Project.Project_type = this.Project_type;
          this.D_Project.Objective = this.Objective;
          this.D_Project.TargetGroup = this.TargetGroup;
          this.D_Project.Remarks = this.Remarks;
          this.D_Project.CalCredit = this.CalCredit;
          this.D_Project.CalHourse = this.CalHourse;
          this.D_Project.PLACE = this.PLACE;
          this.D_Project.Province_id = this.Province_id;
          this.D_Project.Country_id = this.Country_id;
          this.D_Project.BudgetRequest = this.BudgetRequest;
          this.D_Project.ExpenseSummary = this.ExpenseSummary;
          this.D_Project.Location = this.Location;
          this.D_Project.WorkBy = this.WorkBy;
          this.D_Project.WorkByName = this.WorkByName;
          this.D_Project.WorkByPhone = this.WorkByPhone;
          this.D_Project.DateStart = this.DateStart;
          this.D_Project.DateEnd = this.DateEnd;
          this.D_Project.Approve = this.ApproveRadio;
          this.D_Project.FiscalYear = this.FiscalYear;
          this.D_Project.IsPlan = this.IsPlan;
          // this.D_Project.Status = Status == '1' ? this.Project.Status : Status
          this.D_Project.Status = this.Status == "1" ? this.Status : Status;
          // this.D_Project.IsLog = this.Status == '1' ? '1' : '0'
          this.D_Project.IsLog = this.IsLog;
          this.D_Project.Status_Reg = this.ChooseTypRegis;
          this.D_Project.Status_Type_Reg = this.ChooseTypRegis2;
          this.D_Project.Status_Type_Reg2 = this.ChooseTypRegis3;
          this.D_Project.DateS_Reg = this.dateRegStart;
          this.D_Project.DateE_Reg = this.dateRegEnd;
          if (this.ChkJoinPerson) {
            this.D_Project.Status_Count_Reg = "1";
          } else {
            this.D_Project.Status_Count_Reg = "0";
          }
          this.D_Project.Count_Reg = this.ProjectQuotaCount;
          this.D_Project.Dep_Code = this.DepSelect;

          if (this.roundNeed) {
            this.D_Project.IsRoundStatus = "1";
          } else {
            this.D_Project.IsRoundStatus = "0";
          }

          /*รอปรับ บันทึกข้อมูลผ่าน serviceAPI*/
          /*axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'saveProjectData',
            param: btoa(encodeURIComponent(JSON.stringify({
              method: this.ProjectPlan == null ? 'insert' : 'update',
              Status: Status,
              Project: this.D_Project,
              Project_code_dump: this.Project_code_dump,
              Committee: this.Coordinator,
              Lecturer: this.WorkGroupData,
              Template: this.editorData,
              Template2: this.editorData3,
              CoverSheet: this.editorData2,
              Budget: this.budgetData,
              DepQuota: this.DepQuotaData,
              File: this.FileProject,
              FileOld: this.FileProjectOld,
              JoinPerson: this.JoinPerson,
              RoundData: this.RoundData,
              IsRound: this.roundNeed,
            })))
          })

          console.log(Ref_id)
          console.log(Project_group)
          console.log(Project_name)
          console.log(DateStart)
          console.log(DateEnd)*/

          this.ExecInsertProject(Status).then(async (resExec) => {
            if (resExec) {
                if (this.TypeInsertProject == "0") {
                  this.AddCompetency(ProjectCode);
                }

                if (Status == "1" && (this.Project_type == "1" || (this.Project_type == "2" && (this.IsProcess == "1" || this.IsProcess =="3")))) {
                  this.initApproveMasterByType(
                    {
                      type: this
                        .Project
                        .Project_category,
                    }
                  ).then(
                    (res) => {
                      if (res) {
                        if (this.ApproveMaster.length > 0) {
                          var SendMailApprove = this.ApproveMaster.filter((Approveitem) => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == "1" && Approveitem.readonly =="0");
                          if (SendMailApprove.length > 0) {
                            SendMailApprove.map((SendMailI) => {
                              this.SendMail(SendMailI);
                            });
                          }
                        }
                      }
                    });
                }

                if (Status == "1") {
                  axios.post(ConstData.ConnectionHost + "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" + ProjectCode,
                    {
                      IsLog: "1",
                      Update_By: this
                        .MeData[0]
                        .perid,
                    },
                    {
                      headers: {
                        "Content-Type":
                          "application/json",
                      },
                    }
                  );
                }

                this.initProjectDataForApprove(
                  {
                    perid: this
                      .MeData[0]
                      .perid,
                  }
                ).then((res) => {
                  if (res) {
                    this.init();
                    this.$swal.fire(
                      {
                        icon:
                          "success",
                        title:
                          "บันทึกข้อมูลสำเร็จ",
                      }
                    );

                    this.dialogLoading = false;
                    this.btnDisable = false;

                    this.e1 = "1";

                    // this.DepSelect = ''
                    this.Period_code = "";
                    this.Project_code = "";
                    this.Project_name = "";
                    this.Course_code = null;
                    this.course_group = "";
                    this.Project_group = null;
                    this.txtProject_group = "";
                    this.Objective = "";
                    this.TargetGroup = "";
                    this.Remarks = "";
                    this.WorkBy = "";
                    this.WorkByName = "";
                    this.WorkByPhone = "";
                    this.Location = "";
                    this.DateStart = "";
                    this.DateEnd = "";
                    this.CalHourse = "0";
                    this.CalCredit = "0";
                    this.PLACE = "";
                    this.Province_id = null;
                    this.Country_id = null;
                    this.BudgetRequest = "0";
                    this.ExpenseSummary = 0;
                    this.Expense = 0;
                    this.ChooseTypeDep = "0";
                    this.ChooseTypRegis = "1";
                    this.ChooseTypRegis2 = "0";
                    this.ChooseTypRegis3 = "0";
                    this.dateRegStart = "";
                    this.dateRegEnd = "";
                    this.ProjectQuotaCount = "";
                    this.ProjectQuotaDepCount = 0;
                    this.MessageSuc = "";
                    this.MessageError = "";
                    this.ChkJoinPerson = true;
                    this.ShowAlertErr = false;
                    this.ShowAlertSuc = false;
                    this.DepQuotaSelect = "";
                    this.DepQuotaCount = "";
                    this.FiscalYear =  this.FiscalYearData.length > 0 ? this.FiscalYearData[this.FiscalYearData.length - 1].year: null;
                    this.files = [];
                    this.DataCondi = [];
                    this.ProjectPlan = null;
                    this.Project_plan = [];
                    this.roundNeed = false;
                    this.IsProcess = null;
                    this.Project_category = "1";
                    this.Project_type = this.TypeProject;
                    this.IsPlan = "0";
                    this.IsLog = "0";
                    this.CheckProcess = true;
                    this.satisfaction = 0
                    this.Knowledge_before = 0
                    this.Knowledge_after = 0
                  }
                });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "พบข้อผิดพลาด",
                text: "ไม่สามารถบันทึกข้อมูลได้",
              });

              this.dialogLoading = false;
              this.btnDisable = false;

              // this.DepSelect = ''
              this.Project_code = "";
              this.Project_name = "";
              this.Course_code = null;
              this.course_group = "";
              this.Project_group = null;
              this.txtProject_group = "";
              this.Objective = "";
              this.TargetGroup = "";
              this.Remarks = "";
              this.WorkBy = "";
              this.WorkByName = "";
              this.WorkByPhone = "";
              this.Location = "";
              this.DateStart = "";
              this.DateEnd = "";
              this.CalHourse = "0";
              this.CalCredit = "0";
              this.PLACE = "";
              this.Province_id = null;
              this.Country_id = null;
              this.BudgetRequest = "0";
              this.ExpenseSummary = 0;
              this.ChooseTypeDep = "0";
              this.ChooseTypRegis = "1";
              this.ChooseTypRegis2 = "0";
              this.ChooseTypRegis3 = "0";
              this.dateRegStart = "";
              this.dateRegEnd = "";
              this.ProjectQuotaCount = "";
              this.ProjectQuotaDepCount = 0;
              this.MessageSuc = "";
              this.MessageError = "";
              this.ChkJoinPerson = true;
              this.ShowAlertErr = false;
              this.ShowAlertSuc = false;
              this.DepQuotaSelect = "";
              this.DepQuotaCount = "";
              this.FiscalYear =
                  this.FiscalYearData.length > 0
                      ? this.FiscalYearData[this.FiscalYearData.length - 1].year
                      : null;
              this.files = [];
              this.ProjectPlan = null;
              this.roundNeed = false;
              this.IsProcess = null;
              this.Project_category = "1";
              this.Project_type = this.TypeProject;
              this.IsPlan = "0";
              this.IsLog = "0";
              this.CheckProcess = true;
              this.satisfaction = 0
              this.Knowledge_before = 0
              this.Knowledge_after = 0
            }
          });
        }
      });
    },
    CheckProjectCode(ProjectCode) {
      return new Promise((resolve) => {
        if (this.Project == null) {
          axios
              .get(
                  ConstData.ConnectionHost +
                  "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" +
                  ProjectCode
              )
              .then((res) => {
                if (res.data) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
        } else {
          resolve(false);
        }
      });
    },
    insertTravelProject(Status) {
      this.initMeData().then((res) => {
        if (res) {
          this.$swal
              .fire({
                title: "ยืนยันการทำรายการ",
                text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยัน",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((result) => {
                if (result.value) {
                  this.dialogLoading = true;
                  this.btnDisable = true;
                  this.CheckPermission().then((resPermiss) => {
                    if (resPermiss) {
                      if (
                          this.Project_name == "" ||
                          this.Project_group == null ||
                          this.PLACE == "" ||
                          this.WorkBy == "" ||
                          this.WorkByName == "" ||
                          this.Location == "" ||
                          this.dateRegS == "" ||
                          this.dateRegE == "" ||
                          this.BudgetRequest == "" ||
                          this.CalCredit == "" ||
                          this.CalHourse == "" ||
                          this.DepSelect == null
                      ) {
                        /*console.log('this.Project_code = ' + this.Project_code)
                    console.log('this.Project_name = ' + this.Project_name)
                    console.log('this.Project_group = ' + this.Project_group)
                    console.log('this.PLACE = ' + this.PLACE)
                    console.log('this.WorkBy = ' + this.WorkBy)
                    console.log('this.WorkByName = ' + this.WorkByName)
                    console.log('this.Location = ' + this.Location)
                    console.log('this.dateRegS = ' + this.dateRegS)
                    console.log('this.dateRegE = ' + this.dateRegE)
                    console.log('this.BudgetRequest = ' + this.BudgetRequest)
                    console.log('this.CalCredit = ' + this.CalCredit)
                    console.log('this.CalHourse = ' + this.CalHourse)
                    console.log('this.DepSelect = ' + this.DepSelect)*/
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาด",
                          text: "โปรดกรอกข้อมูลให้ครบถ้วน",
                        });
                        this.dialogLoading = false;
                        this.btnDisable = false;
                      } else if (this.PLACE == "2" && this.Province_id == null) {
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาด",
                          text: "โปรดกรอกข้อมูลจังหวัด",
                        });
                        this.dialogLoading = false;
                        this.btnDisable = false;
                      } else if (this.PLACE == "3" && this.Country_id == null) {
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาด",
                          text: "โปรดกรอกข้อมูลประเทศ",
                        });
                        this.dialogLoading = false;
                        this.btnDisable = false;
                      } else if (
                          this.Project_group == "999" &&
                          this.txtProject_group == ""
                      ) {
                        this.$swal.fire({
                          icon: "error",
                          title: "พบข้อผิดพลาด",
                          text: "โปรดกรอกรายละเอียดประเภทการปฏิบัติงาน",
                        });
                        this.dialogLoading = false;
                        this.btnDisable = false;
                      } else if (this.Project_name == "") {
                        this.dialogLoading = false;
                        this.btnDisable = false;
                        this.tabsTravel = 1;
                        this.$refs.Project_name.$refs.input.focus();
                      } else if (this.IsProcess == null) {
                        this.dialogLoading = false;
                        this.btnDisable = false;
                        this.tabsTravel = 1;
                        this.$refs.IsProcess.$refs.input.focus();
                      } else if (this.IsExpense == null) {
                        this.dialogLoading = false;
                        this.btnDisable = false;
                        this.tabsTravel = 1;
                        this.$refs.IsExpense.$refs.input.focus();
                      } else if (this.selection.length == 0) {
                        this.dialogLoading = false;
                        this.btnDisable = false;
                        this.tabsTravel = 1;
                        this.$swal.fire({
                          icon: "error",
                          title:
                              "กรุณาระบุ ค่าสมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์",
                        });
                      } else {
                        this.Project_code =
                            (parseInt(this.FiscalYear) + 543)
                                .toString()
                                .substring(2) +
                            "-" +
                            (this.Project_type == "1"
                                ? this.Project_category
                                : this.IsProcess) +
                            this.Project_type +
                            this.IsExpense + '1';

                              if (this.ProjectPlan != null && !this.CheckProcess) {
                                this.Project_code = this.Project_code_dump;
                              }
                              // this.insertTravelData(this.Project_code, Status)
                              this.insertTravelData(
                                  this.Project_code,
                                  Status,
                                  this.Project_name,
                                  this.CalCredit,
                                  this.CalHourse,
                                  this.Project_group,
                                  this.dateRegS,
                                  this.dateRegE,
                                  this.IsProcess,
                                  this.IsExpense
                              );

                      }
                    } else {
                      this.dialogLoading = false;
                      this.btnDisable = false;
                      this.$swal.fire({
                        icon: "error",
                        title:
                            "ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้",
                      });
                    }
                  });
                }
              });
        }
      });
    },
    insertProject(Status) {
      this.$swal
          .fire({
            title: "ยืนยันการทำรายการ",
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยัน",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.value) {
              // ตรวจสอบว่า budgetData มีข้อมูลหรือไม่ หากมี ให้กลับไป step 3 และ ให้ focus ที่ปุ่ม btnSaveHistoryExpense
              if (this.budgetData.length > 0) {
                this.$swal.fire({
                  icon: "warning",
                  title: "กรุณาบันทึกข้อมูลค่าใช้จ่าย",
                  text: "คุณมีข้อมูลค่าใช้จ่ายที่ยังไม่ได้บันทึก โปรดบันทึกก่อนดำเนินการต่อ",
                });
                this.e1 = 4;
                this.$refs.btnSaveHistoryExpense.$el.focus();
                //  this.$refs.staffSel.$refs.input.focus();
                return;
              } else {
                this.dialogLoading = true;
                this.btnDisable = true;
                var IsCheckProjectCode = false;
                this.CheckPermission().then((resPermiss) => {
                  if (resPermiss) {
                    this.Project_code =
                        (parseInt(this.FiscalYear) + 543).toString().substring(2) +
                        "-" +
                        this.Project_category +
                        this.Project_type +
                        this.IsPlan +
                        "0-0001";
                    axios
                        .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                          queryName: "getProjectCode",
                          param: {
                            id:
                                (parseInt(this.FiscalYear) + 543)
                                    .toString()
                                    .substring(2) +
                                "-" +
                                this.Project_category +
                                this.Project_type +
                                this.IsPlan +
                                "1",
                          },
                        })
                        .then((res) => {
                          if (res.data) {
                            if (this.Project == null) {
                              this.Project_code = res.data[0].Project_code;
                            }
                          }
  
                          if (this.ProjectPlan != null) {
                            this.Project_code = this.Project_code_dump;
                          }
  
                          if (
                              this.Project_code == "" ||
                              this.Project_name == "" ||
                              this.Project_group == null ||
                              this.PLACE == "" ||
                              this.WorkBy == "" ||
                              this.WorkByName == "" ||
                              this.Location == "" ||
                              this.DateStart == "" ||
                              this.DateEnd == "" ||
                              this.BudgetRequest == "" ||
                              this.CalCredit == "" ||
                              this.CalHourse == "" ||
                              this.DepSelect == null ||
                              this.Objective == "" ||
                              (this.ProjectPlan == null && this.TargetGroup == "")
                          ) {
                            /*console.log('Project_code = ' + this.Project_code + ' ' + (this.Project_code == ''))
                    console.log('Project_name = ' + this.Project_name + ' ' + (this.Project_name == ''))
                    console.log('Project_group = ' + this.Project_group + ' ' + (this.Project_group == ''))
                    console.log('PLACE = ' + this.PLACE + ' ' + (this.PLACE == ''))
                    console.log('WorkBy = ' + this.WorkBy + ' ' + (this.WorkBy == ''))
                    console.log('WorkByName = ' + this.WorkByName + ' ' + (this.WorkByName == ''))
                    console.log('WorkByPhone = ' + this.WorkByPhone + ' ' + (this.WorkByPhone == ''))
                    console.log('Location = ' + this.Location + ' ' + (this.Location == ''))
                    console.log('BudgetRequest = ' + this.BudgetRequest + ' ' + (this.BudgetRequest == ''))
                    console.log('DateStart = ' + this.DateStart + ' ' + (this.DateStart == ''))
                    console.log('DateEnd = ' + this.DateEnd + ' ' + (this.DateEnd == ''))
                    console.log('CalCredit = ' + this.CalCredit + ' ' + (this.CalCredit == ''))
                    console.log('CalHourse = ' + this.CalHourse + ' ' + (this.CalHourse == ''))
                    console.log('DepSelect = ' + this.DepSelect + ' ' + (this.DepSelect == ''))
                    console.log('Objective = ' + this.Objective + ' ' + (this.Objective == ''))
                    console.log('IsPlan = ' + this.IsPlan + ' ' + (this.IsPlan == ''))
                    console.log('Project_category = ' + this.Project_category + ' ' + (this.Project_category == ''))
                    console.log('IsProcess = ' + this.IsProcess + ' ' + (this.IsProcess == ''))
                    console.log('Project_type = ' + this.Project_type + ' ' + (this.Project_type == ''))*/
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "โปรดกรอกข้อมูลให้ครบถ้วน",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                            // } else if (this.Project_group == '101' || this.Project_group == '102' || this.Project_group == '103' || this.Project_group == '104') {
                            //   if (this.Course_code == null || this.Course_code == '') {
                            //     this.$swal.fire({
                            //       icon: 'error',
                            //       title: 'พบข้อผิดพลาด',
                            //       text: 'เลือกประเภทโครงการ : จัดบริหารวิชาการ,จัดพัฒนาบุคลากร เงื่อนไขหลักสูตรต้องห้ามว่าง',
                            //     })
                            //     this.btnDisable = false
                            //   } else {
                            //     this.insertData(this.Project_code, Status)
                            //   }
                          } else if (this.PLACE == "2" && this.Province_id == null) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "โปรดกรอกข้อมูลจังหวัด",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                          } else if (this.PLACE == "3" && this.Country_id == null) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "โปรดกรอกข้อมูลประเทศ",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                          } else if (
                              !this.roundNeed &&
                              this.ChooseTypRegis == "0" &&
                              (this.dateRegStart == "" || this.dateRegEnd == "")
                          ) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "โปรดกรอกข้อมูล วันที่เปิด - ปิด รับสมัคร",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                          } else if (
                              !this.ChkJoinPerson &&
                              (this.ProjectQuotaCount == "" ||
                                  parseInt(this.ProjectQuotaCount) == 0)
                          ) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "โปรดกรอกจำนวนผู้เข้าร่วมโครงการ",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                          } else if (this.Project == null && !IsCheckProjectCode) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text:
                                  "ไม่สามารถใช้รหัสแผนได้ โปรดติดต่อฝ่ายเทคโนโลยีสารสนเทศ!!",
                            });
                            this.btnDisable = false;
                          } else {
                            this.insertData(this.Project_code, Status);
                          }
                        })
                        .catch((res) => {
                          if (res) {
                            this.$swal.fire({
                              icon: "error",
                              title: "พบข้อผิดพลาด",
                              text: "ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
                            });
                            this.dialogLoading = false;
                            this.btnDisable = false;
                          }
                        });
                  } else {
                    this.dialogLoading = false;
                    this.btnDisable = false;
                    this.$swal.fire({
                      icon: "error",
                      title: "ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้",
                    });
                  }
                });
              }
            }
          });
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    AddLogCompetency(ProjectCode, Ref_id_edit) {
      const headerAxiosPUT = {
        headers: {
          "Content-Type": "application/json",
          "X-REST-METHOD": "PUT",
        },
      };
      return new Promise((resolve) => {
        if (this.logSelection.length > 0) {
          for (var i = 0; i <= this.logSelection.length - 1; i++) {
            this.CompetencyData.map((root) => {
              if (root.children.length > 0) {
                root.children.map((child1) => {
                  if (child1.children.length > 0) {
                    child1.children.map((child2) => {
                      if (child2.id == this.logSelection[i]) {
                        axios.post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/Log_D_project_competency/",
                            {
                              Ref_id: Ref_id_edit,
                              Project_code: ProjectCode,
                              DelvNo: child2.DelvNo,
                              create_by: this.MeData[0].perid,
                            },
                            headerAxiosPUT
                        );
                      }
                    });
                  }
                  if (child1.id == this.logSelection[i]) {
                    axios.post(
                        ConstData.ConnectionHost +
                        "/app-api/v2/?/apis/hrtrain/Log_D_project_competency/",
                        {
                          Ref_id: Ref_id_edit,
                          Project_code: ProjectCode,
                          DelvNo: child1.DelvNo,
                          create_by: this.MeData[0].perid,
                        },
                        headerAxiosPUT
                    );
                  }
                });
              }
              if (root.id == this.logSelection[i]) {
                axios.post(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/Log_D_project_competency/",
                    {
                      Ref_id: Ref_id_edit,
                      Project_code: ProjectCode,
                      DelvNo: root.DelvNo,
                      create_by: this.MeData[0].perid,
                    },
                    headerAxiosPUT
                );
              }
            });
          }
          this.logSelection = [];
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    AddLogFileProject(ProjectCode, Ref_id) {
      return new Promise((resolve) => {
        // Log D_project_files
        if (this.FileProjectOld.length > 0) {
          var countLogFileProject = 0;
          this.FileProjectOld.map(async (item) => {
            await axios
                .post(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/Log_D_project_files",
                    {
                      Ref_id: Ref_id,
                      Project_code: ProjectCode,
                      File_name: item.name,
                      File_path: item.path,
                      File_type: item.type_Img,
                      Type: "0",
                      Create_By: this.MeData[0].perid,
                    },
                    this.headerAxiosPut
                )
                .then((res) => {
                  if (res.data.status) {
                    countLogFileProject++;
                    if (countLogFileProject == this.FileProjectOld.length) {
                      this.FileProjectOld = [];
                      resolve(true);
                    }
                  }
                });
          });
        } else {
          resolve(true);
        }
      });
    },
    AddRoundProject(
        ProjectCode,
        Ref_id,
        Project_name,
        Project_group,
        DateStart,
        DateEnd
    ) {
      return new Promise((resolve) => {
        /*if (this.Project.IsPlanStatus == '0' && !this.roundNeed) {
          1131-48 รเวอ
        }*/
        if (this.roundNeed) {
          var Status_Count_Dump = "";
          if (this.RoundData.length > 0) {
            this.RoundData.map((Round_i, idx_Round) => {
              Status_Count_Dump = "";
              if (Round_i.ChkJoinPerson) {
                Status_Count_Dump = "1";
              } else {
                Status_Count_Dump = "0";
              }

              axios.post(
                  ConstData.ConnectionHost +
                  "/app-api/v2/?/apis/hrtrain/D_project_round",
                  {
                    id: Round_i.Ref_id,
                    Round: Round_i.round,
                    Round_name: Round_i.round_name,
                    DateS: Round_i.dateRegS,
                    DateE: Round_i.dateRegE,
                    TimeS: Round_i.time_start,
                    TimeE: Round_i.time_end,
                    Project_code: ProjectCode,
                    Status_Reg: Round_i.ChooseTypRegis,
                    Status_Type_Reg: Round_i.ChooseTypRegis2,
                    Status_Type_Reg2: Round_i.ChooseTypRegis3,
                    DateS_Reg: Round_i.dateRegStart,
                    DateE_Reg: Round_i.dateRegEnd,
                    Status_Count_Reg: Status_Count_Dump,
                    Count_Reg: Round_i.ProjectQuotaCount,
                    Create_By: this.MeData[0].perid,
                    Create_Time: "now()",
                  },
                  this.headerAxiosPut
              );

              if (Round_i.WorkAgeData.length > 0) {
                var countDataCondi = 0;
                Round_i.WorkAgeData.map((item) => {
                  const DataObj = {
                    PosCode: item.PosCode,
                    Level: item.Level,
                    WSYear: item.workAgeStart,
                    WEYear: item.workAgeEnd,
                    Project_code: ProjectCode,
                    D_project_round_id: Round_i.Ref_id,
                    create_by: this.MeData[0].perid,
                    create_time: "now()",
                  };
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/C_person_level",
                          DataObj,
                          this.headerAxiosPut
                      )
                      .then((res) => {
                        if (res.data.status) {
                          countDataCondi++;
                          if (countDataCondi == Round_i.WorkAgeData.length) {
                            Round_i.WorkAgeData = [];
                          }
                        }
                      });
                });
              }

              if (Round_i.DepQuotaData.length > 0) {
                var countDepQuota = 0;
                Round_i.DepQuotaData.map((item_dep_q) => {
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/quata_dep_reg",
                          {
                            Project_code: ProjectCode,
                            dep_type: item_dep_q.type_id,
                            dep_id: item_dep_q.dep_id,
                            dep_group_id: item_dep_q.dep_group_id,
                            count: item_dep_q.count,
                            D_project_round_id: Round_i.Ref_id,
                            create_by: this.MeData[0].perid,
                            create_time: "now()",
                          },
                          this.headerAxiosPut
                      )
                      .then((res) => {
                        if (res.data.status) {
                          countDepQuota++;
                          if (countDepQuota == Round_i.DepQuotaData.length) {
                            Round_i.DepQuotaData = [];
                          }
                        }
                      });
                });
              }

              if (Round_i.JoinPersonData.length > 0) {
                var CountJoin = 0;
                Round_i.JoinPersonData.map((item) => {
                  const RegObj = {
                    Project_code: ProjectCode,
                    uid: item.uid,
                    name: item.name.split(" ")[0],
                    sname: item.sname,
                    id_card: item.idCard,
                    affiliation: item.affiliation,
                    position: item.position,
                    join_status: item.status_reg,
                    extra_type: item.extra_type,
                    phone: "",
                    registerType_id: item.registerType_id,
                    D_project_round_id: Round_i.Ref_id,
                    Create_By: this.MeData[0].perid,
                    Create_Time: "now()",
                  };
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/join_project",
                          RegObj,
                          this.headerAxiosPut
                      )
                      .then((res) => {
                        if (res.data) {
                          if (item.status_reg == "1") {
                            axios.post(
                                ConstData.ConnectionHost +
                                "/app-api/v2/?/apis/hrtrain/History_Experts",
                                {
                                  perid: item.uid,
                                  Project_code: ProjectCode,
                                  type:
                                      Project_group == "106" ||
                                      Project_group == "107" ||
                                      Project_group == "109"
                                          ? "18"
                                          : "17",
                                  subject: Project_name,
                                  date_start: DateStart,
                                  date_end: DateEnd,
                                  date_travel_start: "",
                                  date_travel_end: "",
                                  time_start: "",
                                  time_end: "",
                                  Rm: "",
                                  Ref_id: Ref_id,
                                  active: "0",
                                  create_by: this.MeData[0].perid,
                                  create_time: "now()",
                                  update_by: this.MeData[0].perid,
                                },
                                this.headerAxiosPut
                            );
                          }
                          CountJoin++;
                          if (CountJoin == Round_i.JoinPersonData.length) {
                            Round_i.JoinPersonData = [];
                            this.JoinPerson = [];
                          }
                        }
                      });
                });
              }

              if (idx_Round == this.RoundData.length - 1) {
                this.RoundData = [];
              }
            });
          }

          /*if (this.RoundDataDel.length > 0) {
            this.RoundDataDel.map((itemDel, idxDel) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/id/' + itemDel.Ref_id, {
                active: '0',
                Update_By: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              if (idxDel == this.RoundDataDel.length - 1) {
                this.RoundDataDel = []
              }
            })
          }

          if (this.DataCondiDel.length > 0) {
            this.DataCondiDel.map((itemDel, idxDel) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/D_project_round_id/' + itemDel.Ref_id, {
                active: '0',
                update_by: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              if (idxDel == this.DataCondiDel.length - 1) {
                this.DataCondiDel = []
              }
            })
          }

          if (this.DepQuotaDataDel.length > 0) {
            this.DepQuotaDataDel.map((itemDel, idxDel) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/D_project_round_id/' + itemDel.Ref_id, {
                active: '0',
                update_by: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              if (idxDel == this.DepQuotaDataDel.length - 1) {
                this.DepQuotaDataDel = []
              }
            })
          }

          if (this.JoinPersonDel.length > 0) {
            this.JoinPersonDel.map((itemDel, idxDel) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/D_project_round_id/' + itemDel.Ref_id, {
                active: '0',
                Update_By: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              if (idxDel == this.JoinPersonDel.length - 1) {
                this.JoinPersonDel = []
              }
            })
          }*/

          resolve(true);
        } else {
          resolve(true);
        }
      });
    },
    AddJoinProject(
        ProjectCode,
        Ref_id,
        Project_name,
        Project_group,
        DateStart,
        DateEnd
    ) {
      return new Promise((resolve) => {
        if (this.JoinPerson.length > 0) {
          var CountJoin = 0;
          this.JoinPerson.map((item) => {
            const RegObj2 = {
              Project_code: ProjectCode,
              uid: item.uid,
              name: item.name.split(" ")[0],
              sname: item.sname,
              id_card: item.idCard,
              affiliation: item.affiliation,
              position: item.position,
              join_status: item.status_reg,
              extra_type: item.extra_type,
              phone: "",
              registerType_id: item.registerType_id,
              Create_By: this.MeData[0].perid,
              Create_Time: "now()",
            };
            axios
                .post(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/join_project",
                    RegObj2,
                    this.headerAxiosPut
                )
                .then((res) => {
                  if (res.data.status) {
                    if (item.status_reg == "1") {
                      axios.post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/History_Experts",
                          {
                            perid: item.uid,
                            Project_code: ProjectCode,
                            type:
                                Project_group == "106" ||
                                Project_group == "107" ||
                                Project_group == "109"
                                    ? "18"
                                    : "17",
                            subject: Project_name,
                            date_start: DateStart,
                            date_end: DateEnd,
                            date_travel_start: "",
                            date_travel_end: "",
                            time_start: "",
                            time_end: "",
                            Rm: "",
                            Ref_id: Ref_id,
                            active: "0",
                            create_by: this.MeData[0].perid,
                            create_time: "now()",
                            update_by: this.MeData[0].perid,
                          },
                          this.headerAxiosPut
                      );
                    }
                    CountJoin++;
                    if (CountJoin == this.JoinPerson.length) {
                      this.JoinPerson = [];
                      resolve(true);
                    }
                  }
                });
          });
        } else {
          resolve(true);
        }
      });
    },
    // AddJoinTravelToDb(ProjectCode, Ref_id, Project_name, Project_group, DateStart, DateEnd, IsProcess) {
    AddJoinTravelToDb(
        ProjectCode,
        Ref_id,
        Project_name,
        Project_group,
        DateStart,
        DateEnd
    ) {
      return new Promise((resolve) => {
        if (this.JoinTravel.length > 0) {
          var CountJoin = 0;
          var urlExpert = "";
          this.JoinTravel.map((item) => {
            const RegObj2 = {
              Project_code: ProjectCode,
              perid: item.uid,
              prefix: item.prefix,
              full_name: item.full_name,
              affiliation: item.affiliation,
              position: item.position,
              registerType_id: item.registerType_id,
              Create_By: this.MeData[0].perid,
              Create_Time: "now()",
            };
            axios
                .post(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/join_travel",
                    RegObj2,
                    this.headerAxiosPut
                )
                .then((res) => {
                  if (res.data.status) {
                    // urlExpert = IsProcess == '3' ? 'History_Experts_Temp' : 'History_Experts'
                    urlExpert = "History_Experts_Temp";
                    if (item.Lecturer != null) {
                      item.Lecturer.map((lecI, LecIdx) => {
                        axios
                            .post(
                                ConstData.ConnectionHost +
                                "/app-api/v2/?/apis/hrtrain/" +
                                urlExpert,
                                {
                                  perid: item.uid,
                                  Project_code: ProjectCode,
                                  type:
                                      this.projectGroup.filter(
                                          (projG) => projG.Project_group == Project_group
                                      ).length > 0
                                          ? this.projectGroup.filter(
                                              (projG) =>
                                                  projG.Project_group == Project_group
                                          )[0].Committee_Code
                                          : null,
                                  subject: Project_name,
                                  date_start: DateStart,
                                  date_end: DateEnd,
                                  date_travel_start: "",
                                  date_travel_end: "",
                                  time_start: "",
                                  time_end: "",
                                  Rm: "",
                                  Ref_id: lecI.Ref_id,
                                  create_by: this.MeData[0].perid,
                                  create_time: "now()",
                                  update_by: this.MeData[0].perid,
                                },
                                this.headerAxiosPut
                            )
                            .then((res) => {
                              if (res.data.status) {
                                if (lecI.Lecturer != null) {
                                  axios.post(
                                      ConstData.ConnectionHost +
                                      "/app-api/v2/?/apis/hrtrain/Lecturer",
                                      {
                                        perid: item.perid,
                                        Project_name: lecI.Lecturer.Project_name,
                                        Hour: lecI.Lecturer.Hour,
                                        Invite: lecI.Lecturer.Invite,
                                        Place: lecI.Lecturer.Place,
                                        DocNo: lecI.Lecturer.DocNo,
                                        DateDocNo: lecI.Lecturer.DateDocNo,
                                        DateStart: lecI.Lecturer.DateStart,
                                        TimeStart: lecI.Lecturer.TimeStart,
                                        DateEnd: lecI.Lecturer.DateEnd,
                                        TimeEnd: lecI.Lecturer.TimeEnd,
                                        Ref_id: lecI.Ref_id,
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: "now()",
                                      },
                                      this.headerAxiosPut
                                  );
                                }
                                if (lecI.files != null && lecI.files.length > 0) {
                                  lecI.files.map((file) => {
                                    axios.post(
                                        ConstData.ConnectionHost +
                                        "/app-api/v2/?/apis/hrtrain/train_files",
                                        {
                                          File_name: file.File_name,
                                          File_path: file.File_path,
                                          File_type: file.File_type,
                                          Ref_id: lecI.Ref_id,
                                          Create_By: this.MeData[0].perid,
                                          Create_Time: "now()",
                                        },
                                        this.headerAxiosPut
                                    );
                                  });
                                }
                              }
                              if (LecIdx == item.Lecturer.length - 1) {
                                CountJoin++;
                                if (CountJoin == this.JoinTravel.length) {
                                  this.JoinTravel = [];
                                  resolve(true);
                                }
                              }
                            });
                      });
                    } else {
                      axios
                          .post(
                              ConstData.ConnectionHost +
                              "/app-api/v2/?/apis/hrtrain/" +
                              urlExpert,
                              {
                                perid: item.uid,
                                Project_code: ProjectCode,
                                type:
                                    this.projectGroup.filter(
                                        (projG) => projG.Project_group == Project_group
                                    ).length > 0
                                        ? this.projectGroup.filter(
                                            (projG) =>
                                                projG.Project_group == Project_group
                                        )[0].Committee_Code
                                        : null,
                                subject: Project_name,
                                date_start: DateStart,
                                date_end: DateEnd,
                                date_travel_start: "",
                                date_travel_end: "",
                                time_start: "",
                                time_end: "",
                                Rm: "",
                                Ref_id: Ref_id,
                                create_by: this.MeData[0].perid,
                                create_time: "now()",
                                update_by: this.MeData[0].perid,
                              },
                              this.headerAxiosPut
                          )
                          .then((res) => {
                            if (res.data.status) {
                              CountJoin++;
                            } else {
                              CountJoin++;
                            }
                            if (CountJoin == this.JoinTravel.length) {
                              this.JoinTravel = [];
                              resolve(true);
                            }
                          });
                    }
                  }
                });
          });
        } else {
          resolve(true);
        }
      });
    },
    AddFileProject(ProjectCode, Ref_id) {
      return new Promise((resolve) => {
        this.AddLogFileProject(ProjectCode, Ref_id).then((resLogFile) => {
          if (resLogFile) {
            if (this.FileProject.length > 0) {
              var Count = 0;
              if (this.FileProject.length > 0) {
                this.FileProject.map((item) => {
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/D_project_files",
                          {
                            Project_code: ProjectCode,
                            File_name: item.name,
                            File_path: item.path,
                            File_type: item.type_Img,
                            Type: "0",
                            Create_By: this.MeData[0].perid,
                            Create_Time: "now()",
                          },
                          this.headerAxiosPut
                      )
                      .then((res) => {
                        if (res.data.status) {
                          Count++;
                          if (Count == this.FileProject.length) {
                            this.FileProject = [];
                            this.files = [];
                            resolve(true);
                          }
                        }
                      });
                });
              }
            } else {
              this.FileProject = [];
              this.files = [];
              resolve(true);
            }
          }
        });
      });
    },
    AddQuataDepReg(ProjectCode) {
      return new Promise((resolve) => {
        if (!this.roundNeed) {
          if (this.DepQuotaData.length > 0) {
            var countDepQuota = 0;
            if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((item_dep_q) => {
                axios
                    .post(
                        ConstData.ConnectionHost +
                        "/app-api/v2/?/apis/hrtrain/quata_dep_reg",
                        {
                          Project_code: ProjectCode,
                          dep_type: item_dep_q.type_id,
                          dep_id: item_dep_q.dep_id,
                          dep_group_id: item_dep_q.dep_group_id,
                          count: item_dep_q.count,
                          create_by: this.MeData[0].perid,
                          create_time: "now()",
                        },
                        this.headerAxiosPut
                    )
                    .then((res) => {
                      if (res.data.status) {
                        countDepQuota++;
                        if (countDepQuota == this.DepQuotaData.length) {
                          this.DepQuotaData = [];
                          resolve(true);
                        }
                      }
                    });
              });
            }
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },
    AddPersonLevel(ProjectCode) {
      return new Promise((resolve) => {
        if (!this.roundNeed) {
          if (this.DataCondi.length > 0) {
            var countDataCondi = 0;
            this.DataCondi.map((item) => {
              const DataObj = {
                PosCode: item.PosCode,
                Level: item.Level,
                WSYear: item.workAgeStart,
                WEYear: item.workAgeEnd,
                Project_code: ProjectCode,
                create_by: this.MeData[0].perid,
                create_time: "now()",
              };
              axios
                  .post(
                      ConstData.ConnectionHost +
                      "/app-api/v2/?/apis/hrtrain/C_person_level",
                      DataObj,
                      this.headerAxiosPut
                  )
                  .then((res) => {
                    if (res.data.status) {
                      countDataCondi++;
                      if (countDataCondi == this.DataCondi.length) {
                        this.DataCondi = [];
                        resolve(true);
                      }
                    }
                  });
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },
    confirmSaveHistoryExpensse() {
      this.dialogCreateNameHistoryExpense = false;
      if (this.budgetData.length > 0) {
        this.dialogCreateNameHistoryExpense = true;
      } else {
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด",
          text: "กรุณาเพิ่มข้อมูลค่าใช้จ่ายก่อนทำการบันทึก",
        });
      }
    },
    SaveHistoryExpenseData() {
      return new Promise((resolve) => {
        this.$swal
            .fire({
              title: "ยืนยันการบันทึกข้อมูล",
              text: "คุณต้องการบันทึกข้อมูลหรือไม่",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
            })
            .then((result) => {
              if (result.value) {
                if (this.budgetData.length > 0) {
                  axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                    queryName: 'saveExpenseProject',
                    param: btoa(encodeURIComponent(JSON.stringify({
                      Project_code: this.Project_code,
                      ExpenseName: this.nameHistoryExpense,
                      ExpenseData: this.budgetData,
                      Create_By: this.MeData[0].perid,
                      Create_Time: "now()",
                    })))
                  }).then(res => {
                    if (res.data.status) {
                      this.$swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "บันทึกข้อมูลเรียบร้อยแล้ว",
                      });
                      this.dialogCreateNameHistoryExpense = false;
                      this.nameHistoryExpense = "";
                      this.budgetData = [];
                      resolve(true);
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        title: "พบข้อผิดพลาด",
                        text: "ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
                      });
                      this.dialogCreateNameHistoryExpense = false;
                      this.nameHistoryExpense = "";
                      this.budgetData = [];
                      resolve(false);
                    }
                  }).catch((err) => {
                    console.log(err);
                    this.$swal.fire({
                      icon: "error",
                      title: "พบข้อผิดพลาด",
                      text: "ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
                    });
                    this.dialogCreateNameHistoryExpense = false;
                    this.nameHistoryExpense = "";
                    this.budgetData = [];
                    resolve(false);
                  });
                } else {
                  resolve(false);
                }
              } else {
                resolve(false);
              }
            });

      });
    },
    showHistoryExpense(item) {
      this.budgetHistoryDetailData = [];
      this.groupExpenseObj = item
      this.ExpenseGroupDetail = 0
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getExpenseDetailProject',
        param: btoa(encodeURIComponent(JSON.stringify({
          id: item.id,
          permiss_check: this.MeData[0].perid,
        })))
      }).then(res => {
        if (res.data.status && res.data.data.length > 0) {
          res.data.data.map((item) => {
            this.ExpenseGroupDetail += parseFloat(item.SumMoney)
            this.budgetHistoryDetailData.push({
              ...item,
              Expense_id: item.Expense_id,
              Expense_des: item.cost_desc,
              Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                  '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
            })
          })
        } 
        this.dialogShowHistoryExpense = true;
      }).catch((err) => {
        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด",
          text: "ไม่สามารถแสดงข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
        });
      })
    },
    showHistoryExpenseReal(item) {
      this.expenseDetailRealHistotyData = [];
      this.groupExpenseRealObj = item
      this.expenseDetailRealHistotyData = item.ExpenseDetail
      this.dialogShowHistoryExpenseReal = true;
    },
    DeleteHistoryExpense(item) {
      this.$swal.fire({
        title: "ยืนยันการลบข้อมูล",
        text: "คุณต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        cancelButtonColor: "#d33",
      })
          .then((result) => {
            if (result.value) {
              this.$swal.fire({
                title: "กำลังลบข้อมูล",
                text: "กรุณารอสักครู่",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                  this.$swal.showLoading();
                },
              });
              this.DeleteHistoryExpenseData(item);
            }
          });
    },
    DeleteHistoryExpenseData(item) {
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'delExpenseGroupDetailProject',
        param: btoa(encodeURIComponent(JSON.stringify({
          id: item.id,
          permiss_check: this.MeData[0].perid,
        })))
      }).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: "success",
            title: "ลบข้อมูลสำเร็จ",
            text: "ลบข้อมูลเรียบร้อยแล้ว",
          });
          this.budgetHistoryDetailData = [];
          this.Expense = 0
          this.ChangeTypeBuggetProject()
        } else {
          this.$swal.fire({
            icon: "error",
            title: "พบข้อผิดพลาด",
            text: "ไม่สามารถลบข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
          });
        }
      }).catch((err) => {

        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด",
          text: "ไม่สามารถลบข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
        });
      })
    },
    ChangeTypeBuggetProject() {
      switch (this.TypeBuggetProject) {
        case "1":

          break;
        case "2":
          this.ExpenseGroup = 0;
          this.budgetHistoryData = [];
          var checkExpense = false
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getExpenseProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: this.Project_code,
              permiss_check: this.MeData[0].perid,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              checkExpense = res.data.filter((item) => item.Expense_name).length > 0 ? true : false
              if (checkExpense) {
                this.budgetHistoryData = res.data;
                this.budgetHistoryData.map((item) => {
                  this.ExpenseGroup += parseFloat(item.SumMoney)
                })
              }
            }
          })
          break;
        case "3":
          this.expenseRealData = [];
          this.ExpenseRealSummay = 0;
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getExpenseRealProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: this.Project_code,
              permiss_check: this.MeData[0].perid,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              this.expenseRealData = res.data;
              this.expenseRealData.map((item) => {
                this.ExpenseRealSummay += parseFloat(item.Mon_total)
              })
            }
          })
          break;
        default:
          break;
      }
    },
    AddBudgetProject(ProjectCode) {
      return new Promise((resolve) => {
        if (this.budgetData.length > 0) {
          axios
              .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                queryName: "addExpenseProject",
                param: btoa(
                    encodeURIComponent(
                        JSON.stringify({
                          id: ProjectCode,
                          expenseData: this.budgetData,
                          Create_By: this.MeData[0].perid,
                        })
                    )
                ),
              })
              .then((res) => {
                if (res.data.status) {
                  this.budgetData = [];
                  resolve(true);
                }
              })
              .catch((err) => {
                console.log(err);
              });
        } else {
          resolve(true);
        }
      });
    },
    AddBudgetTravel(ProjectCode) {
      return new Promise((resolve) => {
        if (this.JoinTravel.length > 0) {
          var countbudgetData = 0;
          if (this.JoinTravel.length > 0) {
            this.JoinTravel.map((item_exp) => {
              axios
                  .post(
                      ConstData.ConnectionHost +
                      "/app-api/v2/?/apis/hrtrain/D_travel_expense",
                      {
                        Project_code: ProjectCode,
                        Perid: item_exp.perid,
                        Allowance: item_exp.Allowance,
                        AccommodationCost: item_exp.AccommodationCost,
                        ShippingCosts: item_exp.ShippingCosts,
                        RegistrationFee: item_exp.RegistrationFee,
                        Remark: item_exp.remark,
                        Create_By: this.MeData[0].perid,
                        Create_Time: "now()",
                      },
                      this.headerAxiosPut
                  )
                  .then((res) => {
                    if (res.data.status) {
                      countbudgetData++;
                      if (countbudgetData == this.JoinTravel.length) {
                        resolve(true);
                      }
                    }
                  });
            });
          }
        } else {
          resolve(true);
        }
      });
    },
    AddTemplateProject(ProjectCode) {
      return new Promise((resolve) => {
        axios
            .post(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/TemplateProject/",
                {
                  Project_code: ProjectCode,
                  Template: this.editorData,
                  Template2: this.editorData3,
                  CoverSheet: this.editorData2,
                  Create_By: this.MeData[0].perid,
                  Create_Time: "now()",
                },
                this.headerAxiosPut
            )
            .then((res) => {
              if (res.data.status) {
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((res) => {
              if (res) {
                resolve(true);
              }
            });
      });
    },
    ClearDataBeforeToSave(ProjectCode) {
      return new Promise((resolve) => {
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            },
            this.headerAxios
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/join_project/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            },
            this.headerAxios
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/request_project/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );
        axios.post(
            ConstData.ConnectionHost +
            "/app-api/v2/?/apis/hrtrain/Person_files/Project_code/" +
            ProjectCode,
            {
              active: "0",
              Update_By: this.MeData[0].perid,
            }
        );

        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/" +
                ProjectCode +
                "/active/1"
            )
            .then((res) => {
              if (res.data) {
                if (res.data.length > 0) {
                  res.data.map((item, idx) => {
                    axios
                        .post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/History_Experts/id/" +
                            item.id,
                            {
                              active: "0",
                              Update_By: this.MeData[0].perid,
                            },
                            this.headerAxios
                        )
                        .then((resUpdate) => {
                          axios.post(
                              ConstData.ConnectionHost +
                              "/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/" +
                              item.Ref_id,
                              {
                                active: "0",
                                update_by: this.MeData[0].perid,
                              },
                              this.headerAxios
                          );
                          axios.post(
                              ConstData.ConnectionHost +
                              "/app-api/v2/?/apis/hrtrain/train_files/Ref_id/" +
                              item.Ref_id,
                              {
                                active: "0",
                                update_by: this.MeData[0].perid,
                              },
                              this.headerAxios
                          );
                          if (resUpdate.data.status) {
                            if (idx == res.data.length - 1) {
                              resolve(true);
                            }
                          } else {
                            if (idx == res.data.length - 1) {
                              resolve(true);
                            }
                          }
                        })
                        .catch((resCatch) => {
                          if (resCatch) {
                            if (idx == res.data.length - 1) {
                              resolve(true);
                            }
                          }
                        });
                  });
                } else {
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/History_Experts/id/" +
                          res.data.id,
                          {
                            active: "0",
                            Update_By: this.MeData[0].perid,
                          },
                          this.headerAxios
                      )
                      .then((resUpdate) => {
                        axios.post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/" +
                            res.data.Ref_id,
                            {
                              active: "0",
                              update_by: this.MeData[0].perid,
                            },
                            this.headerAxios
                        );
                        axios.post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/train_files/Ref_id/" +
                            res.data.Ref_id,
                            {
                              active: "0",
                              update_by: this.MeData[0].perid,
                            },
                            this.headerAxios
                        );
                        if (resUpdate.data.status) {
                          resolve(true);
                        } else {
                          resolve(true);
                        }
                      })
                      .catch((resCatch) => {
                        if (resCatch) {
                          resolve(true);
                        }
                      });
                }
              } else {
                resolve(true);
              }
            });
      });
    },
    AddCoordinator(Coordinator, WorkGroupData) {
      return new Promise((resolve) => {
        // var CountCoordinator = 0;
        if (Coordinator != null) {
           axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
                {
                  queryName: "insertProjectCommittee2",
                  param: btoa(
                      encodeURIComponent(
                          JSON.stringify({
                            Coordinator: Coordinator,
                            WorkGroupData: WorkGroupData,
                            Project_code: this.Project_code,
                            Project_name: this.Project_name,
                            date_start: this.date_start,
                            date_end: this.date_end,
                            permiss_check: this.MeData[0].perid,
                          })
                      )
                  ),
                }
            ).then((res) => {
              if (res.data.status) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: "success",
                  title: "เพิ่มข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.execCommitteeData(res.data.data)
                resolve(true);
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "พบข้อผิดพลาด",
                  text: "ไม่สามารถเพิ่มข้อมูลได้ โปรดลองทำรายการอีกครั้ง !",
                });
                resolve(false);
              }
            }).catch((err) => {
              console.log(err);
              resolve(false);
            });
        } else {
          resolve(true);
        }
      });
    },
    AddLecturer(ProjectCode) {
      return new Promise((resolve) => {
        if (this.WorkGroupData.length > 0) {
          var CountLecturer = 0;
          this.WorkGroupData.map((item) => {
            item.Project_code = ProjectCode;
            axios
                .post(
                    ConstData.ConnectionHost +
                    "/app-api/v2/?/apis/hrtrain/History_Experts",
                    {
                      perid: item.perid,
                      Project_code: ProjectCode,
                      type: item.type,
                      subject: item.subject,
                      date_start: item.date_start,
                      date_end: item.date_end,
                      date_travel_start: item.date_travel_start,
                      date_travel_end: item.date_travel_end,
                      time_start: item.time_start,
                      time_end: item.time_end,
                      Rm: item.Rm,
                      Ref_id: item.Ref_id,
                      create_by: this.MeData[0].perid,
                      create_time: "now()",
                      update_by: this.MeData[0].perid,
                    },
                    this.headerAxiosPut
                )
                .then((res) => {
                  if (res.data.status) {
                    CountLecturer++;
                    if (item.Lecturer != null) {
                      axios.post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/Lecturer",
                          {
                            perid: item.perid,
                            Project_name: item.Lecturer.Project_name,
                            Hour: item.Lecturer.Hour,
                            Invite: item.Lecturer.Invite,
                            Place: item.Lecturer.Place,
                            DocNo: item.Lecturer.DocNo,
                            DateDocNo: item.Lecturer.DateDocNo,
                            DateStart: item.Lecturer.DateStart,
                            TimeStart: item.Lecturer.TimeStart,
                            DateEnd: item.Lecturer.DateEnd,
                            TimeEnd: item.Lecturer.TimeEnd,
                            Ref_id: item.Ref_id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: "now()",
                          },
                          this.headerAxiosPut
                      );
                    }
                    if (item.files != null && item.files.length > 0) {
                      item.files.map((file) => {
                        axios.post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/train_files",
                            {
                              File_name: file.File_name,
                              File_path: file.File_path,
                              File_type: file.File_type,
                              Ref_id: item.Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: "now()",
                            },
                            this.headerAxiosPut
                        );
                      });
                    }
                    if (CountLecturer == this.WorkGroupData.length) {
                      this.WorkGroupData = [];
                      resolve(true);
                    }
                  }
                });
          });
        } else {
          this.WorkGroupData = [];
          resolve(true);
        }
      });
    },
    AddCompetency(ProjectCode) {
      return new Promise((resolve) => {
        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/" +
                ProjectCode +
                "/active/1"
            )
            .then((res) => {
              if (res.data) {
                axios
                    .post(
                        ConstData.ConnectionHost +
                        "/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/" +
                        ProjectCode,
                        {
                          active: "0",
                          update_by: this.MeData[0].perid,
                        },
                        this.headerAxios
                    )
                    .then((res) => {
                      if (res.data.status) {
                        if (this.selection.length > 0) {
                          for (var i = 0; i <= this.selection.length - 1; i++) {
                            this.CompetencyData.map((root) => {
                              if (root.children.length > 0) {
                                root.children.map((child1) => {
                                  if (child1.children.length > 0) {
                                    child1.children.map((child2) => {
                                      if (child2.id == this.selection[i]) {
                                        axios.post(
                                            ConstData.ConnectionHost +
                                            "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                                            {
                                              Project_code: ProjectCode,
                                              DelvNo: child2.DelvNo,
                                              create_by: this.MeData[0].perid,
                                              create_time: "now()",
                                            },
                                            this.headerAxiosPut
                                        );
                                      }
                                    });
                                  }
                                  if (child1.id == this.selection[i]) {
                                    axios.post(
                                        ConstData.ConnectionHost +
                                        "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                                        {
                                          Project_code: ProjectCode,
                                          DelvNo: child1.DelvNo,
                                          create_by: this.MeData[0].perid,
                                          create_time: "now()",
                                        },
                                        this.headerAxiosPut
                                    );
                                  }
                                });
                              }
                              if (root.id == this.selection[i]) {
                                axios.post(
                                    ConstData.ConnectionHost +
                                    "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                                    {
                                      Project_code: ProjectCode,
                                      DelvNo: root.DelvNo,
                                      create_by: this.MeData[0].perid,
                                      create_time: "now()",
                                    },
                                    this.headerAxiosPut
                                );
                              }
                            });
                          }
                          this.selection = [];
                          resolve(true);
                        } else {
                          resolve(true);
                        }
                      } else {
                        resolve(false);
                      }
                    });
              } else {
                if (this.selection.length > 0) {
                  for (var i = 0; i <= this.selection.length - 1; i++) {
                    this.CompetencyData.map((root) => {
                      if (root.children.length > 0) {
                        root.children.map((child1) => {
                          if (child1.children.length > 0) {
                            child1.children.map((child2) => {
                              if (child2.id == this.selection[i]) {
                                axios.post(
                                    ConstData.ConnectionHost +
                                    "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                                    {
                                      Project_code: ProjectCode,
                                      DelvNo: child2.DelvNo,
                                      create_by: this.MeData[0].perid,
                                      create_time: "now()",
                                    },
                                    this.headerAxiosPut
                                );
                              }
                            });
                          }
                          if (child1.id == this.selection[i]) {
                            axios.post(
                                ConstData.ConnectionHost +
                                "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                                {
                                  Project_code: ProjectCode,
                                  DelvNo: child1.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: "now()",
                                },
                                this.headerAxiosPut
                            );
                          }
                        });
                      }
                      if (root.id == this.selection[i]) {
                        axios.post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/D_project_competency/",
                            {
                              Project_code: ProjectCode,
                              DelvNo: root.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: "now()",
                            },
                            this.headerAxiosPut
                        );
                      }
                    });
                  }
                  this.selection = [];
                  resolve(true);
                } else {
                  resolve(true);
                }
              }
            });
      });
    },
    DeleteFile(file_i) {
      this.FileProject.map((item, idx) => {
        if (item.index == file_i.index) {
          this.FileProject.splice(idx, 1);
        }
      });
    },
    DeleteFile2(file_i) {
      this.FileProjectExpert.map((item, idx) => {
        if (item.name == file_i.name) {
          this.FileProjectExpert.splice(idx, 1);
        }
      });
    },
    CheckPermission() {
      return new Promise((resolve) => {
        var CheckPermiss = false;
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == "9001") {
              resolve(true);
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false);
              }
            }
          });
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == "9001") {
              resolve(true);
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false);
              }
            }
          });
        }
      });
    },
    CheckPermissionFunc(permissionId) {
      return new Promise((resolve) => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permissionId) {
              resolve(true);
            } else {
              if (idx == this.PermissionAdmin.length - 1) {
                resolve(false);
              }
            }
          });
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permissionId) {
              resolve(true);
            } else {
              if (idx == this.Permission.length - 1) {
                resolve(false);
              }
            }
          });
        }
      });
    },
    OpenIDCheckIn() {
      window.open(
          "https://medhr.medicine.psu.ac.th/IdCheckIn/TakeALeave",
          "_blank"
      );
    },
    GetOldData(item) {
      var objIem = JSON.parse(JSON.stringify(item));
      this.SubjectForLecturer = objIem.subject;
      this.dateSForLecturer = objIem.date_start;
      this.dateEForLecturer = objIem.date_end;
      this.dateSTravelForLecturer = objIem.date_travel_start;
      this.dateETravelForLecturer = objIem.date_travel_end;
      this.timeSForLecturer = objIem.time_start;
      this.timeEForLecturer = objIem.time_end;
      this.FileProjectExpert = objIem.files;
      this.Rm2 = objIem.Rm;
      this.LecturerProjectName = objIem.Lecturer.Project_name;
      this.LecturerHour = objIem.Lecturer.Hour;
      this.LecturerInvite = objIem.Lecturer.Invite;
      this.LecturerPlace = objIem.Lecturer.Place;
      this.LecturerDocNo = objIem.Lecturer.DocNo;
      this.LecturerDateDocOut = objIem.Lecturer.DateDocNo;
      this.LecturerDateStart = objIem.Lecturer.DateStart;
      this.LecturerTimeStart = objIem.Lecturer.TimeStart;
      this.LecturerDateEnd = objIem.Lecturer.DateEnd;
      this.LecturerTimeEnd = objIem.Lecturer.TimeEnd;
    },
    DelLecturer(idx) {
      this.Lecturer.splice(idx, 1);
    },
    toggleExpanded(item) {
      // Toggle the expanded state of the item
      item.expanded = !item.expanded;
    },
    showCompetency(item) {
      this.CompetencyToShow = [];
      var urlConnection = "";
      this.dialogLoading = true;
      urlConnection =
          ConstData.ConnectionHost +
          "/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/" +
          item.Project_code +
          "/active/1";
      axios
          .get(urlConnection)
          .then((res) => {
            if (res.data) {
              this.dialogCompetency = true;
              this.dialogLoading = false;
              if (res.data.length > 0) {
                res.data.map((posi_i) => {
                  this.Competency.map((compe_i) => {
                    if (posi_i.DelvCover == compe_i.DelvNo) {
                      if (compe_i.DelvCover != null && compe_i.DelvCover != "") {
                        this.Competency.map((compe_i2) => {
                          if (compe_i.DelvCover == compe_i2.DelvNo) {
                            var CheckCompetency = this.CompetencyToShow.filter(
                                (ComToShow) => ComToShow.DelvNo == compe_i2.DelvNo
                            );

                            if (CheckCompetency.length == 0) {
                              if (
                                  compe_i2.DelvEng == null ||
                                  compe_i2.DelvEng == ""
                              ) {
                                this.CompetencyToShow.push({
                                  ...compe_i2,
                                  id: compe_i2.DelvNo,
                                  name: compe_i2.DelvDes,
                                  DelvLevel: "0",
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: [],
                                });
                              } else {
                                this.CompetencyToShow.push({
                                  ...compe_i2,
                                  id: compe_i2.DelvNo,
                                  name:
                                      compe_i2.DelvDes +
                                      "( " +
                                      compe_i2.DelvEng +
                                      " )",
                                  DelvLevel: "0",
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: [],
                                });
                              }
                            }
                          }
                        });

                        // lv1
                        if (this.CompetencyToShow.length > 0) {
                          this.CompetencyToShow.map((ComToShow) => {
                            if (ComToShow.children.length > 0) {
                              ComToShow.children.map(
                                  (ComToShow_c, idx_to_Show) => {
                                    CheckCompetency = false;
                                    if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                                      CheckCompetency = true;
                                    }
                                    if (
                                        !CheckCompetency &&
                                        idx_to_Show == ComToShow.children.length - 1
                                    ) {
                                      this.CompetencyToShow.map((data_i, idx) => {
                                        if (data_i.DelvNo == compe_i.DelvCover) {
                                          if (
                                              compe_i.DelvEng == null ||
                                              compe_i.DelvEng == ""
                                          ) {
                                            this.CompetencyToShow[
                                                idx
                                                ].children.push({
                                              ...compe_i,
                                              id: compe_i.DelvNo,
                                              name: compe_i.DelvDes,
                                              DelvLevel: "1",
                                              NeedsCredit: posi_i.NeedsCredit,
                                              ExpectCredit: posi_i.ExpectCredit,
                                              children: [],
                                            });
                                          } else {
                                            this.CompetencyToShow[
                                                idx
                                                ].children.push({
                                              ...compe_i,
                                              id: compe_i.DelvNo,
                                              name:
                                                  compe_i.DelvDes +
                                                  "( " +
                                                  compe_i.DelvEng +
                                                  " )",
                                              DelvLevel: "1",
                                              NeedsCredit: posi_i.NeedsCredit,
                                              ExpectCredit: posi_i.ExpectCredit,
                                              children: [],
                                            });
                                          }
                                        }
                                      });
                                    }
                                  }
                              );
                            } else {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (
                                      compe_i.DelvEng == null ||
                                      compe_i.DelvEng == ""
                                  ) {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: "1",
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: [],
                                    });
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name:
                                          compe_i.DelvDes +
                                          "( " +
                                          compe_i.DelvEng +
                                          " )",
                                      DelvLevel: "1",
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: [],
                                    });
                                  }
                                }
                              });
                            }
                          });
                        }

                        //lv2
                        this.CompetencyToShow.map((data_i, idx) => {
                          data_i.children.map((child_i, c_idx) => {
                            if (child_i.DelvNo == posi_i.DelvCover) {
                              if (
                                  posi_i.DelvEng == null ||
                                  posi_i.DelvEng == ""
                              ) {
                                this.CompetencyToShow[idx].children[
                                    c_idx
                                    ].children.push({
                                  ...posi_i,
                                  id: posi_i.DelvNo,
                                  name: posi_i.DelvDes,
                                  DelvLevel: "2",
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: [],
                                });
                              } else {
                                this.CompetencyToShow[idx].children[
                                    c_idx
                                    ].children.push({
                                  ...posi_i,
                                  id: posi_i.DelvNo,
                                  name:
                                      posi_i.DelvDes + "( " + posi_i.DelvEng + " )",
                                  DelvLevel: "2",
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: [],
                                });
                              }
                            }
                          });
                        });
                      } else {
                        var CheckCompetency = this.CompetencyToShow.filter(
                            (ComToShow) => ComToShow.DelvNo == compe_i.DelvNo
                        );

                        if (CheckCompetency.length == 0) {
                          if (compe_i.DelvEng == null || compe_i.DelvEng == "") {
                            this.CompetencyToShow.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name: compe_i.DelvDes,
                              DelvLevel: "0",
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: [],
                            });
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name:
                                  compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                              DelvLevel: "0",
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: [],
                            });
                          }
                        }

                        this.Competency.map((compe_i2) => {
                          if (posi_i.DelvNo == compe_i2.DelvNo) {
                            this.CompetencyToShow.map((data_i, idx) => {
                              if (data_i.DelvNo == posi_i.DelvCover) {
                                if (
                                    compe_i2.DelvEng == null ||
                                    compe_i2.DelvEng == ""
                                ) {
                                  this.CompetencyToShow[idx].children.push({
                                    ...compe_i2,
                                    id: compe_i2.DelvNo,
                                    name: compe_i2.DelvDes,
                                    DelvLevel: "1",
                                    NeedsCredit: posi_i.NeedsCredit,
                                    ExpectCredit: posi_i.ExpectCredit,
                                    children: [],
                                  });
                                } else {
                                  this.CompetencyToShow[idx].children.push({
                                    ...compe_i2,
                                    id: compe_i2.DelvNo,
                                    name:
                                        compe_i2.DelvDes +
                                        "( " +
                                        compe_i2.DelvEng +
                                        " )",
                                    DelvLevel: "1",
                                    NeedsCredit: posi_i.NeedsCredit,
                                    ExpectCredit: posi_i.ExpectCredit,
                                    children: [],
                                  });
                                }
                              }
                            });
                          }
                        });
                      }
                    }
                  });
                });
              } else {
                // root
                this.Competency.map((compe_i) => {
                  if (res.data.DelvCover == compe_i.DelvNo) {
                    if (compe_i.DelvCover != null && compe_i.DelvCover != "") {
                      this.Competency.map((compe_i2) => {
                        if (compe_i.DelvCover == compe_i2.DelvNo) {
                          if (
                              compe_i2.DelvEng == null ||
                              compe_i2.DelvEng == ""
                          ) {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: "0",
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: [],
                            });
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name:
                                  compe_i2.DelvDes + "( " + compe_i2.DelvEng + " )",
                              DelvLevel: "0",
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: [],
                            });
                          }
                        }
                      });

                      // lv1
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == compe_i.DelvCover) {
                          if (compe_i.DelvEng == null || compe_i.DelvEng == "") {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name: compe_i.DelvDes,
                              DelvLevel: "1",
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: [],
                            });
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name:
                                  compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                              DelvLevel: "1",
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: [],
                            });
                          }
                        }
                      });

                      //lv2
                      this.CompetencyToShow.map((data_i, idx) => {
                        data_i.children.map((child_i, c_idx) => {
                          if (child_i.DelvNo == res.data.DelvCover) {
                            if (
                                res.data.DelvEng == null ||
                                res.data.DelvEng == ""
                            ) {
                              this.CompetencyToShow[idx].children[
                                  c_idx
                                  ].children.push({
                                ...res.data,
                                id: res.data.DelvNo,
                                name: res.data.DelvDes,
                                DelvLevel: "2",
                                NeedsCredit: res.data.NeedsCredit,
                                ExpectCredit: res.data.ExpectCredit,
                                children: [],
                              });
                            } else {
                              this.CompetencyToShow[idx].children[
                                  c_idx
                                  ].children.push({
                                ...res.data,
                                id: res.data.DelvNo,
                                name:
                                    res.data.DelvDes +
                                    "( " +
                                    res.data.DelvEng +
                                    " )",
                                DelvLevel: "2",
                                NeedsCredit: res.data.NeedsCredit,
                                ExpectCredit: res.data.ExpectCredit,
                                children: [],
                              });
                            }
                          }
                        });
                      });
                    } else {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == "") {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: "0",
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: [],
                        });
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                          DelvLevel: "0",
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: [],
                        });
                      }

                      this.Competency.map((compe_i2) => {
                        if (res.data.DelvNo == compe_i2.DelvNo) {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == res.data.DelvCover) {
                              if (
                                  compe_i2.DelvEng == null ||
                                  compe_i2.DelvEng == ""
                              ) {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i2,
                                  id: compe_i2.DelvNo,
                                  name: compe_i2.DelvDes,
                                  DelvLevel: "1",
                                  NeedsCredit: res.data.NeedsCredit,
                                  ExpectCredit: res.data.ExpectCredit,
                                  children: [],
                                });
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i2,
                                  id: compe_i2.DelvNo,
                                  name:
                                      compe_i2.DelvDes +
                                      "( " +
                                      compe_i2.DelvEng +
                                      " )",
                                  DelvLevel: "1",
                                  NeedsCredit: res.data.NeedsCredit,
                                  ExpectCredit: res.data.ExpectCredit,
                                  children: [],
                                });
                              }
                            }
                          });
                        }
                      });
                    }
                  }
                });
              }
            } else {
              this.dialogCompetency = true;
              this.dialogLoading = false;
              // Error Competency
            }
          })
          .catch((res) => {
            if (res) {
              this.dialogCompetency = true;
              this.dialogLoading = false;
            }
          });
    },
    showFile() {
      this.dialogFile = true;
    },
    getLecturer(param) {
      return new Promise((resolve) => {
        var dumpArr = [];
        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/Lecturer/perid/" +
                param.perid +
                "/Ref_id/" +
                param.Ref_id
            )
            .then((res) => {
              if (res.data) {
                if (res.data.length > 0) {
                  dumpArr = res.data;
                } else {
                  dumpArr.push(res.data);
                }
                resolve({
                  status: true,
                  data: dumpArr,
                });
              } else {
                resolve({
                  status: false,
                  data: [],
                });
              }
            })
            .catch((res) => {
              if (res) {
                resolve({
                  status: false,
                  data: [],
                });
              }
            });
      });
    },
    getTrainFiles(Ref_id) {
      return new Promise((resolve) => {
        var dumpArr = [];
        axios
            .get(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/train_files/active/1/Ref_id/" +
                Ref_id
            )
            .then((res) => {
              if (res.data) {
                if (res.data.length > 0) {
                  dumpArr = res.data;
                } else {
                  dumpArr.push(res.data);
                }
                resolve({
                  status: true,
                  data: dumpArr,
                });
              } else {
                resolve({
                  status: false,
                  data: [],
                });
              }
            })
            .catch((res) => {
              if (res) {
                resolve({
                  status: false,
                  data: [],
                });
              }
            });
      });
    },
    SendMail(
        receiverPerid = null,
        sendPerid = null,
        projectCode = "-",
        topic = "-"
    ) {
      axios.post(
          ConstData.ConnectionHost + "/sendMail/SendMailData.php",
          queryString.stringify({
            perid_admin: receiverPerid,
            perid: sendPerid,
            headerName:
                (this.TypeProject == "1"
                    ? "แจ้งเตือนการเสนออนุมัติหลักการโครงการจากแผนตั้งงบประมาณประจำปี "
                    : "พิจารณาการเดินทางไปราชการ : ") +
                topic +
                " (" +
                projectCode +
                ")",
            header: topic,
            body:
                this.TypeProject == "1"
                    ? '<p style="font-size: 25px;color: peru;font-weight: bold">แผน: ' +
                    topic +
                    " (" +
                    projectCode +
                    ") ได้ถูกเสนออนุมัติหลักการแล้ว</p> " +
                    '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Project/"> พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
                    : '<p style="font-size: 25px;color: peru;font-weight: bold">' +
                    topic +
                    " (" +
                    projectCode +
                    ") ได้ถูกเสนออนุมัติแล้ว</p> " +
                    '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveTravelByDep/' +
                    projectCode +
                    '"> พิจารณาการเดินทางไปราชการ </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
      );
    },
    SendMailApproveForHR(
        receiverPerid = null,
        sendPerid = null,
        projectCode = "-",
        topic = "-"
    ) {
      axios.post(
          ConstData.ConnectionHost + "/sendMail/SendMailData.php",
          queryString.stringify({
            perid_admin: receiverPerid,
            perid: sendPerid,
            headerName:
                "พิจารณาการเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) " +
                topic +
                " (" +
                projectCode +
                ")",
            header: topic + " (" + projectCode + ")",
            body:
                '<p style="font-size: 25px;color: peru;font-weight: bold">' +
                topic +
                " (" +
                projectCode +
                ")" +
                "</p> " +
                '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณา</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' +
                projectCode +
                '"> พิจารณาเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) </a> </p> ' +
                '<hr style="margin-top: 50px;">' +
                '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
      );
    },
    openDialogEditObj() {
      this.Objective = "";
      this.dialogEditObj = true;
    },
    editObjectProj() {
      if (this.Objective == "" || this.Objective == null) {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาระบุวัตถุประสงค์",
        });
      } else {
        this.Project.Objective = this.Objective;
        this.dialogEditObj = false;
      }
    },
    unlockProj() {
      this.CheckPermissionFunc("9002").then((resPermiss) => {
        if (resPermiss) {
          this.$swal
              .fire({
                title: "ยืนยันการทำรายการ",
                text:
                    "คุณต้องการปลดล็อคการแก้ไขเพื่อไม่ให้มีการแก้ไขโครงการ หรือไม่ ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((result) => {
                if (result.value) {
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" +
                          this.Project_code_dump,
                          {
                            IsLog: "0",
                            Update_By: this.MeData[0].perid,
                          },
                          {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          }
                      )
                      .then((res) => {
                        if (res.data.status) {
                          this.IsLog = "0";
                          this.$swal.fire({
                            position: "top-end",
                            icon: "success",
                            title:
                                "ปลคล็อคการแก้ไข " +
                                this.Project_name +
                                " (" +
                                this.Project_code +
                                ") สำเร็จ",
                            showConfirmButton: false,
                            timer: 1000,
                          });
                        } else {
                          this.$swal.fire({
                            position: "top-end",
                            icon: "error",
                            title:
                                "ไม่สามารถปลดล็อคการแก้ไข " +
                                this.Project_name +
                                " (" +
                                this.Project_code +
                                ") ได้ โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ",
                            showConfirmButton: false,
                            timer: 1000,
                          });
                        }
                      });
                }
              });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "คุณไม่ได้รับสิทธิ์ในการทำรายการ !!",
          });
        }
      });
    },
    lockProj() {
      this.CheckPermissionFunc("9002").then((resPermiss) => {
        if (resPermiss) {
          this.$swal
              .fire({
                title: "ยืนยันการทำรายการ",
                text:
                    "คุณต้องการล็อคการแก้ไขเพื่อไม่ให้มีการแก้ไขโครงการ หรือไม่ ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((result) => {
                if (result.value) {
                  axios
                      .post(
                          ConstData.ConnectionHost +
                          "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" +
                          this.Project_code_dump,
                          {
                            IsLog: "1",
                            Update_By: this.MeData[0].perid,
                          },
                          {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          }
                      )
                      .then((res) => {
                        if (res.data.status) {
                          this.IsLog = "1";
                          this.e1 = 1;
                          this.$swal.fire({
                            position: "top-end",
                            icon: "success",
                            title:
                                "ล็อคการแก้ไข " +
                                this.Project_name +
                                " (" +
                                this.Project_code +
                                ") สำเร็จ",
                            showConfirmButton: false,
                            timer: 1000,
                          });
                        } else {
                          this.$swal.fire({
                            position: "top-end",
                            icon: "error",
                            title:
                                "ไม่สามารถล็อคการแก้ไข " +
                                this.Project_name +
                                " (" +
                                this.Project_code +
                                ") ได้ โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ",
                            showConfirmButton: false,
                            timer: 1000,
                          });
                        }
                      });
                }
              });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "คุณไม่ได้รับสิทธิ์ในการทำรายการ !!",
          });
        }
      });
    },
    unlockTravel(traObj, clear) {
      this.CheckPermissionFunc("9002").then((resPermiss) => {
        if (resPermiss) {
          this.$swal
              .fire({
                title: "ยืนยันการทำรายการ",
                text:
                    "คุณต้องการปลดล็อคการแก้ไขเพื่อไม่ให้มีการแก้ไขโครงการ หรือไม่ ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((result) => {
                if (result.value) {
                  if (traObj != null) {
                    axios
                        .post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" +
                            traObj.Project_code,
                            {
                              IsLog: "0",
                              Update_By: this.MeData[0].perid,
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                            }
                        )
                        .then((res) => {
                          if (res.data.status) {
                            traObj.IsLog = "0";
                            if (clear) {
                              this.Project_plan.map((itemP) => {
                                if (itemP.project_id == traObj.project_id) {
                                  itemP.IsLog = "1";
                                }
                              });
                              this.ClearPlanProject();
                            }
                            this.$swal.fire({
                              position: "top-end",
                              icon: "success",
                              title:
                                  "ปลคล็อคการแก้ไข " +
                                  traObj.Project_name +
                                  " (" +
                                  traObj.Project_code +
                                  ") สำเร็จ",
                              showConfirmButton: false,
                              timer: 1000,
                            });
                          } else {
                            this.$swal.fire({
                              position: "top-end",
                              icon: "error",
                              title:
                                  "ไม่สามารถปลดล็อคการแก้ไข " +
                                  traObj.Project_name +
                                  " (" +
                                  traObj.Project_code +
                                  ") ได้ โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ",
                              showConfirmButton: false,
                              timer: 1000,
                            });
                          }
                        });
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title:
                          "ไม่สามารถปลดล็อคการแก้ไขได้ เนื่องจากไม่พบข้อมูลโครงการ",
                    });
                  }
                }
              });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "คุณไม่ได้รับสิทธิ์ในการทำรายการ !!",
          });
        }
      });
    },
    lockTravel(traObj, clear) {
      this.CheckPermissionFunc("9002").then((resPermiss) => {
        if (resPermiss) {
          this.$swal
              .fire({
                title: "ยืนยันการทำรายการ",
                text:
                    "คุณต้องการล็อคการแก้ไขเพื่อไม่ให้มีการแก้ไขโครงการ หรือไม่ ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              })
              .then((result) => {
                if (result.value) {
                  if (traObj != null) {
                    axios
                        .post(
                            ConstData.ConnectionHost +
                            "/app-api/v2/?/apis/hrtrain/D_project/Project_code/" +
                            traObj.Project_code,
                            {
                              IsLog: "1",
                              Update_By: this.MeData[0].perid,
                            },
                            {
                              headers: {
                                "Content-Type": "application/json",
                              },
                            }
                        )
                        .then((res) => {
                          if (res.data.status) {
                            traObj.IsLog = "1";
                            if (clear) {
                              this.Project_plan.map((itemP) => {
                                if (itemP.project_id == traObj.project_id) {
                                  itemP.IsLog = "1";
                                }
                              });
                              this.ClearPlanProject();
                            }
                            this.$swal.fire({
                              position: "top-end",
                              icon: "success",
                              title:
                                  "ล็อคการแก้ไข " +
                                  traObj.Project_name +
                                  " (" +
                                  traObj.Project_code +
                                  ") สำเร็จ",
                              showConfirmButton: false,
                              timer: 1000,
                            });
                          } else {
                            this.$swal.fire({
                              position: "top-end",
                              icon: "error",
                              title:
                                  "ไม่สามารถล็อคการแก้ไข " +
                                  traObj.Project_name +
                                  " (" +
                                  traObj.Project_code +
                                  ") ได้ โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ",
                              showConfirmButton: false,
                              timer: 1000,
                            });
                          }
                        });
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title:
                          "ไม่สามารถปลดล็อคการแก้ไขได้ เนื่องจากไม่พบข้อมูลโครงการ",
                    });
                  }
                }
              });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "คุณไม่ได้รับสิทธิ์ในการทำรายการ !!",
          });
        }
      });
    },
    showDialogAddJoinTravel() {
      if (this.Project_group == null) {
        this.$swal.fire({
          icon: "warning",
          title:
              "กรุณาเลือกประเภทไปปฏิบัติราชการก่อนทำการเพิ่มรายชื่อผู้เข้าร่วม",
        });
        this.$refs.Project_group.$refs.input.focus();
      } else if (this.Project_group == "999" && this.txtProject_group == "") {
        this.$swal.fire({
          icon: "warning",
          title: "โปรดกรอกรายละเอียดประเภทการปฏิบัติงาน",
        });
      } else {
        this.peridTravel = null;
        this.joinTravelprefixFullName = "";
        this.joinTravelfullName = "";
        this.joinTravelPosition = "";
        this.joinTravelAllowance = "0";
        this.joinTravelAccommodationCost = "0";
        this.joinTravelShippingCosts = "0";
        this.joinTravelRegistrationFee = "0";
        this.joinTravelAllTravelExpenses = "0";
        this.joinTravelRemainingBudget = "0";
        this.dialogJoinTravel = true;
      }
    },
    checkKeyEnterTravel(e) {
      if (e.keyCode === 13) {
        this.peridTravel = this.$refs.peridTravel.$refs.input.value;
        // ปิดลิสต์รายการ (autocomplete dropdown)
        if (this.$refs.peridTravel && this.$refs.peridTravel.blur) {
          this.$refs.peridTravel.blur();
        }
        if (this.$refs.btnAddJoinTravel && this.$refs.btnAddJoinTravel.$el) {
          setTimeout(() => {
            this.$refs.btnAddJoinTravel.$el.click();
            this.$refs.peridTravel.$refs.input.focus();
          }, 500);
        }
        this.choosePeridTravel();
      }
    },
    async choosePeridTravel() {
      if (this.peridTravel != null) {
        var objStaff = this.staffData.filter(
            (stfItem) => stfItem.perid == this.peridTravel
        );
        if (objStaff.length > 0) {
          await this.initAcademicFundsByPerson({
            perid: objStaff[0].perid,
          }).then((res) => {
            if (res) {
              this.joinTravelprefixFullName = objStaff[0].iname;
              this.joinTravelfullName = objStaff[0].full_Name;
              this.joinTravelPosition = objStaff[0].pos_name;
              if (
                  this.JoinTravel.length > 0 &&
                  this.JoinTravel.filter((item) => item.perid == this.peridTravel)
                      .length > 0
              ) {
                var joinObj = this.JoinTravel.filter(
                    (item) => item.perid == this.peridTravel
                )[0];
                this.joinTravelprefixFullName =
                    joinObj.prefix == null ? "" : joinObj.prefix;
                this.joinTravelPosition =
                    joinObj.position == null ? "" : joinObj.position;
                this.joinTravelAllowance =
                    joinObj.Allowance == null ? "0" : joinObj.Allowance;
                this.joinTravelAccommodationCost =
                    joinObj.AccommodationCost == null
                        ? "0"
                        : joinObj.AccommodationCost;
                this.joinTravelShippingCosts =
                    joinObj.ShippingCosts == null ? "0" : joinObj.ShippingCosts;
                this.joinTravelRegistrationFee =
                    joinObj.RegistrationFee == null
                        ? "0"
                        : joinObj.RegistrationFee;
                this.joinTravelAllTravelExpenses =
                    joinObj.AllTravelExpenses == null
                        ? "0"
                        : joinObj.AllTravelExpenses;
                this.joinTravelRemainingBudget =
                    joinObj.RemainingBudget == null
                        ? "0"
                        : joinObj.RemainingBudget;
              } else {
                this.joinTravelRemainingBudget =
                    this.AcademicFundsByPerson.length > 0
                        ? this.AcademicFundsByPerson[0].academic_funds != null &&
                        this.AcademicFundsByPerson[0].academic_funds != ""
                            ? this.AcademicFundsByPerson[0].academic_funds
                            : "0"
                        : "0";
              }

              if (this.rdoTypeJoinTravel == "2") {
                this.addJoinTravel();
              }
            }
          });
        }
      }
    },
    async choosePeridTravelReport(param, type) {
      // console.log("%c data is => ", "color: #007acc", param)
      // console.log(param)
      if (
          param.Allowance != "" &&
          param.Allowance != null &&
          param.AccommodationCost != "" &&
          param.AccommodationCost != null &&
          param.ShippingCosts != "" &&
          param.ShippingCosts != null &&
          param.RegistrationFee != "" &&
          param.RegistrationFee != null
      ) {
        this.disPerid = param.perid;
        this.disFullName =
            (param.prefix == null || param.prefix == ""
                ? ""
                : param.prefix + " ") + param.full_name;
        this.disPosition = param.position;
        this.disDepName = param.affiliation;
        this.disTypeStart = "1";
        this.disDateStart = "";
        this.disTimeStart = "";
        this.disTypeEnd = "1";
        this.disDateEnd = "";
        this.disTimeEnd = "";
        this.disAllowance = parseFloat(param.Allowance);
        this.disAllowance_Days = parseFloat(param.Allowance_Days);
        this.disAccommodationCost = parseFloat(param.AccommodationCost);
        this.disAccommodationCost_Type = param.AccommodationCost_Type;
        this.disAccommodationCost_Days = parseFloat(
            param.AccommodationCost_Days
        );
        this.disShippingCosts = parseFloat(param.ShippingCosts);
        this.disShippingCosts_Days = parseFloat(param.ShippingCosts_Days);
        this.disRegistrationFee = parseFloat(param.RegistrationFee);
        this.disSummary = parseFloat(param.Summary);
        this.disDateReceipt = "";
        this.disRemark = "";
        this.disLoanNumber = "";
        this.disLoanAmount = 0;
        this.disMororNumber = "";
        this.disDocDate = "";
        this.disDocDateWithdraw = "";
        this.disTopic = "";
        this.disDear = "";
        this.disMessage1 = "";
        this.disDocDateApprove = "";
        this.disPeridSave = param.perid;
        this.disNameSave =
            (param.prefix == null || param.prefix == ""
                ? ""
                : param.prefix + " ") + param.full_name;
        this.disMessage2 = "";
        this.disMessage3 = "";
        this.disTypeWithdraw = "1";
        this.disNote = "";
        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
              queryName: "getTravelDisbursement",
              param: btoa(
                  JSON.stringify({
                    Project_code: this.Project.Project_code,
                    type: type,
                    perid: param.uid,
                  })
              ),
            })
            .then((res) => {
              if (res.data.status) {
                if (res.data.data != null) {
                  // const sumAllowance = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.Allowance), 0);
                  // const sumAccommodationCost = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.AccommodationCost), 0);
                  // const sumShippingCosts = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.ShippingCosts), 0);
                  // const sumRegistrationFee = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.RegistrationFee), 0);
                  res.data.data.map((itemJoin) => {
                    this.disId = res.data.formDis.id;
                    this.disPerid = param.perid;
                    this.disFullName =
                        (param.prefix == null || param.prefix == ""
                            ? ""
                            : param.prefix + " ") + param.full_name;
                    this.disPosition = param.position;
                    this.disDepName = param.affiliation;
                    this.disTypeStart =
                        res.data.formDis.TypeStart != null
                            ? res.data.formDis.TypeStart
                            : "1";
                    this.disDateStart =
                        res.data.formDis.DateStart != null
                            ? res.data.formDis.DateStart
                            : "";
                    this.disTimeStart =
                        res.data.formDis.TimeStart != null
                            ? res.data.formDis.TimeStart
                            : "";
                    this.disTypeEnd =
                        res.data.formDis.TypeEnd != null
                            ? res.data.formDis.TypeEnd
                            : "1";
                    this.disDateEnd =
                        res.data.formDis.DateEnd != null
                            ? res.data.formDis.DateEnd
                            : "";
                    this.disTimeEnd =
                        res.data.formDis.TimeEnd != null
                            ? res.data.formDis.TimeEnd
                            : "";
                    // this.disAllowance = type == '1' ? parseFloat(itemJoin.Allowance) : sumAllowance
                    // this.disAllowance_Days = param.Allowance_Days != null ? parseInt(param.Allowance_Days) : 0
                    // this.disAccommodationCost = type == '1' ? parseFloat(itemJoin.AccommodationCost) : sumAccommodationCost
                    // this.disAccommodationCost_Type = param.AccommodationCost_Type != null ? param.AccommodationCost_Type : '1'
                    // this.disAccommodationCost_Days = param.AccommodationCost_Days != null ? parseInt(param.AccommodationCost_Days) : 0
                    // this.disShippingCosts = type == '1' ? parseFloat(itemJoin.ShippingCosts) : sumShippingCosts
                    // this.disRegistrationFee = type == '1' ? parseFloat(itemJoin.RegistrationFee) : sumRegistrationFee
                    this.disDateReceipt = "";
                    this.disRemark = "";
                    this.disLoanNumber =
                        itemJoin.LoanNumber != null ? itemJoin.LoanNumber : "";
                    this.disLoanAmount =
                        itemJoin.LoanAmount != null
                            ? parseFloat(itemJoin.LoanAmount)
                            : "";
                    this.disMororNumber =
                        res.data.formDis.moror_number != null
                            ? res.data.formDis.moror_number
                            : "";
                    this.disDocDate =
                        res.data.formDis.doc_date != null
                            ? res.data.formDis.doc_date
                            : "";
                    this.disDocDateWithdraw =
                        res.data.formDis.doc_date_withdraw != null
                            ? res.data.formDis.doc_date_withdraw
                            : "";
                    this.disTopic =
                        res.data.formDis.topic != null
                            ? res.data.formDis.topic
                            : "";
                    this.disDear =
                        res.data.formDis.dear != null ? res.data.formDis.dear : "";
                    this.disMessage1 =
                        res.data.formDis.message1 != null
                            ? res.data.formDis.message1
                            : "";
                    this.disDocDateApprove =
                        res.data.formDis.doc_date_approve != null
                            ? res.data.formDis.doc_date_approve
                            : "";
                    this.disPeridSave =
                        res.data.formDis.perid_save != null
                            ? res.data.formDis.perid_save
                            : param.perid;
                    this.disNameSave =
                        res.data.formDis.name_save != null
                            ? res.data.formDis.name_save
                            : (param.prefix == null || param.prefix == ""
                            ? ""
                            : param.prefix + " ") + param.full_name;
                    this.disMessage2 =
                        res.data.formDis.message2 != null
                            ? res.data.formDis.message2
                            : "";
                    this.disMessage3 =
                        res.data.formDis.message3 != null
                            ? res.data.formDis.message3
                            : "";
                    this.disTypeWithdraw =
                        res.data.formDis.type_withdraw != null
                            ? res.data.formDis.type_withdraw
                            : "";
                    this.disNote =
                        res.data.formDis.note != null
                            ? res.data.formDis.note
                            : " - ผู้จัดเลี้ยงอาหารมื้อเช้า/กลางวัน/เย็น รวม";
                  });
                }
              }
            });
        this.dialogJoinTravelReport = false;
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ห้ามปล่อยให้ค่าใช้จ่ายเป็นค่าว่าง !",
        });
      }
    },
    summaryMoney(item) {
      item.Summary =
          parseFloat(item.Allowance) +
          parseFloat(item.AccommodationCost) +
          parseFloat(item.ShippingCosts) +
          parseFloat(item.RegistrationFee);
    },
    calulateDateTime() {
      var startDate = new Date(this.disDateStart + " " + this.disTimeStart);
      var endDate = new Date(this.disDateEnd + " " + this.disTimeEnd);

      var diffDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

      var diffMinutes = Math.floor((endDate - startDate) / (1000 * 60));

      console.log("จำนวนวันที่ผ่านมา:", diffDays, "วัน");
      console.log("จำนวนนาทีที่ผ่านมา:", diffMinutes, "นาที");
    },
    choosePeridSave() {
      if (this.peridSave != null) {
        var objStaff = this.staffData.filter(
            (stfItem) => stfItem.perid == this.peridSave
        );
        if (objStaff.length > 0) {
          this.nameSave = objStaff[0].iname + " " + objStaff[0].full_Name;
          this.positionSave = objStaff[0].pos_name;
        }
      }
    },
    choosePeridApprove() {
      if (this.peridApprove != null) {
        var objStaff = this.staffData.filter(
            (stfItem) => stfItem.perid == this.peridApprove
        );
        if (objStaff.length > 0) {
          this.nameApprove = objStaff[0].iname + " " + objStaff[0].full_Name;
          this.positionApprove = objStaff[0].pos_name;
        }
      }
    },
    chooseDepartID() {
      if (this.DepSelect != null) {
        var objDepart = this.depart.filter(
            (depItem) => depItem.dep_id == this.DepSelect
        );
        if (objDepart.length > 0) {
          this.departName = objDepart[0].dep_name;

          /*this.IsProcess = '1'
          this.IsExpense = '1'
          this.Project_group = '104'
          this.PLACE = '0'
          this.BudgetRequest = '5000'
          this.WorkBy = 'P'
          this.dateRegS = '2023-12-05'
          this.dateRegE = '2023-12-15'
          this.WorkByName = 'Apple ctd.'
          this.Location = 'โรงแรมลากูน่า'
          this.WorkByPhone = '0854423312'
          this.phone2 = '0994451123'
          this.mororNumber = 'มอ.104/55412123'
          this.docDate = '2023-12-22'
          this.topic = 'ไปราชการ อบรมที่อเมริกา'
          this.dear = 'หัวหน้าสาขาวิชา'
          this.detail = 'เพื่อไปเป็นวิทยากร และอบรมหัวข้อการพัฒนางาน'
          this.note = '1. ให้ยืมเงินได้ \n' +
              '2. พจบ.'
          this.peridSave = '46792'
          this.nameSave = 'ธวัชชัย จันทรทิพย์'
          this.positionSave = 'นักวิชาการคอมพิวเตอร์'
          this.peridApprove = '43654'
          this.nameApprove = 'ชฎาพร สังขชาติ'
          this.positionApprove = 'เจ้าหน้าที่บริหารงานทั่วไป'*/
        }
      }
    },
    openDialogInsertRecordLecturer() {
      if (
          this.peridTravel != null &&
          this.joinTravelprefixFullName != "" &&
          this.joinTravelfullName != "" &&
          this.joinTravelPosition != "" &&
          this.joinTravelAllowance != "" &&
          this.joinTravelShippingCosts != "" &&
          this.joinTravelRegistrationFee != "" &&
          this.joinTravelRegistrationFee != ""
      ) {
        this.dialogLecturer = true;

        this.SubjectForLecturer = "";
        this.dateSTravelForLecturer = "";
        this.dateETravelForLecturer = "";
        this.dateSForLecturer = "";
        this.dateEForLecturer = "";
        this.timeSForLecturer = "";
        this.timeEForLecturer = "";
        this.LecturerProjectName = "";
        this.LecturerHour = "";
        this.LecturerInvite = "";
        this.LecturerPlace = "";
        this.LecturerDocNo = "";
        this.LecturerDateDocOut = "";
        this.LecturerDateStart = "";
        this.LecturerTimeStart = "";
        this.LecturerDateEnd = "";
        this.LecturerTimeEnd = "";
        this.FileProjectExpert = [];
        this.filesExpert = [];
        this.txtAlertExpert = [];
        this.alertExpert = false;
        this.Rm2 = "";
        this.Lecturer = [];

        this.LecturerProjectName = this.Project_name;
        this.LecturerHour = this.CalHourse;
        this.LecturerInvite = this.WorkByName;
        this.LecturerPlace = this.Location;
        this.dateSForLecturer = this.dateRegS;
        this.dateEForLecturer = this.dateRegE;

        // ไว้ทดสอบคีย์ข้อมูลประเภทวิทยากร
        /*this.SubjectForLecturer = 'test'
        this.dateSTravelForLecturer = '2023-12-10'
        this.dateETravelForLecturer = '2023-12-20'
        this.dateSForLecturer = '2023-12-11'
        this.dateEForLecturer = '2023-12-16'
        this.timeSForLecturer = '10:00'
        this.timeEForLecturer = '16:00'
        this.LecturerProjectName = 'test2'
        this.LecturerHour = '3'
        this.LecturerInvite = 'test4'
        this.LecturerPlace = 'test5'
        this.LecturerDocNo = 'มอ.1201/2212'
        this.LecturerDateDocOut = '2023-12-05'
        this.LecturerDateStart = '2023-12-12'
        this.LecturerTimeStart = '10:30'
        this.LecturerDateEnd = '2023-12-15'
        this.LecturerTimeEnd = '12:00'
        this.Rm2 = 'test6'*/
      } else {
        this.$swal.fire({
          icon: "error",
          title: "โปรดกรอกข้อมูล ให้ครบถ้วน!",
        });
      }
    },
    ChooseCompetency() {
      this.CompetencyData = JSON.parse(JSON.stringify(this.CompetencyDataDump));
      if (this.Project_category == "1") {
        this.CompetencyData[0].checkCordi = true;
        this.CompetencyData[2].checkCordi = true;
      } else {
        this.CompetencyData[0].checkCordi = false;
        this.CompetencyData[2].checkCordi = true;
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map((root) => {
            if (root.children.length > 0) {
              root.children.map((child1) => {
                if (child1.children.length > 0) {
                  child1.children.map((child2) => {
                    if (child2.id == this.selection[i]) {
                      if (
                          (this.Project_category == "1" &&
                              ((root.DelvGroup == "A" && root.DelvLevel == "0") ||
                                  (root.DelvGroup == "D" &&
                                      root.DelvLevel == "0"))) ||
                          (this.Project_category != "1" &&
                              root.DelvGroup == "D" &&
                              root.DelvLevel == "0")
                      ) {
                        root.checkCordi = false;
                      }
                    }
                  });
                }
                if (child1.id == this.selection[i]) {
                  if (
                      (this.Project_category == "1" &&
                          ((root.DelvGroup == "A" && root.DelvLevel == "0") ||
                              (root.DelvGroup == "D" && root.DelvLevel == "0"))) ||
                      (this.Project_category != "1" &&
                          root.DelvGroup == "D" &&
                          root.DelvLevel == "0")
                  ) {
                    root.checkCordi = false;
                  }
                }
              });
            }
            if (root.id == this.selection[i]) {
              if (
                  (this.Project_category == "1" &&
                      ((root.DelvGroup == "A" && root.DelvLevel == "0") ||
                          (root.DelvGroup == "D" && root.DelvLevel == "0"))) ||
                  (this.Project_category != "1" &&
                      root.DelvGroup == "D" &&
                      root.DelvLevel == "0")
              ) {
                root.checkCordi = false;
              } else {
                root.checkCordi = true;
              }
            }
          });
        }
      }
      this.getCourseType();
    },
    addJoinTravel() {
      if (
          this.peridTravel != null &&
          this.joinTravelprefixFullName &&
          this.joinTravelfullName != "" &&
          this.joinTravelPosition != "" &&
          this.joinTravelAllowance != "" &&
          this.joinTravelShippingCosts != "" &&
          this.joinTravelRegistrationFee != "" &&
          this.joinTravelRegistrationFee != ""
      ) {
        var objStaff = this.staffData.filter(
            (stfItem) => stfItem.perid == this.peridTravel
        );
        var checkLecturer = false;
        if (objStaff.length > 0) {
          if (
              this.Project_group != null &&
              this.Project_group != "" &&
              this.Project_group == "116"
          ) {
            if (this.Lecturer.length == 0) {
              checkLecturer = true;
            }
          }
          if (!checkLecturer) {
            if (
                this.JoinTravel.filter((item) => item.perid == this.peridTravel)
                    .length > 0
            ) {
              this.JoinTravel.map((item) => {
                if (item.perid == this.peridTravel) {
                  item.prefix = this.joinTravelprefixFullName;
                  item.full_name = this.joinTravelfullName;
                  item.customTravelDetail =
                      '<p style="font-weight: bold">' +
                      this.joinTravelprefixFullName +
                      " " +
                      this.joinTravelfullName +
                      "</p>" +
                      '<p style="font-weight: bold">ตำแหน่ง: ' +
                      this.joinTravelPosition +
                      "</p>";
                  item.position = this.joinTravelPosition;
                  item.Allowance = this.joinTravelAllowance;
                  item.AccommodationCost = this.joinTravelAccommodationCost;
                  item.ShippingCosts = this.joinTravelShippingCosts;
                  item.RegistrationFee = this.joinTravelRegistrationFee;
                  item.AllTravelExpenses = this.joinTravelAllTravelExpenses;
                  item.RemainingBudget = this.joinTravelRemainingBudget;
                  item.Lecturer =
                      this.Project_group != null && this.Project_group != ""
                          ? this.Project_group == "116"
                              ? this.Lecturer
                              : null
                          : null;
                }
              });
              this.$swal.fire({
                position: "top-end",
                icon: "success",
                title:
                    "อัพเดทข้อมูลผู้เข้าร่วม " +
                    this.joinTravelprefixFullName +
                    " " +
                    this.joinTravelfullName +
                    " สำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
            } else {
              this.JoinTravel.unshift({
                ...objStaff[0],
                id: this.JoinTravel.length + 1,
                prefix: this.joinTravelprefixFullName,
                full_name: this.joinTravelfullName,
                customTravelDetail:
                    '<p style="font-weight: bold">' +
                    this.joinTravelprefixFullName +
                    " " +
                    this.joinTravelfullName +
                    "</p>" +
                    '<p style="font-weight: bold">ตำแหน่ง: ' +
                    this.joinTravelPosition +
                    "</p>",
                position: this.joinTravelPosition,
                Allowance: this.joinTravelAllowance,
                AccommodationCost: this.joinTravelAccommodationCost,
                ShippingCosts: this.joinTravelShippingCosts,
                RegistrationFee: this.joinTravelRegistrationFee,
                AllTravelExpenses: this.joinTravelAllTravelExpenses,
                RemainingBudget: this.joinTravelRemainingBudget,
                Lecturer:
                    this.Project_group != null && this.Project_group != ""
                        ? this.Project_group == "116"
                            ? this.Lecturer
                            : null
                        : null,
                files: [],
                uid: objStaff[0].perid,
                name: objStaff[0].name,
                sname: objStaff[0].surname,
                idCard: objStaff[0].citizen_id,
                affiliation: objStaff[0].dep_name,
                phone: "",
                registerType_id: 0,
              });
            }
            this.dialogLecturer = false;
            this.peridTravel = null;
            this.joinTravelprefixFullName = "";
            this.joinTravelfullName = "";
            this.joinTravelPosition = "";
            this.joinTravelAllowance = "0";
            this.joinTravelAccommodationCost = "0";
            this.joinTravelShippingCosts = "0";
            this.joinTravelRegistrationFee = "0";
            this.joinTravelAllTravelExpenses = "0";
            this.joinTravelRemainingBudget = "0";
            this.Lecturer = [];
          } else {
            this.$swal.fire({
              icon: "error",
              title:
                  "กรุณากรอกข้อมูลการเป็นวิทยากรและเพิ่มข้อมูลวิทยากรให้ครบถ้วนก่อนบันทึก",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่สามารถเพิ่มรายชื่อผู้เข้าร่วมได้ โปรดลองอีกครั้ง !!",
          });
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "โปรดกรอกข้อมูล ให้ครบถ้วน!",
        });
      }
    },
    clearDataJoinTravel() {
      this.peridTravel = null;
      this.joinTravelprefixFullName = "";
      this.joinTravelfullName = "";
      this.joinTravelPosition = "";
      this.joinTravelAllowance = "0";
      this.joinTravelAccommodationCost = "0";
      this.joinTravelShippingCosts = "0";
      this.joinTravelRegistrationFee = "0";
      this.joinTravelAllTravelExpenses = "0";
      this.joinTravelRemainingBudget = "0";
    },
    editJoinTravel(index) {
      var joinObj = this.JoinTravel[index];
      this.peridTravel = joinObj.perid;
      this.choosePeridTravel();
    },
    delJoinTravel(index) {
      this.JoinTravel.splice(index, 1);
    },
    insertTravelDataToDb(
        ProjectCode,
        Project_name,
        credit,
        hour,
        Project_group,
        DateStart,
        DateEnd
    ) {
      return new Promise((resolve) => {
        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
              queryName: "saveDataToForm",
              param: {
                Project_code: ProjectCode,
                type:
                    this.projectGroup.filter(
                        (projG) => projG.Project_group == Project_group
                    ).length > 0
                        ? this.projectGroup.filter(
                            (projG) => projG.Project_group == Project_group
                        )[0].Committee_Code
                        : null,
                subject: Project_name,
                credit: credit,
                hour: hour,
                date_start: DateStart,
                date_end: DateEnd,
                depart_id: this.DepSelect,
                depart_name: this.departName,
                phone: this.phone2,
                moror_number: this.mororNumber,
                doc_date: this.docDate,
                topic: this.topic,
                dear: this.dear,
                detail: this.detail,
                note: this.note,
                perid_save: this.peridSave,
                name_save: this.nameSave,
                position_save: this.positionSave,
                perid_approve: this.peridApprove,
                name_approve: this.nameApprove,
                position_approve: this.positionApprove,
                create_time: "now()",
                create_by: this.MeData[0].perid,
                joinTravel: this.JoinTravel,
              },
            })
            .then((res) => {
              if (res.data.status) {
                this.formId = res.data.id;
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((rescatch) => {
              if (rescatch) {
                resolve(false);
              }
            });
      });
    },
    /*insertTeamTravelDataToDb(ProjectCode) {
      return new Promise(resolve => {
        this.JoinTravelDis.map(item => {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/travel_and_training_form_dis', {
            Project_code: ProjectCode,
            depart_id: this.DepSelect,
            depart_name: this.departName,
            phone: this.phone2,
            moror_number: this.mororNumber,
            doc_date: this.docDate,
            topic: this.topic,
            dear: this.dear,
            detail: this.detail,
            note: this.note,
            perid_save: this.peridSave,
            name_save: this.nameSave,
            position_save: this.positionSave,
            perid_approve: this.peridApprove,
            name_approve: this.nameApprove,
            position_approve: this.positionApprove,
            create_time: 'now()',
            create_by: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }).then(res => {
            if (res.data.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch(res => {
            if (res) {
              resolve(true)
            }
          })
        })
      })
    },*/
    insertTravelDisbursementForm() {
      this.loadingSaveReport2 = true;
      this.CheckPermission().then((resPermiss) => {
        if (resPermiss) {
          return new Promise((resolve) => {
            this.JoinTravelDis = [];
            this.JoinTravel.map((travelItem) => {
              if (travelItem.perid == this.disPerid) {
                this.JoinTravelDis.unshift({
                  ...travelItem,
                  Allowance_Days: this.disAllowance_Days,
                  AccommodationCost_Type: this.disAccommodationCost_Type,
                  AccommodationCost_Days: this.disAccommodationCost_Days,
                  ShippingCosts_Days: this.disShippingCosts_Days,
                });
              } else {
                this.JoinTravelDis.unshift({
                  ...travelItem,
                });
              }
            });
            axios
                .post(
                    ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php",
                    {
                      queryName: "saveDataToFormDis",
                      param: {
                        Project_code: this.ProjectPlan,
                        moror_number: this.disMororNumber,
                        doc_date: this.disDocDate,
                        doc_date_withdraw: this.disDocDateWithdraw,
                        topic: this.disTopic,
                        dear: this.disDear,
                        message1: this.disMessage1,
                        message2: this.disMessage2,
                        message3: this.disMessage3,
                        type_withdraw: this.disTypeWithdraw,
                        doc_date_approve: this.disDocDateApprove,
                        TypeStart: this.disTypeStart,
                        DateStart: this.disDateStart,
                        TimeStart: this.disTimeStart,
                        DateEnd: this.disDateEnd,
                        TimeEnd: this.disTimeEnd,
                        TypeEnd: this.disTypeEnd,
                        note: this.disNote,
                        perid_save: this.disPeridSave,
                        name_save: this.disNameSave,
                        create_time: "now()",
                        create_by: this.MeData[0].perid,
                        joinTravel:
                            this.disTypeWithdraw == "1"
                                ? this.JoinTravelDis.filter(
                                    (travelItem) => travelItem.perid == this.disPerid
                                )
                                : this.JoinTravelDis,
                      },
                    }
                )
                .then((res) => {
                  if (res.data.status) {
                    this.$swal.fire({
                      icon: "success",
                      title: "บันทึกแบบฟอร์มเบิกสำเร็จ!",
                    });
                    this.disId = res.data.id;
                    axios
                        .post(
                            ConstData.ConnectionHost +
                            "/HrTrain2/serviceReportAPI.php",
                            {
                              queryName: "getFileReport2",
                              param: btoa(
                                  JSON.stringify({
                                    Project_code: this.Project.Project_code,
                                    uid: res.data.id,
                                  })
                              ),
                            }
                        )
                        .then((resFile) => {
                          if (parseInt(resFile.data.count) > 0) {
                            window.open(
                                "https://medhr.medicine.psu.ac.th/HrTrain2/upload/file/" +
                                resFile.data.data[0].file_name,
                                "_blank" // <- This is what makes it open in a new window.
                            );
                          }
                          this.loadingSaveReport2 = false;
                        });
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title: "บันทึกแบบฟอร์มเบิกไม่สำเร็จ! โปรดลองอีกครั้ง",
                    });
                    this.loadingSaveReport2 = false;
                  }
                  resolve(true);
                })
                .catch((rescatch) => {
                  this.loadingSaveReport2 = false;
                  console.log("rescatch = > " + rescatch);
                  resolve(false);
                });
          });
        } else {
          this.loadingSaveReport2 = false;
          this.$swal.fire({
            icon: "error",
            title: "ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้",
          });
        }
      });
    },
    insertTravelDisbursement(ProjectCode) {
      return new Promise((resolve) => {
        axios
            .post(
                ConstData.ConnectionHost +
                "/app-api/v2/?/apis/hrtrain/D_travel_disbursement",
                {
                  Project_code: ProjectCode,
                  Perid: this.disPerid,
                  Full_Name: this.disFullName,
                  Position: this.disPosition,
                  DepName: this.disDepName,
                  TypeStart: this.disTypeStart,
                  DateStart: this.disDateStart,
                  TimeStart: this.disTimeStart,
                  DateEnd: this.disDateEnd,
                  TimeEnd: this.disTimeEnd,
                  TypeEnd: this.disTypeEnd,
                  Allowance: this.disAllowance,
                  Allowance_Days: this.disAllowance_Days,
                  AccommodationCost: this.disAccommodationCost,
                  AccommodationCost_Type: this.disAccommodationCost_Type,
                  AccommodationCost_Days: this.disAccommodationCost_Days,
                  ShippingCosts_Days: this.disShippingCosts_Days,
                  ShippingCosts: this.disShippingCosts,
                  RegistrationFee: this.disRegistrationFee,
                  DateReceipt: this.disDateReceipt,
                  Remark: this.disRemark,
                  LoanNumber: this.disLoanNumber,
                  LoanAmount: this.disLoanAmount,
                  create_time: "now()",
                  create_by: this.MeData[0].perid,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    "X-REST-METHOD": "PUT",
                  },
                }
            )
            .then((res) => {
              if (res.data.status) {
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((res) => {
              if (res) {
                resolve(false);
              }
            });
      });
    },
    summaryBudget() {
      this.joinTravelAllTravelExpenses =
          parseFloat(this.joinTravelAllowance) +
          parseFloat(this.joinTravelAccommodationCost) +
          parseFloat(this.joinTravelShippingCosts) +
          parseFloat(this.joinTravelRegistrationFee);
    },
    getDateNowToDB() {
      // Get current timestamp in milliseconds
      const timestamp = Date.now();

      // Convert timestamp to Date object
      const date = new Date(timestamp);

      // Convert Date object to ISO 8601 format
      const isoString = date.toISOString();

      return isoString;
    },
    insertTravelForm() {
      this.initMeData().then((res) => {
        if (res) {
          this.loadingSaveReport = true;
          this.CheckPermission().then((resPermiss) => {
            if (resPermiss) {
              axios
                  .post(
                      ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php",
                      {
                        queryName: "updateFormReport1",
                        param: {
                          Project_code: this.Project.Project_code,
                          type: this.projectGroup.filter(
                              (projG) => projG.Project_group == this.Project_group
                          ).length
                              ? this.projectGroup.filter(
                                  (projG) => projG.Project_group == this.Project_group
                              )[0].Committee_Code
                              : null,
                          subject: this.Project_name,
                          date_start: this.dateRegS,
                          date_end: this.dateRegE,
                          depart_id: this.DepSelect,
                          depart_name: this.departName,
                          phone: this.phone2,
                          moror_number: this.mororNumber,
                          doc_date: this.docDate,
                          topic: this.topic,
                          dear: this.dear,
                          detail: this.detail,
                          note: this.note,
                          perid_save: this.peridSave,
                          name_save: this.nameSave,
                          position_save: this.positionSave,
                          perid_approve: this.peridApprove,
                          name_approve: this.nameApprove,
                          position_approve: this.positionApprove,
                          create_time: "now()",
                          create_by: this.MeData[0].perid,
                          joinTravel: this.JoinTravel,
                        },
                      }
                  )
                  .then((res) => {
                    if (res.data.status) {
                      axios
                          .post(
                              ConstData.ConnectionHost +
                              "/HrTrain2/serviceReportAPI.php",
                              {
                                queryName: "getFileReport",
                                param: btoa(
                                    JSON.stringify({
                                      Project_code: this.Project.Project_code,
                                      uid: res.data.id,
                                    })
                                ),
                              }
                          )
                          .then((resFile) => {
                            if (resFile.data.status) {
                              this.$swal.fire({
                                icon: "success",
                                title: "บันทึกแบบฟอร์มเสนออนุมัติสำเร็จ!",
                              });
                              this.formId = res.data.id;
                              if (parseInt(resFile.data.count) > 0) {
                                window.open(
                                    "https://medhr.medicine.psu.ac.th/HrTrain2/upload/file/" +
                                    resFile.data.data[0].file_name,
                                    "_blank" // <- This is what makes it open in a new window.
                                );
                              }
                              this.loadingSaveReport = false;
                            } else {
                              this.loadingSaveReport = false;
                              this.$swal.fire({
                                icon: "warning",
                                title:
                                    "บันทึกแบบฟอร์มเสนออนุมัติสำเร็จ! แต่ไม่่สามารถดึงข้อมูลฟอร์มได้ โปรดติดต่อฝ่าย IT !",
                              });
                            }
                          });
                    } else {
                      this.loadingSaveReport = false;
                    }
                  })
                  .catch((rescatch) => {
                    this.loadingSaveReport = false;
                    console.log("rescatch = > " + rescatch);
                  });
            } else {
              this.loadingSaveReport = false;
              this.$swal.fire({
                icon: "error",
                title: "ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้",
              });
            }
          });
        }
      });
    },
    showReport(Project_code = null) {
      if (this.formId != null) {
        this.loadingShowReport = true;
        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
              queryName: "getFileReport",
              param: btoa(
                  JSON.stringify({
                    Project_code:
                        Project_code == null
                            ? this.Project.Project_code
                            : Project_code,
                    uid: this.formId,
                  })
              ),
            })
            .then((resFile) => {
              if (parseInt(resFile.data.count) > 0) {
                window.open(
                    "https://medhr.medicine.psu.ac.th/HrTrain2/upload/file/" +
                    resFile.data.data[0].file_name,
                    "_blank" // <- This is what makes it open in a new window.
                );
              } else {
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่พบข้อมูลแบบฟอร์มเบิก ทำการบันทึกแบบฟอร์มก่อนทำการพิมพ์ทุกครั้ง!",
                });
              }
              this.loadingShowReport = false;
            })
            .catch((resCatch) => {
              console.log(resCatch);
              this.loadingShowReport = false;
              this.$swal.fire({
                icon: "error",
                title: "ไม่พบข้อมูลแบบฟอร์มเบิก โปรดลองอีกครั้ง",
              });
            });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูลแบบฟอร์มเบิก โปรดลองอีกครั้ง",
        });
      }
    },
    showReport2(id = null) {
      this.disId = id == null ? this.disId : id;
      if (this.disId != null) {
        this.loadingShowReport2 = true;
        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
              queryName: "getFileReport2",
              param: btoa(
                  JSON.stringify({
                    Project_code: this.Project.Project_code,
                    uid: this.disId,
                  })
              ),
            })
            .then((resFile) => {
              if (parseInt(resFile.data.count) > 0) {
                window.open(
                    "https://medhr.medicine.psu.ac.th/HrTrain2/upload/file/" +
                    resFile.data.data[0].file_name,
                    "_blank" // <- This is what makes it open in a new window.
                );
              } else {
                this.$swal.fire({
                  icon: "error",
                  title:
                      "ไม่พบข้อมูลแบบฟอร์มเบิก ทำการบันทึกแบบฟอร์มก่อนทำการพิมพ์ทุกครั้ง!",
                });
              }
              this.loadingShowReport2 = false;
            })
            .catch((resCatch) => {
              console.log(resCatch);
              this.loadingShowReport2 = false;
            });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูลแบบฟอร์มเบิก โปรดลองอีกครั้ง",
        });
      }
    },
    printGroupReport() {
      this.loadingPrintGroupReport = true;
      axios
          .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
            queryName: "getFileGroupReport",
            param: btoa(
                JSON.stringify({
                  Project_code: this.Project.Project_code,
                })
            ),
          })
          .then((resFile) => {
            if (parseInt(resFile.data.count) > 0) {
              window.open(
                  "https://medhr.medicine.psu.ac.th/HrTrain2/upload/file/" +
                  resFile.data.data[0].file_name,
                  "_blank" // <- This is what makes it open in a new window.
              );
            } else {
              this.$swal.fire({
                icon: "error",
                title:
                    "ไม่พบข้อมูลแบบฟอร์มเบิกคณะเดินทาง ทำการบันทึกแบบฟอร์มก่อนทำการพิมพ์ทุกครั้ง!",
              });
            }
            this.loadingPrintGroupReport = false;
          })
          .catch((resCatch) => {
            console.log(resCatch);
            this.loadingPrintGroupReport = false;
          });
    },
    showDialogJoinTravelReport() {
      this.dialogLoading = true;
      axios
          .post(ConstData.ConnectionHost + "/HrTrain2/serviceReportAPI.php", {
            queryName: "getJoinTravelDisbursementById",
            param: btoa(
                JSON.stringify({
                  Project_code: this.Project.Project_code,
                })
            ),
          })
          .then((res) => {
            if (res.data.length > 0) {
              // const sumAllowance = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.Allowance), 0);
              // const sumAccommodationCost = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.AccommodationCost), 0);
              // const sumShippingCosts = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.ShippingCosts), 0);
              // const sumRegistrationFee = res.data.data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.RegistrationFee), 0);
              this.JoinTravel.map((itemJoin) => {
                res.data.map((itemJoin2) => {
                  if (itemJoin.uid == itemJoin2.perid) {
                    itemJoin.Allowance = parseFloat(itemJoin2.Allowance);
                    itemJoin.AccommodationCost = parseFloat(
                        itemJoin2.AccommodationCost
                    );
                    itemJoin.ShippingCosts = parseFloat(itemJoin2.ShippingCosts);
                    itemJoin.RegistrationFee = parseFloat(
                        itemJoin2.RegistrationFee
                    );
                    itemJoin.Allowance_Days = parseFloat(
                        itemJoin2.Allowance_Days
                    );
                    itemJoin.AccommodationCost_Type =
                        itemJoin2.AccommodationCost_Type;
                    itemJoin.AccommodationCost_Days = parseFloat(
                        itemJoin2.AccommodationCost_Days
                    );
                    itemJoin.ShippingCosts_Days = parseFloat(
                        itemJoin2.ShippingCosts_Days
                    );
                    itemJoin.Summary =
                        itemJoin.Allowance +
                        itemJoin.AccommodationCost +
                        itemJoin.ShippingCosts +
                        itemJoin.RegistrationFee;
                    itemJoin.LoanNumber = itemJoin2.LoanNumber;
                    itemJoin.LoanAmount =
                        itemJoin2.LoanAmount == null || itemJoin2.LoanAmount == ""
                            ? 0
                            : parseFloat(itemJoin2.LoanAmount);
                    itemJoin.DateReceipt = itemJoin2.DateReceipt;
                    itemJoin.AmountRequest =
                        itemJoin2.AmountRequest == null ||
                        itemJoin2.AmountRequest == ""
                            ? 0
                            : parseFloat(itemJoin2.AmountRequest);
                    itemJoin.Remark = itemJoin2.Remark;
                  }
                  // this.disAllowance = type == '1' ? parseFloat(itemJoin.Allowance) : sumAllowance
                  // this.disAccommodationCost = type == '1' ? parseFloat(itemJoin.AccommodationCost) : sumAccommodationCost
                  // this.disShippingCosts = type == '1' ? parseFloat(itemJoin.ShippingCosts) : sumShippingCosts
                  // this.disRegistrationFee = type == '1' ? parseFloat(itemJoin.RegistrationFee) : sumRegistrationFee
                });
              });
              this.dialogJoinTravelReport = true;
            } else {
              this.JoinTravel.map((itemJoin) => {
                itemJoin.Allowance_Days = 0;
                itemJoin.AccommodationCost_Type = "1";
                itemJoin.AccommodationCost_Days = 0;
                itemJoin.ShippingCosts_Days = 0;
                itemJoin.Summary =
                    parseFloat(itemJoin.Allowance) +
                    parseFloat(itemJoin.AccommodationCost) +
                    parseFloat(itemJoin.ShippingCosts) +
                    parseFloat(itemJoin.RegistrationFee);
                itemJoin.LoanNumber = "";
                itemJoin.LoanAmount = 0;
                itemJoin.DateReceipt = "";
                itemJoin.AmountRequest = 0;
                itemJoin.Remark = "";
                itemJoin
              });
              this.dialogJoinTravelReport = true;
            }
            this.dialogLoading = false;
          });
    },
    summaryDateTime() {
      if (
          this.disDateStart != "" &&
          this.disTimeStart != "" &&
          this.disDateEnd != "" &&
          this.disTimeEnd != ""
      ) {
        var startDate = new Date(this.disDateStart + " " + this.disTimeStart);
        var endDate = new Date(this.disDateEnd + " " + this.disTimeEnd);
        //
        // var diffDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
        //
        // var diffMinutes = Math.floor((endDate - startDate) / (1000 * 60));
        //
        // console.log("จำนวนวันที่ผ่านมา:", diffDays, "วัน");
        // var convertedTime = this.convertMinutesToHoursMinutesSeconds(diffMinutes);
        // console.log(convertedTime.hours + " ชั่วโมง, " + convertedTime.minutes + " นาที, " + convertedTime.seconds + " วินาที");
        //
        // // วันที่เริ่มต้นและวันที่สิ้นสุด
        // var startDate = new Date("2024-01-12T22:33:00");
        // var endDate = new Date("2024-02-12T22:33:00");

        var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
        var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

        var diffHours = Math.floor(
            (timeDiff % (1000 * 3600 * 24)) / (1000 * 3600)
        );
        var diffMinutes = Math.floor((timeDiff % (1000 * 3600)) / (1000 * 60));

        // console.log("เหลือวัน:", diffDays, "วัน");
        // console.log("เหลือเวลา:", diffHours, "ชั่วโมง", diffMinutes, "นาที");
        this.disMessage3 =
            diffDays + " วัน " + diffHours + " ชั่วโมง " + diffMinutes + " นาที";
      } else {
        this.disMessage3 = "";
      }
    },
    convertMinutesToHoursMinutesSeconds(minutes) {
      var hours = Math.floor(minutes / 60);
      var remainingMinutes = minutes % 60;
      var seconds = Math.floor((minutes % 1) * 60);

      return {
        hours: hours,
        minutes: remainingMinutes,
        seconds: seconds,
      };
    },
    chooseTypeDicProcess() {
      var sumAllowance = 0;
      var sumAccommodationCost = 0;
      var sumShippingCosts = 0;
      var sumRegistrationFee = 0;
      var summary = 0;
      /*const sumAllowance = this.JoinTravel.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.Allowance), 0);
      const sumAccommodationCost = this.JoinTravel.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.AccommodationCost), 0);
      const sumShippingCosts = this.JoinTravel.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.ShippingCosts), 0);
      const sumRegistrationFee = this.JoinTravel.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.RegistrationFee), 0);
      const summary = sumAllowance + sumAccommodationCost + sumShippingCosts + sumRegistrationFee*/
      this.JoinTravel.map((item) => {
        sumAllowance += parseFloat(item.Allowance);
        sumAccommodationCost += parseFloat(item.AccommodationCost);
        sumShippingCosts += parseFloat(item.ShippingCosts);
        sumRegistrationFee += parseFloat(item.RegistrationFee);
      });

      summary =
          sumAllowance +
          sumAccommodationCost +
          sumShippingCosts +
          sumRegistrationFee;

      this.disAllowance =
          this.disTypeWithdraw == "1"
              ? this.JoinTravel.filter(
                  (itemJoin) => itemJoin.uid == this.disPerid
              )[0].Allowance
              : sumAllowance;
      this.disAccommodationCost =
          this.disTypeWithdraw == "1"
              ? this.JoinTravel.filter(
                  (itemJoin) => itemJoin.uid == this.disPerid
              )[0].AccommodationCost
              : sumAccommodationCost;
      this.disShippingCosts =
          this.disTypeWithdraw == "1"
              ? this.JoinTravel.filter(
                  (itemJoin) => itemJoin.uid == this.disPerid
              )[0].ShippingCosts
              : sumShippingCosts;
      this.disRegistrationFee =
          this.disTypeWithdraw == "1"
              ? this.JoinTravel.filter(
                  (itemJoin) => itemJoin.uid == this.disPerid
              )[0].RegistrationFee
              : sumRegistrationFee;
      this.disSummary =
          this.disTypeWithdraw == "1"
              ? this.JoinTravel.filter(
                  (itemJoin) => itemJoin.uid == this.disPerid
              )[0].Summary
              : summary;
    },
    execProcessSendMail(
        callFunc,
        DepCode = null,
        objProj = null,
        sendPerid = null,
        ProjectCode = "",
        Topic = "-"
    ) {
      if (DepCode != null) {
        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
              queryName: "getPermissionByDep",
              param: btoa(
                  JSON.stringify({
                    dep_id: DepCode,
                    permission_id: "1001",
                    type: "1",
                  })
              ),
            })
            .then((res) => {
              if (res.data.length > 0) {
                res.data.map((App_item) => {
                  if (App_item.sendmail == "1") {
                    switch (callFunc) {
                      case "1":
                        this.SendMail(
                            App_item.perid,
                            sendPerid,
                            ProjectCode,
                            Topic
                        );
                        break;
                      case "2":
                        this.SendMailSucProject(App_item, objProj);
                        break;
                      case "3":
                        this.SendMailCancelPlan(App_item, objProj);
                        break;
                      default:
                        break;
                    }
                  }
                });
              }
            })
            .catch((res) => {
              if (res) {
                console.log(res);
              }
            });

        axios
            .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
              queryName: "getPermissionByDep",
              param: btoa(
                  JSON.stringify({
                    dep_id: DepCode,
                    permission_id: "1001",
                    type: "2",
                  })
              ),
            })
            .then((res2) => {
              if (res2) {
                if (res2.data.length > 0) {
                  res2.data.map((App_item) => {
                    if (App_item.sendmail == "1") {
                      this.SendMail(App_item);
                    }
                  });
                }
              }
            })
            .catch((res) => {
              if (res) {
                console.log(res);
              }
            });
      }
    },
    CheckSendmail(perid) {
      return new Promise((resolve) => {
        this.initPermissionOptionData({
          perid: perid,
        }).then((res) => {
          if (res) {
            if (this.OptPermission.length > 0) {
              this.OptPermission.map((optI) => {
                if (optI.email == "1") {
                  resolve(true);
                }
              });
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
      });
    },
    CheckSendmail2(perid) {
      return new Promise((resolve) => {
        this.initPermissionOptionUserData({
          perid: perid,
        }).then((res) => {
          if (res) {
            if (this.getOptUserPermission.length > 0) {
              this.getOptUserPermission.map((optI) => {
                this.Option.map((optI2) => {
                  if (optI2.value == "email") {
                    if (optI.email == "1") {
                      resolve(true);
                    }
                  }
                });
              });
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
      });
    },
    openProjectRecord() {
      this.dialogShowProjectRecord = true;
    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.ProjectPlan = null
      this.Project_plan = []
      this.initProjDataFromFiscalYearUser({
        FiscalYear: this.FiscalYear,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.ProjectFromFiscalYearUser.length > 0) {
            this.ProjectFromFiscalYearUser.map((Project) => {
              this.Project_plan.push({
                  ...Project,
                  full_Text:
                      "ข้อมูลปี " +
                      (parseInt(Project.FiscalYear) + 543) +
                      " => " +
                      Project.Project_code +
                      " " +
                      Project.Project_name +
                      " " +
                      (this.TypeProject == "1" &&
                      Project.Approve == "1" &&
                      Project.Status == "1"
                          ? " (โครงการถูกจัดแล้ว)"
                          : Project.Approve == "1" && Project.Status == "0"
                              ? "(โครงการรอดำเนินการ)"
                              : ""),
                  disabled: false,
                });
              })
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
          });
        }
      }).catch((res) => {
        console.log(res);
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
    insertIndicator() {
      this.$swal
        .fire({
          title: "ยืนยันการทำรายการ",
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.dialogLoading = true;
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
              {
                queryName: "insertProjectIndicator",
                param: btoa(
                    encodeURIComponent(
                        JSON.stringify({
                          Project_code: this.Project_code_dump,
                          satisfaction: this.satisfaction,
                          Knowledge_after: this.Knowledge_after,
                          Knowledge_before: this.Knowledge_before,
                          permiss_check: this.MeData[0].perid,
                        })
                    )
                ),
              }).then((res) => {
                if (res.data.status) {
                  this.$swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                  });
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "ไม่สามารถบันทึกข้อมูลได้",
                  });
                }
                this.dialogLoading = false;
              }).catch((res) => {
                this.dialogLoading = false;
                console.log(res);
                this.$swal.fire({
                  icon: "error",
                  title: "ไม่สามารถบันทึกข้อมูลได้ โปรดลองทำรายการอีกครั้ง",
                });
              });
          }
        })
    },
    /*saveReport2(type) {
      return new Promise(resolve => {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_travel_disbursement', {
            Project_code: this.ProjectPlan,
            Perid: this.disPerid,
            Full_Name: this.disFullName,
            Position: this.disPosition,
            DepName: this.disDepName,
            TypeStart: this.disTypeStart,
            DateStart: this.disDateStart,
            TimeStart: this.disTimeStart,
            DateEnd: this.disDateEnd,
            TimeEnd: this.disTimeEnd,
            TypeEnd: this.disTypeEnd,
            Allowance: this.disAllowance,
            Allowance_Days: this.disAllowance_Days,
            AccommodationCost: this.disAccommodationCost,
            AccommodationCost_Type: this.disAccommodationCost_Type,
            AccommodationCost_Days: this.disAccommodationCost_Days,
            ShippingCosts: this.disShippingCosts,
            RegistrationFee: this.disRegistrationFee,
            DateReceipt: this.disDateReceipt,
            Remark: this.disRemark,
            LoanNumber: this.disLoanNumber,
            LoanAmount: this.disLoanAmount,
            create_time: 'now()',
            create_by: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }).then(res => {
            if (res.data.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch(res => {
            if (res) {
              resolve(false)
            }
          })
        })
    },*/
    init() {
      this.initMeData().then((res) => {
        if (res) {
          this.isLoading = true;
          this.DepSelect = this.MeData[0].dep_id;
          if (this.TypeProject == "2") {
            this.chooseDepartID();
          }
          this.ExecForm();
          this.CompetencyData = [];
          this.CompetencyDataDump = [];
          this.itemsSel = [];
          this.FiscalYearData = [];
          this.Project_plan = [];
          this.Project_type = this.TypeProject;

          this.editorData =
              '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ ' +
              this.projectGroupToShow +
              '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' +
              this.Project_name +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' +
              this.Objective +
              '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>';

          for (
              var i = new Date().getFullYear() - 1;
              i <= new Date().getFullYear() + 1;
              i++
          ) {
            this.FiscalYearData.push({
              year: i,
              yearth: i + 543,
            });
          }

          this.FiscalYear = this.FiscalYearData[
          this.FiscalYearData.length - 1
              ].year;

          // this.GenerateUrl().then(res => {
          //   this.url = res
          // })

          this.initCountryData();
          this.selProjFiscalYear()
          this.isLoading = false;

          /* this.initProjectData({
            perid: this.MeData[0].perid,
          }); */

          if (this.courseData.length == 0) {
            this.initCourseData();
          }

          this.initDepartData().then((res) => {
            if (res) {
              if (this.depart.length > 0) {
                this.groupDepart = this.UniqueArraybyId(
                    this.depart,
                    "dep_group_name"
                );
              }
            }
          });

          if (this.positions.length == 0) {
            this.initPositionsData();
          }

          this.initStaffData().then((res) => {
            if (res) {
              if (this.staffData.length > 0) {
                this.staffData.map((item) => {
                  item.customDetail =
                      item.full_Name +
                      " รหัส (" +
                      item.perid +
                      ")" +
                      " " +
                      item.dep_name +
                      " (" +
                      item.dep_group_name +
                      ")";
                });
              }
            }
          });

          this.initExpenseData({
            cost_type: this.TypeProject,
          });

          if (this.committee_Posi.length == 0) {
            this.initComitteeType();
          }

          if (this.provinces_Data.length == 0) {
            this.initProvincesData();
          }

          if (this.projectGroup.length == 0) {
            this.initProjectGroupData();
          }

          if (this.levelData.length == 0) {
            this.initlevelData();
          }

          if (this.CardData.length == 0) {
            this.initCardData();
          }

          this.initCompetencyData().then((res) => {
            if (res) {
              this.Competency.map((compe_i) => {
                if (compe_i.DelvCover == null || compe_i.DelvCover == "") {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == "") {
                    this.CompetencyData.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: "0",
                      children: [],
                    });
                  } else {
                    this.CompetencyData.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                      DelvLevel: "0",
                      children: [],
                    });
                  }
                }
              });
              this.CompetencyData.map((data_i, idx) => {
                if (data_i.children.length == 0) {
                  this.Competency.map((compe_i) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == "") {
                        this.CompetencyData[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: "1",
                          children: [],
                        });
                      } else {
                        this.CompetencyData[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                          DelvLevel: "1",
                          children: [],
                        });
                      }
                    }
                  });
                }
              });
              // lv2
              this.CompetencyData.map((data_i) => {
                if (data_i.children.length > 0) {
                  data_i.children.map((child1_i, idx) => {
                    if (child1_i.children.length == 0) {
                      this.Competency.map((compe_i) => {
                        if (child1_i.DelvNo == compe_i.DelvCover) {
                          if (
                              compe_i.DelvEng == null ||
                              compe_i.DelvEng == ""
                          ) {
                            data_i.children[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name: compe_i.DelvDes,
                              DelvLevel: "2",
                              children: [],
                            });
                          } else {
                            data_i.children[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name:
                                  compe_i.DelvDes + "( " + compe_i.DelvEng + " )",
                              DelvLevel: "2",
                              children: [],
                            });
                          }
                        }
                      });
                    }
                  });
                }
              });

              // item to autocomplete
              this.CompetencyData.map((itemRoot) => {
                this.itemsSel.push({
                  ...itemRoot,
                });
                if (itemRoot.children.length > 0) {
                  itemRoot.children.map((itemChild1) => {
                    this.itemsSel.push({
                      ...itemChild1,
                    });
                    if (itemChild1.children.length > 0) {
                      itemChild1.children.map((itemChild2) => {
                        this.itemsSel.push({
                          ...itemChild2,
                        });
                      });
                    }
                  });
                }
              });
              this.CompetencyDataDump = JSON.parse(
                  JSON.stringify(this.CompetencyData)
              );
            }
          });

          this.initGroup_Quota();

          this.initGroup_Quota_Ms();

          this.initAppointment();

          axios
              .get(
                  ConstData.ConnectionHost +
                  "/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999"
              )
              .then((res) => {
                if (res.data) {
                  if (res.data.length > 0) {
                    res.data.map((item) => {
                      this.studentData.push({
                        ...item,
                        fullName:
                            "รหัสนักศึกษา : " +
                            item.STUDENT_ID +
                            " ชื่อ-สกุล " +
                            item.STUD_NAME_THAI +
                            " " +
                            item.STUD_SNAME_THAI,
                      });
                    });
                  } else {
                    this.studentData.push({
                      ...res.data,
                      fullName:
                          "รหัสนักศึกษา : " +
                          res.data[0].STUDENT_ID +
                          " ชื่อ-สกุล " +
                          res.data[0].STUD_NAME_THAI +
                          " " +
                          res.data[0].STUD_SNAME_THAI,
                    });
                  }
                } else {
                  this.studentData = [];
                }
              });

          axios
              .get(
                  ConstData.ConnectionHost +
                  "/rest/v1/AllPersonal/dss_person.W_FACULTY/1"
              )
              .then((res) => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.AllDepartData = res.data;
                  } else {
                    this.AllDepartData.push(res.data);
                  }
                } else {
                  this.AllDepartData = [];
                }
              });
        }
      });
    },
    CopySuccess(url) {
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์ ' + url + ' สำเร็จ !!',
        showConfirmButton: false,
        timer: 1000
      })
    },
    downloadURI(qrUrl) {
      if (qrUrl != '' && this.Project != null) {
        var link = document.createElement("a");
        link.download = 'ไฟล์ภาพ QR CODE โครงการ ' + this.Project.Project_name;
        link.href = qrUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูล QR CODE",
        });
      }
    },
    chooseCommitteeType() {
      this.perid = null
      this.IdDepart = null
      this.Idstudent = null
      this.IdDepartStd = null
      this.IdstudentUni = null
      this.Committee_code = null
      this.NameP = ''
      this.SurNameP = ''
      this.NameStd = ''
      this.SurNameStd = ''
      this.phone = ''
      this.full_name = ''
    },
    execCommitteeData(CommitteeData) {
      if (CommitteeData.length > 0) {
        this.Coordinator = [];
        this.Committee_ToShow = [];
        this.LecturerToShow = [];

        CommitteeData.map((itemCoor) => {
          this.Coordinator.push({
            idx: this.Coordinator.length,
            ...itemCoor,
          });
        });
      } else {
        this.Coordinator.push({
          idx: this.Coordinator.length,
          ...CommitteeData,
        });
      }

      this.Committee_ToShow = this.Coordinator.filter(
          (itemLecturer) =>
              itemLecturer.Committee_code != "6" &&
              itemLecturer.Committee_code != "23" &&
              itemLecturer.Committee_code != "24"
      );
      this.LecturerToShow = this.Coordinator.filter(
          (itemLecturer) =>
              itemLecturer.Committee_code == "6" ||
              itemLecturer.Committee_code == "23" ||
              itemLecturer.Committee_code == "24"
      );
      if (this.Committee_ToShow.length > 0) {
        this.Committee_ToShow.map((item) => {
          item.Committee_des = this.committee_Posi.filter(
              (commit_i) =>
                  commit_i.Committee_code == item.Committee_code
          ).length > 0 ? this.committee_Posi.filter(
              (commit_i) =>
                  commit_i.Committee_code == item.Committee_code
          )[0].committee_des : '-'
        });
      }
      if (this.LecturerToShow.length > 0) {
        this.LecturerToShow.map((item) => {
          item.Committee_des =this.committee_Posi.filter(
              (commit_i) =>
                  commit_i.Committee_code == item.Committee_code
          ).length > 0 ? this.committee_Posi.filter(
              (commit_i) =>
                  commit_i.Committee_code == item.Committee_code
          )[0].committee_des : '-'
        })
      }
    },
    showAddBudgetHistory() {
      this.newExpenseCost = null;
      this.newRm = "";
      this.newReqMoney = 0;
      this.newReqPerson = 0;
      this.newMoneySummary = 0;
      this.dialogAddBudgetHistory = true;
      /* this.BudgetHistory = [];
      this.BudgetHistory.push({
        BudgetYear: this.FiscalYear,
        BudgetAmount: 0,
        BudgetType: "1",
        BudgetTypeName: "งบประมาณแผ่นดิน",
      }); */
    },
  },
  mounted() {
    this.changeHeaderPage({
      page: "1",
    });
    this.changeManageProjectPage({
      page: "2",
    });
    for (var l = 2020; l <= (new Date().getFullYear() + 3); l++) {
      this.FiscalYearDataSel.push({
        year: l,
        yearth: l + 543
      })
    }
    this.initMeData()
        .then(async (res) => {
          if (res) {
            await this.getIgnoreSubMenuPermissData({
              perid: this.MeData[0].perid,
              page_id: "8",
              page_sub_id: "5",
            });
            this.getPermissionData({
              perid: this.MeData[0].perid,
            }).then((resAdmin) => {
              if (resAdmin) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == "9000") {
                    this.getSubMenuPermissData()
                        .then((res) => {
                          if (res) {
                            if (
                                (this.SubMenuPermiss.length > 0 &&
                                    this.SubMenuPermiss.filter(
                                        (item) =>
                                            item.page_sub_id == "5" &&
                                            item.page_status == "1"
                                    ).length > 0) ||
                                this.IgnoreSubMenuPermiss.filter(
                                    (item) => item.perid == this.MeData[0].perid
                                ).length > 0
                            ) {
                              this.maintain = false;
                              this.init();
                            } else {
                              this.pageMessage =
                                  this.SubMenuPermiss.filter(
                                      (item) =>
                                          item.page_sub_id == "5" &&
                                          item.page_message != null
                                  ).length > 0
                                      ? this.SubMenuPermiss.filter(
                                          (item) => item.page_sub_id == "5"
                                      )[0].page_message
                                      : "ปิดปรับปรุงระบบชั่วคราว";
                              this.maintain = true;
                            }
                          }
                        })
                        .then((err) => {
                          if (err) {
                            this.pageMessage =
                                this.SubMenuPermiss.filter(
                                    (item) =>
                                        item.page_sub_id == "5" &&
                                        item.page_message != null
                                ).length > 0
                                    ? this.SubMenuPermiss.filter(
                                        (item) => item.page_sub_id == "5"
                                    )[0].page_message
                                    : "ปิดปรับปรุงระบบชั่วคราว";
                            this.maintain = true;
                          }
                        });
                    this.CheckAdmin = true;
                  } else {
                    if (
                        !this.CheckAdmin &&
                        idx == this.PermissionAdmin.length - 1
                    ) {
                      this.$router.push("/");
                    }
                  }
                });
              } else {
                this.getPermissionUserData({
                  perid: this.MeData[0].perid,
                }).then((resUser) => {
                  if (resUser) {
                    this.Permission.map((Per_i, idx) => {
                      if (Per_i.permission_id == "9000") {
                        this.getSubMenuPermissData()
                            .then((res) => {
                              if (res) {
                                if (
                                    (this.SubMenuPermiss.length > 0 &&
                                        this.SubMenuPermiss.filter(
                                            (item) =>
                                                item.page_sub_id == "5" &&
                                                item.page_status == "1"
                                        ).length > 0) ||
                                    this.IgnoreSubMenuPermiss.filter(
                                        (item) => item.perid == this.MeData[0].perid
                                    ).length > 0
                                ) {
                                  this.maintain = false;
                                  this.init();
                                } else {
                                  this.pageMessage =
                                      this.SubMenuPermiss.filter(
                                          (item) =>
                                              item.page_sub_id == "5" &&
                                              item.page_message != null
                                      ).length > 0
                                          ? this.SubMenuPermiss.filter(
                                              (item) => item.page_sub_id == "5"
                                          )[0].page_message
                                          : "ปิดปรับปรุงระบบชั่วคราว";
                                  this.maintain = true;
                                }
                              }
                            })
                            .then((err) => {
                              if (err) {
                                this.pageMessage =
                                    this.SubMenuPermiss.filter(
                                        (item) =>
                                            item.page_sub_id == "5" &&
                                            item.page_message != null
                                    ).length > 0
                                        ? this.SubMenuPermiss.filter(
                                            (item) => item.page_sub_id == "5"
                                        )[0].page_message
                                        : "ปิดปรับปรุงระบบชั่วคราว";
                                this.maintain = true;
                              }
                            });
                        this.CheckSubAdmin = true;
                      } else {
                        if (
                            !this.CheckSubAdmin &&
                            idx == this.Permission.length - 1
                        ) {
                          this.$router.push("/");
                        }
                      }
                    });
                  } else {
                    this.CheckSubAdmin = false;
                    this.CheckAdmin = false;
                    this.$router.push("/");
                  }
                });
              }
            });
          }
        })
        .catch((reason) => {
          console.log("Reject = " + reason);
        });
  },
};
</script>

<style scoped>
/*@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');*/

@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@200&display=swap");

.fr-box.fr-basic .fr-element.fr-view {
  font-family: "Sarabun", sans-serif;
  font-size: 16px;
  color: #444444;
}

@font-face {
  font-family: "THSarabunNew";
  src: url("../../lib/font/THSarabunNew.ttf");
}

@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url("../../lib/font/THSarabunNew Bold.ttf");
}

.pdf-content {
  width: 100%;
  background: #fff;
}

@media print {
  .no-print {
    display: none !important;
  }
}

@media screen {
  .no-screen {
    display: none !important;
  }
}

.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

/*.v-text-field >>> button {*/
/*  font-size: 0.1em;*/
/*}*/

.ck-content {
  height: 500px;
}

.ck-editor__editable {
  min-height: 500px;
}

</style>
